import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  Date: { input: any; output: any };
  JSON: { input: any; output: any };
  Upload: { input: any; output: any };
  Upload_Scalar: { input: any; output: any };
}

export interface AbuseModel {
  abuser?: Maybe<UserModel>;
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  reason?: Maybe<UserReportReason>;
  updatedAt: Scalars["Date"]["output"];
  victim?: Maybe<UserModel>;
}

export interface ActivateUserInput {
  activationKey: Scalars["String"]["input"];
}

export interface AddBulkMembersInput {
  action: BulkAddAction;
  channelId: Scalars["String"]["input"];
  channelType: BulkChannelType;
  emails: Array<Scalars["String"]["input"]>;
}

export interface AddEventCalendarInput {
  calendarType: CalendarType;
  eventID: Scalars["String"]["input"];
}

export interface AdminFilterBannersInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterCoversInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterEventsInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface AdminFilterFeatureFlagsInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterIllustrationsInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterReportsUserFilterInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterThemesInput {
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGrammarLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResource?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStandard?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterTopicsInput {
  category?: InputMaybe<AdminTopicsCategories>;
  excludeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AdminTopicsOrderBy>;
  sort?: InputMaybe<SortDirection>;
  status?: InputMaybe<TopicStatus>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  theme?: InputMaybe<Scalars["String"]["input"]>;
}

export interface AdminFilterUsersInput {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  badges?: InputMaybe<Array<UserBadgeType>>;
  cancelledInRecovery?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** How reliably she shows up. */
  commitmentLevels?: InputMaybe<Array<CommitmentLevel>>;
  /** How much she uses the platform (E1–E5). */
  engagementLevels?: InputMaybe<Array<EngagementLevel>>;
  englishLevels?: InputMaybe<Array<SpeakingLevelCategories>>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  /** How close to drifting away (Detected / Dormant / Critical / …). */
  faderLevels?: InputMaybe<Array<FaderLevel>>;
  ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Industry ids. Broader than occupation — 'Education' rather than 'Teacher', so you can reach a whole field at once. */
  industries?: InputMaybe<Array<Scalars["String"]["input"]>>;
  interests?: InputMaybe<Array<Interest>>;
  kind?: InputMaybe<Array<EventPermissions>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location?: InputMaybe<Array<UserLocation>>;
  /** Only members who have attended at least this many events. */
  minEventsAttended?: InputMaybe<Scalars["Int"]["input"]>;
  occupations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  openToSpeakingPartners?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  order?: InputMaybe<SortDirection>;
  orderBy?: InputMaybe<AdminUsersOrderBy>;
  plan?: InputMaybe<Array<MembershipPlans>>;
  query?: InputMaybe<Scalars["String"]["input"]>;
  /** Words to look for in her bio — 'teacher', 'mother', 'startup'. Searches only the story, unlike the main search box which also matches name and email. */
  storyKeyword?: InputMaybe<Scalars["String"]["input"]>;
  subscriptionStatus?: InputMaybe<Array<SubscriptionStatus>>;
  /** How long she's been a member. */
  tenures?: InputMaybe<Array<TenureBucket>>;
  /** Match members whose timezone currently sits at this UTC offset, in minutes (e.g. 60 = UTC+1) — 'everyone on that clock', DST-aware. */
  timezoneOffsetMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  verificationStatus?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  /** The member's colour zone — when she's actually around. */
  zones?: InputMaybe<Array<ZoneLabel>>;
}

export interface AdminFilterVideoSetInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminFilterZineCoversInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface AdminShareSelectionResponse {
  alreadySharedCount: Scalars["Int"]["output"];
  cap: Scalars["Int"]["output"];
  eligibleCount: Scalars["Int"]["output"];
  inactiveCount: Scalars["Int"]["output"];
  notAllowedCount: Scalars["Int"]["output"];
  totalMatched: Scalars["Int"]["output"];
  truncated: Scalars["Boolean"]["output"];
  userIds: Array<Scalars["String"]["output"]>;
}

export enum AdminTopicsCategories {
  GrammarLibrary = "GrammarLibrary",
  Resource = "Resource",
  Standard = "Standard",
  TopicLibrary = "TopicLibrary",
}

export enum AdminTopicsOrderBy {
  LastUpdated = "lastUpdated",
  Theme = "theme",
  Title = "title",
}

export interface AdminUserSignUpAnswers {
  createdAt: Scalars["Date"]["output"];
  detectedTimezone?: Maybe<Scalars["String"]["output"]>;
  eligibilityAgeGender?: Maybe<Scalars["String"]["output"]>;
  englishLevel?: Maybe<EnglishLevel>;
  firstEventBookingSkipped: Scalars["Boolean"]["output"];
  guestPassWeeklyPracticeReadiness?: Maybe<Scalars["String"]["output"]>;
  mainSpeakingPracticeChallenge?: Maybe<Scalars["String"]["output"]>;
  mainSpokenEnglishPriority?: Maybe<Scalars["String"]["output"]>;
  selectedFirstEventId?: Maybe<Scalars["String"]["output"]>;
  selectedFirstEventTime?: Maybe<Scalars["Date"]["output"]>;
  selectedTimezone?: Maybe<Scalars["String"]["output"]>;
}

export enum AdminUsersOrderBy {
  Country = "country",
  Date = "date",
  Email = "email",
  Name = "name",
  RecoveryDays = "recoveryDays",
}

export interface AnswerHomeCheckInFollowUpInput {
  followUp: HomeCheckInFollowUp;
  kind: HomeCheckInKind;
}

export interface AnswerHomeCheckInInput {
  answer: HomeCheckInAnswer;
  kind: HomeCheckInKind;
}

export enum ArticleAction {
  Publish = "Publish",
}

export enum ArticleByAuthor {
  Any = "Any",
  Follow = "Follow",
  Heylady = "Heylady",
  Members = "Members",
}

export enum ArticleCategory {
  Any = "Any",
  Featured = "Featured",
  Interests = "Interests",
  Journey = "Journey",
  Liked = "Liked",
  Popular = "Popular",
  Recommended = "Recommended",
  Topics = "Topics",
}

export interface ArticleModel {
  attachments?: Maybe<Array<ArticlesAttachmentModel>>;
  author?: Maybe<UserModel>;
  comments?: Maybe<Array<CommentModel>>;
  content?: Maybe<Scalars["String"]["output"]>;
  coverUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  likedByMe?: Maybe<LikeModel>;
  likes?: Maybe<Array<LikeModel>>;
  myEnglishJourney?: Maybe<Scalars["Boolean"]["output"]>;
  noComments?: Maybe<Scalars["Int"]["output"]>;
  noLikes?: Maybe<Scalars["Int"]["output"]>;
  publishedAt?: Maybe<Scalars["Date"]["output"]>;
  reads: ReadArticleModel;
  scheduledFor?: Maybe<Scalars["Date"]["output"]>;
  tags?: Maybe<Array<Interest>>;
  theme?: Maybe<ArticleThemes>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface ArticleNotificationModel {
  article: ArticleModel;
  articleAction: ArticleAction;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export enum ArticleOrderBy {
  Published = "Published",
  Title = "Title",
}

export interface ArticleSearchResult {
  item: ArticleModel;
  matches?: Maybe<Array<SearchMatch>>;
  refIndex: Scalars["Int"]["output"];
}

export enum ArticleThemes {
  ArtAndCulture = "ART_AND_CULTURE",
  CareerWomen = "CAREER_WOMEN",
  Community = "COMMUNITY",
  FamilyAndFriends = "FAMILY_AND_FRIENDS",
  FoodAndTraditions = "FOOD_AND_TRADITIONS",
  HealthAndWellness = "HEALTH_AND_WELLNESS",
  PersonalDevelopment = "PERSONAL_DEVELOPMENT",
  ScienceAndTechnology = "SCIENCE_AND_TECHNOLOGY",
  TheEnvironment = "THE_ENVIRONMENT",
  Travel = "TRAVEL",
}

export interface ArticlesAttachmentModel {
  article: ArticleModel;
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  meta?: Maybe<MetaFileType>;
  updatedAt: Scalars["Date"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
}

export interface AssessmentResultContentRecord {
  question: Scalars["String"]["output"];
  recording: Scalars["String"]["output"];
}

export interface AssessmentResultModel {
  assessmentId: Scalars["String"]["output"];
  assessmentType?: Maybe<Scalars["String"]["output"]>;
  cefrScore?: Maybe<Scalars["String"]["output"]>;
  coherenceScore: Scalars["Float"]["output"];
  content?: Maybe<Array<AssessmentResultContentRecord>>;
  createdAt: Scalars["Date"]["output"];
  fluencyScore: Scalars["Float"]["output"];
  grammarScore: Scalars["Float"]["output"];
  halloScore: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  improvements?: Maybe<Array<Scalars["String"]["output"]>>;
  isAddedByAdmin: Scalars["Boolean"]["output"];
  language?: Maybe<Scalars["String"]["output"]>;
  pronunciationScore: Scalars["Float"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  vocabularyScore: Scalars["Float"]["output"];
}

export interface AssignOrDeleteBadgeInput {
  achievedDate?: InputMaybe<Scalars["Date"]["input"]>;
  type: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export enum AssistanceReasons {
  Assistance = "ASSISTANCE",
  HelpFindingEvents = "HELP_FINDING_EVENTS",
  HelpFindingPeople = "HELP_FINDING_PEOPLE",
  NeedMoreTime = "NEED_MORE_TIME",
  SomethingElse = "SOMETHING_ELSE",
}

export interface AssistanceReasonsInput {
  customReason?: InputMaybe<Scalars["String"]["input"]>;
  reason: Array<AssistanceReasons>;
}

export interface AttendEventInput {
  eventID: Scalars["String"]["input"];
}

/** Whether the member can attend the event, and if not, what stops her. */
export enum AttendVerdict {
  Blocked = "BLOCKED",
  Locked = "LOCKED",
  Open = "OPEN",
}

export interface AttendanceMetrics {
  attendedDuration?: Maybe<Scalars["Int"]["output"]>;
  attendedEvents?: Maybe<Scalars["Int"]["output"]>;
  attendedGroup?: Maybe<Scalars["Int"]["output"]>;
  attendedInPerson?: Maybe<Scalars["Int"]["output"]>;
  attendedOneToOnes?: Maybe<Scalars["Int"]["output"]>;
  attendedOther?: Maybe<Scalars["Int"]["output"]>;
  attendedWebinars?: Maybe<Scalars["Int"]["output"]>;
  hostedDuration?: Maybe<Scalars["Int"]["output"]>;
  hostedEvents?: Maybe<Scalars["Int"]["output"]>;
  hostedGroup?: Maybe<Scalars["Int"]["output"]>;
  hostedInPerson?: Maybe<Scalars["Int"]["output"]>;
  hostedOneToOnes?: Maybe<Scalars["Int"]["output"]>;
  hostedOther?: Maybe<Scalars["Int"]["output"]>;
  hostedWebinars?: Maybe<Scalars["Int"]["output"]>;
  totalAttendedNonScheduledEvents?: Maybe<Scalars["Int"]["output"]>;
  totalAttendedScheduledEvents?: Maybe<Scalars["Int"]["output"]>;
  totalDuration?: Maybe<Scalars["Int"]["output"]>;
  totalEvents?: Maybe<Scalars["Int"]["output"]>;
  totalGroup?: Maybe<Scalars["Int"]["output"]>;
  totalInPerson?: Maybe<Scalars["Int"]["output"]>;
  totalOneToOnes?: Maybe<Scalars["Int"]["output"]>;
  totalOther?: Maybe<Scalars["Int"]["output"]>;
  totalWebinars?: Maybe<Scalars["Int"]["output"]>;
  videoCalls?: Maybe<Scalars["Int"]["output"]>;
}

export interface AttendanceRecord {
  attendanceRatio?: Maybe<Scalars["Float"]["output"]>;
  attended?: Maybe<Scalars["Int"]["output"]>;
  totalRsvps?: Maybe<Scalars["Int"]["output"]>;
}

export interface AttendedEvents {
  groupEvents?: Maybe<Scalars["Int"]["output"]>;
  inPersonEvents?: Maybe<Scalars["Int"]["output"]>;
  oneToOnes?: Maybe<Scalars["Int"]["output"]>;
  other?: Maybe<Scalars["Int"]["output"]>;
  webinars?: Maybe<Scalars["Int"]["output"]>;
}

export enum Audience {
  NewMembers = "NEW_MEMBERS",
  OneMonthPlus = "ONE_MONTH_PLUS",
  Zero = "ZERO",
}

export interface Availability {
  from: Scalars["String"]["output"];
  until: Scalars["String"]["output"];
}

export interface AvailabilityForUsersInput {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface AvailabilityInput {
  from: Scalars["String"]["input"];
  until: Scalars["String"]["input"];
}

export interface AvailabilityMatchForUsers {
  availabilityMatch?: Maybe<AvailabilityStatus>;
  userId: Scalars["String"]["output"];
}

export enum AvailabilityStatus {
  Different = "Different",
  Shared = "Shared",
}

export interface BadgeNotificationModel {
  badge: UserBadgeModel;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export interface BannerModel {
  audience?: Maybe<Array<EventPermissions>>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  sliders?: Maybe<Array<SliderModel>>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface BulkActionResultType {
  failed: Scalars["Int"]["output"];
  notFound: Array<Scalars["String"]["output"]>;
  sendId?: Maybe<Scalars["String"]["output"]>;
  skipped: Array<Scalars["String"]["output"]>;
  succeeded: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
}

export enum BulkAddAction {
  Add = "add",
  Invite = "invite",
}

export enum BulkChannelType {
  GroupChat = "group_chat",
  PublicChannel = "public_channel",
}

export interface BulkInviteResponse {
  invitedUserIds: Array<Scalars["String"]["output"]>;
  warningMessages: Array<Scalars["String"]["output"]>;
}

export interface BulkInviteWithEmailsInput {
  emails: Array<Scalars["String"]["input"]>;
}

export interface BulkInviteWithUserIdsInput {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface BulkSendProgressType {
  error?: Maybe<Scalars["String"]["output"]>;
  failed: Scalars["Int"]["output"];
  finishedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  pending: Scalars["Int"]["output"];
  sent: Scalars["Int"]["output"];
  status: ChatBulkSendStatus;
  total: Scalars["Int"]["output"];
}

export interface BulkUploadCreatedEvent {
  id: Scalars["String"]["output"];
  row: Scalars["Int"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
}

export interface BulkUploadEventError {
  column: Scalars["String"]["output"];
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  row: Scalars["Int"]["output"];
}

export interface BulkUploadEventsInput {
  file: Scalars["Upload"]["input"];
}

export interface BulkUploadEventsResponse {
  createdCount: Scalars["Int"]["output"];
  createdEvents: Array<BulkUploadCreatedEvent>;
  inviteWarnings: Array<BulkUploadInviteWarning>;
  validationErrors: Array<BulkUploadEventError>;
}

export interface BulkUploadInviteWarning {
  column: Scalars["String"]["output"];
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  row: Scalars["Int"]["output"];
}

export interface BulkUploadValidationResponse {
  inviteWarnings: Array<BulkUploadInviteWarning>;
  totalRows: Scalars["Int"]["output"];
  validationErrors: Array<BulkUploadEventError>;
}

export interface CalendarEventModel {
  /** Event category (featured / new_member …). */
  category?: Maybe<Scalars["String"]["output"]>;
  /** 0 = Monday … 6 = Sunday (UTC). */
  dayOfWeek: Scalars["Int"]["output"];
  hostFirstName?: Maybe<Scalars["String"]["output"]>;
  hostName?: Maybe<Scalars["String"]["output"]>;
  /** Big Sister / Coach / CXT / Member — who's hosting. */
  hostType: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  /** Only members whose plan includes coaching can attend. */
  isCoachEvent: Scalars["Boolean"]["output"];
  /** Sign-ups have reached the cap. */
  isFull: Scalars["Boolean"]["output"];
  /** Event kind, prettified (e.g. 'Conversation'). */
  kind: Scalars["String"]["output"];
  /** Target level: Intermediate / Advanced / All levels. */
  level: Scalars["String"]["output"];
  /** Cap; null/absent when unlimited. */
  maxParticipants?: Maybe<Scalars["Int"]["output"]>;
  /** Shows locked until she has attended three events. */
  needsThreeEvents: Scalars["Boolean"]["output"];
  /** First names of some members signed up (capped). */
  participants: Array<Scalars["String"]["output"]>;
  /** Repeats weekly. */
  recurring: Scalars["Boolean"]["output"];
  /** How many members have signed up (host excluded). */
  registered: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
  /** Start clock in UTC, e.g. '19:00'. */
  timeUtc: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  /** No participant cap. */
  unlimited: Scalars["Boolean"]["output"];
  /** Who can see it: Members / Members + trial / Private. */
  visibility: Scalars["String"]["output"];
  /** The 3-hour UTC zone its start time falls in. */
  zone: ZoneLabel;
}

export interface CalendarModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
  user: UserModel;
}

export interface CalendarResponseType {
  reason?: Maybe<GoogleApiMessage>;
  status: MutationStatus;
  url?: Maybe<Scalars["String"]["output"]>;
}

export enum CalendarType {
  Google = "GOOGLE",
  Outlook = "OUTLOOK",
}

export interface CalendarWeekModel {
  events: Array<CalendarEventModel>;
  total: Scalars["Int"]["output"];
  /** Week start (Monday 00:00 UTC). */
  weekStart: Scalars["Date"]["output"];
}

export interface CampaignEventResultModel {
  came: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  invited: Scalars["Int"]["output"];
  saidYes: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  /** Everyone who attended, however they got there. */
  totalThere: Scalars["Int"]["output"];
}

export interface CampaignResultWeekModel {
  /** Of those invited, how many actually turned up. */
  came: Scalars["Int"]["output"];
  /** Events this campaign covers that were held that week. */
  events: Scalars["Int"]["output"];
  /** Members holding an invitation they did not create by signing up themselves. Counts everyone asked, including those who never replied. */
  invited: Scalars["Int"]["output"];
  /** The current week, still running — read its rate with caution. */
  partial: Scalars["Boolean"]["output"];
  /** Of those invited, how many accepted. */
  saidYes: Scalars["Int"]["output"];
  /** Everyone who attended those events, however they got there. */
  totalThere: Scalars["Int"]["output"];
  /** Monday of the week the events were held. */
  weekStarting: Scalars["Date"]["output"];
}

export interface CancelAttendanceInput {
  eventID?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CancellationGroupModel {
  /** Plan category (scheduled only). */
  category?: Maybe<Scalars["String"]["output"]>;
  count: Scalars["Int"]["output"];
  /** Stable key, e.g. 'efm:very_soon' or 'trial:zero'. */
  key: Scalars["String"]["output"];
  members: Array<CancellationMemberModel>;
  /** Group sub-heading. */
  subtitle?: Maybe<Scalars["String"]["output"]>;
  /** The editable template, with {name}/{end_date}/{link} placeholders. */
  template: Scalars["String"]["output"];
  /** Urgency tier (scheduled) or attendance tier (trial). */
  tier: Scalars["String"]["output"];
  /** Group heading. */
  title: Scalars["String"]["output"];
}

export interface CancellationMemberModel {
  country?: Maybe<Scalars["String"]["output"]>;
  /** Calendar days until her subscription ends. */
  daysLeft?: Maybe<Scalars["Int"]["output"]>;
  email: Scalars["String"]["output"];
  /** Her end date as it appears in the message, e.g. 'August 12'. */
  endDate: Scalars["String"]["output"];
  /** Subscription end, e.g. 2026-08-12. */
  endsAt?: Maybe<Scalars["Date"]["output"]>;
  /** Trial only: how many events she has actually attended. */
  eventsAttended?: Maybe<Scalars["Int"]["output"]>;
  firstName: Scalars["String"]["output"];
  /** Her message with {name}/{end_date}/{link} already filled in. */
  message: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  planId?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
}

export interface CancellationsResultModel {
  /** The look-ahead window used, in days. */
  days: Scalars["Int"]["output"];
  groups: Array<CancellationGroupModel>;
  /** 'scheduled' or 'trial'. */
  kind: Scalars["String"]["output"];
  total: Scalars["Int"]["output"];
}

export interface CapturedCampaignModel {
  campaign: Scalars["String"]["output"];
  messageCount: Scalars["Int"]["output"];
  replyCount: Scalars["Int"]["output"];
}

export interface CapturedConversationModel {
  campaigns: Array<Scalars["String"]["output"]>;
  lastFromOperator: Scalars["Boolean"]["output"];
  lastMessageAt: Scalars["Date"]["output"];
  lastText: Scalars["String"]["output"];
  memberEmail?: Maybe<Scalars["String"]["output"]>;
  memberId: Scalars["String"]["output"];
  memberName?: Maybe<Scalars["String"]["output"]>;
  messageCount: Scalars["Int"]["output"];
  replyCount: Scalars["Int"]["output"];
}

export interface CapturedMessageItemModel {
  campaign?: Maybe<Scalars["String"]["output"]>;
  fromOperator: Scalars["Boolean"]["output"];
  messageId: Scalars["String"]["output"];
  sentAt: Scalars["Date"]["output"];
  text: Scalars["String"]["output"];
}

export interface ChargeBeeAddress {
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  line1?: Maybe<Scalars["String"]["output"]>;
  line2?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  zip?: Maybe<Scalars["String"]["output"]>;
}

export interface ChargeBeeAddressInput {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  line1?: InputMaybe<Scalars["String"]["input"]>;
  line2?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  zip?: InputMaybe<Scalars["String"]["input"]>;
}

export interface ChargebeeCustomerModel {
  cbAddress?: Maybe<ChargeBeeAddress>;
  cbId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  oldId?: Maybe<Scalars["String"]["output"]>;
  paymentMethods: Array<ChargebeePaymentMethodModel>;
  promotionalCredits?: Maybe<Scalars["Int"]["output"]>;
  resourceVersion: Scalars["Date"]["output"];
  subscriptions: Array<ChargebeeSubscriptionModel>;
  user: UserModel;
}

export interface ChargebeePaymentMethodModel {
  card?: Maybe<Scalars["JSON"]["output"]>;
  cbCustomerId?: Maybe<Scalars["String"]["output"]>;
  cbId?: Maybe<Scalars["String"]["output"]>;
  cbObj?: Maybe<Scalars["JSON"]["output"]>;
  customer: ChargebeeCustomerModel;
  id: Scalars["String"]["output"];
  isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
  resourceVersion: Scalars["Date"]["output"];
  type?: Maybe<Scalars["String"]["output"]>;
}

export interface ChargebeeSubscriptionModel {
  billingCycleAnchor?: Maybe<Scalars["Date"]["output"]>;
  cancelReason?: Maybe<Scalars["String"]["output"]>;
  cancelScheduleCreatedAt?: Maybe<Scalars["Date"]["output"]>;
  cancelledAt?: Maybe<Scalars["Date"]["output"]>;
  cbCustomerId?: Maybe<Scalars["String"]["output"]>;
  cbId?: Maybe<Scalars["String"]["output"]>;
  cbPaymentMethodId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  currentPeriodEnd?: Maybe<Scalars["Date"]["output"]>;
  currentPeriodStart?: Maybe<Scalars["Date"]["output"]>;
  customer: ChargebeeCustomerModel;
  dueSince?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  plan?: Maybe<Scalars["JSON"]["output"]>;
  resourceVersion: Scalars["Date"]["output"];
  resumesAt?: Maybe<Scalars["Date"]["output"]>;
  scheduledPlan?: Maybe<Scalars["JSON"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export enum ChatAction {
  Invite = "Invite",
  Mention = "Mention",
  Thread = "Thread",
}

export enum ChatBulkSendStatus {
  Done = "done",
  Failed = "failed",
  Queued = "queued",
  Running = "running",
}

export enum ChatChannelType {
  Messaging = "messaging",
  Public = "public",
  UserPublic = "userPublic",
}

export interface ChatInviteInput {
  channelCid: Scalars["String"]["input"];
  channelName?: InputMaybe<Scalars["String"]["input"]>;
  userIds: Array<Scalars["String"]["input"]>;
}

export interface ChatInviteModel {
  actor?: Maybe<UserModel>;
  actorId?: Maybe<Scalars["String"]["output"]>;
  channelId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  status: ChatInviteStatus;
  updatedAt: Scalars["Date"]["output"];
  user?: Maybe<UserModel>;
  userId?: Maybe<Scalars["String"]["output"]>;
}

export enum ChatInviteStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Pending = "Pending",
}

export interface ChatInvitesForUsersInput {
  channelCid: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface ChatNotificationModel {
  actor?: Maybe<UserModel>;
  channelId?: Maybe<Scalars["String"]["output"]>;
  channelName?: Maybe<Scalars["String"]["output"]>;
  chatAction: ChatAction;
  chatMessage?: Maybe<Scalars["String"]["output"]>;
  chatMessageId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  parentChatMessageId?: Maybe<Scalars["String"]["output"]>;
  user: UserModel;
}

export enum ColourCode {
  Blue = "BLUE",
  Green = "GREEN",
  Orange = "ORANGE",
  Pink = "PINK",
  Red = "RED",
}

export enum CommentAction {
  Comment = "Comment",
  Mention = "Mention",
}

export interface CommentModel {
  author?: Maybe<UserModel>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  parent?: Maybe<CommentModel>;
  parentID?: Maybe<Scalars["String"]["output"]>;
  reactions?: Maybe<Array<CommentReactionsModel>>;
  replies?: Maybe<Array<CommentModel>>;
  targetArticle?: Maybe<ArticleModel>;
  targetEvent?: Maybe<EventModel>;
  targetId: Scalars["String"]["output"];
  targetTopic?: Maybe<TopicModel>;
  targetType: CommentTargetType;
  updatedAt: Scalars["Date"]["output"];
}

export interface CommentNotificationModel {
  actor?: Maybe<UserModel>;
  comment: CommentModel;
  commentAction: CommentAction;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export interface CommentReactionsModel {
  comment: CommentModel;
  commentId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  unifiedId: Scalars["String"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export enum CommentTargetType {
  Article = "Article",
  Event = "Event",
  Topic = "Topic",
}

/** How reliably a member shows up. */
export enum CommitmentLevel {
  BarelyCommitted = "BARELY_COMMITTED",
  ExtremelyCommitted = "EXTREMELY_COMMITTED",
  HighlyCommitted = "HIGHLY_COMMITTED",
  LightlyCommitted = "LIGHTLY_COMMITTED",
  ModeratelyCommitted = "MODERATELY_COMMITTED",
}

export interface CompletedVideoModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  user: UserModel;
  videoId: Scalars["String"]["output"];
}

export interface ConfirmGuestPassSignupInput {
  signUpId: Scalars["String"]["input"];
  termsAccepted: Scalars["Boolean"]["input"];
}

export interface ConfirmInPersonEventInput {
  status: InPersonEventConfirmationStatus;
  userIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface ConfirmTotpInput {
  deviceName: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
}

export enum ContactUsCategories {
  Events = "EVENTS",
  Feedback = "FEEDBACK",
  GeneralQuestion = "GENERAL_QUESTION",
  MyAccount = "MY_ACCOUNT",
  TechnicalSupport = "TECHNICAL_SUPPORT",
  TopicsAndLessons = "TOPICS_AND_LESSONS",
}

export interface ContactUsInput {
  category: ContactUsCategories;
  email: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  wantsNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export enum ConversationKind {
  CasualConversation = "CASUAL_CONVERSATION",
  DeepDive = "DEEP_DIVE",
  None = "NONE",
  StudyGroup = "STUDY_GROUP",
}

export interface ConversationPactModel {
  agreedPromises: Array<ConversationPactPromise>;
  completedAt?: Maybe<Scalars["Date"]["output"]>;
  version: Scalars["Int"]["output"];
}

export enum ConversationPactPromise {
  BeCurious = "BE_CURIOUS",
  BeFullyPresent = "BE_FULLY_PRESENT",
  BeRespectful = "BE_RESPECTFUL",
  BeWelcoming = "BE_WELCOMING",
}

export interface Coordinates {
  lat?: Maybe<Scalars["Float"]["output"]>;
  long?: Maybe<Scalars["Float"]["output"]>;
}

export interface CoverModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  primary?: Maybe<ResponsiveType>;
  secondary?: Maybe<ResponsiveType>;
  tertiary?: Maybe<ResponsiveType>;
  theme?: Maybe<Array<ThemeModel>>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface CreateArticlesAttachmentInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<MetaFileInput>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateBannerInput {
  title: Scalars["String"]["input"];
}

export interface CreateChannelInput {
  channelType?: InputMaybe<ChatChannelType>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  image?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  usersID?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface CreateCommentInput {
  mentions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  message: Scalars["String"]["input"];
  parentID?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateCoverInput {
  primary?: InputMaybe<ResponsiveInput>;
  secondary?: InputMaybe<ResponsiveInput>;
  tertiary?: InputMaybe<ResponsiveInput>;
  title: Scalars["String"]["input"];
}

export interface CreateEventAttachmentInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<MetaFileInput>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateEventInput {
  attachments?: InputMaybe<Array<CreateEventAttachmentInput>>;
  conversationKind?: InputMaybe<ConversationKind>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  createdFromTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  customTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevel>;
  eventCategory?: InputMaybe<EventCategory>;
  format?: InputMaybe<Format>;
  hostId?: InputMaybe<Scalars["String"]["input"]>;
  ideasToDiscuss?: InputMaybe<Array<Scalars["String"]["input"]>>;
  illustrationUrl?: InputMaybe<Scalars["String"]["input"]>;
  invitePeople?: InputMaybe<Scalars["Boolean"]["input"]>;
  isCoachEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isForUnverified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isLargeCall?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventKind>;
  links?: InputMaybe<Array<LinkInput>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  maxParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  peopleIDToInvite?: InputMaybe<Array<Scalars["String"]["input"]>>;
  permissions?: InputMaybe<Array<EventPermissions>>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  savedDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateFeatureFlagInput {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
}

export interface CreateIllustrationInput {
  title: Scalars["String"]["input"];
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateInviteInput {
  eventID: Scalars["String"]["input"];
  invitedByHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  isConfirmed?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHost?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  userID: Scalars["String"]["input"];
}

export interface CreateLessonInput {
  description?: InputMaybe<Scalars["String"]["input"]>;
  kind: LessonKind;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicID: Scalars["String"]["input"];
}

export interface CreateLikeInput {
  genericId: Scalars["String"]["input"];
  userId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateLiveTableInput {
  englishLevel?: InputMaybe<EventEnglishLevelNamed>;
  maxParticipants?: Scalars["Int"]["input"];
  questionId?: InputMaybe<Scalars["String"]["input"]>;
  timeLimit: TimeLimit;
  title: Scalars["String"]["input"];
}

export interface CreateMessageInput {
  description: Scalars["String"]["input"];
  receiver_id: Scalars["String"]["input"];
}

export interface CreateQuestionInput {
  question?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  type: QuestionType;
}

export interface CreateReactionInput {
  commentId: Scalars["String"]["input"];
  unifiedId: Scalars["String"]["input"];
}

export interface CreateSectionInput {
  elements?: InputMaybe<Array<ElementInput>>;
  lessonID: Scalars["String"]["input"];
  order: Scalars["Int"]["input"];
}

export interface CreateSparkInput {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  liveTableId?: InputMaybe<Scalars["String"]["input"]>;
  videoCallId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface CreateThemeInput {
  isGrammarLibrary: Scalars["Boolean"]["input"];
  isResource: Scalars["Boolean"]["input"];
  isStandard: Scalars["Boolean"]["input"];
  isTopicLibrary: Scalars["Boolean"]["input"];
  title: Scalars["String"]["input"];
}

export interface CreateTopicInput {
  title: Scalars["String"]["input"];
}

export interface CreateUserFeatureFlagInput {
  featureFlagId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface CreateUserInput {
  charges?: InputMaybe<Array<Scalars["String"]["input"]>>;
  detectedTimezone?: InputMaybe<Scalars["String"]["input"]>;
  eligibilityAgeGender?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  englishLevel: Scalars["Int"]["input"];
  firstEventBookingSkipped?: InputMaybe<Scalars["Boolean"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  guestPassWeeklyPracticeReadiness?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mainSpeakingPracticeChallenge?: InputMaybe<Scalars["String"]["input"]>;
  mainSpokenEnglishPriority?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  planParam: Scalars["String"]["input"];
  referredById?: InputMaybe<Scalars["String"]["input"]>;
  selectedFirstEventId?: InputMaybe<Scalars["String"]["input"]>;
  selectedFirstEventTime?: InputMaybe<Scalars["Date"]["input"]>;
  selectedTimezone?: InputMaybe<Scalars["String"]["input"]>;
  toltReferralId?: InputMaybe<Scalars["String"]["input"]>;
  trial?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface CreateVideoCallInput {
  channelType: ChatChannelType;
  chatRoomId: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
}

export interface CreateVideoInput {
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  videoSetId: Scalars["String"]["input"];
}

export interface CreateVideoSetInput {
  colour: ColourCode;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title: Scalars["String"]["input"];
}

export interface CreateWebpushSubscriptionInput {
  authKey: Scalars["String"]["input"];
  endpoint: Scalars["String"]["input"];
  p256hdKey: Scalars["String"]["input"];
}

export interface CreateZineInput {
  coverUrl: Scalars["String"]["input"];
}

export interface CrispIdentity {
  email: Scalars["String"]["output"];
  signature: Scalars["String"]["output"];
}

export interface CursorPaginatedNotifications {
  items: Array<NotificationBaseModel>;
  nextCursor?: Maybe<Scalars["Date"]["output"]>;
  total: Scalars["Int"]["output"];
}

export interface CustomNotificationDisplayModel {
  buttonText?: Maybe<Scalars["String"]["output"]>;
  buttonUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  illustration?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface CustomNotificationModel {
  customNotificationDisplay: CustomNotificationDisplayModel;
  id: Scalars["String"]["output"];
}

export interface CustomNotificationResponseType {
  sentTo: Scalars["Int"]["output"];
  warningMessages: Array<Scalars["String"]["output"]>;
}

export enum DailyEventTypes {
  BatchProcessorError = "BATCH_PROCESSOR_ERROR",
  BatchProcessorJobFinished = "BATCH_PROCESSOR_JOB_FINISHED",
  DialinConnected = "DIALIN_CONNECTED",
  DialinError = "DIALIN_ERROR",
  DialinStopped = "DIALIN_STOPPED",
  DialinWarning = "DIALIN_WARNING",
  DialoutAnswered = "DIALOUT_ANSWERED",
  DialoutConnected = "DIALOUT_CONNECTED",
  DialoutError = "DIALOUT_ERROR",
  DialoutStopped = "DIALOUT_STOPPED",
  DialoutWarning = "DIALOUT_WARNING",
  MeetingEnded = "MEETING_ENDED",
  MeetingStarted = "MEETING_STARTED",
  ParticipantJoined = "PARTICIPANT_JOINED",
  ParticipantLeft = "PARTICIPANT_LEFT",
  RecordingError = "RECORDING_ERROR",
  RecordingReadyToDownload = "RECORDING_READY_TO_DOWNLOAD",
  RecordingStarted = "RECORDING_STARTED",
  StreamingEnded = "STREAMING_ENDED",
  StreamingError = "STREAMING_ERROR",
  StreamingStarted = "STREAMING_STARTED",
  StreamingUpdated = "STREAMING_UPDATED",
  TranscriptError = "TRANSCRIPT_ERROR",
  TranscriptReadyToDownload = "TRANSCRIPT_READY_TO_DOWNLOAD",
  TranscriptStarted = "TRANSCRIPT_STARTED",
  WaitingParticipantJoined = "WAITING_PARTICIPANT_JOINED",
  WaitingParticipantLeft = "WAITING_PARTICIPANT_LEFT",
}

export interface DailyMeetingInput {
  id: Scalars["String"]["input"];
  userID: Scalars["String"]["input"];
}

export interface DailyWebHookType {
  createdAt: Scalars["String"]["output"];
  eventTypes: Array<Scalars["String"]["output"]>;
  retryType: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
  uuid: Scalars["String"]["output"];
}

export interface DatetimeFilters {
  gt?: InputMaybe<Scalars["Date"]["input"]>;
  lt?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface DeactivateInput {
  otherReason: Scalars["String"]["input"];
  reason: Array<UserDeactivationReason>;
}

export interface DeclineInviteInput {
  inviteID?: InputMaybe<Scalars["String"]["input"]>;
}

export enum DeepDiveKind {
  RolePlay = "ROLE_PLAY",
  Roundtable = "ROUNDTABLE",
  ShareAndCompare = "SHARE_AND_COMPARE",
  SolveAProblem = "SOLVE_A_PROBLEM",
}

export interface DeleteInvitesInput {
  eventId: Scalars["String"]["input"];
  isHost: Scalars["Boolean"]["input"];
}

export interface DeletePhotoInput {
  id: Scalars["String"]["input"];
}

export interface DeleteTopicsInput {
  topicIds: Array<Scalars["String"]["input"]>;
}

export interface DunningStatusUpdatedResponse {
  dunning: Scalars["Boolean"]["output"];
  userId: Scalars["String"]["output"];
}

export interface DuplicateLessonInput {
  lessonId: Scalars["String"]["input"];
  topicId: Scalars["String"]["input"];
}

export interface EditArticleInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  myEnglishJourney?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledFor?: InputMaybe<Scalars["Date"]["input"]>;
  tags?: InputMaybe<Array<Interest>>;
  theme?: InputMaybe<ArticleThemes>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditArticlesAttachmentInput {
  description: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface EditBannerInput {
  audience?: InputMaybe<Array<EventPermissions>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditCommentInput {
  message: Scalars["String"]["input"];
}

export interface EditCoverInput {
  primary?: InputMaybe<ResponsiveInput>;
  secondary?: InputMaybe<ResponsiveInput>;
  tertiary?: InputMaybe<ResponsiveInput>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditCustomNotificationDisplayInput {
  buttonText?: InputMaybe<Scalars["String"]["input"]>;
  buttonUrl?: InputMaybe<Scalars["String"]["input"]>;
  illustration?: InputMaybe<Scalars["String"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditEventInput {
  conversationKind?: InputMaybe<ConversationKind>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevel>;
  eventCategory?: InputMaybe<EventCategory>;
  eventLessonKind?: InputMaybe<EventLessonKind>;
  hostId?: InputMaybe<Scalars["String"]["input"]>;
  ideasToDiscuss?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isForUnverified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventKind>;
  links?: InputMaybe<Array<LinkInput>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["Any"]["input"]>;
  noParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  permissions?: InputMaybe<Array<EventPermissions>>;
  recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditFeatureFlagInput {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
}

export interface EditIllustrationInput {
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditLessonInput {
  deepDiveKind?: InputMaybe<DeepDiveKind>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  kind?: InputMaybe<LessonKind>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicID?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditQuestionInput {
  id: Scalars["String"]["input"];
  question?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditSectionInput {
  elements?: InputMaybe<Array<ElementInput>>;
  lessonID?: InputMaybe<Scalars["String"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface EditSliderInput {
  background?: InputMaybe<ResponsiveInput>;
  buttonText?: InputMaybe<Scalars["String"]["input"]>;
  buttonURL?: InputMaybe<Scalars["String"]["input"]>;
  featureImage?: InputMaybe<Scalars["String"]["input"]>;
  imageAlignment?: InputMaybe<Scalars["String"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  subtitle?: InputMaybe<Scalars["String"]["input"]>;
  textColour?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  titleStyle?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditThemeInput {
  coverId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGrammarLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResource?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStandard?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditTopicInput {
  illustrationId?: InputMaybe<Scalars["String"]["input"]>;
  stars?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<TopicStatus>;
  themeId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditUserFeatureFlagInput {
  featureFlagId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface EditUserInput {
  availability?: InputMaybe<Array<AvailabilityInput>>;
  avatarUrl?: InputMaybe<Scalars["String"]["input"]>;
  badge?: InputMaybe<UserBadge>;
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  createdAt?: InputMaybe<Scalars["Date"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  extraConversations?: InputMaybe<Scalars["Int"]["input"]>;
  extraHostedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  isAgeVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHeyLady?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventPermissions>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<Scalars["String"]["input"]>;
  needSpeakingPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  occupationId?: InputMaybe<Scalars["String"]["input"]>;
  otherLanguage?: InputMaybe<Scalars["String"]["input"]>;
  pauseCredits?: InputMaybe<Scalars["Int"]["input"]>;
  showBirthday?: InputMaybe<Scalars["Boolean"]["input"]>;
  showBirthdayYear?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  story?: InputMaybe<Scalars["String"]["input"]>;
  wantsNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface EditVideoInput {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  thumbnail?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  videoSetID?: InputMaybe<Scalars["String"]["input"]>;
  videoURL?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditVideoSetInput {
  audience?: InputMaybe<Array<Audience>>;
  colour?: InputMaybe<ColourCode>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  position?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface EditZineInput {
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface Element {
  kind: ElementKind;
  meta: Scalars["JSON"]["output"];
  value?: Maybe<Scalars["Any"]["output"]>;
}

export interface ElementInput {
  kind: ElementKind;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  value?: InputMaybe<Scalars["Any"]["input"]>;
}

export enum ElementKind {
  Attachment = "ATTACHMENT",
  Banner = "BANNER",
  Button = "BUTTON",
  Divider = "DIVIDER",
  Embedded = "EMBEDDED",
  Grid = "GRID",
  Ideas = "IDEAS",
  Image = "IMAGE",
  ImageAndButton = "IMAGE_AND_BUTTON",
  Layout = "LAYOUT",
  Links = "LINKS",
  Paragraph = "PARAGRAPH",
  Questions = "QUESTIONS",
  Spacing = "SPACING",
  Title = "TITLE",
  Video = "VIDEO",
}

export enum EmailNotifications {
  Digest = "DIGEST",
  Inactive = "INACTIVE",
  Spot = "SPOT",
}

/** How much a member uses the platform. */
export enum EngagementLevel {
  E1PowerUser = "E1_POWER_USER",
  E2HighlyEngaged = "E2_HIGHLY_ENGAGED",
  E3ModeratelyEngaged = "E3_MODERATELY_ENGAGED",
  E4LightlyEngaged = "E4_LIGHTLY_ENGAGED",
  E5NeverEngaged = "E5_NEVER_ENGAGED",
  Unknown = "UNKNOWN",
}

export enum EnglishLevel {
  A1 = "A1",
  A2 = "A2",
  B1 = "B1",
  B2 = "B2",
  C1 = "C1",
  C2 = "C2",
}

export enum EnglishLevelMatch {
  Different = "Different",
  Same = "Same",
  Similar = "Similar",
}

export enum EnglishSkill {
  GivingAPresentation = "GIVING_A_PRESENTATION",
  InterviewOrBeInterviewed = "INTERVIEW_OR_BE_INTERVIEWED",
  IntroduceMyself = "INTRODUCE_MYSELF",
  MeetNewPeople = "MEET_NEW_PEOPLE",
  NegotiateAndDebate = "NEGOTIATE_AND_DEBATE",
  PassAnEnglishExam = "PASS_AN_ENGLISH_EXAM",
  PersonalNetworking = "PERSONAL_NETWORKING",
  Pronunciation = "PRONUNCIATION",
  SpeakConfidentlyAtWork = "SPEAK_CONFIDENTLY_AT_WORK",
  ThinkInEnglish = "THINK_IN_ENGLISH",
  UnderstandMoviesAndMusic = "UNDERSTAND_MOVIES_AND_MUSIC",
  UnderstandNativeSpeakers = "UNDERSTAND_NATIVE_SPEAKERS",
  WriteCreatively = "WRITE_CREATIVELY",
  WriteProfessionally = "WRITE_PROFESSIONALLY",
}

export interface EntityIdResponseType {
  id: Scalars["String"]["output"];
}

export interface EventAttachmentModel {
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  event: EventModel;
  id: Scalars["String"]["output"];
  meta?: Maybe<MetaFileType>;
  updatedAt: Scalars["Date"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
}

export enum EventCategory {
  Featured = "FEATURED",
  NewMember = "NEW_MEMBER",
  None = "NONE",
}

export interface EventDoorStatus {
  closedDoorAt?: Maybe<Scalars["Date"]["output"]>;
}

export enum EventEnglishLevel {
  Advanced = "ADVANCED",
  Everyone = "EVERYONE",
  Intermediate = "INTERMEDIATE",
}

export enum EventEnglishLevelFilter {
  Advanced = "ADVANCED",
  All = "ALL",
  AnyLevel = "ANY_LEVEL",
  Intermediate = "INTERMEDIATE",
}

export enum EventEnglishLevelNamed {
  Advanced = "ADVANCED",
  AnyLevel = "ANY_LEVEL",
  Intermediate = "INTERMEDIATE",
}

export interface EventForMemberModel {
  connectionScore: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  hostBadge?: Maybe<Scalars["String"]["output"]>;
  hostName?: Maybe<Scalars["String"]["output"]>;
  inHerZone: Scalars["Boolean"]["output"];
  isFull: Scalars["Boolean"]["output"];
  kind: Scalars["String"]["output"];
  labels: Array<EventLabelModel>;
  /** Her local hour for the event. */
  localHour?: Maybe<Scalars["Int"]["output"]>;
  /** 'label' (topic match) or 'zone' (also-in-zone fill). */
  matchBasis: Scalars["String"]["output"];
  spotsLeft?: Maybe<Scalars["Int"]["output"]>;
  startsAt: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  /** Why she'd enjoy it — specific reasons. */
  why: Array<Scalars["String"]["output"]>;
  zone: ZoneLabel;
}

export enum EventHostedByFilter {
  Anyone = "ANYONE",
  BigSisters = "BIG_SISTERS",
  HlCoach = "HL_COACH",
  HlMembers = "HL_MEMBERS",
  HlTeam = "HL_TEAM",
  PeopleIFollow = "PEOPLE_I_FOLLOW",
}

export interface EventInsightModel {
  /** Big Sister / Coach / CXT / Member. */
  hostType: Scalars["String"]["output"];
  isFull: Scalars["Boolean"]["output"];
  /** How the labels were found (series / keyword / host / none). */
  labelSource: Scalars["String"]["output"];
  /** Topic / skill labels for this event. */
  labels: Array<EventLabelModel>;
  /** Target level: Intermediate / Advanced / All levels. */
  level: Scalars["String"]["output"];
  maxParticipants?: Maybe<Scalars["Int"]["output"]>;
  /** Members signed up (host excluded). */
  registered: Scalars["Int"]["output"];
  unlimited: Scalars["Boolean"]["output"];
  /** Members / Members + trial / Private. */
  visibility: Scalars["String"]["output"];
  /** The zone its start time falls in. */
  zone: ZoneLabel;
}

export enum EventKind {
  CoachConversations = "COACH_CONVERSATIONS",
  CoachWorkshop = "COACH_WORKSHOP",
  ConversationsOverCoffee = "CONVERSATIONS_OVER_COFFEE",
  Custom = "CUSTOM",
  FifteenMinutes = "FIFTEEN_MINUTES",
  GrammarSpot = "GRAMMAR_SPOT",
  Interview = "INTERVIEW",
  InPerson = "IN_PERSON",
  NewMemberWelcome = "NEW_MEMBER_WELCOME",
  OfficeHours = "OFFICE_HOURS",
  OneToOne = "ONE_TO_ONE",
  SpeakingEvent = "SPEAKING_EVENT",
  StudyEvent = "STUDY_EVENT",
}

export interface EventLabelModel {
  family: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
}

export enum EventLessonKind {
  DeepDive = "DEEP_DIVE",
  Overview = "OVERVIEW",
  Vocabulary = "VOCABULARY",
}

export interface EventMatchModel {
  /** How strongly this member connects to the event's topic. */
  connectionScore: Scalars["Int"]["output"];
  country?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  /** Very active / Active / Occasional / Quiet lately. */
  engagement: Scalars["String"]["output"];
  /** Intermediate / Advanced / — (all levels). */
  englishBand: Scalars["String"]["output"];
  eventsAttended: Scalars["Int"]["output"];
  /** Events attended in the last 90 days. */
  eventsRecent: Scalars["Int"]["output"];
  industry?: Maybe<Scalars["String"]["output"]>;
  /** In her first 90 days. */
  isNewcomer: Scalars["Boolean"]["output"];
  /** Her local hour for this event. */
  localHour?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  occupation?: Maybe<Scalars["String"]["output"]>;
  /** 4+ recent invites/shares — unticked by default. */
  overContacted: Scalars["Boolean"]["output"];
  /** Still-upcoming invites/shares to her in the last 14 days. */
  recentNotifs: Scalars["Int"]["output"];
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  /** The word in her profile that matched. */
  storyMatch?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  /** Why she matched — specific reasons. */
  why: Array<Scalars["String"]["output"]>;
  zone?: Maybe<ZoneLabel>;
}

export interface EventMatchResultModel {
  /** Candidates below/above the event's English level. */
  englishFiltered: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  /** The event's level band, or '' for all levels. */
  eventLevel: Scalars["String"]["output"];
  eventZone: ZoneLabel;
  /** Candidates who can't access the event. */
  excludedCantAccess: Scalars["Int"]["output"];
  isFull: Scalars["Boolean"]["output"];
  /** How the labels were found (series / keyword / host / none). */
  labelSource: Scalars["String"]["output"];
  /** What the event is about. */
  labels: Array<EventLabelModel>;
  /** 'label' (matched on topic) or 'zone' (no topic, fell back). */
  matchBasis: Scalars["String"]["output"];
  matches: Array<EventMatchModel>;
  maxParticipants: Scalars["Int"]["output"];
  /** Candidates past their first 3 months — a New Member Welcome isn't for them. */
  newcomerFiltered: Scalars["Int"]["output"];
  /** Candidates whose local time is 11pm–7am. */
  quietFiltered: Scalars["Int"]["output"];
  spotsLeft?: Maybe<Scalars["Int"]["output"]>;
  spotsTaken: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  /** Eligible matches before the display limit. */
  totalMatches: Scalars["Int"]["output"];
}

export interface EventModel {
  addedToCalendar: Scalars["Boolean"]["output"];
  attachments?: Maybe<Array<EventAttachmentModel>>;
  closedDoorAt?: Maybe<Scalars["Date"]["output"]>;
  cohosts: Array<UserModel>;
  comments?: Maybe<Array<CommentModel>>;
  confirmationStatus?: Maybe<InPersonEventConfirmationStatus>;
  conversationKind?: Maybe<ConversationKind>;
  coverUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  createdFromTopic?: Maybe<Scalars["Boolean"]["output"]>;
  customTopic?: Maybe<Scalars["Boolean"]["output"]>;
  declined: Array<UserModel>;
  deletedNote?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duplicateOf?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["Date"]["output"]>;
  endedAt?: Maybe<Scalars["Date"]["output"]>;
  englishLevel?: Maybe<EventEnglishLevel>;
  englishSkills?: Maybe<Array<EnglishSkill>>;
  eventCategory?: Maybe<EventCategory>;
  eventLessonKind?: Maybe<EventLessonKind>;
  eventParticipants: Array<EventParticipantModel>;
  format?: Maybe<Format>;
  guestPassAccess?: Maybe<GuestPassEventAccess>;
  hasSharedEventNotification?: Maybe<Scalars["Boolean"]["output"]>;
  host?: Maybe<UserModel>;
  id: Scalars["String"]["output"];
  ideasToDiscuss?: Maybe<Array<Scalars["String"]["output"]>>;
  illustrationUrl?: Maybe<Scalars["String"]["output"]>;
  interests?: Maybe<Array<Interest>>;
  invited: Array<UserModel>;
  invites?: Maybe<Array<InviteModel>>;
  isCoachEvent?: Maybe<Scalars["Boolean"]["output"]>;
  isDeleted?: Maybe<Scalars["Boolean"]["output"]>;
  isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  isForUnverified?: Maybe<Scalars["Boolean"]["output"]>;
  isFull?: Maybe<Scalars["Boolean"]["output"]>;
  isLargeCall?: Maybe<Scalars["Boolean"]["output"]>;
  isProfessional?: Maybe<Scalars["Boolean"]["output"]>;
  isPublic?: Maybe<Scalars["Boolean"]["output"]>;
  kind?: Maybe<EventKind>;
  likes?: Maybe<Array<LikeModel>>;
  links?: Maybe<Array<Link>>;
  location?: Maybe<Scalars["String"]["output"]>;
  locationId?: Maybe<Scalars["String"]["output"]>;
  locationLat?: Maybe<Scalars["Float"]["output"]>;
  locationLong?: Maybe<Scalars["Float"]["output"]>;
  maxParticipants?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  noCountableParticipants?: Maybe<Scalars["Int"]["output"]>;
  noParticipants?: Maybe<Scalars["Int"]["output"]>;
  occupations?: Maybe<Array<OccupationModel>>;
  organizer?: Maybe<UserModel>;
  participants: Array<UserModel>;
  permissions?: Maybe<Array<EventPermissions>>;
  recurring?: Maybe<Scalars["Boolean"]["output"]>;
  savedDraft?: Maybe<Scalars["Boolean"]["output"]>;
  series?: Maybe<EventSeriesModel>;
  seriesEvents?: Maybe<Array<EventModel>>;
  seriesId?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["Date"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  topic?: Maybe<TopicModel>;
  updatedAt: Scalars["Date"]["output"];
  videoUrl?: Maybe<Scalars["String"]["output"]>;
}

export enum EventNotificationAction {
  Cohosting = "Cohosting",
  ConfirmInPersonEvent = "ConfirmInPersonEvent",
  Delete = "Delete",
  FollowingIsHosting = "FollowingIsHosting",
  HostRemoveCohost = "HostRemoveCohost",
  HostRemoveParticipant = "HostRemoveParticipant",
  InApp1HourBeforeEvent = "InApp1HourBeforeEvent",
  InApp10MinBeforeEvent = "InApp10MinBeforeEvent",
  Invite = "Invite",
  OneToOneNoResponse = "OneToOneNoResponse",
  RecurringResponse = "RecurringResponse",
  SharedEvent = "SharedEvent",
  Update = "Update",
  UserAccept = "UserAccept",
  UserDecline = "UserDecline",
  Web1HourBeforeEvent = "Web1HourBeforeEvent",
  Web10MinBeforeEvent = "Web10MinBeforeEvent",
}

export interface EventNotificationModel {
  action: EventNotificationAction;
  actor?: Maybe<UserModel>;
  event?: Maybe<EventModel>;
  id: Scalars["String"]["output"];
  invite?: Maybe<InviteModel>;
  seriesId?: Maybe<Scalars["String"]["output"]>;
  user: UserModel;
}

export interface EventParticipantModel {
  createdAt: Scalars["Date"]["output"];
  event: EventModel;
  eventId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export enum EventPermissions {
  BigSister = "BIG_SISTER",
  HeyLadyAdmin = "HEY_LADY_ADMIN",
  HeyLadyTeam = "HEY_LADY_TEAM",
  InactiveMember = "INACTIVE_MEMBER",
  MoreThanTwelveMonths = "MORE_THAN_TWELVE_MONTHS",
  OneToThree = "ONE_TO_THREE",
  ThreeToTwelve = "THREE_TO_TWELVE",
  ZeroToOne = "ZERO_TO_ONE",
}

export interface EventSeriesModel {
  createdAt: Scalars["Date"]["output"];
  events?: Maybe<Array<EventModel>>;
  id: Scalars["String"]["output"];
  inviteToAllRecurring: Scalars["Boolean"]["output"];
  parentEventId?: Maybe<Scalars["String"]["output"]>;
  recurrenceCount?: Maybe<Scalars["Int"]["output"]>;
  recurrenceDays?: Maybe<Array<WeekDay>>;
  recurrenceEndDate?: Maybe<Scalars["Date"]["output"]>;
  recurrenceEndType: RecurrenceEndType;
  recurrenceInterval: Scalars["Int"]["output"];
  recurrenceType: RecurrenceType;
  updatedAt: Scalars["Date"]["output"];
}

export enum EventTimeFilter {
  Afternoon = "Afternoon",
  Custom = "Custom",
  Evening = "Evening",
  Morning = "Morning",
  Night = "Night",
}

export interface EventTimezoneSupplyModel {
  /** The look-ahead window, in days. */
  days: Scalars["Int"]["output"];
  /** Every upcoming public event in the window. */
  events: Array<TzEventModel>;
  hostTypes: Array<HostTypeOptionModel>;
  /** Members grouped by UTC offset, biggest region first. */
  regions: Array<TzRegionModel>;
}

export enum EventTopicFilter {
  All = "ALL",
  HlTopics = "HL_TOPICS",
  Other = "OTHER",
}

export enum EventTypeFilter {
  AllEventTypes = "ALL_EVENT_TYPES",
  Conversation = "CONVERSATION",
  DeepDive = "DEEP_DIVE",
  InPerson = "IN_PERSON",
  ListenOnly = "LISTEN_ONLY",
  NewMemberMeetup = "NEW_MEMBER_MEETUP",
  Professional = "PROFESSIONAL",
  StudyAndLearn = "STUDY_AND_LEARN",
}

export interface EventUpdatedResponse {
  eventAndInvites?: Maybe<EventModel>;
  eventDoorStatus?: Maybe<EventDoorStatus>;
}

export interface EventsForMemberResultModel {
  /** Events hidden because she can't join them. */
  hiddenCantJoin: Scalars["Int"]["output"];
  /** New Member Welcomes hidden because she's past her first 3 months. */
  hiddenPastNewcomerWindow: Scalars["Int"]["output"];
  /** Events hidden because they fall in her 11pm–7am. */
  hiddenQuietHours: Scalars["Int"]["output"];
  /** Events hidden as pitched at another English level. */
  hiddenWrongLevel: Scalars["Int"]["output"];
  matches: Array<EventForMemberModel>;
  member: MemberProfileModel;
  /** How many of the matches connect on topic (vs zone only). */
  topicMatchCount: Scalars["Int"]["output"];
}

export enum EventsOrderBy {
  Created = "CREATED",
  EndDate = "END_DATE",
  InvitedFirst = "INVITED_FIRST",
  StartDate = "START_DATE",
  Updated = "UPDATED",
}

export interface EventsPerDay {
  count: Scalars["Int"]["output"];
  day: Scalars["Date"]["output"];
}

/** How close a member is to drifting away. */
export enum FaderLevel {
  Cancelled = "CANCELLED",
  Critical = "CRITICAL",
  Detected = "DETECTED",
  Dormant = "DORMANT",
  New_3PlusEvents = "NEW_3_PLUS_EVENTS",
  NewBelow_3Events = "NEW_BELOW_3_EVENTS",
  NewNeverAttended = "NEW_NEVER_ATTENDED",
  Paused = "PAUSED",
  RecentlyEngaged = "RECENTLY_ENGAGED",
  Trial_3PlusEvents = "TRIAL_3_PLUS_EVENTS",
  TrialBelow_3Events = "TRIAL_BELOW_3_EVENTS",
  TrialNeverAttended = "TRIAL_NEVER_ATTENDED",
}

export interface FeatureFlagModel {
  active?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  users: Array<UserFlagModel>;
}

export interface FilterArticlesInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  byAuthor?: InputMaybe<ArticleByAuthor>;
  category?: InputMaybe<ArticleCategory>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FilterChatInvitesInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FilterCustomNotificationDisplayInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FilterPaginatedEventInput {
  customTimeFrom?: InputMaybe<Scalars["String"]["input"]>;
  customTimeUntil?: InputMaybe<Scalars["String"]["input"]>;
  duration?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  englishLevel?: InputMaybe<EventEnglishLevelFilter>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  eventDate?: InputMaybe<Scalars["Date"]["input"]>;
  eventTime?: InputMaybe<Array<EventTimeFilter>>;
  featured?: InputMaybe<Scalars["Boolean"]["input"]>;
  groupStudy?: InputMaybe<Scalars["Boolean"]["input"]>;
  hostId?: InputMaybe<Scalars["String"]["input"]>;
  hostedBy?: InputMaybe<EventHostedByFilter>;
  interests?: InputMaybe<Array<Interest>>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPast?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  matchEnglishLevel?: InputMaybe<Scalars["Boolean"]["input"]>;
  occupationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  organizerId?: InputMaybe<Scalars["String"]["input"]>;
  showFullEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicFilter?: InputMaybe<EventTopicFilter>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<EventTypeFilter>;
  userInviteStatus?: InputMaybe<UserInviteStatus>;
  withSharedEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface FilterThemesInput {
  isCurrent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGrammarLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  isResource?: InputMaybe<Scalars["Boolean"]["input"]>;
  isStandard?: InputMaybe<Scalars["Boolean"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface FilterTopicsInput {
  excludeTheme?: InputMaybe<Scalars["String"]["input"]>;
  includeTheme?: InputMaybe<Scalars["String"]["input"]>;
  isTopicLibrary?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface FilterUsersInput {
  availability?: InputMaybe<Array<AvailabilityStatus>>;
  englishLevels?: InputMaybe<Array<SpeakingLevelCategories>>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  following?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasProfilePicture?: InputMaybe<Scalars["Boolean"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isOnline?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<Array<EventPermissions>>;
  lastOnlineAt?: InputMaybe<DatetimeFilters>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location?: InputMaybe<Array<UserLocation>>;
  occupations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface FollowInput {
  followingId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface FollowerModel {
  createdAt: Scalars["Date"]["output"];
  follower: UserModel;
  following: UserModel;
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export enum Format {
  InPerson = "IN_PERSON",
  ListenOnly = "LISTEN_ONLY",
  Meeting = "MEETING",
}

export interface FriendInput {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
}

export interface FriendJoinedNotificationModel {
  friend: UserModel;
  id: Scalars["String"]["output"];
  type: FriendJoinedNotificationType;
  user: UserModel;
}

export enum FriendJoinedNotificationType {
  AcceptedInvite = "AcceptedInvite",
  BringAFriendThanks = "BringAFriendThanks",
  FriendDidNotJoin = "FriendDidNotJoin",
  FriendJoined = "FriendJoined",
}

export interface FriendlyFaces {
  attended?: Maybe<Scalars["Int"]["output"]>;
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
}

export interface GenericResponseType {
  reason?: Maybe<Scalars["String"]["output"]>;
  status: MutationStatus;
}

export enum GoogleApiMessage {
  CalendarAlreadyAdded = "CALENDAR_ALREADY_ADDED",
  CalendarNotFound = "CALENDAR_NOT_FOUND",
  EventAlreadyAdded = "EVENT_ALREADY_ADDED",
  EventNotFound = "EVENT_NOT_FOUND",
  InvalidGrant = "INVALID_GRANT",
  InviteNotFound = "INVITE_NOT_FOUND",
  Success = "SUCCESS",
  Unauthorized = "UNAUTHORIZED",
}

export interface GoogleCalendarModel {
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  etag?: Maybe<Scalars["String"]["output"]>;
  googleId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  kind?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface GoogleEventModel {
  createdAt: Scalars["Date"]["output"];
  endDate?: Maybe<Scalars["String"]["output"]>;
  etag?: Maybe<Scalars["String"]["output"]>;
  event?: Maybe<EventModel>;
  googleCalendar?: Maybe<GoogleCalendarModel>;
  googleId?: Maybe<Scalars["String"]["output"]>;
  hostID?: Maybe<Scalars["String"]["output"]>;
  iCalUID?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  invite: InviteModel;
  kind?: Maybe<Scalars["String"]["output"]>;
  link?: Maybe<Scalars["String"]["output"]>;
  organizerID?: Maybe<Scalars["String"]["output"]>;
  reminders?: Maybe<Scalars["JSON"]["output"]>;
  startDate?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface GrantGuestPassTokensInput {
  amount: Scalars["Int"]["input"];
  reason: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface GuestPassBookingEvent {
  durationMinutes: Scalars["Int"]["output"];
  endDate: Scalars["Date"]["output"];
  format: Format;
  id: Scalars["String"]["output"];
  kind: EventKind;
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
}

export interface GuestPassEventAccess {
  consumesToken: Scalars["Boolean"]["output"];
  status: GuestPassEventAccessStatus;
}

export enum GuestPassEventAccessStatus {
  AfterGuestPass = "AFTER_GUEST_PASS",
  Available = "AVAILABLE",
  MembersOnly = "MEMBERS_ONLY",
  TokensExhausted = "TOKENS_EXHAUSTED",
}

export interface GuestPassSignupResult {
  email: Scalars["String"]["output"];
  guestPass: GuestPassSummary;
  hasVerifiedEmail: Scalars["Boolean"]["output"];
}

export interface GuestPassSummary {
  canActivateMembership: Scalars["Boolean"]["output"];
  canRestartGuestPass: Scalars["Boolean"]["output"];
  daysRemaining: Scalars["Int"]["output"];
  endsAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  shouldShowCompletionModal: Scalars["Boolean"]["output"];
  startsAt: Scalars["Date"]["output"];
  tokenAllowance: Scalars["Int"]["output"];
  tokensRemaining: Scalars["Int"]["output"];
  tokensUsed: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
}

export interface GuestPassTokenAdjustment {
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  grantedByEmail?: Maybe<Scalars["String"]["output"]>;
  grantedById: Scalars["String"]["output"];
  grantedByName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  reason: Scalars["String"]["output"];
}

export enum HomeCheckInAnswer {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
}

export enum HomeCheckInFollowUp {
  DidNotSpeakMuch = "DID_NOT_SPEAK_MUCH",
  FeltUncomfortable = "FELT_UNCOMFORTABLE",
  FirstTime = "FIRST_TIME",
  Introvert = "INTROVERT",
  MyLevel = "MY_LEVEL",
  SomethingElse = "SOMETHING_ELSE",
  TechnicalIssue = "TECHNICAL_ISSUE",
}

export enum HomeCheckInKind {
  AfterFirstEvent = "AFTER_FIRST_EVENT",
  BeforeFirstEvent = "BEFORE_FIRST_EVENT",
  SoFar = "SO_FAR",
}

export interface HomeCheckInModel {
  answer: HomeCheckInAnswer;
  answeredAt: Scalars["Date"]["output"];
  dismissedAt?: Maybe<Scalars["Date"]["output"]>;
  followUp?: Maybe<HomeCheckInFollowUp>;
  followUpAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  kind: HomeCheckInKind;
}

export interface HostTypeOptionModel {
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
}

export interface IllustrationModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  topics?: Maybe<Array<TopicModel>>;
  updatedAt: Scalars["Date"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
}

export enum ImageAlignment {
  Left = "Left",
  Right = "Right",
}

export interface ImportUserInput {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  extraConversations?: InputMaybe<Scalars["Int"]["input"]>;
  extraHostedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventPermissions>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  priceId?: InputMaybe<Scalars["String"]["input"]>;
  trialDays?: InputMaybe<Scalars["Int"]["input"]>;
}

export enum InPersonEventConfirmationStatus {
  Hosted = "Hosted",
  Initial = "Initial",
  NotHosted = "NotHosted",
}

export interface Industry {
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  occupations: Array<OccupationModel>;
}

export interface IndustryInput {
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  occupations: Array<OccupationInput>;
}

export interface InitiateAssessmentResponse {
  assessmentId: Scalars["String"]["output"];
  assessmentUrl: Scalars["String"]["output"];
}

export enum Interest {
  AnimalsAndWildlife = "ANIMALS_AND_WILDLIFE",
  ArtsAndCrafts = "ARTS_AND_CRAFTS",
  BeautyAndFashion = "BEAUTY_AND_FASHION",
  BusinessAndEntrepreneurship = "BUSINESS_AND_ENTREPRENEURSHIP",
  CareersAndProfessionalDevelopment = "CAREERS_AND_PROFESSIONAL_DEVELOPMENT",
  Design = "DESIGN",
  DifferentCultures = "DIFFERENT_CULTURES",
  Economics = "ECONOMICS",
  EnvironmentalIssues = "ENVIRONMENTAL_ISSUES",
  Equality = "EQUALITY",
  FamilyAndMotherhood = "FAMILY_AND_MOTHERHOOD",
  FeminismAndEmpowerment = "FEMINISM_AND_EMPOWERMENT",
  FoodAndCooking = "FOOD_AND_COOKING",
  Games = "GAMES",
  GoalsSettingAndSuccess = "GOALS_SETTING_AND_SUCCESS",
  HealthAndWellness = "HEALTH_AND_WELLNESS",
  Hiking = "HIKING",
  History = "HISTORY",
  HomeAndGardening = "HOME_AND_GARDENING",
  Ielts = "IELTS",
  Languages = "LANGUAGES",
  Leadership = "LEADERSHIP",
  LivingAbroad = "LIVING_ABROAD",
  LoveAndRelationships = "LOVE_AND_RELATIONSHIPS",
  MoviesAndTvShows = "MOVIES_AND_TV_SHOWS",
  MusicAndDance = "MUSIC_AND_DANCE",
  NatureAndTheEnvironment = "NATURE_AND_THE_ENVIRONMENT",
  PersonalDevelopment = "PERSONAL_DEVELOPMENT",
  Photography = "PHOTOGRAPHY",
  Politics = "POLITICS",
  Psychology = "PSYCHOLOGY",
  Reading = "READING",
  ScienceAndTechnology = "SCIENCE_AND_TECHNOLOGY",
  Spirituality = "SPIRITUALITY",
  Sports = "SPORTS",
  SustainableLiving = "SUSTAINABLE_LIVING",
  TheatreAndPerformance = "THEATRE_AND_PERFORMANCE",
  Travel = "TRAVEL",
  VideoGames = "VIDEO_GAMES",
  VolunteeringAndCharity = "VOLUNTEERING_AND_CHARITY",
  Writing = "WRITING",
}

/** Which invitation list to build. */
export enum InviteCampaignKey {
  Coach = "COACH",
  CxtBigSister = "CXT_BIG_SISTER",
  HowToStudy = "HOW_TO_STUDY",
  Nmw = "NMW",
}

export interface InviteCampaignMemberModel {
  /** The event starts after her Guest Pass ends. */
  afterPass: Scalars["Boolean"]["output"];
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** She's on a Guest Pass. */
  isGuest: Scalars["Boolean"]["output"];
  /** Why she's on the list at all, when the list's own rule wouldn't have her — a Guest it had gone quiet on. */
  note?: Maybe<Scalars["String"]["output"]>;
  /** For an extra invitation: 'second' (nearer than her best one) or 'weekend'. */
  option?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  /** Why the invitation rules picked this event for her. */
  why?: Maybe<Scalars["String"]["output"]>;
}

export interface InviteCampaignZoneModel {
  /** Null when nothing is scheduled yet. */
  eventId?: Maybe<Scalars["String"]["output"]>;
  eventStartDate?: Maybe<Scalars["Date"]["output"]>;
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  /** Members this event is an EXTRA invitation for — nearer than their best one, or a weekend one for a Guest. Not included in 'Invite all'. */
  extraMembers: Array<InviteCampaignMemberModel>;
  /** How many members are waiting to be invited in this zone. */
  memberCount: Scalars["Int"]["output"];
  members: Array<InviteCampaignMemberModel>;
  /** nmw / cxt / bs, for the planned campaigns. */
  programme?: Maybe<Scalars["String"]["output"]>;
  /** Null on the row of members with no event. */
  zone?: Maybe<ZoneLabel>;
}

export interface InviteModel {
  acceptedAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  declinedAt?: Maybe<Scalars["Date"]["output"]>;
  event: EventModel;
  googleEvent: GoogleEventModel;
  id: Scalars["String"]["output"];
  invitedByHost?: Maybe<Scalars["Boolean"]["output"]>;
  isConfirmed?: Maybe<Scalars["Boolean"]["output"]>;
  isDraft?: Maybe<Scalars["Boolean"]["output"]>;
  isHost?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<InviteStatus>;
  updatedAt: Scalars["Date"]["output"];
  user?: Maybe<UserModel>;
}

export enum InviteStatus {
  Accepted = "Accepted",
  Declined = "Declined",
  Initial = "Initial",
}

export interface InvitedFriendsStats {
  invitedFriendsTotal?: Maybe<Scalars["Int"]["output"]>;
  invitedPaidFriends?: Maybe<Scalars["Int"]["output"]>;
}

export interface Invoice {
  amount?: Maybe<Scalars["Int"]["output"]>;
  created?: Maybe<Scalars["Date"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  last4Digits?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
}

/** The rule that decided whether she may attend. */
export enum JoinReason {
  CoachTierBlocked = "COACH_TIER_BLOCKED",
  HostOrCohost = "HOST_OR_COHOST",
  Invited = "INVITED",
  KindAllowed = "KIND_ALLOWED",
  KindBlocked = "KIND_BLOCKED",
  Staff = "STAFF",
  UnverifiedAllowed = "UNVERIFIED_ALLOWED",
  UnverifiedBlocked = "UNVERIFIED_BLOCKED",
}

export enum LessonKind {
  Custom = "CUSTOM",
  DeepDive = "DEEP_DIVE",
  Overview = "OVERVIEW",
  Vocabulary = "VOCABULARY",
}

export interface LessonModel {
  createdAt: Scalars["Date"]["output"];
  deepDiveKind?: Maybe<DeepDiveKind>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  kind: LessonKind;
  sections?: Maybe<Array<SectionModel>>;
  title?: Maybe<Scalars["String"]["output"]>;
  topic: TopicModel;
  updatedAt: Scalars["Date"]["output"];
}

export interface LikeModel {
  article: ArticleModel;
  event: EventModel;
  genericId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  topic: TopicModel;
  user: UserModel;
}

export interface Link {
  description: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
}

export interface LinkInput {
  description: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface LiveTableModel {
  createdAt: Scalars["Date"]["output"];
  creatorId?: Maybe<Scalars["String"]["output"]>;
  dailyRoomId: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["Date"]["output"]>;
  endedAt?: Maybe<Scalars["Date"]["output"]>;
  englishLevel?: Maybe<EventEnglishLevelNamed>;
  id: Scalars["String"]["output"];
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  maxParticipants: Scalars["Int"]["output"];
  participants: Array<LiveTableParticipantModel>;
  question?: Maybe<QuestionModel>;
  questionId?: Maybe<Scalars["String"]["output"]>;
  timeLimit?: Maybe<TimeLimit>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface LiveTableParticipantModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  liveTable: LiveTableModel;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export interface LiveTableStartedMessage {
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  tableCreatorId: Scalars["String"]["output"];
  tableEnglishLevel?: Maybe<EventEnglishLevelNamed>;
  tableId: Scalars["String"]["output"];
  tableTitle: Scalars["String"]["output"];
}

export interface LiveTableStartedMessageInput {
  tableEnglishLevel?: InputMaybe<EventEnglishLevelNamed>;
  tableId: Scalars["String"]["input"];
  tableTitle: Scalars["String"]["input"];
}

export interface LiveTablesFeedbackInput {
  comment: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
  willUseAgain: Scalars["Int"]["input"];
}

/** Why the member app would show this event's card locked. */
export enum LockReason {
  CoachTierLocked = "COACH_TIER_LOCKED",
  NeedsThreeEvents = "NEEDS_THREE_EVENTS",
  NotLocked = "NOT_LOCKED",
  TierLocked = "TIER_LOCKED",
}

export interface MatchDetails {
  availabilityMatch?: Maybe<AvailabilityStatus>;
  commonEnglishSkills?: Maybe<Array<EnglishSkill>>;
  commonInterests?: Maybe<Array<Interest>>;
  englishLevelMatch?: Maybe<EnglishLevelMatch>;
  occupationMatch?: Maybe<OccupationMatch>;
  sameCity?: Maybe<Scalars["Boolean"]["output"]>;
}

export interface MatchMembersInput {
  emails: Array<Scalars["String"]["input"]>;
}

export interface MatchMembersResultType {
  matched: Array<MatchedMemberType>;
  notFound: Array<Scalars["String"]["output"]>;
}

export interface MatchScores {
  availabilityScore: Scalars["Float"]["output"];
  englishInterestScore: Scalars["Float"]["output"];
  englishLevelScore: Scalars["Float"]["output"];
  eventParticipationScore: Scalars["Float"]["output"];
  interestScore: Scalars["Float"]["output"];
  locationScore: Scalars["Float"]["output"];
  occupationScore: Scalars["Float"]["output"];
}

export interface MatchedMemberType {
  email: Scalars["String"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
}

export interface MeetingTokenResponse {
  exp?: Maybe<Scalars["Int"]["output"]>;
  roomName: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
}

export interface MemberEventAccessModel {
  /** Whether she can attend — the headline answer. */
  canAttend: Scalars["Boolean"]["output"];
  englishLevel?: Maybe<Scalars["String"]["output"]>;
  eventId: Scalars["String"]["output"];
  hostName?: Maybe<Scalars["String"]["output"]>;
  /** Whether the event is a coach event. */
  isCoachEvent: Scalars["Boolean"]["output"];
  /** Whether the event is public. Private ones are hidden by default. */
  isPublic: Scalars["Boolean"]["output"];
  /** The permission rule that applied. */
  joinReason: JoinReason;
  kind?: Maybe<Scalars["String"]["output"]>;
  /** The lock rule that applied, if any. */
  lockReason: LockReason;
  /** Member kinds the event is restricted to, if any. */
  permissions: Array<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["Date"]["output"]>;
  title: Scalars["String"]["output"];
  verdict: AttendVerdict;
}

export interface MemberEventReviewModel {
  acceptedInvites: Scalars["Int"]["output"];
  englishLevel: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  hostBadge: Scalars["String"]["output"];
  hostName: Scalars["String"]["output"];
  /** This is the host's first public event. */
  isFirstPublic: Scalars["Boolean"]["output"];
  isPublic: Scalars["Boolean"]["output"];
  kind: Scalars["String"]["output"];
  labels: Array<EventLabelModel>;
  /** An admin pinned these labels by hand. */
  labelsEdited: Scalars["Boolean"]["output"];
  maxParticipants: Scalars["Int"]["output"];
  /** RSVP-health priority tier (🔴/🟡/🟢/⚪ with reason). */
  priority: Scalars["String"]["output"];
  spotsLeft?: Maybe<Scalars["Int"]["output"]>;
  /** Invites not declined — the seats the platform holds. */
  spotsTaken: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  zone: ZoneLabel;
}

export interface MemberExperienceModel {
  /** How many the permission gate refuses outright. */
  blocked: Scalars["Int"]["output"];
  /** Of those, how many she can attend. */
  canAttend: Scalars["Int"]["output"];
  events: Array<MemberEventAccessModel>;
  /** How many would appear locked. */
  locked: Scalars["Int"]["output"];
  member: SimulatedMemberModel;
  /** Events considered in the window. */
  total: Scalars["Int"]["output"];
}

export interface MemberProfileModel {
  country?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  /** Very active / Active / Occasional / Quiet lately. */
  engagement: Scalars["String"]["output"];
  /** Intermediate / Advanced / — (all levels). */
  englishBand: Scalars["String"]["output"];
  englishSkills: Array<Scalars["String"]["output"]>;
  eventsAttended: Scalars["Int"]["output"];
  /** Events attended in the last 90 days. */
  eventsRecent: Scalars["Int"]["output"];
  hasBio: Scalars["Boolean"]["output"];
  industry?: Maybe<Scalars["String"]["output"]>;
  interests: Array<Scalars["String"]["output"]>;
  /** In her first 90 days. */
  isNewcomer: Scalars["Boolean"]["output"];
  lastOnlineAt?: Maybe<Scalars["Date"]["output"]>;
  name: Scalars["String"]["output"];
  occupation?: Maybe<Scalars["String"]["output"]>;
  /** 4+ recent invites/shares — untick her by default. */
  overContacted: Scalars["Boolean"]["output"];
  /** Still-upcoming invites/shares to her in the last 14 days. */
  recentNotifs: Scalars["Int"]["output"];
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  /** Tenure bucket text, e.g. '1 to 3 months'. */
  tenureBucket: Scalars["String"]["output"];
  tenureDays: Scalars["Int"]["output"];
  timezone?: Maybe<Scalars["String"]["output"]>;
  /** Upcoming events she's already invited to / booked. */
  upcomingBooked: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface MemberStatsModel {
  /** How committed she's been over time. */
  commitmentLevel?: Maybe<Scalars["String"]["output"]>;
  /** How engaged she is right now. */
  engagementLevel?: Maybe<Scalars["String"]["output"]>;
  /** Scheduled events this member has attended. */
  eventsAttended: Scalars["Int"]["output"];
  /** How far she's drifted — Detected, Dormant, Critical and the rest. */
  faderLevel?: Maybe<Scalars["String"]["output"]>;
  /** When the team last sent her a chat message, by any tool. Null if she's never been messaged. */
  lastMessagedAt?: Maybe<Scalars["Date"]["output"]>;
  /** When she was last on the platform. */
  lastOnlineAt?: Maybe<Scalars["Date"]["output"]>;
  /** Logins in the last 14 days. */
  loginsRecent: Scalars["Int"]["output"];
  /** Her Chargebee plan. Null when she has no subscription. */
  plan?: Maybe<Scalars["String"]["output"]>;
  /** Where she stands with us — Member, Cancelling, Paused, Cancelled, Trial. Null when she has no subscription at all. */
  status?: Maybe<Scalars["String"]["output"]>;
  /** How long she's been a member, measured in paid active days. */
  tenure?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  /** The three-hour UTC band this member is usually around in. */
  zone: ZoneLabel;
}

export interface MemberZoneMatrixModel {
  grandTotal: Scalars["Int"]["output"];
  /** One row per tenure bucket, in order. */
  rows: Array<MemberZoneRowModel>;
  /** Column totals — members per zone. */
  zoneTotals: Array<ZoneCountModel>;
  zones: Array<ZoneLabel>;
}

export interface MemberZoneRowModel {
  counts: Array<ZoneCountModel>;
  /** TenureBucket key. */
  tenure: Scalars["String"]["output"];
  /** Display label, e.g. '1 to 3 months'. */
  tenureLabel: Scalars["String"]["output"];
  total: Scalars["Int"]["output"];
}

export interface MemberZonesModel {
  /** Fair: each member's zone by attendance rate (÷ how often each zone is offered). */
  adjusted: MemberZoneMatrixModel;
  /** Biased: each member's zone by raw attendance count. */
  raw: MemberZoneMatrixModel;
}

/** Where a member stands with her membership now, read live. */
export enum MembershipNow {
  Cancelled = "CANCELLED",
  Leaving = "LEAVING",
  Paused = "PAUSED",
  Stayed = "STAYED",
  Unknown = "UNKNOWN",
}

export enum MembershipPlans {
  Annual = "Annual",
  FreeOneMonth = "FreeOneMonth",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Social = "Social",
  SocialAnnual = "SocialAnnual",
  SocialQuarterly = "SocialQuarterly",
  SupporterOneMonth = "SupporterOneMonth",
  ThreeMonthsOnly = "ThreeMonthsOnly",
}

export interface MessageCaptureStatusModel {
  /** When the last scan finished. */
  lastScanAt?: Maybe<Scalars["Date"]["output"]>;
  /** Messages stored, both directions. */
  messages: Scalars["Int"]["output"];
  /** The newest message captured. */
  newestMessageAt?: Maybe<Scalars["Date"]["output"]>;
  /** Messages a member sent us (replies). */
  replies: Scalars["Int"]["output"];
  /** A scan is in progress right now. */
  running: Scalars["Boolean"]["output"];
  /** Distinct DM threads captured. */
  threads: Scalars["Int"]["output"];
}

export interface MessageModel {
  bodyText: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  receiver: UserModel;
  sender: UserModel;
  updatedAt: Scalars["Date"]["output"];
}

export interface MetaFileInput {
  extension?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface MetaFileType {
  extension?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<Scalars["Int"]["output"]>;
}

export enum MonthlyRecapSteps {
  ArticlesWritten = "ArticlesWritten",
  AttendanceRatio = "AttendanceRatio",
  EventsAttended = "EventsAttended",
  EventsHosted = "EventsHosted",
  EventsStreak = "EventsStreak",
  FriendlyFaces = "FriendlyFaces",
  GlobalNetwork = "GlobalNetwork",
  ParticipationTime = "ParticipationTime",
  Sparks = "Sparks",
  SpontaneousConversations = "SpontaneousConversations",
  ThankYou = "ThankYou",
}

export interface MonthlyReportNotificationModel {
  id: Scalars["String"]["output"];
  type: MonthlyReportNotificationType;
}

export enum MonthlyReportNotificationType {
  MonthlyReport = "MonthlyReport",
}

export interface Mutation {
  acceptChannelInvite?: Maybe<GenericResponseType>;
  activateGuestPass?: Maybe<Scalars["JSON"]["output"]>;
  activateTrialSubscription: GenericResponseType;
  activateUser?: Maybe<GenericResponseType>;
  addEventToGoogleCalendar: CalendarResponseType;
  addMultipleEventsToGoogleCalendar: CalendarResponseType;
  addZoomLicenseToUser?: Maybe<GenericResponseType>;
  adminBanUser?: Maybe<GenericResponseType>;
  adminBulkUploadEvents: BulkUploadEventsResponse;
  adminCreateBanner?: Maybe<BannerModel>;
  adminCreateCover?: Maybe<CoverModel>;
  adminCreateCustomNotificationDisplay?: Maybe<CustomNotificationDisplayModel>;
  adminCreateFeatureFlag?: Maybe<FeatureFlagModel>;
  adminCreateIllustration?: Maybe<IllustrationModel>;
  adminCreateLesson?: Maybe<LessonModel>;
  adminCreateNote?: Maybe<NoteModel>;
  adminCreateQuestion?: Maybe<GenericResponseType>;
  adminCreateSection?: Maybe<SectionModel>;
  adminCreateSlider?: Maybe<GenericResponseType>;
  adminCreateTheme?: Maybe<ThemeModel>;
  adminCreateTopic?: Maybe<TopicModel>;
  adminCreateUserFeatureFlag?: Maybe<UserFlagModel>;
  adminCreateVideo?: Maybe<GenericResponseType>;
  adminCreateVideoSet?: Maybe<VideoSetModel>;
  adminCreateZineCover?: Maybe<ZineModel>;
  adminDeleteArticle?: Maybe<GenericResponseType>;
  adminDeleteBanner?: Maybe<GenericResponseType>;
  adminDeleteCover?: Maybe<GenericResponseType>;
  adminDeleteEvent?: Maybe<GenericResponseType>;
  adminDeleteFeatureFlag?: Maybe<GenericResponseType>;
  adminDeleteIllustration?: Maybe<GenericResponseType>;
  adminDeleteLesson?: Maybe<GenericResponseType>;
  adminDeleteQuestion?: Maybe<GenericResponseType>;
  adminDeleteSection?: Maybe<GenericResponseType>;
  adminDeleteSlider?: Maybe<GenericResponseType>;
  adminDeleteTheme?: Maybe<GenericResponseType>;
  adminDeleteTopic?: Maybe<GenericResponseType>;
  adminDeleteTopics?: Maybe<GenericResponseType>;
  adminDeleteUserFeatureFlag?: Maybe<GenericResponseType>;
  adminDeleteUserReport?: Maybe<GenericResponseType>;
  adminDeleteVideo?: Maybe<GenericResponseType>;
  adminDeleteVideoSet?: Maybe<GenericResponseType>;
  adminDeleteZineCover?: Maybe<GenericResponseType>;
  adminEditArticle?: Maybe<ArticleModel>;
  adminEditBanner?: Maybe<BannerModel>;
  adminEditCover?: Maybe<CoverModel>;
  adminEditCustomNotificationDisplay?: Maybe<GenericResponseType>;
  adminEditEvent?: Maybe<GenericResponseType>;
  adminEditFeatureFlag?: Maybe<FeatureFlagModel>;
  adminEditIllustration?: Maybe<IllustrationModel>;
  adminEditLesson?: Maybe<LessonModel>;
  adminEditQuestion?: Maybe<QuestionModel>;
  adminEditSection?: Maybe<SectionModel>;
  adminEditSlide?: Maybe<SliderModel>;
  adminEditTheme?: Maybe<ThemeModel>;
  adminEditTopic?: Maybe<TopicModel>;
  adminEditUser?: Maybe<GenericResponseType>;
  adminEditUserFeatureFlag?: Maybe<UserFlagModel>;
  adminEditVideo?: Maybe<VideoModel>;
  adminEditVideoSet?: Maybe<VideoSetModel>;
  adminEditZineCover?: Maybe<ZineModel>;
  adminForceSignOut?: Maybe<GenericResponseType>;
  adminFulfillReferral: ReferralRewardModel;
  adminGenerateAttachmentUploadUrl?: Maybe<UploadUrlsType>;
  adminGrantGuestPassTokens: GuestPassSummary;
  adminImportUser?: Maybe<GenericResponseType>;
  adminOrderSlider?: Maybe<GenericResponseType>;
  adminOrderVideo?: Maybe<GenericResponseType>;
  adminOrderVideoSet?: Maybe<GenericResponseType>;
  adminRecordCampaignInvites: Scalars["Int"]["output"];
  adminRecordInvites: Scalars["Int"]["output"];
  adminRecordRetentionOutreach: Scalars["Int"]["output"];
  adminRepublishEvent: GenericResponseType;
  adminReviewReferral: ReferralRewardModel;
  adminRunMessageCapture: MessageCaptureStatusModel;
  adminSelectionUserIds: AdminShareSelectionResponse;
  adminSetEventLabels: Scalars["Boolean"]["output"];
  adminShareEventToEmails: ShareEventResultModel;
  adminShareEventToUserIds: ShareEventResultModel;
  adminUnbanUser?: Maybe<GenericResponseType>;
  adminValidateBulkUploadEvents: BulkUploadValidationResponse;
  adminWelcomeUser?: Maybe<GenericResponseType>;
  agreeToConversationPactPromise: ConversationPactModel;
  answerHomeCheckIn: HomeCheckInModel;
  answerHomeCheckInFollowUp: HomeCheckInModel;
  applyPowerUp: GenericResponseType;
  assignAllExtraReferralBadges: GenericResponseType;
  assignAllFirstConversationBadges: GenericResponseType;
  assignAllLocalHostsBadges: GenericResponseType;
  assignAllNMMEventAttendedBadges: GenericResponseType;
  assignAllNewEventsAttendedBadges: GenericResponseType;
  assignCompleteOnboardingQuizBadge: GenericResponseType;
  assignUserBadge?: Maybe<GenericResponseType>;
  attendEvent?: Maybe<InviteModel>;
  attendMultipleEvents?: Maybe<GenericResponseType>;
  bulkInviteWithUserIds?: Maybe<BulkInviteResponse>;
  cancelAttendance: InviteModel;
  cancelScheduleCancelSubscription?: Maybe<GenericResponseType>;
  chatAddMembersToChannel?: Maybe<GenericResponseType>;
  chatAutomationsAddMembers: BulkActionResultType;
  chatAutomationsRecallSend: RecallResultType;
  chatAutomationsSendMessages: BulkActionResultType;
  chatAutomationsSendPersonalMessages: BulkActionResultType;
  chatCreateChannel?: Maybe<Scalars["String"]["output"]>;
  chatGiveAdminRole?: Maybe<Scalars["Any"]["output"]>;
  chatRemoveMembersFromChannel?: Maybe<GenericResponseType>;
  chatRenameChannel?: Maybe<GenericResponseType>;
  chatSendDirectMessage?: Maybe<GenericResponseType>;
  chatUpdatePublicChannelInfo?: Maybe<GenericResponseType>;
  chatUpdateUserChannelPermission: GenericResponseType;
  chooseSubscription?: Maybe<Scalars["JSON"]["output"]>;
  closeDoor?: Maybe<EventModel>;
  closeVideoCallDoor: VideoCallModel;
  completeVideo?: Maybe<CompletedVideoModel>;
  confirmGuestPassSignup: GuestPassSignupResult;
  confirmInPersonEvent: GenericResponseType;
  confirmStreakCelebration: GenericResponseType;
  confirmTotp: GenericResponseType;
  contactUs?: Maybe<GenericResponseType>;
  createAbuse?: Maybe<AbuseModel>;
  createArticle?: Maybe<ArticleModel>;
  createArticleAttachment?: Maybe<ArticlesAttachmentModel>;
  createAttachment?: Maybe<EventAttachmentModel>;
  createComment?: Maybe<CommentModel>;
  createEvent?: Maybe<EventModel>;
  createInvite: InviteModel;
  createLike?: Maybe<LikeModel>;
  createLiveTable: LiveTableModel;
  createMessage?: Maybe<MessageModel>;
  createNewWebhook: GenericResponseType;
  createReaction: CommentReactionsModel;
  createSpark: GenericResponseType;
  createTopicForPreviewMode?: Maybe<EntityIdResponseType>;
  createTotp: UserTotpModel;
  createUser: UserSignUpModel;
  createUserPhoto?: Maybe<UserPhotoModel>;
  createVideoCall: VideoCallModel;
  createWebpushSubscription: GenericResponseType;
  deactivate?: Maybe<GenericResponseType>;
  declineChannelInvite?: Maybe<GenericResponseType>;
  declineInvite: InviteModel;
  declineSharedEvent: GenericResponseType;
  deleteAccount?: Maybe<GenericResponseType>;
  deleteArticle?: Maybe<EntityIdResponseType>;
  deleteArticleAttachment?: Maybe<EntityIdResponseType>;
  deleteAttachment?: Maybe<EntityIdResponseType>;
  deleteChannelInvite?: Maybe<GenericResponseType>;
  deleteComment?: Maybe<GenericResponseType>;
  deleteDailyWebhook: GenericResponseType;
  deleteEvent?: Maybe<GenericResponseType>;
  deleteInvite?: Maybe<GenericResponseType>;
  deleteInvites?: Maybe<GenericResponseType>;
  deleteLike?: Maybe<GenericResponseType>;
  deleteReaction: GenericResponseType;
  deleteUserBadge?: Maybe<GenericResponseType>;
  deleteUserPhoto?: Maybe<EntityIdResponseType>;
  dismissGuestPassCompletionModal: GuestPassSummary;
  dismissHomeCheckIn: HomeCheckInModel;
  duplicateEvent?: Maybe<EventModel>;
  duplicateLesson?: Maybe<GenericResponseType>;
  duplicateTopic?: Maybe<GenericResponseType>;
  editArticle?: Maybe<ArticleModel>;
  editComment?: Maybe<CommentModel>;
  eventMeetingToken?: Maybe<MeetingTokenResponse>;
  follow?: Maybe<GenericResponseType>;
  generateArticlesAttachmentUploadUrl?: Maybe<UploadUrlsType>;
  generateAttachmentUploadUrl?: Maybe<UploadUrlsType>;
  generateChannelPictureUploadUrl?: Maybe<UploadUrlsType>;
  generateUserUploadUrl?: Maybe<UploadUrlsType>;
  getHostedPage?: Maybe<Scalars["JSON"]["output"]>;
  getOrCreateCalendar: CalendarModel;
  getPrecancelPage?: Maybe<Scalars["String"]["output"]>;
  heartbeat?: Maybe<GenericResponseType>;
  initiateAssessment: InitiateAssessmentResponse;
  issueCompleteProfileNotification: GenericResponseType;
  liveTableMeetingToken: MeetingTokenResponse;
  markAllAsSeen?: Maybe<GenericResponseType>;
  markEventsTabAsSeen?: Maybe<GenericResponseType>;
  markEventsTabAsSeenAfterAttendedThreeEvents?: Maybe<GenericResponseType>;
  markJoinEvent: GenericResponseType;
  markPowerUpRevealed: GenericResponseType;
  markRechargeExplainerSeen: GenericResponseType;
  markReportAsSeen?: Maybe<GenericResponseType>;
  markStreakResetSeen: GenericResponseType;
  markStreaksExplainerSeen: GenericResponseType;
  notificationSeen?: Maybe<NotificationBaseModel>;
  notifyAboutStartedLiveTable: GenericResponseType;
  openDoor?: Maybe<EventModel>;
  openVideoCallDoor: VideoCallModel;
  pause: GenericResponseType;
  populateUserEventStatistics?: Maybe<GenericResponseType>;
  publishEvent?: Maybe<EventModel>;
  publishOrScheduleArticle?: Maybe<ArticleModel>;
  recoverAccount?: Maybe<GenericResponseType>;
  regenerateCalendarPath: GenericResponseType;
  removeTotp: GenericResponseType;
  requestAssistance?: Maybe<GenericResponseType>;
  requestHomeCheckInChat: HomeCheckInModel;
  requestRefund?: Maybe<GenericResponseType>;
  requestResetPassword: GenericResponseType;
  resendConfirmationEmail: GenericResponseType;
  resendSignupEmailCode: UserSignUpModel;
  resetPassword?: Maybe<GenericResponseType>;
  respondToRecurringInvites?: Maybe<GenericResponseType>;
  restartGuestPass: GuestPassSummary;
  restoreUsers?: Maybe<GenericResponseType>;
  resume: GenericResponseType;
  revokeMySession?: Maybe<GenericResponseType>;
  revokeOtherMySessions?: Maybe<GenericResponseType>;
  saveArticle?: Maybe<ArticleModel>;
  saveParticipantSession: GenericResponseType;
  scheduleCancelSubscription?: Maybe<GenericResponseType>;
  sendCustomNotifications?: Maybe<CustomNotificationResponseType>;
  sendEventCalendarInvites: GenericResponseType;
  sendLink?: Maybe<GenericResponseType>;
  sendLiveTablesFeedback: GenericResponseType;
  sendManyChatInvites?: Maybe<GenericResponseType>;
  setChannelPictureUrl?: Maybe<GenericResponseType>;
  setToken: GenericResponseType;
  shareEvent: GenericResponseType;
  subscribe?: Maybe<Scalars["JSON"]["output"]>;
  switch?: Maybe<Scalars["JSON"]["output"]>;
  /** Signed link data for the team's booking page (Book a 1:1 call) */
  teamBookingTicket: Scalars["String"]["output"];
  triggerAssignAllUserBadges: GenericResponseType;
  triggerBackfillConnectionStreaks: GenericResponseType;
  triggerBackupEventsParticipants: GenericResponseType;
  triggerChatServiceSync?: Maybe<GenericResponseType>;
  triggerGuestPassDormancySweep: GenericResponseType;
  triggerRecreateDailyMeetings: GenericResponseType;
  triggerRecreateZoomMeetings: GenericResponseType;
  triggerUserDeletionAfterRetention: GenericResponseType;
  triggerUserPermissionPromotion: GenericResponseType;
  unFollow?: Maybe<GenericResponseType>;
  updateArticleAttachment?: Maybe<ArticlesAttachmentModel>;
  updateAttachment?: Maybe<EventAttachmentModel>;
  updateEvent?: Maybe<EventModel>;
  updateGuestPassBooking: UserSignUpModel;
  updateLiveTable: GenericResponseType;
  updateMe?: Maybe<UserModel>;
  updatePassword: GenericResponseType;
  updatePaymentMethod?: Maybe<Scalars["String"]["output"]>;
  updateSignupName: UserSignUpModel;
  updateUserPhoto?: Maybe<UserPhotoModel>;
  updateUserSettings?: Maybe<GenericResponseType>;
  updateWeeklyGoal: GenericResponseType;
  uploadActiveDays: GenericResponseType;
  uploadArticleCover?: Maybe<ArticleModel>;
  uploadArticleImage?: Maybe<UploadUrlsType>;
  uploadEventCover?: Maybe<UploadUrlsType>;
  uploadEventDescriptionImage?: Maybe<UploadUrlsType>;
  uploadZineCover?: Maybe<ZineModel>;
  validateForSelectionBulkInvite: ValidateSelectionBulkInviteResponse;
  validateUsersForEmailBulkInvite?: Maybe<ValidateBulkInviteResponse>;
  verifySignupEmail: UserSignUpModel;
  verifyUser?: Maybe<GenericResponseType>;
  verifyWebpushSubscription: VerifyWebpushSubscriptionResult;
  videoMeetingToken: MeetingTokenResponse;
  watchedValuesVideo?: Maybe<GenericResponseType>;
  watchedWelcomeVideo?: Maybe<GenericResponseType>;
}

export interface MutationAcceptChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
}

export interface MutationActivateGuestPassArgs {
  planId: Scalars["String"]["input"];
}

export interface MutationActivateUserArgs {
  input: ActivateUserInput;
}

export interface MutationAddEventToGoogleCalendarArgs {
  input: AddEventCalendarInput;
}

export interface MutationAddMultipleEventsToGoogleCalendarArgs {
  calendarType: CalendarType;
  eventIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAddZoomLicenseToUserArgs {
  userID: Scalars["String"]["input"];
}

export interface MutationAdminBanUserArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminBulkUploadEventsArgs {
  input: BulkUploadEventsInput;
}

export interface MutationAdminCreateBannerArgs {
  input: CreateBannerInput;
}

export interface MutationAdminCreateCoverArgs {
  input: CreateCoverInput;
}

export interface MutationAdminCreateFeatureFlagArgs {
  input: CreateFeatureFlagInput;
}

export interface MutationAdminCreateIllustrationArgs {
  input: CreateIllustrationInput;
}

export interface MutationAdminCreateLessonArgs {
  input: CreateLessonInput;
}

export interface MutationAdminCreateNoteArgs {
  input: NoteInput;
  userID: Scalars["String"]["input"];
}

export interface MutationAdminCreateQuestionArgs {
  input: CreateQuestionInput;
}

export interface MutationAdminCreateSectionArgs {
  input: CreateSectionInput;
}

export interface MutationAdminCreateSliderArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminCreateThemeArgs {
  input: CreateThemeInput;
}

export interface MutationAdminCreateTopicArgs {
  input: CreateTopicInput;
}

export interface MutationAdminCreateUserFeatureFlagArgs {
  input: CreateUserFeatureFlagInput;
}

export interface MutationAdminCreateVideoArgs {
  input: CreateVideoInput;
}

export interface MutationAdminCreateVideoSetArgs {
  input: CreateVideoSetInput;
}

export interface MutationAdminCreateZineCoverArgs {
  input: CreateZineInput;
}

export interface MutationAdminDeleteArticleArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteBannerArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteCoverArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteEventArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteIllustrationArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteLessonArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteQuestionArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteSectionArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteSliderArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteThemeArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteTopicArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteTopicsArgs {
  input: DeleteTopicsInput;
}

export interface MutationAdminDeleteUserFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteUserReportArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteVideoArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteVideoSetArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminDeleteZineCoverArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminEditArticleArgs {
  id: Scalars["String"]["input"];
  input: EditArticleInput;
}

export interface MutationAdminEditBannerArgs {
  id: Scalars["String"]["input"];
  input: EditBannerInput;
}

export interface MutationAdminEditCoverArgs {
  id: Scalars["String"]["input"];
  input: EditCoverInput;
}

export interface MutationAdminEditCustomNotificationDisplayArgs {
  id: Scalars["String"]["input"];
  input: EditCustomNotificationDisplayInput;
}

export interface MutationAdminEditEventArgs {
  id: Scalars["String"]["input"];
  input: EditEventInput;
}

export interface MutationAdminEditFeatureFlagArgs {
  id: Scalars["String"]["input"];
  input: EditFeatureFlagInput;
}

export interface MutationAdminEditIllustrationArgs {
  id: Scalars["String"]["input"];
  input: EditIllustrationInput;
}

export interface MutationAdminEditLessonArgs {
  id: Scalars["String"]["input"];
  input: EditLessonInput;
}

export interface MutationAdminEditQuestionArgs {
  input: EditQuestionInput;
}

export interface MutationAdminEditSectionArgs {
  id: Scalars["String"]["input"];
  input: EditSectionInput;
}

export interface MutationAdminEditSlideArgs {
  id: Scalars["String"]["input"];
  input: EditSliderInput;
}

export interface MutationAdminEditThemeArgs {
  id: Scalars["String"]["input"];
  input: EditThemeInput;
}

export interface MutationAdminEditTopicArgs {
  id: Scalars["String"]["input"];
  input: EditTopicInput;
}

export interface MutationAdminEditUserArgs {
  id: Scalars["String"]["input"];
  input: EditUserInput;
}

export interface MutationAdminEditUserFeatureFlagArgs {
  id: Scalars["String"]["input"];
  input: EditUserFeatureFlagInput;
}

export interface MutationAdminEditVideoArgs {
  id: Scalars["String"]["input"];
  input: EditVideoInput;
}

export interface MutationAdminEditVideoSetArgs {
  id: Scalars["String"]["input"];
  input: EditVideoSetInput;
}

export interface MutationAdminEditZineCoverArgs {
  id: Scalars["String"]["input"];
  input: EditZineInput;
}

export interface MutationAdminForceSignOutArgs {
  userId: Scalars["String"]["input"];
}

export interface MutationAdminFulfillReferralArgs {
  action: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
}

export interface MutationAdminGenerateAttachmentUploadUrlArgs {
  filename: Scalars["String"]["input"];
}

export interface MutationAdminGrantGuestPassTokensArgs {
  input: GrantGuestPassTokensInput;
}

export interface MutationAdminImportUserArgs {
  input: ImportUserInput;
}

export interface MutationAdminOrderSliderArgs {
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}

export interface MutationAdminOrderVideoArgs {
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}

export interface MutationAdminOrderVideoSetArgs {
  id: Scalars["String"]["input"];
  input: Scalars["String"]["input"];
}

export interface MutationAdminRecordCampaignInvitesArgs {
  campaign: InviteCampaignKey;
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminRecordInvitesArgs {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  eventId: Scalars["String"]["input"];
  filters?: InputMaybe<Array<Scalars["String"]["input"]>>;
  source?: InputMaybe<OutreachSource>;
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminRecordRetentionOutreachArgs {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  fader: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminRepublishEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface MutationAdminReviewReferralArgs {
  approve: Scalars["Boolean"]["input"];
  id: Scalars["String"]["input"];
  note: Scalars["String"]["input"];
}

export interface MutationAdminSelectionUserIdsArgs {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  filters: AdminFilterUsersInput;
}

export interface MutationAdminSetEventLabelsArgs {
  labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: Scalars["String"]["input"];
}

export interface MutationAdminShareEventToEmailsArgs {
  emails: Array<Scalars["String"]["input"]>;
  eventId: Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
}

export interface MutationAdminShareEventToUserIdsArgs {
  eventId: Scalars["String"]["input"];
  source?: InputMaybe<OutreachSource>;
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationAdminUnbanUserArgs {
  id: Scalars["String"]["input"];
}

export interface MutationAdminValidateBulkUploadEventsArgs {
  input: BulkUploadEventsInput;
}

export interface MutationAdminWelcomeUserArgs {
  input: ImportUserInput;
}

export interface MutationAgreeToConversationPactPromiseArgs {
  promise: ConversationPactPromise;
}

export interface MutationAnswerHomeCheckInArgs {
  input: AnswerHomeCheckInInput;
}

export interface MutationAnswerHomeCheckInFollowUpArgs {
  input: AnswerHomeCheckInFollowUpInput;
}

export interface MutationAssignUserBadgeArgs {
  input: AssignOrDeleteBadgeInput;
}

export interface MutationAttendEventArgs {
  input: AttendEventInput;
}

export interface MutationAttendMultipleEventsArgs {
  eventIds: Array<Scalars["String"]["input"]>;
}

export interface MutationBulkInviteWithUserIdsArgs {
  eventId: Scalars["String"]["input"];
  input: BulkInviteWithUserIdsInput;
}

export interface MutationCancelAttendanceArgs {
  input: CancelAttendanceInput;
}

export interface MutationChatAddMembersToChannelArgs {
  id: Scalars["String"]["input"];
  input: CreateChannelInput;
}

export interface MutationChatAutomationsAddMembersArgs {
  input: AddBulkMembersInput;
}

export interface MutationChatAutomationsRecallSendArgs {
  batchId: Scalars["String"]["input"];
}

export interface MutationChatAutomationsSendMessagesArgs {
  input: SendBulkMessagesInput;
}

export interface MutationChatAutomationsSendPersonalMessagesArgs {
  input: SendPersonalMessagesInput;
}

export interface MutationChatCreateChannelArgs {
  input: CreateChannelInput;
}

export interface MutationChatGiveAdminRoleArgs {
  id: Scalars["String"]["input"];
}

export interface MutationChatRemoveMembersFromChannelArgs {
  id: Scalars["String"]["input"];
  input: CreateChannelInput;
}

export interface MutationChatRenameChannelArgs {
  channelName: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}

export interface MutationChatSendDirectMessageArgs {
  input: SendDirectChatMessageInput;
}

export interface MutationChatUpdatePublicChannelInfoArgs {
  channelDescription: Scalars["String"]["input"];
  channelName: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}

export interface MutationChatUpdateUserChannelPermissionArgs {
  input: UpdateUserChannelPermissionInput;
}

export interface MutationChooseSubscriptionArgs {
  input: SubscribeInput;
}

export interface MutationCloseDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationCloseVideoCallDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationCompleteVideoArgs {
  id: Scalars["String"]["input"];
}

export interface MutationConfirmGuestPassSignupArgs {
  input: ConfirmGuestPassSignupInput;
}

export interface MutationConfirmInPersonEventArgs {
  id: Scalars["String"]["input"];
  input: ConfirmInPersonEventInput;
}

export interface MutationConfirmTotpArgs {
  currentPassword: Scalars["String"]["input"];
  input: ConfirmTotpInput;
}

export interface MutationContactUsArgs {
  input: ContactUsInput;
}

export interface MutationCreateAbuseArgs {
  input: ReportAbuseInput;
}

export interface MutationCreateArticleAttachmentArgs {
  articleId: Scalars["String"]["input"];
  input: CreateArticlesAttachmentInput;
}

export interface MutationCreateAttachmentArgs {
  eventID: Scalars["String"]["input"];
  input: CreateEventAttachmentInput;
}

export interface MutationCreateCommentArgs {
  input: CreateCommentInput;
  targetId: Scalars["String"]["input"];
  targetType: CommentTargetType;
}

export interface MutationCreateEventArgs {
  input: CreateEventInput;
}

export interface MutationCreateInviteArgs {
  input: CreateInviteInput;
}

export interface MutationCreateLikeArgs {
  input: CreateLikeInput;
}

export interface MutationCreateLiveTableArgs {
  input: CreateLiveTableInput;
}

export interface MutationCreateMessageArgs {
  writeMessageData: CreateMessageInput;
}

export interface MutationCreateNewWebhookArgs {
  eventTypes: Array<DailyEventTypes>;
}

export interface MutationCreateReactionArgs {
  input: CreateReactionInput;
}

export interface MutationCreateSparkArgs {
  input: CreateSparkInput;
}

export interface MutationCreateTopicForPreviewModeArgs {
  input: TopicInPreviewInput;
}

export interface MutationCreateUserArgs {
  input: CreateUserInput;
}

export interface MutationCreateUserPhotoArgs {
  input: UpdatePhotoInput;
}

export interface MutationCreateVideoCallArgs {
  input: CreateVideoCallInput;
}

export interface MutationCreateWebpushSubscriptionArgs {
  input: CreateWebpushSubscriptionInput;
}

export interface MutationDeactivateArgs {
  input: DeactivateInput;
}

export interface MutationDeclineChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
}

export interface MutationDeclineInviteArgs {
  input: DeclineInviteInput;
}

export interface MutationDeclineSharedEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface MutationDeleteAccountArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteArticleArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteArticleAttachmentArgs {
  attachmentId: Scalars["String"]["input"];
}

export interface MutationDeleteAttachmentArgs {
  attachmentID: Scalars["String"]["input"];
}

export interface MutationDeleteChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface MutationDeleteCommentArgs {
  commentID: Scalars["String"]["input"];
}

export interface MutationDeleteDailyWebhookArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteEventArgs {
  deleteScope?: InputMaybe<RecurringEditScope>;
  deletedNote?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  selectedEventIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface MutationDeleteInviteArgs {
  inviteId: Scalars["String"]["input"];
}

export interface MutationDeleteInvitesArgs {
  input: DeleteInvitesInput;
}

export interface MutationDeleteLikeArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteReactionArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDeleteUserBadgeArgs {
  input: AssignOrDeleteBadgeInput;
}

export interface MutationDeleteUserPhotoArgs {
  input: DeletePhotoInput;
}

export interface MutationDismissHomeCheckInArgs {
  kind: HomeCheckInKind;
}

export interface MutationDuplicateEventArgs {
  id: Scalars["String"]["input"];
}

export interface MutationDuplicateLessonArgs {
  input: DuplicateLessonInput;
}

export interface MutationDuplicateTopicArgs {
  id: Scalars["String"]["input"];
}

export interface MutationEditArticleArgs {
  id: Scalars["String"]["input"];
  input: EditArticleInput;
}

export interface MutationEditCommentArgs {
  commentID: Scalars["String"]["input"];
  input: EditCommentInput;
}

export interface MutationEventMeetingTokenArgs {
  input: DailyMeetingInput;
}

export interface MutationFollowArgs {
  input: FollowInput;
}

export interface MutationGenerateArticlesAttachmentUploadUrlArgs {
  articleId: Scalars["String"]["input"];
  filename: Scalars["String"]["input"];
}

export interface MutationGenerateAttachmentUploadUrlArgs {
  eventID: Scalars["String"]["input"];
  filename: Scalars["String"]["input"];
}

export interface MutationGenerateChannelPictureUploadUrlArgs {
  input: UploadPictureInput;
}

export interface MutationGenerateUserUploadUrlArgs {
  input: UploadPhotoInput;
}

export interface MutationGetHostedPageArgs {
  id: Scalars["String"]["input"];
}

export interface MutationHeartbeatArgs {
  input: UpdateUserInput;
}

export interface MutationLiveTableMeetingTokenArgs {
  input: DailyMeetingInput;
}

export interface MutationMarkJoinEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface MutationNotificationSeenArgs {
  id: Scalars["String"]["input"];
}

export interface MutationNotifyAboutStartedLiveTableArgs {
  input: LiveTableStartedMessageInput;
}

export interface MutationOpenDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationOpenVideoCallDoorArgs {
  id: Scalars["String"]["input"];
}

export interface MutationPauseArgs {
  input: PauseInput;
}

export interface MutationPublishEventArgs {
  id: Scalars["String"]["input"];
}

export interface MutationPublishOrScheduleArticleArgs {
  id: Scalars["String"]["input"];
  input: PublishArticleInput;
}

export interface MutationRegenerateCalendarPathArgs {
  userId: Scalars["String"]["input"];
}

export interface MutationRemoveTotpArgs {
  currentPassword?: InputMaybe<Scalars["String"]["input"]>;
  totpId: Scalars["String"]["input"];
}

export interface MutationRequestAssistanceArgs {
  input: AssistanceReasonsInput;
}

export interface MutationRequestHomeCheckInChatArgs {
  kind: HomeCheckInKind;
}

export interface MutationRequestRefundArgs {
  input: RequestRefundInput;
}

export interface MutationRequestResetPasswordArgs {
  input: RequestPasswordInput;
}

export interface MutationResendConfirmationEmailArgs {
  input: ResendConfirmationEmailInput;
}

export interface MutationResendSignupEmailCodeArgs {
  email?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
}

export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}

export interface MutationRespondToRecurringInvitesArgs {
  acceptEventIds: Array<Scalars["String"]["input"]>;
  declineEventIds: Array<Scalars["String"]["input"]>;
  seriesId: Scalars["String"]["input"];
}

export interface MutationRestartGuestPassArgs {
  input?: InputMaybe<RestartGuestPassInput>;
}

export interface MutationRestoreUsersArgs {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationRevokeMySessionArgs {
  sessionId: Scalars["String"]["input"];
}

export interface MutationSaveArticleArgs {
  id: Scalars["String"]["input"];
  input: SaveDraftArticleInput;
}

export interface MutationSaveParticipantSessionArgs {
  meetingSessionId: Scalars["String"]["input"];
  participantId: Scalars["String"]["input"];
}

export interface MutationScheduleCancelSubscriptionArgs {
  input: RequestRefundInput;
}

export interface MutationSendCustomNotificationsArgs {
  emails: Array<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
}

export interface MutationSendEventCalendarInvitesArgs {
  eventIds: Array<Scalars["String"]["input"]>;
}

export interface MutationSendLinkArgs {
  input: FriendInput;
}

export interface MutationSendLiveTablesFeedbackArgs {
  input: LiveTablesFeedbackInput;
}

export interface MutationSendManyChatInvitesArgs {
  input: ChatInviteInput;
}

export interface MutationSetChannelPictureUrlArgs {
  input: SetPictureInput;
}

export interface MutationSetTokenArgs {
  input: Scalars["String"]["input"];
}

export interface MutationShareEventArgs {
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]>;
}

export interface MutationSubscribeArgs {
  input: SubscribeInput;
}

export interface MutationSwitchArgs {
  input: SubscribeInput;
}

export interface MutationUnFollowArgs {
  input: FollowInput;
}

export interface MutationUpdateArticleAttachmentArgs {
  attachmentId: Scalars["String"]["input"];
  input: EditArticlesAttachmentInput;
}

export interface MutationUpdateAttachmentArgs {
  attachmentID: Scalars["String"]["input"];
  input: UpdateEventAttachmentInput;
}

export interface MutationUpdateEventArgs {
  id: Scalars["String"]["input"];
  input: UpdateEventInput;
}

export interface MutationUpdateGuestPassBookingArgs {
  input: UpdateGuestPassBookingInput;
}

export interface MutationUpdateLiveTableArgs {
  id: Scalars["String"]["input"];
  input: UpdateLiveTableInput;
}

export interface MutationUpdateMeArgs {
  input: UpdateUserInput;
}

export interface MutationUpdatePasswordArgs {
  input: UpdatePasswordInput;
}

export interface MutationUpdateSignupNameArgs {
  input: UpdateSignupNameInput;
}

export interface MutationUpdateUserPhotoArgs {
  input: UpdatePhotoInput;
  photoID: Scalars["String"]["input"];
}

export interface MutationUpdateUserSettingsArgs {
  input: UpdateSettingsInput;
}

export interface MutationUpdateWeeklyGoalArgs {
  goal: Scalars["Int"]["input"];
}

export interface MutationUploadActiveDaysArgs {
  input: UploadActiveDaysInput;
}

export interface MutationUploadArticleCoverArgs {
  input: UploadImageArticleInput;
}

export interface MutationUploadArticleImageArgs {
  input: UploadImageArticleInput;
}

export interface MutationUploadEventCoverArgs {
  id: Scalars["String"]["input"];
  input: UploadEventImageInput;
}

export interface MutationUploadEventDescriptionImageArgs {
  id: Scalars["String"]["input"];
  input: UploadEventImageInput;
}

export interface MutationUploadZineCoverArgs {
  input: UploadCoverZineInput;
}

export interface MutationValidateForSelectionBulkInviteArgs {
  eventId: Scalars["String"]["input"];
  filters: AdminFilterUsersInput;
}

export interface MutationValidateUsersForEmailBulkInviteArgs {
  eventId: Scalars["String"]["input"];
  input: BulkInviteWithEmailsInput;
}

export interface MutationVerifySignupEmailArgs {
  code: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
}

export interface MutationVerifyUserArgs {
  id: Scalars["String"]["input"];
  input: VerifyUserInput;
}

export interface MutationVerifyWebpushSubscriptionArgs {
  input: VerifyWebpushSubscriptionInput;
}

export interface MutationVideoMeetingTokenArgs {
  input: DailyMeetingInput;
}

export enum MutationStatus {
  Failed = "FAILED",
  Success = "SUCCESS",
}

export interface NewMemberAngleModel {
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
}

export interface NewMemberEventModel {
  /** It starts after her Guest Pass ends. */
  afterPass: Scalars["Boolean"]["output"];
  /** Whose clock `when` is on: 'profile', 'signup' (her profile has no timezone yet), or '' when we don't know. */
  clock: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  hostName?: Maybe<Scalars["String"]["output"]>;
  /** Pitched at a level that isn't hers. */
  levelMismatch: Scalars["Boolean"]["output"];
  link: Scalars["String"]["output"];
  /** Outside 7am to 10pm on her clock. */
  outsideHerDay: Scalars["Boolean"]["output"];
  /** Which invitation queue: nmw / cxt / bs. */
  programme: Scalars["String"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  typeLabel: Scalars["String"]["output"];
  /** When it is on her clock, e.g. 'Tuesday 16 September, 19:00'. */
  when?: Maybe<Scalars["String"]["output"]>;
  /** Why the invitation rules chose it. */
  why: Scalars["String"]["output"];
}

export interface NewMemberModel {
  /** Upcoming events she has said yes to. */
  acceptedUpcoming: Scalars["Int"]["output"];
  /** Whole days since she signed up. */
  ageDays: Scalars["Int"]["output"];
  angles: Array<NewMemberAngleModel>;
  challenge?: Maybe<Scalars["String"]["output"]>;
  /** What makes practising hard for her. */
  challengeLabel?: Maybe<Scalars["String"]["output"]>;
  defaultAngle: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  eventsAttended: Scalars["Int"]["output"];
  firstEventId?: Maybe<Scalars["String"]["output"]>;
  /** She skipped booking a first event at signup. */
  firstEventSkipped: Scalars["Boolean"]["output"];
  firstEventStart?: Maybe<Scalars["Date"]["output"]>;
  /** came / ahead / missed. */
  firstEventState?: Maybe<Scalars["String"]["output"]>;
  firstEventTitle?: Maybe<Scalars["String"]["output"]>;
  /** Its start on the clock she picked at signup. */
  firstEventWhen?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  /** Whole days left on her Guest Pass. */
  guestDaysLeft?: Maybe<Scalars["Int"]["output"]>;
  guestPassLive: Scalars["Boolean"]["output"];
  /** Guest Pass events left; null when she has no pass. */
  guestTokensLeft?: Maybe<Scalars["Int"]["output"]>;
  /** Her message for the default angle. */
  message: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  priority?: Maybe<Scalars["String"]["output"]>;
  /** Why she wants spoken English, in the words she saw. */
  priorityLabel?: Maybe<Scalars["String"]["output"]>;
  readiness?: Maybe<Scalars["String"]["output"]>;
  /** Whether she has time to practise this week. */
  readinessLabel?: Maybe<Scalars["String"]["output"]>;
  /** no_first_event / missed_first_event: reach her today. */
  redFlag?: Maybe<Scalars["String"]["output"]>;
  redFlagLabel?: Maybe<Scalars["String"]["output"]>;
  /** The timezone she picked at signup. */
  selectedTimezone?: Maybe<Scalars["String"]["output"]>;
  signedUpAt: Scalars["Date"]["output"];
  /** Where she has got to, in the terms her message is written for. */
  signupState: Scalars["String"]["output"];
  speakingLevel?: Maybe<Scalars["String"]["output"]>;
  /** guest / active / non_renewing / paused / gone. */
  status: Scalars["String"]["output"];
  statusLabel: Scalars["String"]["output"];
  suggestion: NewMemberSuggestionModel;
  /** Her profile timezone. The platform fills it in once she opens the app. */
  timezone?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
}

export interface NewMemberSuggestionModel {
  byType: Array<NewMemberTypeModel>;
  /** The one event her message suggests. */
  event?: Maybe<NewMemberEventModel>;
  /** Upcoming invitations and shares she already holds. */
  holds: Scalars["Int"]["output"];
  /** An invitation she already holds and can open. When set, her message points her to her Invitations instead. */
  invitation?: Maybe<NewMemberEventModel>;
  resourceLink: Scalars["String"]["output"];
  resourceTitle: Scalars["String"]["output"];
  /** The queues she hasn't been to yet. */
  untried: Array<Scalars["String"]["output"]>;
}

export interface NewMemberTypeModel {
  /** Null when nothing of this type is open to her. */
  event?: Maybe<NewMemberEventModel>;
  label: Scalars["String"]["output"];
  programme: Scalars["String"]["output"];
  /** She has already been to one of these. */
  tried: Scalars["Boolean"]["output"];
}

export interface NewMembersResultModel {
  /** The look-back window used, in days. */
  days: Scalars["Int"]["output"];
  generatedAt: Scalars["Date"]["output"];
  members: Array<NewMemberModel>;
  total: Scalars["Int"]["output"];
}

export interface NoteInput {
  description: Scalars["String"]["input"];
}

export interface NoteModel {
  createdAt: Scalars["Date"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface NotificationBaseModel {
  articleNotification?: Maybe<ArticleNotificationModel>;
  badgeNotification?: Maybe<BadgeNotificationModel>;
  chatNotification?: Maybe<ChatNotificationModel>;
  commentNotification?: Maybe<CommentNotificationModel>;
  createdAt: Scalars["Date"]["output"];
  customNotification?: Maybe<CustomNotificationModel>;
  eventNotification?: Maybe<EventNotificationModel>;
  friendJoinedNotification?: Maybe<FriendJoinedNotificationModel>;
  id: Scalars["String"]["output"];
  monthlyReportNotification?: Maybe<MonthlyReportNotificationModel>;
  notificationSeen?: Maybe<Array<NotificationSeenModel>>;
  profileUpdateNotification?: Maybe<ProfileUpdateNotificationModel>;
  type: NotificationType;
  updatedAt: Scalars["Date"]["output"];
}

export interface NotificationCursorPaginatedInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  maxDate?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface NotificationSeenModel {
  id: Scalars["String"]["output"];
  seenAt?: Maybe<Scalars["Date"]["output"]>;
  user: UserModel;
}

export enum NotificationType {
  Article = "Article",
  Badge = "Badge",
  Chat = "Chat",
  Comment = "Comment",
  Custom = "Custom",
  Event = "Event",
  FriendJoined = "FriendJoined",
  MonthlyReport = "MonthlyReport",
  ProfileUpdate = "ProfileUpdate",
}

export interface OccupationInput {
  id: Scalars["String"]["input"];
  industry?: InputMaybe<IndustryInput>;
  name?: InputMaybe<Scalars["String"]["input"]>;
}

export enum OccupationMatch {
  Different = "Different",
  Same = "Same",
  SharedIndustry = "SharedIndustry",
}

export interface OccupationModel {
  id: Scalars["String"]["output"];
  industry?: Maybe<Industry>;
  name?: Maybe<Scalars["String"]["output"]>;
}

export enum Onboarding {
  Availability = "AVAILABILITY",
  Avatar = "AVATAR",
  Complete = "COMPLETE",
  EnglishLevel = "ENGLISH_LEVEL",
  EnglishSkills = "ENGLISH_SKILLS",
  Interests = "INTERESTS",
  Location = "LOCATION",
  Name = "NAME",
  Occupation = "OCCUPATION",
  Story = "STORY",
}

export interface OnlineNowMemberModel {
  email: Scalars["String"]["output"];
  faderLevel?: Maybe<FaderLevel>;
  name: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  zone: ZoneLabel;
}

export interface OrderArticlesInput {
  by?: InputMaybe<ArticleOrderBy>;
  sortAsc?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface OrderEventInput {
  by?: InputMaybe<EventsOrderBy>;
  sort?: InputMaybe<SortDirection>;
}

/** How a tool's members are sliced underneath its headline funnel. */
export enum OutreachBreakdown {
  Campaign = "CAMPAIGN",
  Challenge = "CHALLENGE",
  Filter = "FILTER",
  Priority = "PRIORITY",
  RiskThen = "RISK_THEN",
}

export interface OutreachBreakdownRowModel {
  /** Accepted an invitation we sent (self-signups excluded). */
  accepted: Scalars["Int"]["output"];
  /** Came to any conversation at all after we reached her. */
  attendedAny: Scalars["Int"]["output"];
  /** Came to an event this tool actually put in front of her. */
  attendedInvited: Scalars["Int"]["output"];
  /** The slice this row covers. */
  bucket: Scalars["String"]["output"];
  /** Gone. */
  cancelled: Scalars["Int"]["output"];
  /** Declined an invitation we sent. */
  declined: Scalars["Int"]["output"];
  /** Total conversations those members attended since contact. */
  eventsAttended: Scalars["Int"]["output"];
  /** Still subscribed but set to end on a date that hasn't arrived — too early to say. */
  leaving: Scalars["Int"]["output"];
  /** Logged in since — interested, even if she hasn't come yet. */
  loggedIn: Scalars["Int"]["output"];
  /** Median conversations attended since contact. Median, not mean, so one very active member can't carry a cohort that mostly came to none. */
  medianAttended?: Maybe<Scalars["Float"]["output"]>;
  /** On pause. */
  paused: Scalars["Int"]["output"];
  /** Distinct members this reached in the period. */
  reached: Scalars["Int"]["output"];
  /** Of those reached, how many wrote back afterwards. */
  responded: Scalars["Int"]["output"];
  /** Individual sends it took to reach them. */
  sends: Scalars["Int"]["output"];
  /** Subscribed and renewing now. */
  stayed: Scalars["Int"]["output"];
  /** Still on zero conversations since we reached her. */
  stillZero: Scalars["Int"]["output"];
}

export interface OutreachFunnelModel {
  /** Accepted an invitation we sent (self-signups excluded). */
  accepted: Scalars["Int"]["output"];
  /** Came to any conversation at all after we reached her. */
  attendedAny: Scalars["Int"]["output"];
  /** Came to an event this tool actually put in front of her. */
  attendedInvited: Scalars["Int"]["output"];
  /** Gone. */
  cancelled: Scalars["Int"]["output"];
  /** Declined an invitation we sent. */
  declined: Scalars["Int"]["output"];
  /** Total conversations those members attended since contact. */
  eventsAttended: Scalars["Int"]["output"];
  /** Still subscribed but set to end on a date that hasn't arrived — too early to say. */
  leaving: Scalars["Int"]["output"];
  /** Logged in since — interested, even if she hasn't come yet. */
  loggedIn: Scalars["Int"]["output"];
  /** Median conversations attended since contact. Median, not mean, so one very active member can't carry a cohort that mostly came to none. */
  medianAttended?: Maybe<Scalars["Float"]["output"]>;
  /** On pause. */
  paused: Scalars["Int"]["output"];
  /** Distinct members this reached in the period. */
  reached: Scalars["Int"]["output"];
  /** Of those reached, how many wrote back afterwards. */
  responded: Scalars["Int"]["output"];
  /** Individual sends it took to reach them. */
  sends: Scalars["Int"]["output"];
  /** Subscribed and renewing now. */
  stayed: Scalars["Int"]["output"];
  /** Still on zero conversations since we reached her. */
  stillZero: Scalars["Int"]["output"];
}

export interface OutreachMemberModel {
  accepted: Scalars["Boolean"]["output"];
  /** Conversations attended since that first contact. */
  attendedAfter: Scalars["Int"]["output"];
  /** She came to an event this tool put in front of her. */
  attendedInvited: Scalars["Boolean"]["output"];
  /** The campaign tag on that first contact. */
  campaign?: Maybe<Scalars["String"]["output"]>;
  declined: Scalars["Boolean"]["output"];
  email: Scalars["String"]["output"];
  /** When her current billing period ends — the date a cancellation becomes real. */
  endsAt?: Maybe<Scalars["Date"]["output"]>;
  /** Conversations attended at that contact. */
  eventsThen?: Maybe<Scalars["Int"]["output"]>;
  /** Her first contact from this tool, in the period. */
  firstAt: Scalars["Date"]["output"];
  lastAt: Scalars["Date"]["output"];
  lastLoginAt?: Maybe<Scalars["Date"]["output"]>;
  loggedInSince: Scalars["Boolean"]["output"];
  membership: MembershipNow;
  name: Scalars["String"]["output"];
  /** She wrote back after we reached her. */
  responded: Scalars["Boolean"]["output"];
  /** Her risk level, frozen at that first contact. */
  riskThen?: Maybe<Scalars["String"]["output"]>;
  /** How many times this tool reached her in the period. */
  sends: Scalars["Int"]["output"];
  userId: Scalars["String"]["output"];
}

export interface OutreachResultModel {
  breakdown: Array<OutreachBreakdownRowModel>;
  current: OutreachFunnelModel;
  /** The same funnel over the period immediately before this one. */
  previous?: Maybe<OutreachFunnelModel>;
  source?: Maybe<OutreachSource>;
  trend: Array<OutreachTrendPointModel>;
}

/** Which admin screen an outreach was sent from. */
export enum OutreachSource {
  Cancellations = "CANCELLATIONS",
  ChatAutomations = "CHAT_AUTOMATIONS",
  FindEvents = "FIND_EVENTS",
  InviteCampaigns = "INVITE_CAMPAIGNS",
  InviteCohort = "INVITE_COHORT",
  MemberEvents = "MEMBER_EVENTS",
  NewMembers = "NEW_MEMBERS",
  OnlineNow = "ONLINE_NOW",
  Retention = "RETENTION",
  ShareEvent = "SHARE_EVENT",
  ZoneOutreach = "ZONE_OUTREACH",
}

export interface OutreachSourceResultModel {
  /** Accepted an invitation we sent (self-signups excluded). */
  accepted: Scalars["Int"]["output"];
  /** Came to any conversation at all after we reached her. */
  attendedAny: Scalars["Int"]["output"];
  /** Came to an event this tool actually put in front of her. */
  attendedInvited: Scalars["Int"]["output"];
  /** Gone. */
  cancelled: Scalars["Int"]["output"];
  /** Declined an invitation we sent. */
  declined: Scalars["Int"]["output"];
  /** Total conversations those members attended since contact. */
  eventsAttended: Scalars["Int"]["output"];
  /** Still subscribed but set to end on a date that hasn't arrived — too early to say. */
  leaving: Scalars["Int"]["output"];
  /** Logged in since — interested, even if she hasn't come yet. */
  loggedIn: Scalars["Int"]["output"];
  /** Median conversations attended since contact. Median, not mean, so one very active member can't carry a cohort that mostly came to none. */
  medianAttended?: Maybe<Scalars["Float"]["output"]>;
  /** On pause. */
  paused: Scalars["Int"]["output"];
  /** Distinct members this reached in the period. */
  reached: Scalars["Int"]["output"];
  /** Of those reached, how many wrote back afterwards. */
  responded: Scalars["Int"]["output"];
  /** Individual sends it took to reach them. */
  sends: Scalars["Int"]["output"];
  /** Which screen sent it. Null means unattributed — sent before we recorded the screen, and its campaign tag didn't say. */
  source?: Maybe<OutreachSource>;
  /** Subscribed and renewing now. */
  stayed: Scalars["Int"]["output"];
  /** Still on zero conversations since we reached her. */
  stillZero: Scalars["Int"]["output"];
}

export interface OutreachTrendPointModel {
  attendedAny: Scalars["Int"]["output"];
  /** Start of the bucket (its week's Monday or month's first). */
  bucketStart: Scalars["Date"]["output"];
  /** This bucket is still running. Members reached days ago have had no time to act, so it always reads low and shouldn't be compared with finished buckets. */
  partial: Scalars["Boolean"]["output"];
  reached: Scalars["Int"]["output"];
  responded: Scalars["Int"]["output"];
  sends: Scalars["Int"]["output"];
}

/** The kind of outreach action recorded in the log. */
export enum OutreachType {
  AddMember = "ADD_MEMBER",
  Invite = "INVITE",
  Message = "MESSAGE",
  ShareEvent = "SHARE_EVENT",
}

export interface PaginatedArticles {
  items?: Maybe<Array<ArticleModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedAssessmentResult {
  items?: Maybe<Array<AssessmentResultModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedAssessmentResultInput {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface PaginatedBanners {
  items?: Maybe<Array<BannerModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedChatInvite {
  items?: Maybe<Array<ChatInviteModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedCovers {
  items?: Maybe<Array<CoverModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedCustomNotifications {
  items?: Maybe<Array<CustomNotificationDisplayModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedEvent {
  items?: Maybe<Array<EventModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedFeatureFlags {
  items?: Maybe<Array<FeatureFlagModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedIllustrations {
  items?: Maybe<Array<IllustrationModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedMatchedUser {
  items?: Maybe<Array<UserMatchingModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedReportsUser {
  items?: Maybe<Array<AbuseModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedThemes {
  items?: Maybe<Array<ThemeModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedTopics {
  items?: Maybe<Array<TopicModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedUser {
  items?: Maybe<Array<UserModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedVideoSets {
  items?: Maybe<Array<VideoSetModel>>;
  total: Scalars["Int"]["output"];
}

export interface PaginatedZines {
  items?: Maybe<Array<ZineModel>>;
  total: Scalars["Int"]["output"];
}

export enum ParticipationStatus {
  Attending = "Attending",
  Declined = "Declined",
  Invited = "Invited",
  NotInvited = "NotInvited",
}

export interface ParticipationStatusInput {
  eventId: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}

export interface ParticipationStatusResult {
  status: ParticipationStatus;
}

export interface PauseInput {
  durationDays: Scalars["Int"]["input"];
}

export interface PausePreview {
  durationDays: Scalars["Int"]["output"];
  intendedPauseEndDate: Scalars["Date"]["output"];
  nextBillingAt: Scalars["Date"]["output"];
}

export interface PaymentMethod {
  email?: Maybe<Scalars["String"]["output"]>;
  expMonth?: Maybe<Scalars["Int"]["output"]>;
  expYear?: Maybe<Scalars["Int"]["output"]>;
  last4Digits?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
}

export interface PersonalMessageInput {
  email: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
}

export interface ProfileUpdateNotificationModel {
  id: Scalars["String"]["output"];
  type: ProfileUpdateNotificationType;
}

export enum ProfileUpdateNotificationType {
  CompleteProfile = "CompleteProfile",
}

export interface PublishArticleInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  myEnglishJourney?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledFor?: InputMaybe<Scalars["Date"]["input"]>;
  tags?: InputMaybe<Array<Interest>>;
  theme?: InputMaybe<ArticleThemes>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QuarterOptionModel {
  label: Scalars["String"]["output"];
  /** 'YYYY-Q', e.g. '2026-3'. */
  value: Scalars["String"]["output"];
}

export interface Query {
  adminCampaignEventResults: Array<CampaignEventResultModel>;
  adminCampaignResults: Array<CampaignResultWeekModel>;
  adminCapturedCampaigns: Array<CapturedCampaignModel>;
  adminCapturedConversations: Array<CapturedConversationModel>;
  adminCapturedThread: Array<CapturedMessageItemModel>;
  adminEventInsight: EventInsightModel;
  adminEventLabelCatalogue: Array<EventLabelModel>;
  adminEventMemberMatches: EventMatchResultModel;
  adminEventTimezoneSupply: EventTimezoneSupplyModel;
  adminEventsCalendar: CalendarWeekModel;
  adminEventsForMember: EventsForMemberResultModel;
  adminGetArticle: ArticleModel;
  adminGetBanner: BannerModel;
  adminGetCover: CoverModel;
  adminGetFeatureFlag: FeatureFlagModel;
  adminGetGroupedOccupations: Array<OccupationModel>;
  adminGetIllustration: IllustrationModel;
  adminGetLesson: LessonModel;
  adminGetOccupations: Array<OccupationModel>;
  adminGetPlanDetails: CbPlanDetails;
  adminGetSelectedUsers: Array<UserModel>;
  adminGetSlide: SliderModel;
  adminGetTheme: ThemeModel;
  adminGetTopic: TopicModel;
  adminGetTopicByLessonId: TopicModel;
  adminGetUserFeatureFlag: UserFlagModel;
  adminGetVideoSet?: Maybe<VideoSetModel>;
  adminGetZineCover: ZineModel;
  adminGuestPassSummary?: Maybe<GuestPassSummary>;
  adminGuestPassTokenAdjustments: Array<GuestPassTokenAdjustment>;
  adminInviteCampaign: Array<InviteCampaignZoneModel>;
  adminListCovers: Array<CoverModel>;
  adminListIllustrations: Array<IllustrationModel>;
  adminListPaginatedArticles: PaginatedArticles;
  adminListPaginatedBanners: PaginatedBanners;
  adminListPaginatedCovers: PaginatedCovers;
  adminListPaginatedCustomNotificationDisplay: PaginatedCustomNotifications;
  adminListPaginatedFeatureFlags: PaginatedFeatureFlags;
  adminListPaginatedIllustrations: PaginatedIllustrations;
  adminListPaginatedReportsUsers: PaginatedReportsUser;
  adminListPaginatedThemes: PaginatedThemes;
  adminListPaginatedTopics: PaginatedTopics;
  adminListPaginatedVideoSets: PaginatedVideoSets;
  adminListPaginatedZineCovers: PaginatedZines;
  adminListThemes: Array<ThemeModel>;
  adminListTopics: Array<TopicModel>;
  adminListUserFeatureFlags: Array<UserFlagModel>;
  adminListUsers: PaginatedUser;
  adminMemberEventsReview: Array<MemberEventReviewModel>;
  adminMemberExperience: MemberExperienceModel;
  adminMemberStats: Array<MemberStatsModel>;
  adminMemberZoneMatrix: MemberZonesModel;
  adminMessageCaptureStatus: MessageCaptureStatusModel;
  adminNewMembers: NewMembersResultModel;
  adminOnlineNowMembers: Array<OnlineNowMemberModel>;
  adminOutreachBySource: Array<OutreachSourceResultModel>;
  adminOutreachResultMembers: Array<OutreachMemberModel>;
  adminOutreachResults: OutreachResultModel;
  adminRecentOutreach: Array<RecentOutreachModel>;
  adminReferralRewards: Array<ReferralRewardModel>;
  adminRetentionAttendanceDetail: Array<RetentionAttendanceRowModel>;
  adminRetentionComeback: RetentionComebackModel;
  adminRetentionPrepare: RetentionPrepareModel;
  adminScheduledCancellations: CancellationsResultModel;
  adminSearchEvents: PaginatedEvent;
  adminSecurityEvents?: Maybe<Array<SecurityEventModel>>;
  adminShareEventPreview: ShareEventPreviewModel;
  adminTimezoneRegionMembers: TimezoneRegionMembersModel;
  adminTrialCancellations: CancellationsResultModel;
  adminUserSignUpAnswers?: Maybe<AdminUserSignUpAnswers>;
  adminZonePerformance: ZonePerformanceModel;
  adminZonePerformanceEvents: ZonePerformanceEventsModel;
  articlesWritten: Scalars["Int"]["output"];
  attendanceMetrics?: Maybe<AttendanceMetrics>;
  attendanceRatio: Scalars["Int"]["output"];
  attendanceRecord: AttendanceRecord;
  attendedEvents: AttendedEvents;
  backfillConnectionStreaksRunning: Scalars["Boolean"]["output"];
  chatAutomationsMatchMembers: MatchMembersResultType;
  chatAutomationsRecentSends: Array<SentBatchType>;
  chatAutomationsSendProgress?: Maybe<BulkSendProgressType>;
  chatCreateUserToken: Scalars["Any"]["output"];
  communityDistinctSparks: Scalars["Int"]["output"];
  completedVerificationForm: Array<VideoAskModel>;
  conversationPact: ConversationPactModel;
  /** Crisp Identity Verification signature for the logged-in user's email. */
  crispIdentity?: Maybe<CrispIdentity>;
  dailyEvents: Array<EventsPerDay>;
  friendlyFaces: Array<FriendlyFaces>;
  getArticle: ArticleModel;
  getAssessmentResultById?: Maybe<AssessmentResultModel>;
  getAssessmentResultsCount: Scalars["Int"]["output"];
  getAvalibilityMatchForUsers: Array<AvailabilityMatchForUsers>;
  getCalendar?: Maybe<CalendarModel>;
  getChannelInvite?: Maybe<ChatInviteModel>;
  getChannelInvitesForUsers?: Maybe<Array<ChatInviteModel>>;
  getChannelVideoCall?: Maybe<VideoCallModel>;
  getComment?: Maybe<CommentModel>;
  getCurrentBanner?: Maybe<BannerModel>;
  getCurrentTopicQuestions: Array<QuestionModel>;
  getCurrentZine?: Maybe<ZineModel>;
  getCustomNotificationDisplay: CustomNotificationDisplayModel;
  getDailyHooks: Array<DailyWebHookType>;
  getEvent: EventModel;
  getEventAdmin?: Maybe<EventModel>;
  getEventForConnect: EventModel;
  getEventForMeeting: EventModel;
  getEventWithCache: EventModel;
  getGroupedOccupations: Array<OccupationModel>;
  getInvitedFriendsCount: Scalars["Int"]["output"];
  getInvitedFriendsStats: InvitedFriendsStats;
  getLastAssessmentResult?: Maybe<AssessmentResultModel>;
  getLiveTableById: LiveTableModel;
  getLiveTables: Array<LiveTableModel>;
  getMyStreak: UserStreak;
  getOccupations: Array<OccupationModel>;
  getParticipationStatus: ParticipationStatusResult;
  getPendingChannelInvites?: Maybe<Array<ChatInviteModel>>;
  getPopupNotifications: Array<NotificationBaseModel>;
  getPreviousAssessmentScore?: Maybe<Scalars["Float"]["output"]>;
  getTheme: ThemeModel;
  getTopic: TopicModel;
  getTotalDistinctSparks: Scalars["Int"]["output"];
  getUser: UserModel;
  getUserAdmin?: Maybe<UserModel>;
  getUserAssessmentResults: PaginatedAssessmentResult;
  getUserCalendar?: Maybe<CalendarModel>;
  getUserConnectionStreak: Scalars["Int"]["output"];
  getUserInfo: UserModel;
  getUserMatchingInfo: UserMatchingModel;
  getUserSettings: UserSettingsModel;
  getUserSignUp: UserSignUpModel;
  getUsersWithSameSpeakingLevel: UsersWithSameSpeakingLevel;
  getVideoCall: VideoCallModel;
  getVideos: Array<VideoModel>;
  globalNetwork: Array<Coordinates>;
  guestPassBookingEvents: Array<GuestPassBookingEvent>;
  guestPassRestartBookingEvents: Array<GuestPassBookingEvent>;
  guestPassSummary?: Maybe<GuestPassSummary>;
  hasSeenEventsTab: Scalars["Boolean"]["output"];
  hasSeenEventsTabAfterAttendedThreeEvents: Scalars["Boolean"]["output"];
  homeCheckIns: Array<HomeCheckInModel>;
  hostedEvents: Scalars["Int"]["output"];
  hostedParticipationTime: Scalars["Int"]["output"];
  invoices?: Maybe<Array<Invoice>>;
  itemPrice?: Maybe<CbItemPrice>;
  ladiesAttended: Scalars["Int"]["output"];
  listArticles: PaginatedArticles;
  listAttachment: Array<EventAttachmentModel>;
  listMatchedUsers: PaginatedMatchedUser;
  listMessages: Array<MessageModel>;
  listNotificationsForUser: CursorPaginatedNotifications;
  listPaginatedAssessmentResults: PaginatedAssessmentResult;
  listPaginatedEvents: PaginatedEvent;
  listPendingChatInvites: PaginatedChatInvite;
  listRecommendedUsers: Array<UserMatchingModel>;
  listThemes: Array<ThemeModel>;
  listTopics: Array<TopicModel>;
  listTotp: Array<UserTotpModel>;
  listUserPhotos: Array<UserPhotoModel>;
  me: UserModel;
  monthlyRecapSteps: Array<MonthlyRecapSteps>;
  mySessions: Array<SessionInfo>;
  participationTime: Scalars["Int"]["output"];
  pausePreview: PausePreview;
  paymentMethod?: Maybe<Array<PaymentMethod>>;
  planDetails?: Maybe<CbPlanDetails>;
  recentArticles: Array<ArticleModel>;
  searchMemberzine: Array<ArticleSearchResult>;
  searchTopics: Array<TopicSearchResult>;
  searchUsers: Array<UserSearchResult>;
  seenMonthlyReport: Scalars["Boolean"]["output"];
  /** Choose a different time on a team 1:1 reopens the team's booking page */
  teamCallMoveEnabled: Scalars["Boolean"]["output"];
  totalHostedParticipants: Scalars["Int"]["output"];
  totalPublishedArticles: Scalars["Int"]["output"];
  userAttendedDistinctSparks: Scalars["Int"]["output"];
  userDistinctSparks: Scalars["Int"]["output"];
  userGaveSparkInEvent: Scalars["Boolean"]["output"];
  userHasNoAcceptedInvites: Scalars["Boolean"]["output"];
  userHostedDistinctSparks: Scalars["Int"]["output"];
  userHostedEvents: PaginatedEvent;
  userHostedEventsToShareCount: Scalars["Int"]["output"];
}

export interface QueryAdminCampaignEventResultsArgs {
  campaign: InviteCampaignKey;
  weekStarting: Scalars["Date"]["input"];
}

export interface QueryAdminCampaignResultsArgs {
  campaign: InviteCampaignKey;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminCapturedCampaignsArgs {
  days?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface QueryAdminCapturedConversationsArgs {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  days?: InputMaybe<Scalars["Int"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminCapturedThreadArgs {
  days?: InputMaybe<Scalars["Int"]["input"]>;
  memberId: Scalars["String"]["input"];
}

export interface QueryAdminEventInsightArgs {
  eventId: Scalars["String"]["input"];
}

export interface QueryAdminEventMemberMatchesArgs {
  eventId: Scalars["String"]["input"];
  limit?: Scalars["Int"]["input"];
  minEnglish?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminEventTimezoneSupplyArgs {
  days?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface QueryAdminEventsCalendarArgs {
  weekStart: Scalars["String"]["input"];
}

export interface QueryAdminEventsForMemberArgs {
  days?: Scalars["Int"]["input"];
  email: Scalars["String"]["input"];
  limit?: Scalars["Int"]["input"];
}

export interface QueryAdminGetArticleArgs {
  articleID: Scalars["String"]["input"];
}

export interface QueryAdminGetBannerArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetCoverArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetIllustrationArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetLessonArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetPlanDetailsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminGetSelectedUsersArgs {
  filters: AdminFilterUsersInput;
}

export interface QueryAdminGetSlideArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetThemeArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetTopicByLessonIdArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetUserFeatureFlagArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetVideoSetArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGetZineCoverArgs {
  id: Scalars["String"]["input"];
}

export interface QueryAdminGuestPassSummaryArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminGuestPassTokenAdjustmentsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminInviteCampaignArgs {
  campaign: InviteCampaignKey;
}

export interface QueryAdminListPaginatedArticlesArgs {
  filters: FilterArticlesInput;
  order: OrderArticlesInput;
}

export interface QueryAdminListPaginatedBannersArgs {
  filters: AdminFilterBannersInput;
}

export interface QueryAdminListPaginatedCoversArgs {
  filters: AdminFilterCoversInput;
}

export interface QueryAdminListPaginatedCustomNotificationDisplayArgs {
  filters: FilterCustomNotificationDisplayInput;
}

export interface QueryAdminListPaginatedFeatureFlagsArgs {
  filters: AdminFilterFeatureFlagsInput;
}

export interface QueryAdminListPaginatedIllustrationsArgs {
  filters: AdminFilterIllustrationsInput;
}

export interface QueryAdminListPaginatedReportsUsersArgs {
  filters: AdminFilterReportsUserFilterInput;
}

export interface QueryAdminListPaginatedThemesArgs {
  filters: AdminFilterThemesInput;
}

export interface QueryAdminListPaginatedTopicsArgs {
  filters: AdminFilterTopicsInput;
}

export interface QueryAdminListPaginatedVideoSetsArgs {
  filters: AdminFilterVideoSetInput;
}

export interface QueryAdminListPaginatedZineCoversArgs {
  filters: AdminFilterZineCoversInput;
}

export interface QueryAdminListUsersArgs {
  filters: AdminFilterUsersInput;
}

export interface QueryAdminMemberEventsReviewArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminMemberExperienceArgs {
  attendedEvents?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  joinedAt?: InputMaybe<Scalars["Date"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  planSlug?: InputMaybe<Scalars["String"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminMemberStatsArgs {
  userIds: Array<Scalars["String"]["input"]>;
}

export interface QueryAdminNewMembersArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminOnlineNowMembersArgs {
  faderLevels: Array<FaderLevel>;
}

export interface QueryAdminOutreachBySourceArgs {
  from?: InputMaybe<Scalars["Date"]["input"]>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminOutreachResultMembersArgs {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  source?: InputMaybe<OutreachSource>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminOutreachResultsArgs {
  breakdown?: InputMaybe<OutreachBreakdown>;
  bucket?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["Date"]["input"]>;
  source?: InputMaybe<OutreachSource>;
  to?: InputMaybe<Scalars["Date"]["input"]>;
}

export interface QueryAdminRecentOutreachArgs {
  types?: InputMaybe<Array<OutreachType>>;
  userIds: Array<Scalars["String"]["input"]>;
  withinDays?: Scalars["Int"]["input"];
}

export interface QueryAdminReferralRewardsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminRetentionAttendanceDetailArgs {
  month: Scalars["String"]["input"];
}

export interface QueryAdminRetentionComebackArgs {
  month: Scalars["String"]["input"];
}

export interface QueryAdminRetentionPrepareArgs {
  fader?: Scalars["String"]["input"];
  returningEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
}

export interface QueryAdminScheduledCancellationsArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminSearchEventsArgs {
  filters: AdminFilterEventsInput;
}

export interface QueryAdminSecurityEventsArgs {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  userId: Scalars["String"]["input"];
}

export interface QueryAdminShareEventPreviewArgs {
  emails: Array<Scalars["String"]["input"]>;
  eventId?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminTimezoneRegionMembersArgs {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset: Scalars["Float"]["input"];
}

export interface QueryAdminTrialCancellationsArgs {
  days?: Scalars["Int"]["input"];
}

export interface QueryAdminUserSignUpAnswersArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAdminZonePerformanceArgs {
  quarter?: InputMaybe<Scalars["String"]["input"]>;
}

export interface QueryAdminZonePerformanceEventsArgs {
  eventType?: InputMaybe<Scalars["String"]["input"]>;
  period: Scalars["String"]["input"];
  quarter?: InputMaybe<Scalars["String"]["input"]>;
  zone: Scalars["String"]["input"];
}

export interface QueryArticlesWrittenArgs {
  input: StatisticsInput;
}

export interface QueryAttendanceMetricsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAttendanceRatioArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryAttendanceRecordArgs {
  input: StatisticsInput;
}

export interface QueryAttendedEventsArgs {
  input: StatisticsInput;
}

export interface QueryChatAutomationsMatchMembersArgs {
  input: MatchMembersInput;
}

export interface QueryChatAutomationsSendProgressArgs {
  sendId: Scalars["String"]["input"];
}

export interface QueryCommunityDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryDailyEventsArgs {
  input: StatisticsInput;
}

export interface QueryFriendlyFacesArgs {
  input: StatisticsInput;
}

export interface QueryGetArticleArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetAssessmentResultByIdArgs {
  assessmentResultId: Scalars["String"]["input"];
}

export interface QueryGetAvalibilityMatchForUsersArgs {
  input: AvailabilityForUsersInput;
}

export interface QueryGetChannelInviteArgs {
  channelCid: Scalars["String"]["input"];
}

export interface QueryGetChannelInvitesForUsersArgs {
  input: ChatInvitesForUsersInput;
}

export interface QueryGetChannelVideoCallArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetCommentArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetCustomNotificationDisplayArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventAdminArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventForConnectArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventForMeetingArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetEventWithCacheArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetInvitedFriendsStatsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryGetLiveTableByIdArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetParticipationStatusArgs {
  input: ParticipationStatusInput;
}

export interface QueryGetPendingChannelInvitesArgs {
  channelCid: Scalars["String"]["input"];
}

export interface QueryGetPreviousAssessmentScoreArgs {
  assessmentDate: Scalars["Date"]["input"];
}

export interface QueryGetThemeArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetTopicArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserAdminArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserAssessmentResultsArgs {
  filters: PaginatedAssessmentResultInput;
  userId: Scalars["String"]["input"];
}

export interface QueryGetUserCalendarArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryGetUserConnectionStreakArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryGetUserInfoArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserMatchingInfoArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUserSignUpArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGetUsersWithSameSpeakingLevelArgs {
  speakingLevel: SpeakingLevelCategories;
}

export interface QueryGetVideoCallArgs {
  id: Scalars["String"]["input"];
}

export interface QueryGlobalNetworkArgs {
  input: StatisticsInput;
}

export interface QueryGuestPassBookingEventsArgs {
  englishLevel: EnglishLevel;
  mainSpeakingPracticeChallenge?: InputMaybe<SpeakingPracticeChallenge>;
  timezone: Scalars["String"]["input"];
}

export interface QueryGuestPassRestartBookingEventsArgs {
  timezone: Scalars["String"]["input"];
}

export interface QueryHostedEventsArgs {
  input: StatisticsInput;
}

export interface QueryHostedParticipationTimeArgs {
  input: StatisticsInput;
}

export interface QueryItemPriceArgs {
  itemPriceId: Scalars["String"]["input"];
}

export interface QueryLadiesAttendedArgs {
  input: StatisticsInput;
}

export interface QueryListArticlesArgs {
  filters: FilterArticlesInput;
}

export interface QueryListAttachmentArgs {
  eventID: Scalars["String"]["input"];
}

export interface QueryListMatchedUsersArgs {
  filters: FilterUsersInput;
}

export interface QueryListNotificationsForUserArgs {
  cursor: NotificationCursorPaginatedInput;
  unreadOnly: Scalars["Boolean"]["input"];
}

export interface QueryListPaginatedAssessmentResultsArgs {
  filters: PaginatedAssessmentResultInput;
}

export interface QueryListPaginatedEventsArgs {
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}

export interface QueryListPendingChatInvitesArgs {
  filters: FilterChatInvitesInput;
}

export interface QueryListThemesArgs {
  filters: FilterThemesInput;
}

export interface QueryListTopicsArgs {
  filters: FilterTopicsInput;
}

export interface QueryListUserPhotosArgs {
  userID: Scalars["String"]["input"];
}

export interface QueryMonthlyRecapStepsArgs {
  input: StatisticsInput;
}

export interface QueryParticipationTimeArgs {
  input: StatisticsInput;
}

export interface QueryPausePreviewArgs {
  durationDays: Scalars["Int"]["input"];
}

export interface QueryRecentArticlesArgs {
  userId: Scalars["String"]["input"];
}

export interface QuerySearchMemberzineArgs {
  query: Scalars["String"]["input"];
}

export interface QuerySearchTopicsArgs {
  query: Scalars["String"]["input"];
}

export interface QuerySearchUsersArgs {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  permissions?: InputMaybe<Array<Scalars["String"]["input"]>>;
  query: Scalars["String"]["input"];
}

export interface QueryTotalHostedParticipantsArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryTotalPublishedArticlesArgs {
  userId: Scalars["String"]["input"];
}

export interface QueryUserAttendedDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryUserDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryUserGaveSparkInEventArgs {
  eventId: Scalars["String"]["input"];
}

export interface QueryUserHostedDistinctSparksArgs {
  input: StatisticsInput;
}

export interface QueryUserHostedEventsArgs {
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}

export interface QuestionModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  liveTable?: Maybe<Array<LiveTableModel>>;
  question?: Maybe<Scalars["String"]["output"]>;
  topic?: Maybe<TopicModel>;
  type: QuestionType;
  updatedAt: Scalars["Date"]["output"];
}

export enum QuestionType {
  Icebreaker = "Icebreaker",
  Topic = "Topic",
}

export interface ReadArticleModel {
  article: ArticleModel;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface RecallResultType {
  deleted: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  remaining: Scalars["Int"]["output"];
}

export interface RecentOutreachModel {
  /** How many times contacted in the window. */
  count: Scalars["Int"]["output"];
  lastAt: Scalars["Date"]["output"];
  lastCampaign?: Maybe<Scalars["String"]["output"]>;
  lastType: OutreachType;
  userId: Scalars["String"]["output"];
}

export enum RecurrenceEndType {
  AfterOccurrences = "AFTER_OCCURRENCES",
  OnDate = "ON_DATE",
}

export interface RecurrenceInput {
  inviteToAllRecurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  recurrenceCount?: InputMaybe<Scalars["Int"]["input"]>;
  recurrenceDays?: InputMaybe<Array<WeekDay>>;
  recurrenceEndDate?: InputMaybe<Scalars["Date"]["input"]>;
  recurrenceEndType?: InputMaybe<RecurrenceEndType>;
  recurrenceInterval?: InputMaybe<Scalars["Int"]["input"]>;
  recurrenceType?: InputMaybe<RecurrenceType>;
}

export enum RecurrenceType {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export enum RecurringEditScope {
  AllFuture = "ALL_FUTURE",
  ChooseSpecific = "CHOOSE_SPECIFIC",
  ThisAndFollowing = "THIS_AND_FOLLOWING",
  ThisOnly = "THIS_ONLY",
}

export interface ReferralRewardModel {
  activatedAt: Scalars["Date"]["output"];
  appliedAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  eligibleAt: Scalars["Date"]["output"];
  friendEmail?: Maybe<Scalars["String"]["output"]>;
  friendId: Scalars["String"]["output"];
  friendName?: Maybe<Scalars["String"]["output"]>;
  friendSubscriptionId: Scalars["String"]["output"];
  fulfilledBy?: Maybe<Scalars["String"]["output"]>;
  fulfillmentNote?: Maybe<Scalars["String"]["output"]>;
  heldReason?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  invoiceId: Scalars["String"]["output"];
  issue?: Maybe<Scalars["String"]["output"]>;
  milestones: Array<Scalars["String"]["output"]>;
  milestonesFulfilledAt?: Maybe<Scalars["Date"]["output"]>;
  milestonesFulfilledBy?: Maybe<Scalars["String"]["output"]>;
  milestonesFulfillmentNote?: Maybe<Scalars["String"]["output"]>;
  originalBillingAt?: Maybe<Scalars["Date"]["output"]>;
  referralId: Scalars["String"]["output"];
  referrerId: Scalars["String"]["output"];
  reviewNote?: Maybe<Scalars["String"]["output"]>;
  reviewedAt?: Maybe<Scalars["Date"]["output"]>;
  reviewedBy?: Maybe<Scalars["String"]["output"]>;
  rewardSubscriptionId?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  targetBillingAt?: Maybe<Scalars["Date"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export enum RefundReasons {
  Assistance = "ASSISTANCE",
  Custom = "CUSTOM",
  HelpFindingEvents = "HELP_FINDING_EVENTS",
  HelpFindingPeople = "HELP_FINDING_PEOPLE",
  NeedMoreTime = "NEED_MORE_TIME",
  SomethingElse = "SOMETHING_ELSE",
}

export interface ReportAbuseInput {
  abuserID: Scalars["String"]["input"];
  articleId?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  reason: UserReportReason;
}

export interface RequestPasswordInput {
  email: Scalars["String"]["input"];
}

export interface RequestRefundInput {
  customReason?: InputMaybe<Scalars["String"]["input"]>;
  reason: Array<RefundReasons>;
}

export interface ResendConfirmationEmailInput {
  email: Scalars["String"]["input"];
}

export interface ResetPasswordInput {
  newPassword: Scalars["String"]["input"];
  resetToken: Scalars["String"]["input"];
}

export interface ResponsiveInput {
  desktop?: InputMaybe<Scalars["String"]["input"]>;
  mobile?: InputMaybe<Scalars["String"]["input"]>;
}

export interface ResponsiveType {
  desktop?: Maybe<Scalars["String"]["output"]>;
  mobile?: Maybe<Scalars["String"]["output"]>;
}

export interface RestartGuestPassInput {
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
}

export interface RetentionAttendanceRowModel {
  attended?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  event: Scalars["String"]["output"];
  hostBadge?: Maybe<Scalars["String"]["output"]>;
  hostName?: Maybe<Scalars["String"]["output"]>;
  kind?: Maybe<Scalars["String"]["output"]>;
  member: Scalars["String"]["output"];
}

export interface RetentionComebackModel {
  /** Attended a call after outreach. */
  cameBack: Scalars["Int"]["output"];
  /** Cancelled their membership. */
  cancelled: Scalars["Int"]["output"];
  /** Logged in after outreach but no call yet. */
  interested: Scalars["Int"]["output"];
  /** The month reported (includes the previous month too). */
  month: Scalars["String"]["output"];
  rows: Array<RetentionComebackRowModel>;
  /** Members reached out to in the window. */
  total: Scalars["Int"]["output"];
}

export interface RetentionComebackRowModel {
  /** Did she attend an event since we reached out? */
  cameBack: Scalars["Boolean"]["output"];
  /** Has she cancelled her membership? */
  cancelled: Scalars["Boolean"]["output"];
  comebackDate?: Maybe<Scalars["String"]["output"]>;
  comebackEvent?: Maybe<Scalars["String"]["output"]>;
  comebackHost?: Maybe<Scalars["String"]["output"]>;
  comebackHostBadge?: Maybe<Scalars["String"]["output"]>;
  comebackKind?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  /** Her risk level now. */
  currentFader?: Maybe<Scalars["String"]["output"]>;
  /** Which outreach cycles she got. */
  cycles: Scalars["String"]["output"];
  /** The dates we contacted her. */
  dates: Scalars["String"]["output"];
  daysToComeback?: Maybe<Scalars["Int"]["output"]>;
  email: Scalars["String"]["output"];
  /** Her risk level when first contacted. */
  entryFader?: Maybe<Scalars["String"]["output"]>;
  /** Detected or Critical. */
  entrySegment: Scalars["String"]["output"];
  firstOutreach?: Maybe<Scalars["String"]["output"]>;
  joinDate?: Maybe<Scalars["String"]["output"]>;
  lastAttendanceNow?: Maybe<Scalars["String"]["output"]>;
  lastAttendanceThen?: Maybe<Scalars["String"]["output"]>;
  lastLoginNow?: Maybe<Scalars["String"]["output"]>;
  lastLoginThen?: Maybe<Scalars["String"]["output"]>;
  /** Did she log in since we reached out? */
  loggedInSince: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  outreachCount: Scalars["Int"]["output"];
  plan?: Maybe<Scalars["String"]["output"]>;
  subscriptionStatus?: Maybe<Scalars["String"]["output"]>;
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface RetentionCycle1Model {
  count: Scalars["Int"]["output"];
  groups: Array<RetentionGroupModel>;
  matchTiers: RetentionMatchTiersModel;
  unmatched: Array<RetentionUnmatchedModel>;
}

export interface RetentionCycle2MemberModel {
  email: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** Why she's routed here (e.g. 'Cycle 2 — C1 was 6d ago'). */
  route: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface RetentionCycle2Model {
  count: Scalars["Int"]["output"];
  members: Array<RetentionCycle2MemberModel>;
}

export interface RetentionGroupModel {
  /** Members in this per-zone bulk-invite group. */
  emails: Array<Scalars["String"]["output"]>;
  eventId: Scalars["String"]["output"];
  eventTitle: Scalars["String"]["output"];
  startDate?: Maybe<Scalars["Date"]["output"]>;
  userIds: Array<Scalars["String"]["output"]>;
  zone?: Maybe<ZoneLabel>;
}

export interface RetentionMatchTiersModel {
  coach: Scalars["Int"]["output"];
  cxt: Scalars["Int"]["output"];
  featured: Scalars["Int"]["output"];
  /** Cycle 1 members with no matchable event (need one chosen). */
  none: Scalars["Int"]["output"];
}

export interface RetentionPrepareModel {
  /** The cap that was applied. */
  cap: Scalars["Int"]["output"];
  cycle1: RetentionCycle1Model;
  cycle2: RetentionCycle2Model;
  /** Critical only: members excluded as 'Gone' (no login in ~30 days). */
  excluded?: Maybe<Scalars["Int"]["output"]>;
  /** Detected / Dormant. */
  fader: Scalars["String"]["output"];
  /** Whether any outreach history was found (else all first-time). */
  historyKnown: Scalars["Boolean"]["output"];
  /** Total members at this fader level. */
  total: Scalars["Int"]["output"];
  /** True when more members matched than the cap allowed through. */
  truncated: Scalars["Boolean"]["output"];
  /** Contacted too recently — left for later. */
  waiting: Scalars["Int"]["output"];
}

export interface RetentionUnmatchedModel {
  email: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  route: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
  zone?: Maybe<ZoneLabel>;
}

export interface SaveDraftArticleInput {
  authorId?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  myEnglishJourney?: InputMaybe<Scalars["Boolean"]["input"]>;
  publishedAt?: InputMaybe<Scalars["Date"]["input"]>;
  scheduledFor?: InputMaybe<Scalars["Date"]["input"]>;
  tags?: InputMaybe<Array<Interest>>;
  theme?: InputMaybe<ArticleThemes>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface SearchMatch {
  indices: Array<Array<Scalars["Int"]["output"]>>;
  key?: Maybe<Scalars["String"]["output"]>;
  score?: Maybe<Scalars["Float"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
}

export interface SectionModel {
  createdAt: Scalars["Date"]["output"];
  elements?: Maybe<Array<Element>>;
  id: Scalars["String"]["output"];
  lesson: LessonModel;
  order?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

/** Security-relevant event on an account (audit trail). */
export interface SecurityEventModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  ipAddress?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["String"]["output"]>;
  type: SecurityEventType;
  user?: Maybe<UserModel>;
  userAgent?: Maybe<Scalars["String"]["output"]>;
}

export enum SecurityEventType {
  BannedLoginBlocked = "BANNED_LOGIN_BLOCKED",
  CsrfRejected = "CSRF_REJECTED",
  ImpersonationStarted = "IMPERSONATION_STARTED",
  LogoutAll = "LOGOUT_ALL",
  PasswordChanged = "PASSWORD_CHANGED",
  PasswordReset = "PASSWORD_RESET",
  RefreshWithRevokedToken = "REFRESH_WITH_REVOKED_TOKEN",
  SessionsRevokedAll = "SESSIONS_REVOKED_ALL",
  SessionForceRevoked = "SESSION_FORCE_REVOKED",
  TotpRemoved = "TOTP_REMOVED",
}

export interface SendBulkMessagesInput {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  emails: Array<Scalars["String"]["input"]>;
  message: Scalars["String"]["input"];
  skipContactedWithinDays?: InputMaybe<Scalars["Int"]["input"]>;
  source?: InputMaybe<OutreachSource>;
}

export interface SendDirectChatMessageInput {
  receiverId: Scalars["String"]["input"];
  text: Scalars["String"]["input"];
}

export interface SendPersonalMessagesInput {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  recipients: Array<PersonalMessageInput>;
  skipContactedWithinDays?: InputMaybe<Scalars["Int"]["input"]>;
  source?: InputMaybe<OutreachSource>;
}

export interface SentBatchType {
  batchId: Scalars["String"]["output"];
  campaign?: Maybe<Scalars["String"]["output"]>;
  memberCount: Scalars["Int"]["output"];
  messagePreview?: Maybe<Scalars["String"]["output"]>;
  recallableCount: Scalars["Int"]["output"];
  recalledAt?: Maybe<Scalars["Date"]["output"]>;
  sentAt: Scalars["Date"]["output"];
}

export interface SessionInfo {
  browser: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  /** Is this the calling device's session */
  current: Scalars["Boolean"]["output"];
  /** Hardware class: Desktop / Mobile / Tablet */
  device: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  ip: Scalars["String"]["output"];
  lastSeenAt: Scalars["Date"]["output"];
  /** How the session was established */
  method: Scalars["String"]["output"];
  os: Scalars["String"]["output"];
}

export interface SetPictureInput {
  channelId: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface ShareEventPreviewModel {
  /** Members you've already shared this event with. */
  alreadySharedCount?: Maybe<Scalars["Int"]["output"]>;
  /** Members who would receive the share. Null until an event is given. */
  eligibleCount?: Maybe<Scalars["Int"]["output"]>;
  /** Matched members who are inactive. */
  inactiveCount?: Maybe<Scalars["Int"]["output"]>;
  /** Emails that resolved to a member. */
  matchedCount: Scalars["Int"]["output"];
  /** Members who matched but aren't allowed in this event (wrong plan / tier). */
  notAllowedEmails?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Emails that matched no member. */
  notFound: Array<Scalars["String"]["output"]>;
  /** Distinct emails pasted. */
  totalPasted: Scalars["Int"]["output"];
}

export interface ShareEventResultModel {
  /** Emails that matched no member. */
  notFound: Array<Scalars["String"]["output"]>;
  /** Members the event was shared with. */
  sharedCount: Scalars["Int"]["output"];
}

export interface SimulatedMemberModel {
  /** Whether the advanced events are unlocked for her. */
  advancedUnlocked: Scalars["Boolean"]["output"];
  /** Events attended — the number the 3-event lock reads. */
  attendedEvents: Scalars["Int"]["output"];
  email: Scalars["String"]["output"];
  /** Whether this is a real member or a described profile. */
  isReal: Scalars["Boolean"]["output"];
  /** Staff can attend everything, so the simulation is trivially all-open. */
  isStaff: Scalars["Boolean"]["output"];
  isVerified: Scalars["Boolean"]["output"];
  /** Members who joined before 9 Oct 2025 are never locked. */
  joinedAt?: Maybe<Scalars["Date"]["output"]>;
  /** Her member kind — tenure, not events attended. */
  kind?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  planSlug?: Maybe<Scalars["String"]["output"]>;
  /** The subscription tier the coach rules read. */
  subscriptionTier: Scalars["String"]["output"];
  /** Empty when the simulation describes a member rather than naming one. */
  userId: Scalars["String"]["output"];
}

export interface SliderModel {
  background?: Maybe<ResponsiveType>;
  banner: BannerModel;
  buttonText?: Maybe<Scalars["String"]["output"]>;
  buttonURL?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  featureImage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imageAlignment?: Maybe<ImageAlignment>;
  position?: Maybe<Scalars["Int"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  textColour?: Maybe<TextColour>;
  title?: Maybe<Scalars["String"]["output"]>;
  titleStyle?: Maybe<TitleStyle>;
  updatedAt: Scalars["Date"]["output"];
}

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export interface SparkModel {
  createdAt: Scalars["Date"]["output"];
  event?: Maybe<EventModel>;
  id: Scalars["String"]["output"];
  liveTable?: Maybe<LiveTableModel>;
  user: UserModel;
  videoCall?: Maybe<VideoCallModel>;
}

export enum SpeakingLevelCategories {
  AdvancedHigh = "AdvancedHigh",
  AdvancedLow = "AdvancedLow",
  AdvancedMid = "AdvancedMid",
  Dependent = "Dependent",
  IntermediateHigh = "IntermediateHigh",
  IntermediateLow = "IntermediateLow",
  IntermediateMid = "IntermediateMid",
  Proficient = "Proficient",
}

export enum SpeakingPracticeChallenge {
  NoPracticePeople = "no_practice_people",
  NoTopics = "no_topics",
  NotEnoughTime = "not_enough_time",
  Nothing = "nothing",
  ShyOrNervous = "shy_or_nervous",
}

export interface StatisticsInput {
  end: Scalars["Date"]["input"];
  start: Scalars["Date"]["input"];
  userId: Scalars["String"]["input"];
}

export interface SubscribeInput {
  charges?: InputMaybe<Array<Scalars["String"]["input"]>>;
  couponIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  planId?: InputMaybe<Scalars["String"]["input"]>;
  redirectPage?: InputMaybe<Scalars["String"]["input"]>;
  referredById?: InputMaybe<Scalars["String"]["input"]>;
  signUpId?: InputMaybe<Scalars["String"]["input"]>;
  toltReferralId?: InputMaybe<Scalars["String"]["input"]>;
  trial?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface Subscription {
  assessmentChargesAreSavedForUser: Scalars["String"]["output"];
  assessmentResultsAreSaved: AssessmentResultModel;
  channelVideoCall: VideoCallModel;
  commentCreated: CommentModel;
  commentDeleted: CommentModel;
  communitySparkCreated: SparkModel;
  dunningStatusUpdated: DunningStatusUpdatedResponse;
  eventUpdated: EventUpdatedResponse;
  guestPassUpdated: GuestPassSummary;
  liveTableAboutToEnd: LiveTableModel;
  liveTableChanged: LiveTableModel;
  liveTableHasEnded: LiveTableModel;
  liveTableHasStarted: LiveTableStartedMessage;
  liveTableUpdated: LiveTableModel;
  notificationAdded: NotificationBaseModel;
  popupNotificationAdded: NotificationBaseModel;
  reactionCreated: CommentReactionsModel;
  reactionDeleted: CommentReactionsModel;
  sparkCreated: SparkModel;
  streakEventAttended: UserStreak;
  userPermissionsUpdated: UserPermissionsUpdatedResponse;
  userStatisticsUpdated: UserStatisticsUpdatedResponse;
  videoAskFormCreated: VideoAskModel;
  videoCallUpdated: VideoCallModel;
}

export interface SubscriptionAssessmentChargesAreSavedForUserArgs {
  userId: Scalars["String"]["input"];
}

export interface SubscriptionAssessmentResultsAreSavedArgs {
  assessmentId: Scalars["String"]["input"];
}

export interface SubscriptionChannelVideoCallArgs {
  id: Scalars["String"]["input"];
}

export interface SubscriptionCommentCreatedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionCommentDeletedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionEventUpdatedArgs {
  eventId: Scalars["String"]["input"];
}

export interface SubscriptionLiveTableAboutToEndArgs {
  liveTableId: Scalars["String"]["input"];
}

export interface SubscriptionLiveTableHasEndedArgs {
  liveTableId: Scalars["String"]["input"];
}

export interface SubscriptionLiveTableUpdatedArgs {
  liveTableId: Scalars["String"]["input"];
}

export interface SubscriptionReactionCreatedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionReactionDeletedArgs {
  targetId: Scalars["String"]["input"];
}

export interface SubscriptionSparkCreatedArgs {
  eventId: Scalars["String"]["input"];
}

export interface SubscriptionVideoCallUpdatedArgs {
  id: Scalars["String"]["input"];
}

export enum SubscriptionStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
  Future = "FUTURE",
  Incomplete = "INCOMPLETE",
  IncompleteExpired = "INCOMPLETE_EXPIRED",
  InTrial = "IN_TRIAL",
  NonRenewing = "NON_RENEWING",
  PastDue = "PAST_DUE",
  Paused = "PAUSED",
  Unpaid = "UNPAID",
}

export enum SubscriptionTier {
  Free = "Free",
  Pause = "Pause",
  Social = "Social",
  Study = "Study",
  Supporter = "Supporter",
}

/** How long someone has been a member. */
export enum TenureBucket {
  OneTo_3Months = "ONE_TO_3_MONTHS",
  Over_12Months = "OVER_12_MONTHS",
  SixTo_12Months = "SIX_TO_12_MONTHS",
  ThreeTo_6Months = "THREE_TO_6_MONTHS",
  UpTo_1Month = "UP_TO_1_MONTH",
}

export enum TextColour {
  Dark = "Dark",
  Light = "Light",
}

export interface ThemeModel {
  cover?: Maybe<CoverModel>;
  createdAt: Scalars["Date"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  isCurrent?: Maybe<Scalars["Boolean"]["output"]>;
  isGrammarLibrary?: Maybe<Scalars["Boolean"]["output"]>;
  isResource?: Maybe<Scalars["Boolean"]["output"]>;
  isStandard?: Maybe<Scalars["Boolean"]["output"]>;
  isTopicLibrary?: Maybe<Scalars["Boolean"]["output"]>;
  title: Scalars["String"]["output"];
  topics?: Maybe<Array<TopicModel>>;
  updatedAt: Scalars["Date"]["output"];
}

export enum TimeLimit {
  TenMinutes = "TEN_MINUTES",
  ThirtyMinutes = "THIRTY_MINUTES",
  TwentyMinutes = "TWENTY_MINUTES",
  Unlimited = "UNLIMITED",
}

export interface TimezoneRegionMembersModel {
  label: Scalars["String"]["output"];
  members: Array<TzMemberModel>;
  offset: Scalars["Float"]["output"];
  /** Whether the list was capped. */
  truncated: Scalars["Boolean"]["output"];
}

export enum TitleStyle {
  Bold = "Bold",
  Standard = "Standard",
}

export interface TopicInPreviewInput {
  lessonKind?: InputMaybe<Scalars["Int"]["input"]>;
  lessonTitle?: InputMaybe<Scalars["String"]["input"]>;
  sectionsData?: InputMaybe<Array<EditSectionInput>>;
  topicId: Scalars["String"]["input"];
}

export interface TopicModel {
  comments?: Maybe<Array<CommentModel>>;
  createdAt: Scalars["Date"]["output"];
  duplicateOf?: Maybe<Scalars["String"]["output"]>;
  events?: Maybe<Array<EventModel>>;
  id: Scalars["String"]["output"];
  ideasToDiscuss: Array<Scalars["String"]["output"]>;
  illustration?: Maybe<IllustrationModel>;
  isDefault?: Maybe<Scalars["Boolean"]["output"]>;
  isPreviewMode?: Maybe<Scalars["Boolean"]["output"]>;
  lessons?: Maybe<Array<LessonModel>>;
  likes?: Maybe<Array<LikeModel>>;
  questions?: Maybe<Array<QuestionModel>>;
  stars?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<TopicStatus>;
  theme?: Maybe<ThemeModel>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface TopicSearchResult {
  item: TopicModel;
  matches?: Maybe<Array<SearchMatch>>;
  refIndex: Scalars["Int"]["output"];
}

export enum TopicStatus {
  ComingSoon = "COMING_SOON",
  Current = "CURRENT",
  Inactive = "INACTIVE",
}

export interface TzEventModel {
  /** Deep link to the event in the member app. */
  appLink: Scalars["String"]["output"];
  eventId: Scalars["String"]["output"];
  host?: Maybe<Scalars["String"]["output"]>;
  /** coach | big_sister | cxt | member. */
  hostType: Scalars["String"]["output"];
  /** Start as epoch milliseconds. */
  startMs: Scalars["Float"]["output"];
  title: Scalars["String"]["output"];
  /** Minutes-of-day it starts, in UTC (0–1439). */
  utcMin: Scalars["Int"]["output"];
  /** Start formatted in UTC. */
  whenUtc: Scalars["String"]["output"];
}

export interface TzMemberModel {
  country: Scalars["String"]["output"];
  /** English level band, or '—'. */
  level: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  timezone?: Maybe<Scalars["String"]["output"]>;
}

export interface TzRegionModel {
  /** Row label, e.g. 'Europe · UTC+1 · London, Paris'. */
  label: Scalars["String"]["output"];
  /** Current members at this offset. */
  members: Scalars["Int"]["output"];
  /** Live UTC offset in hours, e.g. -5, 1, 5.5. */
  offset: Scalars["Float"]["output"];
  /** Dominant world region, e.g. 'Europe', or 'Other'. */
  region: Scalars["String"]["output"];
}

export interface UpdateEventAttachmentInput {
  description: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
}

export interface UpdateEventInput {
  conversationKind?: InputMaybe<ConversationKind>;
  coverUrl?: InputMaybe<Scalars["String"]["input"]>;
  customTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  editScope?: InputMaybe<RecurringEditScope>;
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevel>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  eventCategory?: InputMaybe<EventCategory>;
  format?: InputMaybe<Format>;
  hostID?: InputMaybe<Scalars["String"]["input"]>;
  ideasToDiscuss?: InputMaybe<Array<Scalars["String"]["input"]>>;
  illustrationUrl?: InputMaybe<Scalars["String"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isCoachEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  isForUnverified?: InputMaybe<Scalars["Boolean"]["input"]>;
  isLargeCall?: InputMaybe<Scalars["Boolean"]["input"]>;
  isProfessional?: InputMaybe<Scalars["Boolean"]["input"]>;
  isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<EventKind>;
  links?: InputMaybe<Array<LinkInput>>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  locationLat?: InputMaybe<Scalars["Float"]["input"]>;
  locationLong?: InputMaybe<Scalars["Float"]["input"]>;
  maxParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  occupationIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  permissions?: InputMaybe<Array<EventPermissions>>;
  recurrence?: InputMaybe<RecurrenceInput>;
  recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  savedDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
  selectedEventIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  topicId?: InputMaybe<Scalars["String"]["input"]>;
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdateGuestPassBookingInput {
  firstEventBookingSkipped: Scalars["Boolean"]["input"];
  selectedFirstEventId?: InputMaybe<Scalars["String"]["input"]>;
  selectedFirstEventTime?: InputMaybe<Scalars["Date"]["input"]>;
  selectedTimezone?: InputMaybe<Scalars["String"]["input"]>;
  signUpId: Scalars["String"]["input"];
}

export interface UpdateLiveTableInput {
  endDate?: InputMaybe<Scalars["Date"]["input"]>;
  englishLevel?: InputMaybe<EventEnglishLevelNamed>;
  questionId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UpdatePasswordInput {
  currentPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
}

export interface UpdatePhotoInput {
  url: Scalars["String"]["input"];
}

export interface UpdateSettingsInput {
  emailNotifications?: InputMaybe<EmailNotifications>;
  receiveChannelInviteEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChannelInviteNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChannelInviteWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatMentionsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatMentionsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatMentionsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatThreadEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatThreadNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveChatThreadWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRemindersEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRemindersNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRemindersWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRsvpEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRsvpNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventRsvpWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventUpdatesAndInvitationsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventUpdatesAndInvitationsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveEventUpdatesAndInvitationsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFollowsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFollowsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveFollowsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveGroupMessagesWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveLiveTableStartedNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveLiveTableStartedWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveMentionsAndCommentsEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveMentionsAndCommentsNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveMentionsAndCommentsWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receivePersonalMessagesWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receivePlatformStatusEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
  receivePublicChannelsMessagesWebNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  receiveSubscriptionChangesEmails?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UpdateSignupNameInput {
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  signUpId: Scalars["String"]["input"];
}

export interface UpdateUserChannelPermissionInput {
  channelId: Scalars["String"]["input"];
  channelType: ChatChannelType;
  permission: UserChannelPermission;
  userId: Scalars["String"]["input"];
}

export interface UpdateUserInput {
  availability?: InputMaybe<Array<AvailabilityInput>>;
  avatarUrl?: InputMaybe<Scalars["String"]["input"]>;
  birthday?: InputMaybe<Scalars["Date"]["input"]>;
  cambridgeEnglishLevel?: InputMaybe<EnglishLevel>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  cityId?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  countryId?: InputMaybe<Scalars["String"]["input"]>;
  englishSkills?: InputMaybe<Array<EnglishSkill>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  interests?: InputMaybe<Array<Interest>>;
  isAgeVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  lastOnlineAt?: InputMaybe<Scalars["Date"]["input"]>;
  lat?: InputMaybe<Scalars["Float"]["input"]>;
  long?: InputMaybe<Scalars["Float"]["input"]>;
  nationality?: InputMaybe<Scalars["String"]["input"]>;
  nativeLanguage?: InputMaybe<Scalars["String"]["input"]>;
  needSpeakingPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  occupationId?: InputMaybe<Scalars["String"]["input"]>;
  otherLanguage?: InputMaybe<Scalars["String"]["input"]>;
  showBirthday?: InputMaybe<Scalars["Boolean"]["input"]>;
  showBirthdayYear?: InputMaybe<Scalars["Boolean"]["input"]>;
  speakingLevelScore?: InputMaybe<Scalars["Float"]["input"]>;
  story?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  wantsNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UploadActiveDaysInput {
  file: Scalars["Upload"]["input"];
}

export interface UploadCoverZineInput {
  file: Scalars["Upload"]["input"];
  zineId: Scalars["String"]["input"];
}

export interface UploadEventImageInput {
  file: Scalars["Upload"]["input"];
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UploadImageArticleInput {
  articleId: Scalars["String"]["input"];
  cropHeight?: InputMaybe<Scalars["Int"]["input"]>;
  cropWidth?: InputMaybe<Scalars["Int"]["input"]>;
  file: Scalars["Upload"]["input"];
  height?: InputMaybe<Scalars["Int"]["input"]>;
  left?: InputMaybe<Scalars["Int"]["input"]>;
  top?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
}

export interface UploadPhotoInput {
  filename: Scalars["String"]["input"];
}

export interface UploadPictureInput {
  channelId: Scalars["String"]["input"];
  channelType?: InputMaybe<ChatChannelType>;
  filename: Scalars["String"]["input"];
}

export interface UploadUrlsType {
  contentURL?: Maybe<Scalars["String"]["output"]>;
  uploadURL?: Maybe<Scalars["String"]["output"]>;
}

export enum UserBadge {
  BigSister = "BIG_SISTER",
  CommunitySuccess = "COMMUNITY_SUCCESS",
  EnglishCoach = "ENGLISH_COACH",
  Founder = "FOUNDER",
  Guest = "GUEST",
  InactiveMember = "INACTIVE_MEMBER",
  LittleSister = "LITTLE_SISTER",
  Member = "MEMBER",
  MemberSupport = "MEMBER_SUPPORT",
  TechnicalSupport = "TECHNICAL_SUPPORT",
}

export interface UserBadgeModel {
  achievedDate?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isSilent?: Maybe<Scalars["Boolean"]["output"]>;
  type: UserBadgeType;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export enum UserBadgeType {
  Ambassador = "Ambassador",
  ArticlesPublished_1 = "ArticlesPublished_1",
  BigSister = "BigSister",
  BroughtAFriend = "BroughtAFriend",
  CertifiedHost = "CertifiedHost",
  DiamondAmbassador = "DiamondAmbassador",
  EventsParticipated_10 = "EventsParticipated_10",
  EventsParticipated_50 = "EventsParticipated_50",
  EventsParticipated_100 = "EventsParticipated_100",
  EventsParticipated_500 = "EventsParticipated_500",
  EventsParticipated_1000 = "EventsParticipated_1000",
  FoundingMember = "FoundingMember",
  HeyLadyWay = "HeyLadyWay",
  Hosted_1 = "Hosted_1",
  Hosted_10 = "Hosted_10",
  Hosted_50 = "Hosted_50",
  Hosted_100 = "Hosted_100",
  Hosted_500 = "Hosted_500",
  LegendaryLady = "LegendaryLady",
  LocalHosted_1 = "LocalHosted_1",
  LocalHosted_3 = "LocalHosted_3",
  LocalHosted_10 = "LocalHosted_10",
  LocalHosted_25 = "LocalHosted_25",
  Membership_1 = "Membership_1",
  Membership_2 = "Membership_2",
  Membership_3 = "Membership_3",
  Membership_4 = "Membership_4",
  NmmEventAttended = "NMMEventAttended",
  PerfectProfile = "PerfectProfile",
  PlatinumAmbassador = "PlatinumAmbassador",
  ScheduledConversations_1 = "ScheduledConversations_1",
  Verified = "Verified",
}

export enum UserChannelPermission {
  Member = "Member",
  Moderator = "Moderator",
}

export enum UserDeactivationReason {
  Custom = "CUSTOM",
  HardToUse = "HARD_TO_USE",
  NoSpeakingPartner = "NO_SPEAKING_PARTNER",
  NoTimeForEnglishPractice = "NO_TIME_FOR_ENGLISH_PRACTICE",
  ToExpensive = "TO_EXPENSIVE",
  TutorOrLanguageCourse = "TUTOR_OR_LANGUAGE_COURSE",
}

export interface UserEngagementMetrics {
  attendanceRatio?: Maybe<Scalars["Float"]["output"]>;
  totalRsvps?: Maybe<Scalars["Int"]["output"]>;
}

export interface UserEventStatisticsModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  totalAttendedScheduledEvents: Scalars["Int"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export interface UserFlagModel {
  featureFlag: FeatureFlagModel;
  id: Scalars["String"]["output"];
  user: UserModel;
}

export interface UserInviteStatus {
  inviteStatus: InviteStatus;
  userId: Scalars["String"]["input"];
  withCohostedEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
  withHostedEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface UserLocation {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  countryId?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
}

export interface UserMatchingModel {
  defaultMatchScore?: Maybe<Scalars["Float"]["output"]>;
  matchDetails?: Maybe<MatchDetails>;
  matchScores?: Maybe<MatchScores>;
  matchWeights?: Maybe<MatchScores>;
  score?: Maybe<Scalars["Float"]["output"]>;
  user: UserModel;
  userId: Scalars["String"]["output"];
}

export interface UserModel {
  abusers?: Maybe<Array<AbuseModel>>;
  activationKey?: Maybe<Scalars["String"]["output"]>;
  actualResumeDate?: Maybe<Scalars["Date"]["output"]>;
  anonymisationStartedAt?: Maybe<Scalars["Date"]["output"]>;
  anonymisedAt?: Maybe<Scalars["Date"]["output"]>;
  availability?: Maybe<Array<Availability>>;
  availabilityFrom?: Maybe<Scalars["Int"]["output"]>;
  availabilityUntil?: Maybe<Scalars["Int"]["output"]>;
  availableAssessmentCharges?: Maybe<Scalars["Int"]["output"]>;
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  badge?: Maybe<UserBadge>;
  badges: Array<UserBadgeModel>;
  birthday?: Maybe<Scalars["Date"]["output"]>;
  cambridgeEnglishLevel?: Maybe<Scalars["Int"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  cityId?: Maybe<Scalars["String"]["output"]>;
  completedHomeTour?: Maybe<Scalars["Boolean"]["output"]>;
  completedPercentage: Scalars["Int"]["output"];
  country?: Maybe<Scalars["String"]["output"]>;
  countryId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  customFlags: Array<UserFlagModel>;
  customers: Array<ChargebeeCustomerModel>;
  deletedAt?: Maybe<Scalars["Date"]["output"]>;
  email: Scalars["String"]["output"];
  engagementMetrics?: Maybe<UserEngagementMetrics>;
  englishSkills?: Maybe<Array<EnglishSkill>>;
  eventStatistics?: Maybe<UserEventStatisticsModel>;
  extraConversations?: Maybe<Scalars["Int"]["output"]>;
  extraHostedEvents?: Maybe<Scalars["Int"]["output"]>;
  extraInvitedFriends?: Maybe<Scalars["Int"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  followers?: Maybe<Array<FollowerModel>>;
  following?: Maybe<Array<FollowerModel>>;
  googleRefreshToken?: Maybe<Scalars["String"]["output"]>;
  hasActivePlan: Scalars["Boolean"]["output"];
  hasGoogleRefreshToken: Scalars["Boolean"]["output"];
  hasPassword: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  impersonated: Scalars["Boolean"]["output"];
  interests?: Maybe<Array<Interest>>;
  invites: Array<InviteModel>;
  isActive?: Maybe<Scalars["Boolean"]["output"]>;
  isAgeVisible?: Maybe<Scalars["Boolean"]["output"]>;
  isBanned: Scalars["Boolean"]["output"];
  isComplete?: Maybe<Scalars["Boolean"]["output"]>;
  isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
  isHeyLady?: Maybe<Scalars["Boolean"]["output"]>;
  isOnline?: Maybe<Scalars["Boolean"]["output"]>;
  isVerified?: Maybe<Scalars["Boolean"]["output"]>;
  isVisible?: Maybe<Scalars["Boolean"]["output"]>;
  kind?: Maybe<EventPermissions>;
  lastActivityAt?: Maybe<Scalars["Date"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  lastOnlineAt?: Maybe<Scalars["Date"]["output"]>;
  lat?: Maybe<Scalars["Float"]["output"]>;
  long?: Maybe<Scalars["Float"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name: Scalars["String"]["output"];
  nationality?: Maybe<Scalars["String"]["output"]>;
  nativeLanguage?: Maybe<Scalars["String"]["output"]>;
  needSpeakingPartner?: Maybe<Scalars["Boolean"]["output"]>;
  notes: Array<NoteModel>;
  occupation?: Maybe<OccupationModel>;
  onboarding: Onboarding;
  otherLanguage?: Maybe<Scalars["String"]["output"]>;
  partners?: Maybe<Scalars["Int"]["output"]>;
  pauseDuration?: Maybe<Scalars["Int"]["output"]>;
  pauseEligibleFrom?: Maybe<Scalars["Date"]["output"]>;
  pauseRemainingDays?: Maybe<Scalars["Int"]["output"]>;
  pauseStartAt?: Maybe<Scalars["Date"]["output"]>;
  pauseUntil?: Maybe<Scalars["Date"]["output"]>;
  photos: Array<UserPhotoModel>;
  planSlug?: Maybe<Scalars["String"]["output"]>;
  promotionalCredits?: Maybe<Scalars["Int"]["output"]>;
  quizPassedAt?: Maybe<Scalars["Date"]["output"]>;
  recoveryStartedAt?: Maybe<Scalars["Date"]["output"]>;
  seenCompletedAt?: Maybe<Scalars["Date"]["output"]>;
  showBirthday?: Maybe<Scalars["Boolean"]["output"]>;
  showBirthdayYear?: Maybe<Scalars["Boolean"]["output"]>;
  speakingLevel: SpeakingLevelCategories;
  speakingLevelScore: Scalars["Float"]["output"];
  speakingPartners?: Maybe<Scalars["String"]["output"]>;
  stepsCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  story?: Maybe<Scalars["String"]["output"]>;
  subscriptionTier: SubscriptionTier;
  takenSpeakingAssessment?: Maybe<Scalars["Boolean"]["output"]>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  timezoneChosenAt?: Maybe<Scalars["Date"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  updatedLocation?: Maybe<Scalars["Boolean"]["output"]>;
  userSettings?: Maybe<UserSettingsModel>;
  valuesVideoWatchedAt?: Maybe<Scalars["Date"]["output"]>;
  victims?: Maybe<Array<AbuseModel>>;
  wantsNewsletter?: Maybe<Scalars["Boolean"]["output"]>;
  welcomeVideoWatchedAt?: Maybe<Scalars["Date"]["output"]>;
}

export interface UserPermissionsUpdatedResponse {
  badge: UserBadge;
  kind: EventPermissions;
  userId: Scalars["String"]["output"];
}

export interface UserPhotoModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
  user: UserModel;
}

export enum UserReportReason {
  MaleGenderOrFalseIdentityOrPreviouslyBanned = "MALE_GENDER_OR_FALSE_IDENTITY_OR_PREVIOUSLY_BANNED",
  OffensiveOrDisrespectful = "OFFENSIVE_OR_DISRESPECTFUL",
  Other = "OTHER",
  UnacceptableBehaviour = "UNACCEPTABLE_BEHAVIOUR",
}

export interface UserSearchResult {
  item: UserModel;
  matches?: Maybe<Array<SearchMatch>>;
  refIndex: Scalars["Int"]["output"];
}

export interface UserSettingsModel {
  createdAt: Scalars["Date"]["output"];
  emailNotifications?: Maybe<EmailNotifications>;
  id: Scalars["String"]["output"];
  receiveChannelInviteEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChannelInviteNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChannelInviteWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatMentionsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatMentionsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatMentionsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatThreadEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatThreadNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveChatThreadWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRemindersEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRemindersNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRemindersWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRsvpEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRsvpNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventRsvpWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventUpdatesAndInvitationsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventUpdatesAndInvitationsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveEventUpdatesAndInvitationsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveFollowsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveFollowsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveFollowsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveGroupMessagesWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveLiveTableStartedNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveLiveTableStartedWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveMentionsAndCommentsEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receiveMentionsAndCommentsNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveMentionsAndCommentsWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receivePersonalMessagesWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receivePlatformStatusEmails?: Maybe<Scalars["Boolean"]["output"]>;
  receivePublicChannelsMessagesWebNotifications?: Maybe<Scalars["Boolean"]["output"]>;
  receiveSubscriptionChangesEmails?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
}

export interface UserSignUpModel {
  createdAt: Scalars["Date"]["output"];
  detectedTimezone?: Maybe<Scalars["String"]["output"]>;
  eligibilityAgeGender?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  englishLevel?: Maybe<Scalars["Int"]["output"]>;
  firstEventBookingSkipped: Scalars["Boolean"]["output"];
  firstName?: Maybe<Scalars["String"]["output"]>;
  guestPassEligible: Scalars["Boolean"]["output"];
  guestPassWeeklyPracticeReadiness?: Maybe<Scalars["String"]["output"]>;
  hasVerifiedEmail: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  mainSpeakingPracticeChallenge?: Maybe<Scalars["String"]["output"]>;
  mainSpokenEnglishPriority?: Maybe<Scalars["String"]["output"]>;
  /** Her name has no English letter (e.g. from Google), so she must type one. */
  needsLatinName: Scalars["Boolean"]["output"];
  planParam: Scalars["String"]["output"];
  requiresEmailVerification: Scalars["Boolean"]["output"];
  selectedFirstEventId?: Maybe<Scalars["String"]["output"]>;
  selectedFirstEventTime?: Maybe<Scalars["Date"]["output"]>;
  selectedTimezone?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  verificationResendAt?: Maybe<Scalars["Date"]["output"]>;
}

export interface UserStatisticsUpdatedResponse {
  eventStatistics: UserEventStatisticsModel;
  userId: Scalars["String"]["output"];
}

export interface UserStreak {
  connectionStreak: Scalars["Int"]["output"];
  connectionStreakBrokeLastWeek: Scalars["Boolean"]["output"];
  connectionStreakIncrementedThisWeek: Scalars["Boolean"]["output"];
  connectionWeekCompletedThisWeek: Scalars["Boolean"]["output"];
  eventsThisWeek: Scalars["Int"]["output"];
  goalCompletedThisWeek: Scalars["Boolean"]["output"];
  goalStreak: Scalars["Int"]["output"];
  goalStreakBrokeLastWeek: Scalars["Boolean"]["output"];
  nextWeeklyGoal: Scalars["Int"]["output"];
  powerUpCount: Scalars["Int"]["output"];
  powerUpProgress: Scalars["Int"]["output"];
  powerUpRevealed: Scalars["Boolean"]["output"];
  rechargeExplainerSeen: Scalars["Boolean"]["output"];
  streaksExplainerSeen: Scalars["Boolean"]["output"];
  weeklyGoal: Scalars["Int"]["output"];
}

export interface UserTotpModel {
  algorithm: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  deviceName?: Maybe<Scalars["String"]["output"]>;
  digits: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  period: Scalars["Int"]["output"];
  secret: Scalars["String"]["output"];
  uri?: Maybe<Scalars["String"]["output"]>;
  user: UserModel;
  verified: Scalars["Boolean"]["output"];
}

export interface UsersWithSameSpeakingLevel {
  randomUsersAvatars?: Maybe<Array<Scalars["String"]["output"]>>;
  total?: Maybe<Scalars["Int"]["output"]>;
}

export interface ValidateBulkInviteResponse {
  userIds: Array<Scalars["String"]["output"]>;
  warningMessages: Array<Scalars["String"]["output"]>;
}

export interface ValidateSelectionBulkInviteResponse {
  eventTitle?: Maybe<Scalars["String"]["output"]>;
  userIds: Array<Scalars["String"]["output"]>;
  warningMessages: Array<Scalars["String"]["output"]>;
}

export interface VerifyUserInput {
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
}

export interface VerifyWebpushSubscriptionInput {
  authKey: Scalars["String"]["input"];
  endpoint: Scalars["String"]["input"];
  p256hdKey: Scalars["String"]["input"];
}

export enum VerifyWebpushSubscriptionResult {
  AlreadyExists = "AlreadyExists",
  Invalid = "Invalid",
  Stored = "Stored",
}

export enum VideoAskFormType {
  Verification = "Verification",
}

export interface VideoAskModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  type: VideoAskFormType;
  user: UserModel;
}

export interface VideoCallModel {
  chatRoomId: Scalars["String"]["output"];
  closedDoorAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  dailyRoomId: Scalars["String"]["output"];
  endedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  organizer?: Maybe<UserModel>;
  participants: Array<VideoParticipantModel>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
}

export interface VideoModel {
  completedByMe: Scalars["Boolean"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  position: Scalars["Int"]["output"];
  set: VideoSetModel;
  thumbnail?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  videoURL?: Maybe<Scalars["String"]["output"]>;
}

export interface VideoParticipantModel {
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isHost: Scalars["Boolean"]["output"];
  updatedAt: Scalars["Date"]["output"];
  user: UserModel;
  userId: Scalars["String"]["output"];
  videoCall: VideoCallModel;
  videoCallId: Scalars["String"]["output"];
}

export interface VideoSetModel {
  audience?: Maybe<Array<Audience>>;
  colour?: Maybe<ColourCode>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  position: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  videos?: Maybe<Array<VideoModel>>;
}

export enum WeekDay {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export interface ZineModel {
  coverUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  isCurrent?: Maybe<Scalars["Boolean"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
}

export interface ZoneCountModel {
  count: Scalars["Int"]["output"];
  zone: ZoneLabel;
}

/** A three-hour UTC colour zone. */
export enum ZoneLabel {
  Black = "BLACK",
  Blue = "BLUE",
  Green = "GREEN",
  Orange = "ORANGE",
  Pink = "PINK",
  Purple = "PURPLE",
  Red = "RED",
  Yellow = "YELLOW",
}

export interface ZonePerfEventModel {
  attended: Scalars["Int"]["output"];
  eventId: Scalars["String"]["output"];
  host?: Maybe<Scalars["String"]["output"]>;
  rsvps: Scalars["Int"]["output"];
  /** attended / rsvps, as a percentage. */
  showRate: Scalars["Float"]["output"];
  startDate: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  /** EventHostType key. */
  type: Scalars["String"]["output"];
  /** Display label for the type. */
  typeLabel: Scalars["String"]["output"];
  /** Start, formatted in UTC, e.g. 'Wed 12 Feb 19:30'. */
  whenUtc: Scalars["String"]["output"];
}

export interface ZonePerfModel {
  totals: ZoneTotalsModel;
  /** Event types in this zone, busiest first. */
  types: Array<ZoneTypePerfModel>;
  zone: ZoneLabel;
}

export interface ZonePerformanceEventsModel {
  count: Scalars["Int"]["output"];
  /** EventHostType key, or '' for the whole zone. */
  eventType: Scalars["String"]["output"];
  /** Display label for the type, when one is set. */
  eventTypeLabel?: Maybe<Scalars["String"]["output"]>;
  events: Array<ZonePerfEventModel>;
  /** How many of these events had nobody there. */
  noAttendance: Scalars["Int"]["output"];
  periodLabel: Scalars["String"]["output"];
  totalAttended: Scalars["Int"]["output"];
  totalRsvps: Scalars["Int"]["output"];
  zone: ZoneLabel;
}

export interface ZonePerformanceModel {
  /** Whether the reference quarter is the current one. */
  isCurrent: Scalars["Boolean"]["output"];
  /** The current calendar month — only present for the current quarter. */
  month?: Maybe<ZonePeriodModel>;
  /** The quarter before the reference one. */
  prevQuarter: ZonePeriodModel;
  /** The reference quarter. */
  quarter: ZonePeriodModel;
  /** The last 8 quarters, newest first. */
  quarters: Array<QuarterOptionModel>;
  /** The reference quarter, as 'YYYY-Q'. */
  selectedQuarter: Scalars["String"]["output"];
  /** Server 'today' (ISO date). */
  today: Scalars["String"]["output"];
  /** Zones in band order. */
  zoneOrder: Array<ZoneLabel>;
}

export interface ZonePeriodModel {
  /** 'month' | 'quarter' | 'prev_quarter'. */
  key: Scalars["String"]["output"];
  /** Human label, e.g. 'July 2026' or 'Q3 2026 (Jul–Sep)'. */
  label: Scalars["String"]["output"];
  zones: Array<ZonePerfModel>;
}

export interface ZoneTotalsModel {
  events: Scalars["Int"]["output"];
  rsvps: Scalars["Int"]["output"];
  /** showed / rsvps, as a percentage. */
  showUpRate: Scalars["Float"]["output"];
  showed: Scalars["Int"]["output"];
}

export interface ZoneTypePerfModel {
  /** Average accepted RSVPs per event. */
  avgRsvps: Scalars["Float"]["output"];
  events: Scalars["Int"]["output"];
  /** Events of this type in this zone with nobody there. */
  noShowEvents: Scalars["Int"]["output"];
  /** Accepted RSVPs. */
  rsvps: Scalars["Int"]["output"];
  /** This type's share of the zone's events, as a percentage. */
  share: Scalars["Float"]["output"];
  /** showed / rsvps, as a percentage. */
  showUpRate: Scalars["Float"]["output"];
  /** Members who showed up. */
  showed: Scalars["Int"]["output"];
  /** EventHostType key, e.g. 'BIG_SISTER_OTHER'. */
  type: Scalars["String"]["output"];
  /** Display label, e.g. '👩 Big Sister — Other'. */
  typeLabel: Scalars["String"]["output"];
}

export interface CbItemPrice {
  amount?: Maybe<Scalars["Int"]["output"]>;
  interval?: Maybe<Scalars["String"]["output"]>;
  intervalCount?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
}

export interface CbPlanDetails {
  cancelledAt?: Maybe<Scalars["Date"]["output"]>;
  customerChargebeeId?: Maybe<Scalars["String"]["output"]>;
  dunning?: Maybe<Scalars["Boolean"]["output"]>;
  end?: Maybe<Scalars["Date"]["output"]>;
  itemPriceId?: Maybe<Scalars["String"]["output"]>;
  plan?: Maybe<Scalars["JSON"]["output"]>;
  recoveryStartedAt?: Maybe<Scalars["Date"]["output"]>;
  resumesAt?: Maybe<Scalars["Date"]["output"]>;
  scheduledPlan?: Maybe<Scalars["JSON"]["output"]>;
  start?: Maybe<Scalars["Date"]["output"]>;
  status?: Maybe<SubscriptionStatus>;
  subscriptionChargebeeId?: Maybe<Scalars["String"]["output"]>;
  userAmount?: Maybe<Scalars["Int"]["output"]>;
}

export type CommentNotificationFieldsFragment = {
  id: string;
  commentAction: CommentAction;
  comment: {
    id: string;
    targetId: string;
    targetType: CommentTargetType;
    targetArticle?: { title?: string | null } | null;
    targetEvent?: { title?: string | null } | null;
    targetTopic?: { title: string } | null;
  };
  actor?: {
    id: string;
    name: string;
    firstName?: string | null;
    lastName?: string | null;
    avatarUrl?: string | null;
    badge?: UserBadge | null;
  } | null;
};

export type EventNotificationFieldsFragment = {
  id: string;
  action: EventNotificationAction;
  seriesId?: string | null;
  actor?: {
    id: string;
    name: string;
    firstName?: string | null;
    lastName?: string | null;
    avatarUrl?: string | null;
    badge?: UserBadge | null;
  } | null;
  event?: {
    id: string;
    startDate?: any | null;
    endDate?: any | null;
    title?: string | null;
    kind?: EventKind | null;
    isDeleted?: boolean | null;
    deletedNote?: string | null;
    recurring?: boolean | null;
    seriesId?: string | null;
    hasSharedEventNotification?: boolean | null;
    series?: {
      id: string;
      recurrenceType: RecurrenceType;
      recurrenceInterval: number;
      recurrenceDays?: Array<WeekDay> | null;
      recurrenceEndType: RecurrenceEndType;
      recurrenceEndDate?: any | null;
      recurrenceCount?: number | null;
      inviteToAllRecurring: boolean;
      parentEventId?: string | null;
    } | null;
    seriesEvents?: Array<{ id: string; startDate?: any | null; endDate?: any | null }> | null;
    host?: { id: string; name: string } | null;
  } | null;
  invite?: { id: string; status?: InviteStatus | null } | null;
};

export type ChatNotificationFieldsFragment = {
  id: string;
  channelId?: string | null;
  channelName?: string | null;
  chatMessageId?: string | null;
  parentChatMessageId?: string | null;
  chatMessage?: string | null;
  chatAction: ChatAction;
  actor?: {
    id: string;
    name: string;
    firstName?: string | null;
    lastName?: string | null;
    avatarUrl?: string | null;
    badge?: UserBadge | null;
  } | null;
};

export type BadgeNotificationFieldsFragment = {
  id: string;
  badge: { id: string; type: UserBadgeType; achievedDate?: any | null };
};

export type ProfileUpdateNotificationFieldsFragment = {
  id: string;
  type: ProfileUpdateNotificationType;
};

export type ArticleNotificationFieldsFragment = {
  id: string;
  articleAction: ArticleAction;
  article: {
    id: string;
    title?: string | null;
    author?: {
      id: string;
      avatarUrl?: string | null;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      badge?: UserBadge | null;
    } | null;
  };
};

export type MonthlyReportNotificationFieldsFragment = {
  id: string;
  type: MonthlyReportNotificationType;
};

export type FriendJoinedNotificationFieldsFragment = {
  id: string;
  type: FriendJoinedNotificationType;
  user: { id: string; firstName?: string | null; lastName?: string | null };
  friend: {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    avatarUrl?: string | null;
    badge?: UserBadge | null;
  };
};

export type CustomNotificationFieldsFragment = {
  id: string;
  customNotificationDisplay: {
    id: string;
    illustration?: string | null;
    title?: string | null;
    text?: string | null;
    buttonText?: string | null;
    buttonUrl?: string | null;
  };
};

export type InitiateAssessmentMutationVariables = Exact<{ [key: string]: never }>;

export type InitiateAssessmentMutation = {
  initiateAssessment: { assessmentUrl: string; assessmentId: string };
};

export type ChatCreateChannelMutationVariables = Exact<{
  input: CreateChannelInput;
}>;

export type ChatCreateChannelMutation = { chatCreateChannel?: string | null };

export type ChatAddMembersToChannelMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: CreateChannelInput;
}>;

export type ChatAddMembersToChannelMutation = {
  chatAddMembersToChannel?: { status: MutationStatus } | null;
};

export type ChatRemoveMembersFromChannelMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: CreateChannelInput;
}>;

export type ChatRemoveMembersFromChannelMutation = {
  chatRemoveMembersFromChannel?: { status: MutationStatus } | null;
};

export type ChatRenameChannelMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  channelName: Scalars["String"]["input"];
}>;

export type ChatRenameChannelMutation = { chatRenameChannel?: { status: MutationStatus } | null };

export type ChatUpdatePublicChannelInfoMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  channelName: Scalars["String"]["input"];
  channelDescription: Scalars["String"]["input"];
}>;

export type ChatUpdatePublicChannelInfoMutation = {
  chatUpdatePublicChannelInfo?: { status: MutationStatus } | null;
};

export type GenerateChannelPictureUploadUrlMutationVariables = Exact<{
  input: UploadPictureInput;
}>;

export type GenerateChannelPictureUploadUrlMutation = {
  generateChannelPictureUploadUrl?: {
    contentURL?: string | null;
    uploadURL?: string | null;
  } | null;
};

export type SetChannelPictureUrlMutationVariables = Exact<{
  input: SetPictureInput;
}>;

export type SetChannelPictureUrlMutation = {
  setChannelPictureUrl?: { status: MutationStatus } | null;
};

export type CreateVideoCallMutationVariables = Exact<{
  input: CreateVideoCallInput;
}>;

export type CreateVideoCallMutation = {
  createVideoCall: { id: string; title: string; chatRoomId: string; dailyRoomId: string };
};

export type ChatSendDirectMessageMutationVariables = Exact<{
  input: SendDirectChatMessageInput;
}>;

export type ChatSendDirectMessageMutation = {
  chatSendDirectMessage?: { status: MutationStatus } | null;
};

export type ChatUpdateUserChannelPermissionMutationVariables = Exact<{
  input: UpdateUserChannelPermissionInput;
}>;

export type ChatUpdateUserChannelPermissionMutation = {
  chatUpdateUserChannelPermission: { status: MutationStatus };
};

export type AcceptChannelInviteMutationVariables = Exact<{
  channelCid: Scalars["String"]["input"];
}>;

export type AcceptChannelInviteMutation = {
  acceptChannelInvite?: { status: MutationStatus } | null;
};

export type DeclineChannelInviteMutationVariables = Exact<{
  channelCid: Scalars["String"]["input"];
}>;

export type DeclineChannelInviteMutation = {
  declineChannelInvite?: { status: MutationStatus } | null;
};

export type SendManyChatInvitesMutationVariables = Exact<{
  input: ChatInviteInput;
}>;

export type SendManyChatInvitesMutation = {
  sendManyChatInvites?: { status: MutationStatus } | null;
};

export type DeleteChannelInviteMutationVariables = Exact<{
  channelCid: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
}>;

export type DeleteChannelInviteMutation = {
  deleteChannelInvite?: { status: MutationStatus } | null;
};

export type CreateCommentMutationVariables = Exact<{
  targetId: Scalars["String"]["input"];
  targetType: CommentTargetType;
  input: CreateCommentInput;
}>;

export type CreateCommentMutation = {
  createComment?: {
    id: string;
    createdAt: any;
    message: string;
    author?: { id: string; name: string; avatarUrl?: string | null } | null;
    replies?: Array<{
      id: string;
      createdAt: any;
      message: string;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
    }> | null;
  } | null;
};

export type DeleteCommentMutationVariables = Exact<{
  commentID: Scalars["String"]["input"];
}>;

export type DeleteCommentMutation = { deleteComment?: { status: MutationStatus } | null };

export type CreateReactionMutationVariables = Exact<{
  input: CreateReactionInput;
}>;

export type CreateReactionMutation = { createReaction: { id: string; unifiedId: string } };

export type DeleteReactionMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteReactionMutation = { deleteReaction: { status: MutationStatus } };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;

export type CreateEventMutation = { createEvent?: { id: string } | null };

export type PublishEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type PublishEventMutation = { publishEvent?: { id: string } | null };

export type DuplicateEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DuplicateEventMutation = { duplicateEvent?: { id: string } | null };

export type CreateInviteMutationVariables = Exact<{
  input: CreateInviteInput;
}>;

export type CreateInviteMutation = {
  createInvite: {
    id: string;
    status?: InviteStatus | null;
    isHost?: boolean | null;
    user?: { id: string; name: string; avatarUrl?: string | null } | null;
  };
};

export type DeleteInviteMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteInviteMutation = { deleteInvite?: { status: MutationStatus } | null };

export type GenerateAttachmentUploadUrlMutationVariables = Exact<{
  filename: Scalars["String"]["input"];
  eventID: Scalars["String"]["input"];
}>;

export type GenerateAttachmentUploadUrlMutation = {
  generateAttachmentUploadUrl?: { contentURL?: string | null; uploadURL?: string | null } | null;
};

export type CreateAttachmentMutationVariables = Exact<{
  eventID: Scalars["String"]["input"];
  input: CreateEventAttachmentInput;
}>;

export type CreateAttachmentMutation = {
  createAttachment?: {
    id: string;
    url?: string | null;
    meta?: { name?: string | null; extension?: string | null; size?: number | null } | null;
  } | null;
};

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentID: Scalars["String"]["input"];
}>;

export type DeleteAttachmentMutation = { deleteAttachment?: { id: string } | null };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  deleteScope?: InputMaybe<RecurringEditScope>;
  selectedEventIds?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
  deletedNote?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type DeleteEventMutation = { deleteEvent?: { status: MutationStatus } | null };

export type AttendEventMutationVariables = Exact<{
  input: AttendEventInput;
}>;

export type AttendEventMutation = {
  attendEvent?: { id: string; status?: InviteStatus | null } | null;
};

export type AttendMultipleEventsMutationVariables = Exact<{
  eventIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type AttendMultipleEventsMutation = {
  attendMultipleEvents?: { status: MutationStatus } | null;
};

export type RespondToRecurringInvitesMutationVariables = Exact<{
  seriesId: Scalars["String"]["input"];
  acceptEventIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  declineEventIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type RespondToRecurringInvitesMutation = {
  respondToRecurringInvites?: { status: MutationStatus } | null;
};

export type CancelAttendanceMutationVariables = Exact<{
  input: CancelAttendanceInput;
}>;

export type CancelAttendanceMutation = {
  cancelAttendance: { id: string; status?: InviteStatus | null };
};

export type DeclineInviteMutationVariables = Exact<{
  input: DeclineInviteInput;
}>;

export type DeclineInviteMutation = { declineInvite: { id: string; status?: InviteStatus | null } };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: UpdateEventInput;
}>;

export type UpdateEventMutation = {
  updateEvent?: {
    title?: string | null;
    description?: string | null;
    kind?: EventKind | null;
    conversationKind?: ConversationKind | null;
    startDate?: any | null;
    endDate?: any | null;
    isPublic?: boolean | null;
    isLargeCall?: boolean | null;
    host?: {
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
    } | null;
    topic?: { id: string } | null;
    organizer?: {
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
    } | null;
  } | null;
};

export type CloseDoorMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type CloseDoorMutation = { closeDoor?: { id: string; closedDoorAt?: any | null } | null };

export type OpenDoorMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type OpenDoorMutation = { openDoor?: { id: string; closedDoorAt?: any | null } | null };

export type AddEventToGoogleCalendarMutationVariables = Exact<{
  input: AddEventCalendarInput;
}>;

export type AddEventToGoogleCalendarMutation = {
  addEventToGoogleCalendar: {
    status: MutationStatus;
    url?: string | null;
    reason?: GoogleApiMessage | null;
  };
};

export type AddMultipleEventsToGoogleCalendarMutationVariables = Exact<{
  eventIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  calendarType: CalendarType;
}>;

export type AddMultipleEventsToGoogleCalendarMutation = {
  addMultipleEventsToGoogleCalendar: {
    status: MutationStatus;
    url?: string | null;
    reason?: GoogleApiMessage | null;
  };
};

export type EventMeetingTokenMutationVariables = Exact<{
  input: DailyMeetingInput;
}>;

export type EventMeetingTokenMutation = {
  eventMeetingToken?: { token: string; exp?: number | null } | null;
};

export type MarkJoinEventMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type MarkJoinEventMutation = { markJoinEvent: { status: MutationStatus } };

export type SaveParticipantSessionMutationVariables = Exact<{
  participantId: Scalars["String"]["input"];
  meetingSessionId: Scalars["String"]["input"];
}>;

export type SaveParticipantSessionMutation = { saveParticipantSession: { status: MutationStatus } };

export type UploadEventDescriptionImageMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: UploadEventImageInput;
}>;

export type UploadEventDescriptionImageMutation = {
  uploadEventDescriptionImage?: { contentURL?: string | null } | null;
};

export type UploadEventCoverMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: UploadEventImageInput;
}>;

export type UploadEventCoverMutation = { uploadEventCover?: { contentURL?: string | null } | null };

export type DeleteInvitesMutationVariables = Exact<{
  input: DeleteInvitesInput;
}>;

export type DeleteInvitesMutation = { deleteInvites?: { status: MutationStatus } | null };

export type ConfirmInPersonEventMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: ConfirmInPersonEventInput;
}>;

export type ConfirmInPersonEventMutation = { confirmInPersonEvent: { status: MutationStatus } };

export type ShareEventMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
  userIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ShareEventMutation = { shareEvent: { status: MutationStatus } };

export type DeclineSharedEventMutationVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type DeclineSharedEventMutation = { declineSharedEvent: { status: MutationStatus } };

export type SendEventCalendarInvitesMutationVariables = Exact<{
  eventIds: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type SendEventCalendarInvitesMutation = {
  sendEventCalendarInvites: { status: MutationStatus };
};

export type AgreeToConversationPactPromiseMutationVariables = Exact<{
  promise: ConversationPactPromise;
}>;

export type AgreeToConversationPactPromiseMutation = {
  agreeToConversationPactPromise: {
    version: number;
    agreedPromises: Array<ConversationPactPromise>;
    completedAt?: any | null;
  };
};

export type AnswerHomeCheckInMutationVariables = Exact<{
  input: AnswerHomeCheckInInput;
}>;

export type AnswerHomeCheckInMutation = {
  answerHomeCheckIn: {
    id: string;
    kind: HomeCheckInKind;
    answer: HomeCheckInAnswer;
    followUp?: HomeCheckInFollowUp | null;
    answeredAt: any;
    followUpAt?: any | null;
    dismissedAt?: any | null;
  };
};

export type AnswerHomeCheckInFollowUpMutationVariables = Exact<{
  input: AnswerHomeCheckInFollowUpInput;
}>;

export type AnswerHomeCheckInFollowUpMutation = {
  answerHomeCheckInFollowUp: {
    id: string;
    kind: HomeCheckInKind;
    answer: HomeCheckInAnswer;
    followUp?: HomeCheckInFollowUp | null;
    answeredAt: any;
    followUpAt?: any | null;
    dismissedAt?: any | null;
  };
};

export type DismissHomeCheckInMutationVariables = Exact<{
  kind: HomeCheckInKind;
}>;

export type DismissHomeCheckInMutation = {
  dismissHomeCheckIn: {
    id: string;
    kind: HomeCheckInKind;
    answer: HomeCheckInAnswer;
    followUp?: HomeCheckInFollowUp | null;
    answeredAt: any;
    followUpAt?: any | null;
    dismissedAt?: any | null;
  };
};

export type TeamBookingTicketMutationVariables = Exact<{ [key: string]: never }>;

export type TeamBookingTicketMutation = { teamBookingTicket: string };

export type RequestHomeCheckInChatMutationVariables = Exact<{
  kind: HomeCheckInKind;
}>;

export type RequestHomeCheckInChatMutation = {
  requestHomeCheckInChat: {
    id: string;
    kind: HomeCheckInKind;
    answer: HomeCheckInAnswer;
    followUp?: HomeCheckInFollowUp | null;
    answeredAt: any;
    followUpAt?: any | null;
    dismissedAt?: any | null;
  };
};

export type CreateLiveTableMutationVariables = Exact<{
  input: CreateLiveTableInput;
}>;

export type CreateLiveTableMutation = {
  createLiveTable: { id: string; title: string; dailyRoomId: string };
};

export type UpdateLiveTableMutationVariables = Exact<{
  input: UpdateLiveTableInput;
  id: Scalars["String"]["input"];
}>;

export type UpdateLiveTableMutation = { updateLiveTable: { status: MutationStatus } };

export type LiveTableMeetingTokenMutationVariables = Exact<{
  input: DailyMeetingInput;
}>;

export type LiveTableMeetingTokenMutation = {
  liveTableMeetingToken: { token: string; exp?: number | null };
};

export type SendLiveTablesFeedbackMutationVariables = Exact<{
  input: LiveTablesFeedbackInput;
}>;

export type SendLiveTablesFeedbackMutation = { sendLiveTablesFeedback: { status: MutationStatus } };

export type NotifyAboutStartedLiveTableMutationVariables = Exact<{
  input: LiveTableStartedMessageInput;
}>;

export type NotifyAboutStartedLiveTableMutation = {
  notifyAboutStartedLiveTable: { status: MutationStatus };
};

export type DeleteArticleMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteArticleMutation = { deleteArticle?: { id: string } | null };

export type CreateArticleMutationVariables = Exact<{ [key: string]: never }>;

export type CreateArticleMutation = { createArticle?: { id: string } | null };

export type PublishOrScheduleArticleMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: PublishArticleInput;
}>;

export type PublishOrScheduleArticleMutation = { publishOrScheduleArticle?: { id: string } | null };

export type SaveArticleMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: SaveDraftArticleInput;
}>;

export type SaveArticleMutation = {
  saveArticle?: { id: string; tags?: Array<Interest> | null } | null;
};

export type DeleteLikeMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteLikeMutation = { deleteLike?: { status: MutationStatus } | null };

export type CreateLikeMutationVariables = Exact<{
  input: CreateLikeInput;
}>;

export type CreateLikeMutation = { createLike?: { id: string } | null };

export type GenerateArticlesAttachmentUploadUrlMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  filename: Scalars["String"]["input"];
}>;

export type GenerateArticlesAttachmentUploadUrlMutation = {
  generateArticlesAttachmentUploadUrl?: {
    contentURL?: string | null;
    uploadURL?: string | null;
  } | null;
};

export type CreateArticleAttachmentMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: CreateArticlesAttachmentInput;
}>;

export type CreateArticleAttachmentMutation = {
  createArticleAttachment?: { id: string; url?: string | null } | null;
};

export type DeleteArticleAttachmentMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteArticleAttachmentMutation = { deleteArticleAttachment?: { id: string } | null };

export type UploadArticleImageMutationVariables = Exact<{
  input: UploadImageArticleInput;
}>;

export type UploadArticleImageMutation = {
  uploadArticleImage?: { contentURL?: string | null } | null;
};

export type NotificationSeenMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type NotificationSeenMutation = {
  notificationSeen?: {
    id: string;
    notificationSeen?: Array<{ id: string; seenAt?: any | null }> | null;
  } | null;
};

export type MarkAllAsSeenMutationVariables = Exact<{ [key: string]: never }>;

export type MarkAllAsSeenMutation = { markAllAsSeen?: { status: MutationStatus } | null };

export type SubscribePaymentsMutationVariables = Exact<{
  input: SubscribeInput;
}>;

export type SubscribePaymentsMutation = { subscribe?: any | null };

export type ConfirmGuestPassSignupMutationVariables = Exact<{
  input: ConfirmGuestPassSignupInput;
}>;

export type ConfirmGuestPassSignupMutation = {
  confirmGuestPassSignup: {
    email: string;
    hasVerifiedEmail: boolean;
    guestPass: {
      id: string;
      startsAt: any;
      endsAt: any;
      daysRemaining: number;
      tokenAllowance: number;
      tokensUsed: number;
      tokensRemaining: number;
      isActive: boolean;
    };
  };
};

export type GetHostedPageMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetHostedPageMutation = { getHostedPage?: any | null };

export type SwitchMutationVariables = Exact<{
  input: SubscribeInput;
}>;

export type SwitchMutation = { switch?: any | null };

export type ChooseSubscriptionMutationVariables = Exact<{
  input: SubscribeInput;
}>;

export type ChooseSubscriptionMutation = { chooseSubscription?: any | null };

export type CancelScheduleCancelSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type CancelScheduleCancelSubscriptionMutation = {
  cancelScheduleCancelSubscription?: { status: MutationStatus } | null;
};

export type GetPrecancelPageMutationVariables = Exact<{ [key: string]: never }>;

export type GetPrecancelPageMutation = { getPrecancelPage?: string | null };

export type UpdatePaymentMethodMutationVariables = Exact<{ [key: string]: never }>;

export type UpdatePaymentMethodMutation = { updatePaymentMethod?: string | null };

export type ActivateTrialSubscriptionMutationVariables = Exact<{ [key: string]: never }>;

export type ActivateTrialSubscriptionMutation = {
  activateTrialSubscription: { status: MutationStatus };
};

export type ActivateGuestPassMutationVariables = Exact<{
  planId: Scalars["String"]["input"];
}>;

export type ActivateGuestPassMutation = { activateGuestPass?: any | null };

export type RevokeMySessionMutationVariables = Exact<{
  sessionId: Scalars["String"]["input"];
}>;

export type RevokeMySessionMutation = { revokeMySession?: { status: MutationStatus } | null };

export type RevokeOtherMySessionsMutationVariables = Exact<{ [key: string]: never }>;

export type RevokeOtherMySessionsMutation = {
  revokeOtherMySessions?: { status: MutationStatus } | null;
};

export type CreateSparkMutationVariables = Exact<{
  input: CreateSparkInput;
}>;

export type CreateSparkMutation = { createSpark: { status: MutationStatus } };

export type UpdateWeeklyGoalMutationVariables = Exact<{
  goal: Scalars["Int"]["input"];
}>;

export type UpdateWeeklyGoalMutation = { updateWeeklyGoal: { status: MutationStatus } };

export type MarkStreakResetSeenMutationVariables = Exact<{ [key: string]: never }>;

export type MarkStreakResetSeenMutation = { markStreakResetSeen: { status: MutationStatus } };

export type ApplyPowerUpMutationVariables = Exact<{ [key: string]: never }>;

export type ApplyPowerUpMutation = { applyPowerUp: { status: MutationStatus } };

export type MarkPowerUpRevealedMutationVariables = Exact<{ [key: string]: never }>;

export type MarkPowerUpRevealedMutation = { markPowerUpRevealed: { status: MutationStatus } };

export type MarkStreaksExplainerSeenMutationVariables = Exact<{ [key: string]: never }>;

export type MarkStreaksExplainerSeenMutation = {
  markStreaksExplainerSeen: { status: MutationStatus };
};

export type MarkRechargeExplainerSeenMutationVariables = Exact<{ [key: string]: never }>;

export type MarkRechargeExplainerSeenMutation = {
  markRechargeExplainerSeen: { status: MutationStatus };
};

export type ConfirmStreakCelebrationMutationVariables = Exact<{ [key: string]: never }>;

export type ConfirmStreakCelebrationMutation = {
  confirmStreakCelebration: { status: MutationStatus };
};

export type ActivateUserMutationVariables = Exact<{
  input: ActivateUserInput;
}>;

export type ActivateUserMutation = { activateUser?: { status: MutationStatus } | null };

export type ResendConfirmationEmailMutationVariables = Exact<{
  input: ResendConfirmationEmailInput;
}>;

export type ResendConfirmationEmailMutation = {
  resendConfirmationEmail: { status: MutationStatus };
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateUserMutation = { createUser: { id: string } };

export type VerifyUserMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: VerifyUserInput;
}>;

export type VerifyUserMutation = { verifyUser?: { status: MutationStatus } | null };

export type HeartbeatMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type HeartbeatMutation = { heartbeat?: { status: MutationStatus } | null };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateMeMutation = {
  updateMe?: {
    id: string;
    avatarUrl?: string | null;
    needSpeakingPartner?: boolean | null;
    otherLanguage?: string | null;
    cambridgeEnglishLevel?: number | null;
    firstName?: string | null;
    englishSkills?: Array<EnglishSkill> | null;
    interests?: Array<Interest> | null;
    isComplete?: boolean | null;
    lastName?: string | null;
    city?: string | null;
    country?: string | null;
    story?: string | null;
    birthday?: any | null;
    showBirthday?: boolean | null;
    nativeLanguage?: string | null;
    wantsNewsletter?: boolean | null;
    completedPercentage: number;
    occupation?: { id: string } | null;
    availability?: Array<{ from: string; until: string }> | null;
  } | null;
};

export type GenerateUserUploadUrlMutationVariables = Exact<{
  input: UploadPhotoInput;
}>;

export type GenerateUserUploadUrlMutation = {
  generateUserUploadUrl?: { contentURL?: string | null; uploadURL?: string | null } | null;
};

export type CreateUserPhotoMutationVariables = Exact<{
  input: UpdatePhotoInput;
}>;

export type CreateUserPhotoMutation = {
  createUserPhoto?: { id: string; url: string; createdAt: any; updatedAt: any } | null;
};

export type DeleteUserPhotoMutationVariables = Exact<{
  input: DeletePhotoInput;
}>;

export type DeleteUserPhotoMutation = { deleteUserPhoto?: { id: string } | null };

export type RequestResetPasswordMutationVariables = Exact<{
  input: RequestPasswordInput;
}>;

export type RequestResetPasswordMutation = { requestResetPassword: { status: MutationStatus } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;

export type ResetPasswordMutation = { resetPassword?: { status: MutationStatus } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateSettingsInput;
}>;

export type UpdateUserSettingsMutation = { updateUserSettings?: { status: MutationStatus } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;

export type UpdatePasswordMutation = { updatePassword: { status: MutationStatus } };

export type DeactivateMutationVariables = Exact<{
  input: DeactivateInput;
}>;

export type DeactivateMutation = {
  deactivate?: { reason?: string | null; status: MutationStatus } | null;
};

export type RecoverAccountMutationVariables = Exact<{ [key: string]: never }>;

export type RecoverAccountMutation = { recoverAccount?: { status: MutationStatus } | null };

export type CreateAbuseMutationVariables = Exact<{
  input: ReportAbuseInput;
}>;

export type CreateAbuseMutation = {
  createAbuse?: { reason?: UserReportReason | null; description?: string | null } | null;
};

export type ContactUsMutationVariables = Exact<{
  input: ContactUsInput;
}>;

export type ContactUsMutation = { contactUs?: { status: MutationStatus } | null };

export type AddZoomLicenseToUserMutationVariables = Exact<{
  userID: Scalars["String"]["input"];
}>;

export type AddZoomLicenseToUserMutation = {
  addZoomLicenseToUser?: { status: MutationStatus } | null;
};

export type FollowMutationVariables = Exact<{
  input: FollowInput;
}>;

export type FollowMutation = { follow?: { status: MutationStatus } | null };

export type UnFollowMutationVariables = Exact<{
  input: FollowInput;
}>;

export type UnFollowMutation = { unFollow?: { status: MutationStatus } | null };

export type PauseMutationVariables = Exact<{
  input: PauseInput;
}>;

export type PauseMutation = { pause: { status: MutationStatus } };

export type ResumeMutationVariables = Exact<{ [key: string]: never }>;

export type ResumeMutation = { resume: { status: MutationStatus } };

export type SubscribeMutationVariables = Exact<{
  input: SubscribeInput;
}>;

export type SubscribeMutation = { subscribe?: any | null };

export type SetTokenMutationVariables = Exact<{
  input: Scalars["String"]["input"];
}>;

export type SetTokenMutation = { setToken: { status: MutationStatus } };

export type MarkReportAsSeenMutationVariables = Exact<{ [key: string]: never }>;

export type MarkReportAsSeenMutation = { markReportAsSeen?: { status: MutationStatus } | null };

export type AssignCompleteOnboardingQuizBadgeMutationVariables = Exact<{ [key: string]: never }>;

export type AssignCompleteOnboardingQuizBadgeMutation = {
  assignCompleteOnboardingQuizBadge: { status: MutationStatus };
};

export type WatchedWelcomeVideoMutationVariables = Exact<{ [key: string]: never }>;

export type WatchedWelcomeVideoMutation = {
  watchedWelcomeVideo?: { status: MutationStatus } | null;
};

export type WatchedValuesVideoMutationVariables = Exact<{ [key: string]: never }>;

export type WatchedValuesVideoMutation = { watchedValuesVideo?: { status: MutationStatus } | null };

export type MarkEventsTabAsSeenMutationVariables = Exact<{ [key: string]: never }>;

export type MarkEventsTabAsSeenMutation = {
  markEventsTabAsSeen?: { status: MutationStatus } | null;
};

export type MarkEventsTabAsSeenAfterAttendedThreeEventsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type MarkEventsTabAsSeenAfterAttendedThreeEventsMutation = {
  markEventsTabAsSeenAfterAttendedThreeEvents?: { status: MutationStatus } | null;
};

export type SendLinkMutationVariables = Exact<{
  input: FriendInput;
}>;

export type SendLinkMutation = { sendLink?: { status: MutationStatus } | null };

export type CloseVideoCallDoorMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type CloseVideoCallDoorMutation = {
  closeVideoCallDoor: { id: string; closedDoorAt?: any | null };
};

export type OpenVideoCallDoorMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type OpenVideoCallDoorMutation = {
  openVideoCallDoor: { id: string; closedDoorAt?: any | null };
};

export type VideoMeetingTokenMutationVariables = Exact<{
  input: DailyMeetingInput;
}>;

export type VideoMeetingTokenMutation = {
  videoMeetingToken: { token: string; exp?: number | null };
};

export type CompleteVideoMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type CompleteVideoMutation = { completeVideo?: { id: string } | null };

export type CreateWebpushSubscriptionMutationVariables = Exact<{
  input: CreateWebpushSubscriptionInput;
}>;

export type CreateWebpushSubscriptionMutation = {
  createWebpushSubscription: { status: MutationStatus };
};

export type VerifyWebpushSubscriptionMutationVariables = Exact<{
  input: VerifyWebpushSubscriptionInput;
}>;

export type VerifyWebpushSubscriptionMutation = {
  verifyWebpushSubscription: VerifyWebpushSubscriptionResult;
};

export type GetAssessmentChargesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssessmentChargesQuery = {
  me: { id: string; availableAssessmentCharges?: number | null };
};

export type GetAssessmentResultByIdQueryVariables = Exact<{
  assessmentResultId: Scalars["String"]["input"];
}>;

export type GetAssessmentResultByIdQuery = {
  getAssessmentResultById?: {
    halloScore: number;
    cefrScore?: string | null;
    improvements?: Array<string> | null;
    createdAt: any;
    coherenceScore: number;
    fluencyScore: number;
    grammarScore: number;
    pronunciationScore: number;
    vocabularyScore: number;
    isAddedByAdmin: boolean;
  } | null;
};

export type GetPreviousAssessmentScoreQueryVariables = Exact<{
  assessmentDate: Scalars["Date"]["input"];
}>;

export type GetPreviousAssessmentScoreQuery = { getPreviousAssessmentScore?: number | null };

export type GetLastAssessmentResultQueryVariables = Exact<{ [key: string]: never }>;

export type GetLastAssessmentResultQuery = {
  getLastAssessmentResult?: {
    halloScore: number;
    createdAt: any;
    fluencyScore: number;
    vocabularyScore: number;
    grammarScore: number;
    pronunciationScore: number;
    coherenceScore: number;
    assessmentId: string;
    isAddedByAdmin: boolean;
  } | null;
};

export type GetAssessmentResultsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssessmentResultsCountQuery = { getAssessmentResultsCount: number };

export type ListPaginatedAssessmentResultsQueryVariables = Exact<{
  filters: PaginatedAssessmentResultInput;
}>;

export type ListPaginatedAssessmentResultsQuery = {
  listPaginatedAssessmentResults: {
    total: number;
    items?: Array<{ id: string; assessmentId: string; halloScore: number; createdAt: any }> | null;
  };
};

export type GetCurrentBannerQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentBannerQuery = {
  getCurrentBanner?: {
    id: string;
    title: string;
    isActive: boolean;
    sliders?: Array<{
      id: string;
      title?: string | null;
      subtitle?: string | null;
      buttonText?: string | null;
      buttonURL?: string | null;
      featureImage?: string | null;
      titleStyle?: TitleStyle | null;
      textColour?: TextColour | null;
      imageAlignment?: ImageAlignment | null;
      background?: { mobile?: string | null; desktop?: string | null } | null;
    }> | null;
  } | null;
};

export type ChatCreateUserTokenQueryVariables = Exact<{ [key: string]: never }>;

export type ChatCreateUserTokenQuery = { chatCreateUserToken: any };

export type GetChannelInviteQueryVariables = Exact<{
  channelCid: Scalars["String"]["input"];
}>;

export type GetChannelInviteQuery = {
  getChannelInvite?: {
    channelId: string;
    status: ChatInviteStatus;
    actor?: {
      firstName?: string | null;
      lastName?: string | null;
      name: string;
      avatarUrl?: string | null;
    } | null;
  } | null;
};

export type GetChannelInvitesForUsersQueryVariables = Exact<{
  input: ChatInvitesForUsersInput;
}>;

export type GetChannelInvitesForUsersQuery = {
  getChannelInvitesForUsers?: Array<{
    channelId: string;
    status: ChatInviteStatus;
    userId?: string | null;
    updatedAt: any;
  }> | null;
};

export type GetPendingChannelInvitesQueryVariables = Exact<{
  channelCid: Scalars["String"]["input"];
}>;

export type GetPendingChannelInvitesQuery = {
  getPendingChannelInvites?: Array<{
    userId?: string | null;
    createdAt: any;
    actorId?: string | null;
  }> | null;
};

export type ListPendingChatInvitesQueryVariables = Exact<{
  filters: FilterChatInvitesInput;
}>;

export type ListPendingChatInvitesQuery = {
  listPendingChatInvites: {
    total: number;
    items?: Array<{
      id: string;
      channelId: string;
      createdAt: any;
      updatedAt: any;
      actorId?: string | null;
      userId?: string | null;
    }> | null;
  };
};

export type CrispIdentityQueryVariables = Exact<{ [key: string]: never }>;

export type CrispIdentityQuery = { crispIdentity?: { email: string; signature: string } | null };

export type ListPaginatedEventsQueryVariables = Exact<{
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}>;

export type ListPaginatedEventsQuery = {
  listPaginatedEvents: {
    total: number;
    items?: Array<{
      id: string;
      kind?: EventKind | null;
      title?: string | null;
      description?: string | null;
      format?: Format | null;
      conversationKind?: ConversationKind | null;
      coverUrl?: string | null;
      illustrationUrl?: string | null;
      englishLevel?: EventEnglishLevel | null;
      eventCategory?: EventCategory | null;
      startDate?: any | null;
      endDate?: any | null;
      isForUnverified?: boolean | null;
      isCoachEvent?: boolean | null;
      isLargeCall?: boolean | null;
      isProfessional?: boolean | null;
      isFull?: boolean | null;
      maxParticipants?: number | null;
      noParticipants?: number | null;
      noCountableParticipants?: number | null;
      isDraft?: boolean | null;
      permissions?: Array<EventPermissions> | null;
      hasSharedEventNotification?: boolean | null;
      recurring?: boolean | null;
      seriesId?: string | null;
      guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
      topic?: { id: string } | null;
      participants: Array<{ id: string; avatarUrl?: string | null; badge?: UserBadge | null }>;
      cohosts: Array<{
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        kind?: EventPermissions | null;
        badge?: UserBadge | null;
      }>;
      host?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        kind?: EventPermissions | null;
        badge?: UserBadge | null;
      } | null;
      organizer?: { id: string; name: string; kind?: EventPermissions | null } | null;
      invites?: Array<{
        id: string;
        status?: InviteStatus | null;
        isHost?: boolean | null;
        user?: { id: string } | null;
      }> | null;
      occupations?: Array<{ id: string }> | null;
      series?: {
        id: string;
        recurrenceType: RecurrenceType;
        recurrenceInterval: number;
        recurrenceDays?: Array<WeekDay> | null;
        recurrenceEndType: RecurrenceEndType;
        recurrenceEndDate?: any | null;
        recurrenceCount?: number | null;
        inviteToAllRecurring: boolean;
        parentEventId?: string | null;
      } | null;
      seriesEvents?: Array<{ id: string; startDate?: any | null; endDate?: any | null }> | null;
    }> | null;
  };
};

export type UserHostedEventsQueryVariables = Exact<{
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}>;

export type UserHostedEventsQuery = {
  userHostedEvents: {
    total: number;
    items?: Array<{
      id: string;
      title?: string | null;
      isFull?: boolean | null;
      startDate?: any | null;
    }> | null;
  };
};

export type UserHostedEventsToShareCountQueryVariables = Exact<{ [key: string]: never }>;

export type UserHostedEventsToShareCountQuery = { userHostedEventsToShareCount: number };

export type EventQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type EventQuery = {
  getEvent: {
    id: string;
    coverUrl?: string | null;
    illustrationUrl?: string | null;
    createdAt: any;
    format?: Format | null;
    conversationKind?: ConversationKind | null;
    englishLevel?: EventEnglishLevel | null;
    englishSkills?: Array<EnglishSkill> | null;
    eventCategory?: EventCategory | null;
    duplicateOf?: string | null;
    isForUnverified?: boolean | null;
    description?: string | null;
    endDate?: any | null;
    isPublic?: boolean | null;
    isCoachEvent?: boolean | null;
    isLargeCall?: boolean | null;
    isProfessional?: boolean | null;
    isDraft?: boolean | null;
    isDeleted?: boolean | null;
    confirmationStatus?: InPersonEventConfirmationStatus | null;
    interests?: Array<Interest> | null;
    kind?: EventKind | null;
    meta?: any | null;
    location?: string | null;
    locationId?: string | null;
    locationLat?: number | null;
    locationLong?: number | null;
    noParticipants?: number | null;
    noCountableParticipants?: number | null;
    recurring?: boolean | null;
    seriesId?: string | null;
    startDate?: any | null;
    title?: string | null;
    updatedAt: any;
    closedDoorAt?: any | null;
    videoUrl?: string | null;
    maxParticipants?: number | null;
    eventLessonKind?: EventLessonKind | null;
    permissions?: Array<EventPermissions> | null;
    ideasToDiscuss?: Array<string> | null;
    customTopic?: boolean | null;
    createdFromTopic?: boolean | null;
    hasSharedEventNotification?: boolean | null;
    guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
    occupations?: Array<{ id: string; name?: string | null }> | null;
    series?: {
      id: string;
      recurrenceType: RecurrenceType;
      recurrenceInterval: number;
      recurrenceDays?: Array<WeekDay> | null;
      recurrenceEndType: RecurrenceEndType;
      recurrenceEndDate?: any | null;
      recurrenceCount?: number | null;
      inviteToAllRecurring: boolean;
      parentEventId?: string | null;
    } | null;
    seriesEvents?: Array<{
      id: string;
      startDate?: any | null;
      endDate?: any | null;
      title?: string | null;
      isFull?: boolean | null;
      maxParticipants?: number | null;
      noParticipants?: number | null;
      hasSharedEventNotification?: boolean | null;
      guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
      host?: { id: string } | null;
      invites?: Array<{
        id: string;
        status?: InviteStatus | null;
        isHost?: boolean | null;
        user?: { id: string } | null;
      }> | null;
    }> | null;
    links?: Array<{ url: string; description: string }> | null;
    organizer?: {
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
    } | null;
    host?: {
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
    } | null;
    cohosts: Array<{
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
    }>;
    topic?: {
      id: string;
      title: string;
      ideasToDiscuss: Array<string>;
      illustration?: { id: string; url?: string | null } | null;
      lessons?: Array<{ id: string; kind: LessonKind; deepDiveKind?: DeepDiveKind | null }> | null;
      theme?: { id: string; title: string; isTopicLibrary?: boolean | null } | null;
    } | null;
    participants: Array<{
      id: string;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
      createdAt: any;
      firstName?: string | null;
      lastName?: string | null;
      isVerified?: boolean | null;
      kind?: EventPermissions | null;
    }>;
    invites?: Array<{
      id: string;
      isHost?: boolean | null;
      status?: InviteStatus | null;
      isConfirmed?: boolean | null;
      user?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        createdAt: any;
        badge?: UserBadge | null;
        avatarUrl?: string | null;
      } | null;
    }> | null;
    attachments?: Array<{
      id: string;
      url?: string | null;
      meta?: { extension?: string | null; name?: string | null; size?: number | null } | null;
    }> | null;
    comments?: Array<{
      id: string;
      createdAt: any;
      message: string;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
      reactions?: Array<{
        id: string;
        unifiedId: string;
        user: {
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
        };
      }> | null;
      replies?: Array<{
        id: string;
        createdAt: any;
        message: string;
        author?: { id: string; name: string; avatarUrl?: string | null } | null;
        reactions?: Array<{
          id: string;
          unifiedId: string;
          user: {
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatarUrl?: string | null;
          };
        }> | null;
      }> | null;
    }> | null;
  };
};

export type GetEventWithCacheQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventWithCacheQuery = {
  getEventWithCache: {
    id: string;
    coverUrl?: string | null;
    illustrationUrl?: string | null;
    createdAt: any;
    format?: Format | null;
    conversationKind?: ConversationKind | null;
    englishLevel?: EventEnglishLevel | null;
    englishSkills?: Array<EnglishSkill> | null;
    eventCategory?: EventCategory | null;
    duplicateOf?: string | null;
    isForUnverified?: boolean | null;
    description?: string | null;
    endDate?: any | null;
    isDraft?: boolean | null;
    isDeleted?: boolean | null;
    confirmationStatus?: InPersonEventConfirmationStatus | null;
    interests?: Array<Interest> | null;
    kind?: EventKind | null;
    meta?: any | null;
    location?: string | null;
    locationId?: string | null;
    locationLat?: number | null;
    locationLong?: number | null;
    noParticipants?: number | null;
    noCountableParticipants?: number | null;
    isPublic?: boolean | null;
    isCoachEvent?: boolean | null;
    isLargeCall?: boolean | null;
    isProfessional?: boolean | null;
    recurring?: boolean | null;
    seriesId?: string | null;
    startDate?: any | null;
    title?: string | null;
    updatedAt: any;
    closedDoorAt?: any | null;
    videoUrl?: string | null;
    maxParticipants?: number | null;
    eventLessonKind?: EventLessonKind | null;
    permissions?: Array<EventPermissions> | null;
    ideasToDiscuss?: Array<string> | null;
    customTopic?: boolean | null;
    createdFromTopic?: boolean | null;
    hasSharedEventNotification?: boolean | null;
    guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
    occupations?: Array<{ id: string; name?: string | null }> | null;
    series?: {
      id: string;
      recurrenceType: RecurrenceType;
      recurrenceInterval: number;
      recurrenceDays?: Array<WeekDay> | null;
      recurrenceEndType: RecurrenceEndType;
      recurrenceEndDate?: any | null;
      recurrenceCount?: number | null;
      inviteToAllRecurring: boolean;
      parentEventId?: string | null;
    } | null;
    seriesEvents?: Array<{
      id: string;
      startDate?: any | null;
      endDate?: any | null;
      title?: string | null;
      isFull?: boolean | null;
      maxParticipants?: number | null;
      noParticipants?: number | null;
      hasSharedEventNotification?: boolean | null;
      guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
      host?: { id: string } | null;
      invites?: Array<{
        id: string;
        status?: InviteStatus | null;
        isHost?: boolean | null;
        user?: { id: string } | null;
      }> | null;
    }> | null;
    links?: Array<{ url: string; description: string }> | null;
    organizer?: {
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
    } | null;
    host?: {
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
    } | null;
    cohosts: Array<{
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
    }>;
    topic?: {
      id: string;
      title: string;
      ideasToDiscuss: Array<string>;
      illustration?: { id: string; url?: string | null } | null;
      lessons?: Array<{ id: string; kind: LessonKind; deepDiveKind?: DeepDiveKind | null }> | null;
      theme?: { id: string; title: string; isTopicLibrary?: boolean | null } | null;
    } | null;
    participants: Array<{
      id: string;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
      createdAt: any;
      firstName?: string | null;
      lastName?: string | null;
      isVerified?: boolean | null;
      kind?: EventPermissions | null;
    }>;
    invites?: Array<{
      id: string;
      isHost?: boolean | null;
      status?: InviteStatus | null;
      isConfirmed?: boolean | null;
      user?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        createdAt: any;
        badge?: UserBadge | null;
        avatarUrl?: string | null;
        kind?: EventPermissions | null;
      } | null;
    }> | null;
    attachments?: Array<{
      id: string;
      url?: string | null;
      meta?: { extension?: string | null; name?: string | null; size?: number | null } | null;
    }> | null;
    comments?: Array<{
      id: string;
      createdAt: any;
      message: string;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
      reactions?: Array<{
        id: string;
        unifiedId: string;
        user: {
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
        };
      }> | null;
      replies?: Array<{
        id: string;
        createdAt: any;
        message: string;
        author?: { id: string; name: string; avatarUrl?: string | null } | null;
        reactions?: Array<{
          id: string;
          unifiedId: string;
          user: {
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatarUrl?: string | null;
          };
        }> | null;
      }> | null;
    }> | null;
  };
};

export type GetEventForMeetingQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventForMeetingQuery = {
  getEventForMeeting: {
    id: string;
    title?: string | null;
    kind?: EventKind | null;
    format?: Format | null;
    closedDoorAt?: any | null;
    meta?: any | null;
    host?: { id: string; kind?: EventPermissions | null } | null;
    participants: Array<{ id: string; kind?: EventPermissions | null }>;
    cohosts: Array<{ id: string; kind?: EventPermissions | null }>;
    invites?: Array<{
      id: string;
      isHost?: boolean | null;
      user?: { id: string; kind?: EventPermissions | null } | null;
    }> | null;
  };
};

export type TopicsAndThemesQueryVariables = Exact<{ [key: string]: never }>;

export type TopicsAndThemesQuery = {
  listThemes: Array<{
    id: string;
    title: string;
    createdAt: any;
    description?: string | null;
    isCurrent?: boolean | null;
    isStandard?: boolean | null;
    isTopicLibrary?: boolean | null;
    isGrammarLibrary?: boolean | null;
    updatedAt: any;
    cover?: {
      id: string;
      title: string;
      primary?: { mobile?: string | null; desktop?: string | null } | null;
      secondary?: { mobile?: string | null; desktop?: string | null } | null;
      tertiary?: { mobile?: string | null; desktop?: string | null } | null;
    } | null;
    topics?: Array<{
      id: string;
      title: string;
      illustration?: { id: string; title: string; url?: string | null } | null;
    }> | null;
  }>;
};

export type GetEventForConnectQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventForConnectQuery = {
  getEventForConnect: {
    id: string;
    isDeleted?: boolean | null;
    host?: {
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
      city?: string | null;
      country?: string | null;
      interests?: Array<Interest> | null;
    } | null;
    cohosts: Array<{
      id: string;
      name: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      createdAt: any;
      badge?: UserBadge | null;
      kind?: EventPermissions | null;
      city?: string | null;
      country?: string | null;
      interests?: Array<Interest> | null;
    }>;
    participants: Array<{
      id: string;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
      createdAt: any;
      firstName?: string | null;
      lastName?: string | null;
      isVerified?: boolean | null;
      kind?: EventPermissions | null;
      city?: string | null;
      country?: string | null;
      interests?: Array<Interest> | null;
    }>;
  };
};

export type GetEventForSeriesQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetEventForSeriesQuery = {
  getEvent: {
    id: string;
    seriesId?: string | null;
    seriesEvents?: Array<{
      id: string;
      startDate?: any | null;
      endDate?: any | null;
      title?: string | null;
      isFull?: boolean | null;
      maxParticipants?: number | null;
      noParticipants?: number | null;
      hasSharedEventNotification?: boolean | null;
      guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
      host?: { id: string } | null;
      invites?: Array<{
        id: string;
        status?: InviteStatus | null;
        isHost?: boolean | null;
        user?: { id: string } | null;
      }> | null;
    }> | null;
  };
};

export type GuestHomeNextEventQueryVariables = Exact<{
  filters: FilterPaginatedEventInput;
  order?: InputMaybe<OrderEventInput>;
}>;

export type GuestHomeNextEventQuery = {
  listPaginatedEvents: {
    total: number;
    items?: Array<{
      id: string;
      kind?: EventKind | null;
      title?: string | null;
      format?: Format | null;
      conversationKind?: ConversationKind | null;
      coverUrl?: string | null;
      illustrationUrl?: string | null;
      englishLevel?: EventEnglishLevel | null;
      startDate?: any | null;
      endDate?: any | null;
      isPublic?: boolean | null;
      isCoachEvent?: boolean | null;
      maxParticipants?: number | null;
      noParticipants?: number | null;
      noCountableParticipants?: number | null;
      confirmationStatus?: InPersonEventConfirmationStatus | null;
      closedDoorAt?: any | null;
      addedToCalendar: boolean;
      meta?: any | null;
      guestPassAccess?: { status: GuestPassEventAccessStatus; consumesToken: boolean } | null;
      host?: {
        id: string;
        name: string;
        firstName?: string | null;
        avatarUrl?: string | null;
        kind?: EventPermissions | null;
        badge?: UserBadge | null;
      } | null;
      cohosts: Array<{ id: string; kind?: EventPermissions | null }>;
    }> | null;
  };
};

export type GuestHomeCurrentThemeQueryVariables = Exact<{ [key: string]: never }>;

export type GuestHomeCurrentThemeQuery = { listThemes: Array<{ id: string; title: string }> };

export type GuestPassSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type GuestPassSummaryQuery = {
  guestPassSummary?: {
    id: string;
    startsAt: any;
    endsAt: any;
    daysRemaining: number;
    tokenAllowance: number;
    tokensUsed: number;
    tokensRemaining: number;
    isActive: boolean;
    canActivateMembership: boolean;
    canRestartGuestPass: boolean;
    shouldShowCompletionModal: boolean;
  } | null;
};

export type GuestPassRestartBookingEventsQueryVariables = Exact<{
  timezone: Scalars["String"]["input"];
}>;

export type GuestPassRestartBookingEventsQuery = {
  guestPassRestartBookingEvents: Array<{
    id: string;
    title: string;
    startDate: any;
    endDate: any;
    durationMinutes: number;
    kind: EventKind;
    format: Format;
  }>;
};

export type RestartGuestPassMutationVariables = Exact<{
  input?: InputMaybe<RestartGuestPassInput>;
}>;

export type RestartGuestPassMutation = {
  restartGuestPass: {
    id: string;
    daysRemaining: number;
    isActive: boolean;
    tokenAllowance: number;
    tokensRemaining: number;
    tokensUsed: number;
  };
};

export type DismissGuestPassCompletionModalMutationVariables = Exact<{ [key: string]: never }>;

export type DismissGuestPassCompletionModalMutation = {
  dismissGuestPassCompletionModal: { id: string; shouldShowCompletionModal: boolean };
};

export type CreateGuestPassFlowUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;

export type CreateGuestPassFlowUserMutation = { createUser: { id: string } };

export type UpdateGuestPassBookingMutationVariables = Exact<{
  input: UpdateGuestPassBookingInput;
}>;

export type UpdateGuestPassBookingMutation = {
  updateGuestPassBooking: {
    id: string;
    selectedTimezone?: string | null;
    selectedFirstEventId?: string | null;
    selectedFirstEventTime?: any | null;
    firstEventBookingSkipped: boolean;
  };
};

export type GuestPassBookingEventsQueryVariables = Exact<{
  englishLevel: EnglishLevel;
  timezone: Scalars["String"]["input"];
  mainSpeakingPracticeChallenge?: InputMaybe<SpeakingPracticeChallenge>;
}>;

export type GuestPassBookingEventsQuery = {
  guestPassBookingEvents: Array<{
    id: string;
    title: string;
    startDate: any;
    endDate: any;
    durationMinutes: number;
    kind: EventKind;
    format: Format;
  }>;
};

export type ConversationPactFieldsFragment = {
  version: number;
  agreedPromises: Array<ConversationPactPromise>;
  completedAt?: any | null;
};

export type ConversationPactQueryVariables = Exact<{ [key: string]: never }>;

export type ConversationPactQuery = {
  conversationPact: {
    version: number;
    agreedPromises: Array<ConversationPactPromise>;
    completedAt?: any | null;
  };
};

export type HomeCheckInFieldsFragment = {
  id: string;
  kind: HomeCheckInKind;
  answer: HomeCheckInAnswer;
  followUp?: HomeCheckInFollowUp | null;
  answeredAt: any;
  followUpAt?: any | null;
  dismissedAt?: any | null;
};

export type TeamCallMoveEnabledQueryVariables = Exact<{ [key: string]: never }>;

export type TeamCallMoveEnabledQuery = { teamCallMoveEnabled: boolean };

export type HomeCheckInsQueryVariables = Exact<{ [key: string]: never }>;

export type HomeCheckInsQuery = {
  homeCheckIns: Array<{
    id: string;
    kind: HomeCheckInKind;
    answer: HomeCheckInAnswer;
    followUp?: HomeCheckInFollowUp | null;
    answeredAt: any;
    followUpAt?: any | null;
    dismissedAt?: any | null;
  }>;
};

export type GetLiveTablesQueryVariables = Exact<{ [key: string]: never }>;

export type GetLiveTablesQuery = {
  getLiveTables: Array<{
    id: string;
    title: string;
    englishLevel?: EventEnglishLevelNamed | null;
    maxParticipants: number;
    dailyRoomId: string;
    endDate?: any | null;
    timeLimit?: TimeLimit | null;
    createdAt: any;
    question?: { id: string; question?: string | null; type: QuestionType } | null;
    participants: Array<{
      id: string;
      user: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      };
    }>;
  }>;
};

export type GetLiveTableByIdQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetLiveTableByIdQuery = {
  getLiveTableById: {
    id: string;
    title: string;
    englishLevel?: EventEnglishLevelNamed | null;
    dailyRoomId: string;
    isActive?: boolean | null;
    endedAt?: any | null;
    timeLimit?: TimeLimit | null;
    creatorId?: string | null;
    endDate?: any | null;
    question?: { id: string; question?: string | null; type: QuestionType } | null;
    participants: Array<{
      id: string;
      user: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      };
    }>;
  };
};

export type GetCurrentTopicQuestionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentTopicQuestionsQuery = {
  getCurrentTopicQuestions: Array<{
    id: string;
    question?: string | null;
    updatedAt: any;
    topic?: {
      id: string;
      title: string;
      illustration?: { id: string; title: string; url?: string | null } | null;
    } | null;
  }>;
};

export type MemberzineQueryVariables = Exact<{ [key: string]: never }>;

export type MemberzineQuery = {
  getCurrentZine?: { coverUrl?: string | null } | null;
  listFeatured: {
    total: number;
    items?: Array<{
      id: string;
      coverUrl?: string | null;
      title?: string | null;
      isFeatured?: boolean | null;
      noComments?: number | null;
      noLikes?: number | null;
      author?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
      } | null;
    }> | null;
  };
  followingAuthorsArticles: {
    total: number;
    items?: Array<{
      id: string;
      coverUrl?: string | null;
      title?: string | null;
      isFeatured?: boolean | null;
      noComments?: number | null;
      noLikes?: number | null;
      author?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
      } | null;
    }> | null;
  };
  recommendedArticles: {
    items?: Array<{
      id: string;
      coverUrl?: string | null;
      title?: string | null;
      isFeatured?: boolean | null;
      noComments?: number | null;
      noLikes?: number | null;
      author?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
      } | null;
    }> | null;
  };
  allArticles: {
    total: number;
    items?: Array<{
      id: string;
      coverUrl?: string | null;
      title?: string | null;
      isFeatured?: boolean | null;
      noComments?: number | null;
      noLikes?: number | null;
      author?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
      } | null;
    }> | null;
  };
};

export type UploadArticleCoverMutationVariables = Exact<{
  input: UploadImageArticleInput;
}>;

export type UploadArticleCoverMutation = {
  uploadArticleCover?: { id: string; coverUrl?: string | null } | null;
};

export type GetArticleQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetArticleQuery = {
  getArticle: {
    noComments?: number | null;
    noLikes?: number | null;
    content?: string | null;
    coverUrl?: string | null;
    createdAt: any;
    id: string;
    isDraft?: boolean | null;
    isFeatured?: boolean | null;
    publishedAt?: any | null;
    scheduledFor?: any | null;
    tags?: Array<Interest> | null;
    myEnglishJourney?: boolean | null;
    title?: string | null;
    theme?: ArticleThemes | null;
    updatedAt: any;
    likedByMe?: { id: string } | null;
    author?: { id: string; name: string; avatarUrl?: string | null } | null;
    attachments?: Array<{
      id: string;
      description?: string | null;
      url?: string | null;
      createdAt: any;
      updatedAt: any;
      meta?: { name?: string | null; size?: number | null; extension?: string | null } | null;
    }> | null;
    comments?: Array<{
      id: string;
      createdAt: any;
      message: string;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
      reactions?: Array<{
        id: string;
        unifiedId: string;
        user: {
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
        };
      }> | null;
      replies?: Array<{
        id: string;
        createdAt: any;
        message: string;
        author?: { id: string; name: string; avatarUrl?: string | null } | null;
        reactions?: Array<{
          id: string;
          unifiedId: string;
          user: {
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatarUrl?: string | null;
          };
        }> | null;
      }> | null;
    }> | null;
  };
};

export type ListArticlesQueryVariables = Exact<{
  filters: FilterArticlesInput;
}>;

export type ListArticlesQuery = {
  listArticles: {
    total: number;
    items?: Array<{
      id: string;
      coverUrl?: string | null;
      title?: string | null;
      isFeatured?: boolean | null;
      isDraft?: boolean | null;
      publishedAt?: any | null;
      noComments?: number | null;
      noLikes?: number | null;
      author?: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        name: string;
        avatarUrl?: string | null;
      } | null;
    }> | null;
  };
};

export type ListNotificationsForUserQueryVariables = Exact<{
  cursor: NotificationCursorPaginatedInput;
  unreadOnly: Scalars["Boolean"]["input"];
}>;

export type ListNotificationsForUserQuery = {
  listNotificationsForUser: {
    total: number;
    nextCursor?: any | null;
    items: Array<{
      id: string;
      type: NotificationType;
      createdAt: any;
      notificationSeen?: Array<{ id: string; seenAt?: any | null }> | null;
      chatNotification?: {
        id: string;
        channelId?: string | null;
        channelName?: string | null;
        chatMessageId?: string | null;
        parentChatMessageId?: string | null;
        chatMessage?: string | null;
        chatAction: ChatAction;
        actor?: {
          id: string;
          name: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
          badge?: UserBadge | null;
        } | null;
      } | null;
      commentNotification?: {
        id: string;
        commentAction: CommentAction;
        comment: {
          id: string;
          targetId: string;
          targetType: CommentTargetType;
          targetArticle?: { title?: string | null } | null;
          targetEvent?: { title?: string | null } | null;
          targetTopic?: { title: string } | null;
        };
        actor?: {
          id: string;
          name: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
          badge?: UserBadge | null;
        } | null;
      } | null;
      eventNotification?: {
        id: string;
        action: EventNotificationAction;
        seriesId?: string | null;
        actor?: {
          id: string;
          name: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
          badge?: UserBadge | null;
        } | null;
        event?: {
          id: string;
          startDate?: any | null;
          endDate?: any | null;
          title?: string | null;
          kind?: EventKind | null;
          isDeleted?: boolean | null;
          deletedNote?: string | null;
          recurring?: boolean | null;
          seriesId?: string | null;
          hasSharedEventNotification?: boolean | null;
          series?: {
            id: string;
            recurrenceType: RecurrenceType;
            recurrenceInterval: number;
            recurrenceDays?: Array<WeekDay> | null;
            recurrenceEndType: RecurrenceEndType;
            recurrenceEndDate?: any | null;
            recurrenceCount?: number | null;
            inviteToAllRecurring: boolean;
            parentEventId?: string | null;
          } | null;
          seriesEvents?: Array<{ id: string; startDate?: any | null; endDate?: any | null }> | null;
          host?: { id: string; name: string } | null;
        } | null;
        invite?: { id: string; status?: InviteStatus | null } | null;
      } | null;
      articleNotification?: {
        id: string;
        articleAction: ArticleAction;
        article: {
          id: string;
          title?: string | null;
          author?: {
            id: string;
            avatarUrl?: string | null;
            name: string;
            firstName?: string | null;
            lastName?: string | null;
            badge?: UserBadge | null;
          } | null;
        };
      } | null;
      friendJoinedNotification?: {
        id: string;
        type: FriendJoinedNotificationType;
        user: { id: string; firstName?: string | null; lastName?: string | null };
        friend: {
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
          badge?: UserBadge | null;
        };
      } | null;
    }>;
  };
};

export type GetPopupNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPopupNotificationsQuery = {
  getPopupNotifications: Array<{
    id: string;
    type: NotificationType;
    createdAt: any;
    notificationSeen?: Array<{ id: string; seenAt?: any | null }> | null;
    badgeNotification?: {
      id: string;
      badge: { id: string; type: UserBadgeType; achievedDate?: any | null };
    } | null;
    eventNotification?: {
      id: string;
      action: EventNotificationAction;
      seriesId?: string | null;
      actor?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      } | null;
      event?: {
        id: string;
        startDate?: any | null;
        endDate?: any | null;
        title?: string | null;
        kind?: EventKind | null;
        isDeleted?: boolean | null;
        deletedNote?: string | null;
        recurring?: boolean | null;
        seriesId?: string | null;
        hasSharedEventNotification?: boolean | null;
        series?: {
          id: string;
          recurrenceType: RecurrenceType;
          recurrenceInterval: number;
          recurrenceDays?: Array<WeekDay> | null;
          recurrenceEndType: RecurrenceEndType;
          recurrenceEndDate?: any | null;
          recurrenceCount?: number | null;
          inviteToAllRecurring: boolean;
          parentEventId?: string | null;
        } | null;
        seriesEvents?: Array<{ id: string; startDate?: any | null; endDate?: any | null }> | null;
        host?: { id: string; name: string } | null;
      } | null;
      invite?: { id: string; status?: InviteStatus | null } | null;
    } | null;
    profileUpdateNotification?: { id: string; type: ProfileUpdateNotificationType } | null;
    monthlyReportNotification?: { id: string; type: MonthlyReportNotificationType } | null;
    friendJoinedNotification?: {
      id: string;
      type: FriendJoinedNotificationType;
      user: { id: string; firstName?: string | null; lastName?: string | null };
      friend: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      };
    } | null;
    customNotification?: {
      id: string;
      customNotificationDisplay: {
        id: string;
        illustration?: string | null;
        title?: string | null;
        text?: string | null;
        buttonText?: string | null;
        buttonUrl?: string | null;
      };
    } | null;
  }>;
};

export type GetInvitedFriendsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetInvitedFriendsCountQuery = { getInvitedFriendsCount: number };

export type SearchUsersQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  eventId?: InputMaybe<Scalars["String"]["input"]>;
  isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  permissions?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
}>;

export type SearchUsersQuery = {
  searchUsers: Array<{
    item: { id: string; name: string; avatarUrl?: string | null; badge?: UserBadge | null };
    matches?: Array<{ indices: Array<Array<number>>; value?: string | null }> | null;
  }>;
};

export type SearchMemberzineQueryVariables = Exact<{
  query: Scalars["String"]["input"];
}>;

export type SearchMemberzineQuery = {
  searchMemberzine: Array<{
    item: {
      id: string;
      title?: string | null;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
    };
    matches?: Array<{
      indices: Array<Array<number>>;
      value?: string | null;
      key?: string | null;
    }> | null;
  }>;
};

export type SearchTopicsQueryVariables = Exact<{
  query: Scalars["String"]["input"];
}>;

export type SearchTopicsQuery = {
  searchTopics: Array<{
    item: { id: string; title: string };
    matches?: Array<{
      indices: Array<Array<number>>;
      value?: string | null;
      key?: string | null;
    }> | null;
  }>;
};

export type MySessionsQueryVariables = Exact<{ [key: string]: never }>;

export type MySessionsQuery = {
  mySessions: Array<{
    id: string;
    device: string;
    browser: string;
    os: string;
    ip: string;
    method: string;
    createdAt: any;
    lastSeenAt: any;
    current: boolean;
  }>;
};

export type GetUserSignUpQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetUserSignUpQuery = {
  getUserSignUp: {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
    requiresEmailVerification: boolean;
    verificationResendAt?: any | null;
    guestPassEligible: boolean;
    hasVerifiedEmail: boolean;
    selectedTimezone?: string | null;
    selectedFirstEventId?: string | null;
    selectedFirstEventTime?: any | null;
    firstEventBookingSkipped: boolean;
    needsLatinName: boolean;
  };
};

export type UpdateSignupNameMutationVariables = Exact<{
  input: UpdateSignupNameInput;
}>;

export type UpdateSignupNameMutation = {
  updateSignupName: {
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    needsLatinName: boolean;
  };
};

export type VerifySignupEmailMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  code: Scalars["String"]["input"];
}>;

export type VerifySignupEmailMutation = {
  verifySignupEmail: {
    id: string;
    email: string;
    hasVerifiedEmail: boolean;
    verificationResendAt?: any | null;
  };
};

export type ResendSignupEmailCodeMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ResendSignupEmailCodeMutation = {
  resendSignupEmailCode: {
    id: string;
    email: string;
    hasVerifiedEmail: boolean;
    verificationResendAt?: any | null;
  };
};

export type GetTotalDistinctSparksQueryVariables = Exact<{ [key: string]: never }>;

export type GetTotalDistinctSparksQuery = { getTotalDistinctSparks: number };

export type UserGaveSparkInEventQueryVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type UserGaveSparkInEventQuery = { userGaveSparkInEvent: boolean };

export type GetMyStreakQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyStreakQuery = {
  getMyStreak: {
    weeklyGoal: number;
    nextWeeklyGoal: number;
    connectionStreak: number;
    goalStreak: number;
    eventsThisWeek: number;
    connectionWeekCompletedThisWeek: boolean;
    goalCompletedThisWeek: boolean;
    connectionStreakBrokeLastWeek: boolean;
    goalStreakBrokeLastWeek: boolean;
    powerUpCount: number;
    powerUpRevealed: boolean;
    powerUpProgress: number;
    connectionStreakIncrementedThisWeek: boolean;
    streaksExplainerSeen: boolean;
    rechargeExplainerSeen: boolean;
  };
};

export type GetUserConnectionStreakQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserConnectionStreakQuery = { getUserConnectionStreak: number };

export type ThemesQueryVariables = Exact<{
  filters: FilterThemesInput;
}>;

export type ThemesQuery = {
  listThemes: Array<{
    id: string;
    title: string;
    createdAt: any;
    description?: string | null;
    isCurrent?: boolean | null;
    isStandard?: boolean | null;
    isTopicLibrary?: boolean | null;
    isGrammarLibrary?: boolean | null;
    isResource?: boolean | null;
    updatedAt: any;
    cover?: {
      id: string;
      title: string;
      primary?: { mobile?: string | null; desktop?: string | null } | null;
      secondary?: { mobile?: string | null; desktop?: string | null } | null;
      tertiary?: { mobile?: string | null; desktop?: string | null } | null;
    } | null;
    topics?: Array<{
      id: string;
      title: string;
      status?: TopicStatus | null;
      illustration?: { id: string; title: string; url?: string | null } | null;
    }> | null;
  }>;
};

export type ThemeQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ThemeQuery = {
  getTheme: {
    id: string;
    isResource?: boolean | null;
    topics?: Array<{
      id: string;
      title: string;
      illustration?: { id: string; title: string; url?: string | null } | null;
    }> | null;
  };
};

export type TopicsQueryVariables = Exact<{
  filters: FilterTopicsInput;
}>;

export type TopicsQuery = {
  listTopics: Array<{
    id: string;
    title: string;
    illustration?: { id: string; title: string; url?: string | null } | null;
    theme?: { id: string; title: string } | null;
  }>;
};

export type TopicQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type TopicQuery = {
  getTopic: {
    id: string;
    stars?: number | null;
    title: string;
    ideasToDiscuss: Array<string>;
    comments?: Array<{
      id: string;
      createdAt: any;
      message: string;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
      reactions?: Array<{
        id: string;
        unifiedId: string;
        user: {
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatarUrl?: string | null;
        };
      }> | null;
      replies?: Array<{
        id: string;
        createdAt: any;
        message: string;
        author?: { id: string; name: string; avatarUrl?: string | null } | null;
        reactions?: Array<{
          id: string;
          unifiedId: string;
          user: {
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatarUrl?: string | null;
          };
        }> | null;
      }> | null;
    }> | null;
    theme?: {
      id: string;
      isResource?: boolean | null;
      isGrammarLibrary?: boolean | null;
      cover?: {
        id: string;
        primary?: { desktop?: string | null; mobile?: string | null } | null;
        secondary?: { desktop?: string | null; mobile?: string | null } | null;
        tertiary?: { desktop?: string | null; mobile?: string | null } | null;
      } | null;
    } | null;
    illustration?: { id: string; title: string; url?: string | null } | null;
    lessons?: Array<{
      id: string;
      kind: LessonKind;
      title?: string | null;
      sections?: Array<{
        id: string;
        order?: number | null;
        elements?: Array<{ kind: ElementKind; value?: any | null; meta: any }> | null;
      }> | null;
    }> | null;
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  me: {
    id: string;
    email: string;
    subscriptionTier: SubscriptionTier;
    avatarUrl?: string | null;
    isActive?: boolean | null;
    isVerified?: boolean | null;
    firstName?: string | null;
    isComplete?: boolean | null;
    completedPercentage: number;
    completedHomeTour?: boolean | null;
    badge?: UserBadge | null;
    createdAt: any;
    lastName?: string | null;
    name: string;
    hasActivePlan: boolean;
    kind?: EventPermissions | null;
    timezone?: string | null;
    timezoneChosenAt?: any | null;
    hasGoogleRefreshToken: boolean;
    city?: string | null;
    country?: string | null;
    cityId?: string | null;
    countryId?: string | null;
    lat?: number | null;
    long?: number | null;
    cambridgeEnglishLevel?: number | null;
    speakingLevelScore: number;
    speakingLevel: SpeakingLevelCategories;
    birthday?: any | null;
    showBirthday?: boolean | null;
    showBirthdayYear?: boolean | null;
    needSpeakingPartner?: boolean | null;
    englishSkills?: Array<EnglishSkill> | null;
    interests?: Array<Interest> | null;
    story?: string | null;
    availabilityFrom?: number | null;
    availabilityUntil?: number | null;
    planSlug?: string | null;
    deletedAt?: any | null;
    anonymisedAt?: any | null;
    anonymisationStartedAt?: any | null;
    promotionalCredits?: number | null;
    impersonated: boolean;
    seenCompletedAt?: any | null;
    welcomeVideoWatchedAt?: any | null;
    valuesVideoWatchedAt?: any | null;
    quizPassedAt?: any | null;
    stepsCompleted?: boolean | null;
    lastOnlineAt?: any | null;
    availableAssessmentCharges?: number | null;
    takenSpeakingAssessment?: boolean | null;
    pauseStartAt?: any | null;
    pauseUntil?: any | null;
    pauseEligibleFrom?: any | null;
    badges: Array<{ id: string; type: UserBadgeType; achievedDate?: any | null }>;
    following?: Array<{ id: string }> | null;
    followers?: Array<{ id: string }> | null;
    occupation?: { id: string; name?: string | null } | null;
    availability?: Array<{ from: string; until: string }> | null;
    eventStatistics?: { totalAttendedScheduledEvents: number; updatedAt: any } | null;
    userSettings?: {
      receiveChatMentionsWebNotifications?: boolean | null;
      receiveChatThreadWebNotifications?: boolean | null;
      receiveEventUpdatesAndInvitationsWebNotifications?: boolean | null;
      receiveEventRemindersWebNotifications?: boolean | null;
      receiveEventRsvpWebNotifications?: boolean | null;
      receiveFollowsWebNotifications?: boolean | null;
      receiveMentionsAndCommentsWebNotifications?: boolean | null;
      receiveChannelInviteWebNotifications?: boolean | null;
      receiveLiveTableStartedWebNotifications?: boolean | null;
      receivePersonalMessagesWebNotifications?: boolean | null;
      receiveGroupMessagesWebNotifications?: boolean | null;
      receivePublicChannelsMessagesWebNotifications?: boolean | null;
    } | null;
  };
};

export type MyProfileQueryVariables = Exact<{ [key: string]: never }>;

export type MyProfileQuery = {
  me: {
    id: string;
    email: string;
    avatarUrl?: string | null;
    subscriptionTier: SubscriptionTier;
    needSpeakingPartner?: boolean | null;
    cambridgeEnglishLevel?: number | null;
    speakingLevelScore: number;
    speakingLevel: SpeakingLevelCategories;
    completedPercentage: number;
    isVerified?: boolean | null;
    firstName?: string | null;
    nationality?: string | null;
    otherLanguage?: string | null;
    isComplete?: boolean | null;
    badge?: UserBadge | null;
    createdAt: any;
    lastName?: string | null;
    city?: string | null;
    country?: string | null;
    cityId?: string | null;
    countryId?: string | null;
    lat?: number | null;
    long?: number | null;
    story?: string | null;
    birthday?: any | null;
    englishSkills?: Array<EnglishSkill> | null;
    interests?: Array<Interest> | null;
    showBirthday?: boolean | null;
    showBirthdayYear?: boolean | null;
    nativeLanguage?: string | null;
    name: string;
    wantsNewsletter?: boolean | null;
    completedHomeTour?: boolean | null;
    speakingPartners?: string | null;
    hasActivePlan: boolean;
    kind?: EventPermissions | null;
    timezone?: string | null;
    hasGoogleRefreshToken: boolean;
    availabilityFrom?: number | null;
    availabilityUntil?: number | null;
    planSlug?: string | null;
    deletedAt?: any | null;
    promotionalCredits?: number | null;
    impersonated: boolean;
    seenCompletedAt?: any | null;
    stepsCompleted?: boolean | null;
    pauseStartAt?: any | null;
    pauseUntil?: any | null;
    pauseEligibleFrom?: any | null;
    occupation?: { id: string; name?: string | null } | null;
    badges: Array<{ id: string; type: UserBadgeType; achievedDate?: any | null; createdAt: any }>;
    following?: Array<{ id: string }> | null;
    followers?: Array<{ id: string }> | null;
    availability?: Array<{ from: string; until: string }> | null;
    photos: Array<{ id: string; url: string }>;
    eventStatistics?: { totalAttendedScheduledEvents: number; updatedAt: any } | null;
    userSettings?: {
      receiveChatMentionsWebNotifications?: boolean | null;
      receiveChatThreadWebNotifications?: boolean | null;
      receiveEventUpdatesAndInvitationsWebNotifications?: boolean | null;
      receiveEventRemindersWebNotifications?: boolean | null;
      receiveEventRsvpWebNotifications?: boolean | null;
      receiveFollowsWebNotifications?: boolean | null;
      receiveMentionsAndCommentsWebNotifications?: boolean | null;
      receiveChannelInviteWebNotifications?: boolean | null;
      receiveLiveTableStartedWebNotifications?: boolean | null;
      receivePersonalMessagesWebNotifications?: boolean | null;
      receiveGroupMessagesWebNotifications?: boolean | null;
      receivePublicChannelsMessagesWebNotifications?: boolean | null;
    } | null;
  };
};

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserSettingsQuery = {
  getUserSettings: {
    id: string;
    receiveEventUpdatesAndInvitationsNotifications?: boolean | null;
    receiveEventUpdatesAndInvitationsEmails?: boolean | null;
    receiveEventRemindersNotifications?: boolean | null;
    receiveEventRemindersEmails?: boolean | null;
    receiveEventRsvpNotifications?: boolean | null;
    receiveEventRsvpEmails?: boolean | null;
    receiveFollowsNotifications?: boolean | null;
    receiveFollowsEmails?: boolean | null;
    receiveMentionsAndCommentsNotifications?: boolean | null;
    receiveMentionsAndCommentsEmails?: boolean | null;
    receiveChatMentionsNotifications?: boolean | null;
    receiveChatMentionsEmails?: boolean | null;
    receiveLiveTableStartedNotifications?: boolean | null;
    receivePlatformStatusEmails?: boolean | null;
    receiveSubscriptionChangesEmails?: boolean | null;
    receiveChatThreadNotifications?: boolean | null;
    receiveChatThreadEmails?: boolean | null;
    receiveChannelInviteNotifications?: boolean | null;
    receiveChannelInviteEmails?: boolean | null;
    receiveEventUpdatesAndInvitationsWebNotifications?: boolean | null;
    receiveEventRemindersWebNotifications?: boolean | null;
    receiveEventRsvpWebNotifications?: boolean | null;
    receiveFollowsWebNotifications?: boolean | null;
    receiveMentionsAndCommentsWebNotifications?: boolean | null;
    receiveChatMentionsWebNotifications?: boolean | null;
    receiveChatThreadWebNotifications?: boolean | null;
    receiveChannelInviteWebNotifications?: boolean | null;
    receiveLiveTableStartedWebNotifications?: boolean | null;
    receivePersonalMessagesWebNotifications?: boolean | null;
    receiveGroupMessagesWebNotifications?: boolean | null;
    receivePublicChannelsMessagesWebNotifications?: boolean | null;
    emailNotifications?: EmailNotifications | null;
    updatedAt: any;
    createdAt: any;
  };
};

export type UserQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type UserQuery = {
  getUser: {
    id: string;
    email: string;
    avatarUrl?: string | null;
    needSpeakingPartner?: boolean | null;
    cambridgeEnglishLevel?: number | null;
    speakingLevelScore: number;
    speakingLevel: SpeakingLevelCategories;
    firstName?: string | null;
    otherLanguage?: string | null;
    isComplete?: boolean | null;
    badge?: UserBadge | null;
    createdAt: any;
    lastOnlineAt?: any | null;
    lastName?: string | null;
    city?: string | null;
    name: string;
    country?: string | null;
    story?: string | null;
    birthday?: any | null;
    englishSkills?: Array<EnglishSkill> | null;
    interests?: Array<Interest> | null;
    showBirthday?: boolean | null;
    nativeLanguage?: string | null;
    completedPercentage: number;
    pauseStartAt?: any | null;
    pauseUntil?: any | null;
    occupation?: { id: string; name?: string | null } | null;
    followers?: Array<{ follower: { id: string; name: string } }> | null;
    availability?: Array<{ from: string; until: string }> | null;
    photos: Array<{ id: string; url: string }>;
  };
};

export type SimpleUserQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type SimpleUserQuery = { getUser: { id: string; firstName?: string | null } };

export type PlanDetailsAndPaymentMethodQueryVariables = Exact<{ [key: string]: never }>;

export type PlanDetailsAndPaymentMethodQuery = {
  planDetails?: {
    itemPriceId?: string | null;
    userAmount?: number | null;
    start?: any | null;
    end?: any | null;
    status?: SubscriptionStatus | null;
    resumesAt?: any | null;
    cancelledAt?: any | null;
    recoveryStartedAt?: any | null;
    scheduledPlan?: any | null;
  } | null;
  paymentMethod?: Array<{
    last4Digits?: string | null;
    expYear?: number | null;
    expMonth?: number | null;
    type: string;
    email?: string | null;
  }> | null;
  invoices?: Array<{
    id?: string | null;
    created?: any | null;
    description?: string | null;
    amount?: number | null;
    currency?: string | null;
    downloadUrl?: string | null;
    status?: string | null;
  }> | null;
};

export type GetPlanStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlanStatusQuery = {
  planDetails?: {
    itemPriceId?: string | null;
    status?: SubscriptionStatus | null;
    dunning?: boolean | null;
    plan?: any | null;
    end?: any | null;
  } | null;
};

export type GetItemPriceQueryVariables = Exact<{
  itemPriceId: Scalars["String"]["input"];
}>;

export type GetItemPriceQuery = {
  itemPrice?: {
    name?: string | null;
    interval?: string | null;
    intervalCount?: number | null;
    amount?: number | null;
    meta?: any | null;
  } | null;
};

export type PausePreviewQueryVariables = Exact<{
  durationDays: Scalars["Int"]["input"];
}>;

export type PausePreviewQuery = {
  pausePreview: { intendedPauseEndDate: any; nextBillingAt: any; durationDays: number };
};

export type GetOccupationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOccupationsQuery = { getOccupations: Array<{ id: string; name?: string | null }> };

export type UserHasNoAcceptedInvitesQueryVariables = Exact<{ [key: string]: never }>;

export type UserHasNoAcceptedInvitesQuery = { userHasNoAcceptedInvites: boolean };

export type HasSeenEventsTabQueryVariables = Exact<{ [key: string]: never }>;

export type HasSeenEventsTabQuery = { hasSeenEventsTab: boolean };

export type HasSeenEventsTabAfterAttendedThreeEventsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type HasSeenEventsTabAfterAttendedThreeEventsQuery = {
  hasSeenEventsTabAfterAttendedThreeEvents: boolean;
};

export type AttendedEventsQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type AttendedEventsQuery = {
  attendedEvents: {
    oneToOnes?: number | null;
    groupEvents?: number | null;
    webinars?: number | null;
    inPersonEvents?: number | null;
    other?: number | null;
  };
};

export type AttendanceRecordQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type AttendanceRecordQuery = {
  attendanceRecord: {
    attendanceRatio?: number | null;
    totalRsvps?: number | null;
    attended?: number | null;
  };
};

export type ParticipationTimeQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type ParticipationTimeQuery = { participationTime: number };

export type HostedEventsQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type HostedEventsQuery = { hostedEvents: number };

export type HostedParticipationTimeQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type HostedParticipationTimeQuery = { hostedParticipationTime: number };

export type GlobalNetworkQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type GlobalNetworkQuery = {
  globalNetwork: Array<{ lat?: number | null; long?: number | null }>;
};

export type FriendlyFacesQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type FriendlyFacesQuery = {
  friendlyFaces: Array<{
    userId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    avatarUrl?: string | null;
  }>;
};

export type ArticlesWrittenQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type ArticlesWrittenQuery = { articlesWritten: number };

export type DailyEventsQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type DailyEventsQuery = { dailyEvents: Array<{ day: any; count: number }> };

export type HostedEventsStatisticsQueryVariables = Exact<{
  input: StatisticsInput;
  prevInput: StatisticsInput;
}>;

export type HostedEventsStatisticsQuery = {
  hostedEvents: number;
  ladiesAttended: number;
  userHostedDistinctSparks: number;
  previousHostedEvents: number;
};

export type MonthlyRecapStepsQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type MonthlyRecapStepsQuery = { monthlyRecapSteps: Array<MonthlyRecapSteps> };

export type SeenMonthlyReportQueryVariables = Exact<{ [key: string]: never }>;

export type SeenMonthlyReportQuery = { seenMonthlyReport: boolean };

export type GetGroupedOccupationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetGroupedOccupationsQuery = {
  getGroupedOccupations: Array<{
    id: string;
    name?: string | null;
    industry?: { id: string; name: string } | null;
  }>;
};

export type GetSparksQueryVariables = Exact<{
  input: StatisticsInput;
}>;

export type GetSparksQuery = {
  userDistinctSparks: number;
  userAttendedDistinctSparks: number;
  communityDistinctSparks: number;
};

export type GetUserInfoQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetUserInfoQuery = {
  getUserInfo: { firstName?: string | null; avatarUrl?: string | null };
};

export type GetUsersWithSameSpeakingLevelQueryVariables = Exact<{
  speakingLevel: SpeakingLevelCategories;
}>;

export type GetUsersWithSameSpeakingLevelQuery = {
  getUsersWithSameSpeakingLevel: {
    total?: number | null;
    randomUsersAvatars?: Array<string> | null;
  };
};

export type AttendanceMetricsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AttendanceMetricsQuery = {
  attendanceMetrics?: {
    totalEvents?: number | null;
    totalOneToOnes?: number | null;
    totalGroup?: number | null;
    totalWebinars?: number | null;
    totalInPerson?: number | null;
    totalOther?: number | null;
    totalDuration?: number | null;
    hostedEvents?: number | null;
    hostedOneToOnes?: number | null;
    hostedGroup?: number | null;
    hostedWebinars?: number | null;
    hostedInPerson?: number | null;
    hostedOther?: number | null;
    hostedDuration?: number | null;
    attendedEvents?: number | null;
    totalAttendedScheduledEvents?: number | null;
    attendedOneToOnes?: number | null;
    attendedGroup?: number | null;
    attendedWebinars?: number | null;
    attendedInPerson?: number | null;
    attendedOther?: number | null;
    attendedDuration?: number | null;
    videoCalls?: number | null;
  } | null;
};

export type TotalHostedParticipantsQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type TotalHostedParticipantsQuery = { totalHostedParticipants: number };

export type TotalPublishedArticlesQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type TotalPublishedArticlesQuery = { totalPublishedArticles: number };

export type RecentArticlesQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type RecentArticlesQuery = {
  recentArticles: Array<{
    id: string;
    title?: string | null;
    coverUrl?: string | null;
    noLikes?: number | null;
    likes?: Array<{ id: string }> | null;
  }>;
};

export type ListRecommendedUsersQueryVariables = Exact<{ [key: string]: never }>;

export type ListRecommendedUsersQuery = {
  listRecommendedUsers: Array<{
    userId: string;
    user: {
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      avatarUrl?: string | null;
      badge?: UserBadge | null;
      city?: string | null;
      country?: string | null;
      story?: string | null;
    };
  }>;
};

export type ListMatchedUsersQueryVariables = Exact<{
  filters: FilterUsersInput;
}>;

export type ListMatchedUsersQuery = {
  listMatchedUsers: {
    total: number;
    items?: Array<{
      userId: string;
      score?: number | null;
      defaultMatchScore?: number | null;
      user: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        badge?: UserBadge | null;
        createdAt: any;
        lastOnlineAt?: any | null;
        avatarUrl?: string | null;
        interests?: Array<Interest> | null;
        englishSkills?: Array<EnglishSkill> | null;
        city?: string | null;
        country?: string | null;
        cambridgeEnglishLevel?: number | null;
        speakingLevelScore: number;
        speakingLevel: SpeakingLevelCategories;
        availabilityFrom?: number | null;
        availabilityUntil?: number | null;
        needSpeakingPartner?: boolean | null;
        pauseUntil?: any | null;
        pauseStartAt?: any | null;
        occupation?: { id: string; name?: string | null } | null;
        availability?: Array<{ from: string; until: string }> | null;
      };
      matchDetails?: {
        commonInterests?: Array<Interest> | null;
        commonEnglishSkills?: Array<EnglishSkill> | null;
        sameCity?: boolean | null;
        availabilityMatch?: AvailabilityStatus | null;
      } | null;
      matchScores?: {
        interestScore: number;
        englishInterestScore: number;
        englishLevelScore: number;
        availabilityScore: number;
        eventParticipationScore: number;
        locationScore: number;
      } | null;
      matchWeights?: {
        interestScore: number;
        englishInterestScore: number;
        englishLevelScore: number;
        availabilityScore: number;
        eventParticipationScore: number;
        locationScore: number;
      } | null;
    }> | null;
  };
};

export type GetUserMatchingInfoQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetUserMatchingInfoQuery = {
  getUserMatchingInfo: {
    userId: string;
    defaultMatchScore?: number | null;
    user: {
      id: string;
      availabilityFrom?: number | null;
      availabilityUntil?: number | null;
      email: string;
      avatarUrl?: string | null;
      needSpeakingPartner?: boolean | null;
      cambridgeEnglishLevel?: number | null;
      speakingLevelScore: number;
      speakingLevel: SpeakingLevelCategories;
      firstName?: string | null;
      nationality?: string | null;
      otherLanguage?: string | null;
      isComplete?: boolean | null;
      badge?: UserBadge | null;
      createdAt: any;
      lastOnlineAt?: any | null;
      lastName?: string | null;
      city?: string | null;
      name: string;
      country?: string | null;
      story?: string | null;
      birthday?: any | null;
      englishSkills?: Array<EnglishSkill> | null;
      interests?: Array<Interest> | null;
      showBirthday?: boolean | null;
      showBirthdayYear?: boolean | null;
      nativeLanguage?: string | null;
      completedPercentage: number;
      pauseUntil?: any | null;
      pauseStartAt?: any | null;
      occupation?: { id: string; name?: string | null } | null;
      badges: Array<{ id: string; type: UserBadgeType; achievedDate?: any | null }>;
      followers?: Array<{ follower: { id: string; name: string } }> | null;
      availability?: Array<{ from: string; until: string }> | null;
      photos: Array<{ id: string; url: string }>;
    };
    matchDetails?: {
      availabilityMatch?: AvailabilityStatus | null;
      commonInterests?: Array<Interest> | null;
      commonEnglishSkills?: Array<EnglishSkill> | null;
      sameCity?: boolean | null;
    } | null;
  };
};

export type GetAvalibilityMatchForUsersQueryVariables = Exact<{
  input: AvailabilityForUsersInput;
}>;

export type GetAvalibilityMatchForUsersQuery = {
  getAvalibilityMatchForUsers: Array<{
    userId: string;
    availabilityMatch?: AvailabilityStatus | null;
  }>;
};

export type CompletedVerificationFormQueryVariables = Exact<{ [key: string]: never }>;

export type CompletedVerificationFormQuery = { completedVerificationForm: Array<{ id: string }> };

export type GetVideoCallQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetVideoCallQuery = {
  getVideoCall: {
    id: string;
    title: string;
    dailyRoomId: string;
    closedDoorAt?: any | null;
    endedAt?: any | null;
    chatRoomId: string;
    participants: Array<{ id: string; isHost: boolean; userId: string }>;
  };
};

export type GetChannelVideoCallQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetChannelVideoCallQuery = {
  getChannelVideoCall?: {
    id: string;
    title: string;
    dailyRoomId: string;
    closedDoorAt?: any | null;
    endedAt?: any | null;
    chatRoomId: string;
  } | null;
};

export type GetVideosQueryVariables = Exact<{ [key: string]: never }>;

export type GetVideosQuery = {
  getVideos: Array<{
    id: string;
    title?: string | null;
    videoURL?: string | null;
    thumbnail?: string | null;
    isActive: boolean;
    position: number;
    completedByMe: boolean;
    set: { id: string };
  }>;
};

export type AssessmentResultsAreSavedSubscriptionVariables = Exact<{
  assessmentId: Scalars["String"]["input"];
}>;

export type AssessmentResultsAreSavedSubscription = {
  assessmentResultsAreSaved: { assessmentId: string };
};

export type AssessmentChargesAreSavedForUserSubscriptionVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type AssessmentChargesAreSavedForUserSubscription = {
  assessmentChargesAreSavedForUser: string;
};

export type CommentCreatedSubscriptionVariables = Exact<{
  targetId: Scalars["String"]["input"];
}>;

export type CommentCreatedSubscription = {
  commentCreated: {
    id: string;
    parentID?: string | null;
    message: string;
    createdAt: any;
    author?: { id: string; name: string; avatarUrl?: string | null } | null;
    reactions?: Array<{
      id: string;
      unifiedId: string;
      user: {
        id: string;
        avatarUrl?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      };
    }> | null;
    replies?: Array<{
      id: string;
      message: string;
      createdAt: any;
      author?: { id: string; name: string; avatarUrl?: string | null } | null;
      reactions?: Array<{
        id: string;
        unifiedId: string;
        user: {
          id: string;
          avatarUrl?: string | null;
          firstName?: string | null;
          lastName?: string | null;
        };
      }> | null;
    }> | null;
  };
};

export type CommentDeletedSubscriptionVariables = Exact<{
  targetId: Scalars["String"]["input"];
}>;

export type CommentDeletedSubscription = {
  commentDeleted: { id: string; parentID?: string | null };
};

export type ReactionCreatedSubscriptionVariables = Exact<{
  targetId: Scalars["String"]["input"];
}>;

export type ReactionCreatedSubscription = {
  reactionCreated: {
    id: string;
    unifiedId: string;
    user: {
      id: string;
      avatarUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    };
    comment: { id: string; parentID?: string | null };
  };
};

export type ReactionDeletedSubscriptionVariables = Exact<{
  targetId: Scalars["String"]["input"];
}>;

export type ReactionDeletedSubscription = {
  reactionDeleted: {
    id: string;
    unifiedId: string;
    user: {
      id: string;
      avatarUrl?: string | null;
      firstName?: string | null;
      lastName?: string | null;
    };
    comment: { id: string; parentID?: string | null };
  };
};

export type EventUpdatedSubscriptionVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type EventUpdatedSubscription = {
  eventUpdated: {
    eventAndInvites?: {
      id: string;
      closedDoorAt?: any | null;
      noParticipants?: number | null;
      noCountableParticipants?: number | null;
      participants: Array<{
        id: string;
        avatarUrl?: string | null;
        createdAt: any;
        firstName?: string | null;
        lastName?: string | null;
        isVerified?: boolean | null;
        kind?: EventPermissions | null;
      }>;
      invites?: Array<{
        id: string;
        isHost?: boolean | null;
        status?: InviteStatus | null;
        isConfirmed?: boolean | null;
        user?: {
          id: string;
          name: string;
          firstName?: string | null;
          lastName?: string | null;
          createdAt: any;
          badge?: UserBadge | null;
          avatarUrl?: string | null;
          kind?: EventPermissions | null;
        } | null;
      }> | null;
    } | null;
    eventDoorStatus?: { closedDoorAt?: any | null } | null;
  };
};

export type GuestPassUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type GuestPassUpdatedSubscription = {
  guestPassUpdated: {
    id: string;
    userId: string;
    startsAt: any;
    endsAt: any;
    daysRemaining: number;
    tokenAllowance: number;
    tokensUsed: number;
    tokensRemaining: number;
    isActive: boolean;
    canActivateMembership: boolean;
    shouldShowCompletionModal: boolean;
  };
};

export type LiveTableAboutToEndSubscriptionVariables = Exact<{
  liveTableId: Scalars["String"]["input"];
}>;

export type LiveTableAboutToEndSubscription = { liveTableAboutToEnd: { id: string } };

export type LiveTableHasEndedSubscriptionVariables = Exact<{
  liveTableId: Scalars["String"]["input"];
}>;

export type LiveTableHasEndedSubscription = {
  liveTableHasEnded: { id: string; endedAt?: any | null };
};

export type LiveTableUpdatedSubscriptionVariables = Exact<{
  liveTableId: Scalars["String"]["input"];
}>;

export type LiveTableUpdatedSubscription = {
  liveTableUpdated: {
    id: string;
    title: string;
    englishLevel?: EventEnglishLevelNamed | null;
    timeLimit?: TimeLimit | null;
    endDate?: any | null;
    question?: { id: string; question?: string | null; type: QuestionType } | null;
    participants: Array<{
      id: string;
      user: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
      };
    }>;
  };
};

export type LiveTableHasStartedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type LiveTableHasStartedSubscription = {
  liveTableHasStarted: {
    name?: string | null;
    avatarUrl?: string | null;
    tableId: string;
    tableTitle: string;
    tableCreatorId: string;
    tableEnglishLevel?: EventEnglishLevelNamed | null;
  };
};

export type LiveTableChangedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type LiveTableChangedSubscription = {
  liveTableChanged: {
    id: string;
    title: string;
    englishLevel?: EventEnglishLevelNamed | null;
    timeLimit?: TimeLimit | null;
    endDate?: any | null;
    endedAt?: any | null;
    maxParticipants: number;
    createdAt: any;
    dailyRoomId: string;
    question?: { id: string; question?: string | null; type: QuestionType } | null;
    participants: Array<{
      id: string;
      user: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
      };
    }>;
  };
};

export type NotificationsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type NotificationsSubscriptionSubscription = {
  notificationAdded: {
    id: string;
    type: NotificationType;
    createdAt: any;
    notificationSeen?: Array<{ id: string; seenAt?: any | null }> | null;
    chatNotification?: {
      id: string;
      channelId?: string | null;
      channelName?: string | null;
      chatMessageId?: string | null;
      parentChatMessageId?: string | null;
      chatMessage?: string | null;
      chatAction: ChatAction;
      actor?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      } | null;
    } | null;
    commentNotification?: {
      id: string;
      commentAction: CommentAction;
      comment: {
        id: string;
        targetId: string;
        targetType: CommentTargetType;
        targetArticle?: { title?: string | null } | null;
        targetEvent?: { title?: string | null } | null;
        targetTopic?: { title: string } | null;
      };
      actor?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      } | null;
    } | null;
    eventNotification?: {
      id: string;
      action: EventNotificationAction;
      seriesId?: string | null;
      actor?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      } | null;
      event?: {
        id: string;
        startDate?: any | null;
        endDate?: any | null;
        title?: string | null;
        kind?: EventKind | null;
        isDeleted?: boolean | null;
        deletedNote?: string | null;
        recurring?: boolean | null;
        seriesId?: string | null;
        hasSharedEventNotification?: boolean | null;
        series?: {
          id: string;
          recurrenceType: RecurrenceType;
          recurrenceInterval: number;
          recurrenceDays?: Array<WeekDay> | null;
          recurrenceEndType: RecurrenceEndType;
          recurrenceEndDate?: any | null;
          recurrenceCount?: number | null;
          inviteToAllRecurring: boolean;
          parentEventId?: string | null;
        } | null;
        seriesEvents?: Array<{ id: string; startDate?: any | null; endDate?: any | null }> | null;
        host?: { id: string; name: string } | null;
      } | null;
      invite?: { id: string; status?: InviteStatus | null } | null;
    } | null;
    articleNotification?: {
      id: string;
      articleAction: ArticleAction;
      article: {
        id: string;
        title?: string | null;
        author?: {
          id: string;
          avatarUrl?: string | null;
          name: string;
          firstName?: string | null;
          lastName?: string | null;
          badge?: UserBadge | null;
        } | null;
      };
    } | null;
  };
};

export type PopupNotificationsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type PopupNotificationsSubscriptionSubscription = {
  popupNotificationAdded: {
    id: string;
    type: NotificationType;
    createdAt: any;
    notificationSeen?: Array<{ id: string; seenAt?: any | null }> | null;
    badgeNotification?: {
      id: string;
      badge: { id: string; type: UserBadgeType; achievedDate?: any | null };
    } | null;
    eventNotification?: {
      id: string;
      action: EventNotificationAction;
      seriesId?: string | null;
      actor?: {
        id: string;
        name: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      } | null;
      event?: {
        id: string;
        startDate?: any | null;
        endDate?: any | null;
        title?: string | null;
        kind?: EventKind | null;
        isDeleted?: boolean | null;
        deletedNote?: string | null;
        recurring?: boolean | null;
        seriesId?: string | null;
        hasSharedEventNotification?: boolean | null;
        series?: {
          id: string;
          recurrenceType: RecurrenceType;
          recurrenceInterval: number;
          recurrenceDays?: Array<WeekDay> | null;
          recurrenceEndType: RecurrenceEndType;
          recurrenceEndDate?: any | null;
          recurrenceCount?: number | null;
          inviteToAllRecurring: boolean;
          parentEventId?: string | null;
        } | null;
        seriesEvents?: Array<{ id: string; startDate?: any | null; endDate?: any | null }> | null;
        host?: { id: string; name: string } | null;
      } | null;
      invite?: { id: string; status?: InviteStatus | null } | null;
    } | null;
    profileUpdateNotification?: { id: string; type: ProfileUpdateNotificationType } | null;
    monthlyReportNotification?: { id: string; type: MonthlyReportNotificationType } | null;
    friendJoinedNotification?: {
      id: string;
      type: FriendJoinedNotificationType;
      user: { id: string; firstName?: string | null; lastName?: string | null };
      friend: {
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatarUrl?: string | null;
        badge?: UserBadge | null;
      };
    } | null;
    customNotification?: {
      id: string;
      customNotificationDisplay: {
        id: string;
        illustration?: string | null;
        title?: string | null;
        text?: string | null;
        buttonText?: string | null;
        buttonUrl?: string | null;
      };
    } | null;
  };
};

export type DunningStatusUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type DunningStatusUpdatedSubscription = {
  dunningStatusUpdated: { userId: string; dunning: boolean };
};

export type SparkCreatedSubscriptionVariables = Exact<{
  eventId: Scalars["String"]["input"];
}>;

export type SparkCreatedSubscription = {
  sparkCreated: { id: string; event?: { id: string } | null; user: { id: string } };
};

export type CommunitySparkCreatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type CommunitySparkCreatedSubscription = { communitySparkCreated: { id: string } };

export type StreakEventAttendedSubscriptionSubscriptionVariables = Exact<{ [key: string]: never }>;

export type StreakEventAttendedSubscriptionSubscription = {
  streakEventAttended: {
    weeklyGoal: number;
    nextWeeklyGoal: number;
    connectionStreak: number;
    goalStreak: number;
    eventsThisWeek: number;
    connectionWeekCompletedThisWeek: boolean;
    goalCompletedThisWeek: boolean;
    connectionStreakBrokeLastWeek: boolean;
    goalStreakBrokeLastWeek: boolean;
    powerUpCount: number;
    powerUpRevealed: boolean;
    powerUpProgress: number;
    connectionStreakIncrementedThisWeek: boolean;
  };
};

export type UserStatisticsUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type UserStatisticsUpdatedSubscription = {
  userStatisticsUpdated: {
    userId: string;
    eventStatistics: {
      id: string;
      totalAttendedScheduledEvents: number;
      updatedAt: any;
      createdAt: any;
    };
  };
};

export type UserPermissionsUpdatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type UserPermissionsUpdatedSubscription = {
  userPermissionsUpdated: { userId: string; kind: EventPermissions; badge: UserBadge };
};

export type VideoAskFormCreatedSubscriptionVariables = Exact<{ [key: string]: never }>;

export type VideoAskFormCreatedSubscription = { videoAskFormCreated: { id: string } };

export type VideoCallUpdatedSubscriptionVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type VideoCallUpdatedSubscription = {
  videoCallUpdated: {
    id: string;
    title: string;
    dailyRoomId: string;
    closedDoorAt?: any | null;
    endedAt?: any | null;
  };
};

export type ChannelVideoCallSubscriptionVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type ChannelVideoCallSubscription = {
  channelVideoCall: {
    id: string;
    title: string;
    dailyRoomId: string;
    closedDoorAt?: any | null;
    endedAt?: any | null;
  };
};

export const CommentNotificationFieldsFragmentDoc = gql`
    fragment CommentNotificationFields on CommentNotificationModel {
  id
  comment {
    id
    targetId
    targetType
    targetArticle {
      title
    }
    targetEvent {
      title
    }
    targetTopic {
      title
    }
  }
  commentAction
  actor {
    id
    name
    firstName
    lastName
    avatarUrl
    badge
  }
}
    `;
export const EventNotificationFieldsFragmentDoc = gql`
    fragment EventNotificationFields on EventNotificationModel {
  id
  action
  seriesId
  actor {
    id
    name
    firstName
    lastName
    avatarUrl
    badge
  }
  event {
    id
    startDate
    endDate
    title
    kind
    isDeleted
    deletedNote
    recurring
    seriesId
    series {
      id
      recurrenceType
      recurrenceInterval
      recurrenceDays
      recurrenceEndType
      recurrenceEndDate
      recurrenceCount
      inviteToAllRecurring
      parentEventId
    }
    seriesEvents {
      id
      startDate
      endDate
    }
    hasSharedEventNotification
    host {
      id
      name
    }
  }
  invite {
    id
    status
  }
}
    `;
export const ChatNotificationFieldsFragmentDoc = gql`
    fragment ChatNotificationFields on ChatNotificationModel {
  id
  channelId
  channelName
  chatMessageId
  parentChatMessageId
  chatMessage
  chatAction
  actor {
    id
    name
    firstName
    lastName
    avatarUrl
    badge
  }
}
    `;
export const BadgeNotificationFieldsFragmentDoc = gql`
    fragment BadgeNotificationFields on BadgeNotificationModel {
  id
  badge {
    id
    type
    achievedDate
  }
}
    `;
export const ProfileUpdateNotificationFieldsFragmentDoc = gql`
    fragment ProfileUpdateNotificationFields on ProfileUpdateNotificationModel {
  id
  type
}
    `;
export const ArticleNotificationFieldsFragmentDoc = gql`
    fragment ArticleNotificationFields on ArticleNotificationModel {
  id
  articleAction
  article {
    id
    title
    author {
      id
      avatarUrl
      name
      firstName
      lastName
      badge
    }
  }
}
    `;
export const MonthlyReportNotificationFieldsFragmentDoc = gql`
    fragment MonthlyReportNotificationFields on MonthlyReportNotificationModel {
  id
  type
}
    `;
export const FriendJoinedNotificationFieldsFragmentDoc = gql`
    fragment FriendJoinedNotificationFields on FriendJoinedNotificationModel {
  id
  user {
    id
    firstName
    lastName
  }
  friend {
    id
    firstName
    lastName
    avatarUrl
    badge
  }
  type
}
    `;
export const CustomNotificationFieldsFragmentDoc = gql`
    fragment CustomNotificationFields on CustomNotificationModel {
  id
  customNotificationDisplay {
    id
    illustration
    title
    text
    buttonText
    buttonUrl
  }
}
    `;
export const ConversationPactFieldsFragmentDoc = gql`
    fragment ConversationPactFields on ConversationPactModel {
  version
  agreedPromises
  completedAt
}
    `;
export const HomeCheckInFieldsFragmentDoc = gql`
    fragment HomeCheckInFields on HomeCheckInModel {
  id
  kind
  answer
  followUp
  answeredAt
  followUpAt
  dismissedAt
}
    `;
export const InitiateAssessmentDocument = gql`
    mutation initiateAssessment {
  initiateAssessment {
    assessmentUrl
    assessmentId
  }
}
    `;
export type InitiateAssessmentMutationFn = Apollo.MutationFunction<
  InitiateAssessmentMutation,
  InitiateAssessmentMutationVariables
>;

/**
 * __useInitiateAssessmentMutation__
 *
 * To run a mutation, you first call `useInitiateAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAssessmentMutation, { data, loading, error }] = useInitiateAssessmentMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitiateAssessmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateAssessmentMutation,
    InitiateAssessmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InitiateAssessmentMutation, InitiateAssessmentMutationVariables>(
    InitiateAssessmentDocument,
    options,
  );
}
export type InitiateAssessmentMutationHookResult = ReturnType<typeof useInitiateAssessmentMutation>;
export type InitiateAssessmentMutationResult = Apollo.MutationResult<InitiateAssessmentMutation>;
export type InitiateAssessmentMutationOptions = Apollo.BaseMutationOptions<
  InitiateAssessmentMutation,
  InitiateAssessmentMutationVariables
>;
export const ChatCreateChannelDocument = gql`
    mutation chatCreateChannel($input: CreateChannelInput!) {
  chatCreateChannel(input: $input)
}
    `;
export type ChatCreateChannelMutationFn = Apollo.MutationFunction<
  ChatCreateChannelMutation,
  ChatCreateChannelMutationVariables
>;

/**
 * __useChatCreateChannelMutation__
 *
 * To run a mutation, you first call `useChatCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatCreateChannelMutation, { data, loading, error }] = useChatCreateChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatCreateChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatCreateChannelMutation,
    ChatCreateChannelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChatCreateChannelMutation, ChatCreateChannelMutationVariables>(
    ChatCreateChannelDocument,
    options,
  );
}
export type ChatCreateChannelMutationHookResult = ReturnType<typeof useChatCreateChannelMutation>;
export type ChatCreateChannelMutationResult = Apollo.MutationResult<ChatCreateChannelMutation>;
export type ChatCreateChannelMutationOptions = Apollo.BaseMutationOptions<
  ChatCreateChannelMutation,
  ChatCreateChannelMutationVariables
>;
export const ChatAddMembersToChannelDocument = gql`
    mutation chatAddMembersToChannel($id: String!, $input: CreateChannelInput!) {
  chatAddMembersToChannel(id: $id, input: $input) {
    status
  }
}
    `;
export type ChatAddMembersToChannelMutationFn = Apollo.MutationFunction<
  ChatAddMembersToChannelMutation,
  ChatAddMembersToChannelMutationVariables
>;

/**
 * __useChatAddMembersToChannelMutation__
 *
 * To run a mutation, you first call `useChatAddMembersToChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatAddMembersToChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatAddMembersToChannelMutation, { data, loading, error }] = useChatAddMembersToChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatAddMembersToChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatAddMembersToChannelMutation,
    ChatAddMembersToChannelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChatAddMembersToChannelMutation,
    ChatAddMembersToChannelMutationVariables
  >(ChatAddMembersToChannelDocument, options);
}
export type ChatAddMembersToChannelMutationHookResult = ReturnType<
  typeof useChatAddMembersToChannelMutation
>;
export type ChatAddMembersToChannelMutationResult =
  Apollo.MutationResult<ChatAddMembersToChannelMutation>;
export type ChatAddMembersToChannelMutationOptions = Apollo.BaseMutationOptions<
  ChatAddMembersToChannelMutation,
  ChatAddMembersToChannelMutationVariables
>;
export const ChatRemoveMembersFromChannelDocument = gql`
    mutation chatRemoveMembersFromChannel($id: String!, $input: CreateChannelInput!) {
  chatRemoveMembersFromChannel(id: $id, input: $input) {
    status
  }
}
    `;
export type ChatRemoveMembersFromChannelMutationFn = Apollo.MutationFunction<
  ChatRemoveMembersFromChannelMutation,
  ChatRemoveMembersFromChannelMutationVariables
>;

/**
 * __useChatRemoveMembersFromChannelMutation__
 *
 * To run a mutation, you first call `useChatRemoveMembersFromChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatRemoveMembersFromChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatRemoveMembersFromChannelMutation, { data, loading, error }] = useChatRemoveMembersFromChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatRemoveMembersFromChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatRemoveMembersFromChannelMutation,
    ChatRemoveMembersFromChannelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChatRemoveMembersFromChannelMutation,
    ChatRemoveMembersFromChannelMutationVariables
  >(ChatRemoveMembersFromChannelDocument, options);
}
export type ChatRemoveMembersFromChannelMutationHookResult = ReturnType<
  typeof useChatRemoveMembersFromChannelMutation
>;
export type ChatRemoveMembersFromChannelMutationResult =
  Apollo.MutationResult<ChatRemoveMembersFromChannelMutation>;
export type ChatRemoveMembersFromChannelMutationOptions = Apollo.BaseMutationOptions<
  ChatRemoveMembersFromChannelMutation,
  ChatRemoveMembersFromChannelMutationVariables
>;
export const ChatRenameChannelDocument = gql`
    mutation chatRenameChannel($id: String!, $channelName: String!) {
  chatRenameChannel(id: $id, channelName: $channelName) {
    status
  }
}
    `;
export type ChatRenameChannelMutationFn = Apollo.MutationFunction<
  ChatRenameChannelMutation,
  ChatRenameChannelMutationVariables
>;

/**
 * __useChatRenameChannelMutation__
 *
 * To run a mutation, you first call `useChatRenameChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatRenameChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatRenameChannelMutation, { data, loading, error }] = useChatRenameChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channelName: // value for 'channelName'
 *   },
 * });
 */
export function useChatRenameChannelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatRenameChannelMutation,
    ChatRenameChannelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChatRenameChannelMutation, ChatRenameChannelMutationVariables>(
    ChatRenameChannelDocument,
    options,
  );
}
export type ChatRenameChannelMutationHookResult = ReturnType<typeof useChatRenameChannelMutation>;
export type ChatRenameChannelMutationResult = Apollo.MutationResult<ChatRenameChannelMutation>;
export type ChatRenameChannelMutationOptions = Apollo.BaseMutationOptions<
  ChatRenameChannelMutation,
  ChatRenameChannelMutationVariables
>;
export const ChatUpdatePublicChannelInfoDocument = gql`
    mutation chatUpdatePublicChannelInfo($id: String!, $channelName: String!, $channelDescription: String!) {
  chatUpdatePublicChannelInfo(
    id: $id
    channelName: $channelName
    channelDescription: $channelDescription
  ) {
    status
  }
}
    `;
export type ChatUpdatePublicChannelInfoMutationFn = Apollo.MutationFunction<
  ChatUpdatePublicChannelInfoMutation,
  ChatUpdatePublicChannelInfoMutationVariables
>;

/**
 * __useChatUpdatePublicChannelInfoMutation__
 *
 * To run a mutation, you first call `useChatUpdatePublicChannelInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatUpdatePublicChannelInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatUpdatePublicChannelInfoMutation, { data, loading, error }] = useChatUpdatePublicChannelInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channelName: // value for 'channelName'
 *      channelDescription: // value for 'channelDescription'
 *   },
 * });
 */
export function useChatUpdatePublicChannelInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatUpdatePublicChannelInfoMutation,
    ChatUpdatePublicChannelInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChatUpdatePublicChannelInfoMutation,
    ChatUpdatePublicChannelInfoMutationVariables
  >(ChatUpdatePublicChannelInfoDocument, options);
}
export type ChatUpdatePublicChannelInfoMutationHookResult = ReturnType<
  typeof useChatUpdatePublicChannelInfoMutation
>;
export type ChatUpdatePublicChannelInfoMutationResult =
  Apollo.MutationResult<ChatUpdatePublicChannelInfoMutation>;
export type ChatUpdatePublicChannelInfoMutationOptions = Apollo.BaseMutationOptions<
  ChatUpdatePublicChannelInfoMutation,
  ChatUpdatePublicChannelInfoMutationVariables
>;
export const GenerateChannelPictureUploadUrlDocument = gql`
    mutation generateChannelPictureUploadUrl($input: UploadPictureInput!) {
  generateChannelPictureUploadUrl(input: $input) {
    contentURL
    uploadURL
  }
}
    `;
export type GenerateChannelPictureUploadUrlMutationFn = Apollo.MutationFunction<
  GenerateChannelPictureUploadUrlMutation,
  GenerateChannelPictureUploadUrlMutationVariables
>;

/**
 * __useGenerateChannelPictureUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateChannelPictureUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateChannelPictureUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateChannelPictureUploadUrlMutation, { data, loading, error }] = useGenerateChannelPictureUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateChannelPictureUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateChannelPictureUploadUrlMutation,
    GenerateChannelPictureUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateChannelPictureUploadUrlMutation,
    GenerateChannelPictureUploadUrlMutationVariables
  >(GenerateChannelPictureUploadUrlDocument, options);
}
export type GenerateChannelPictureUploadUrlMutationHookResult = ReturnType<
  typeof useGenerateChannelPictureUploadUrlMutation
>;
export type GenerateChannelPictureUploadUrlMutationResult =
  Apollo.MutationResult<GenerateChannelPictureUploadUrlMutation>;
export type GenerateChannelPictureUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  GenerateChannelPictureUploadUrlMutation,
  GenerateChannelPictureUploadUrlMutationVariables
>;
export const SetChannelPictureUrlDocument = gql`
    mutation setChannelPictureUrl($input: SetPictureInput!) {
  setChannelPictureUrl(input: $input) {
    status
  }
}
    `;
export type SetChannelPictureUrlMutationFn = Apollo.MutationFunction<
  SetChannelPictureUrlMutation,
  SetChannelPictureUrlMutationVariables
>;

/**
 * __useSetChannelPictureUrlMutation__
 *
 * To run a mutation, you first call `useSetChannelPictureUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChannelPictureUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChannelPictureUrlMutation, { data, loading, error }] = useSetChannelPictureUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChannelPictureUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChannelPictureUrlMutation,
    SetChannelPictureUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetChannelPictureUrlMutation, SetChannelPictureUrlMutationVariables>(
    SetChannelPictureUrlDocument,
    options,
  );
}
export type SetChannelPictureUrlMutationHookResult = ReturnType<
  typeof useSetChannelPictureUrlMutation
>;
export type SetChannelPictureUrlMutationResult =
  Apollo.MutationResult<SetChannelPictureUrlMutation>;
export type SetChannelPictureUrlMutationOptions = Apollo.BaseMutationOptions<
  SetChannelPictureUrlMutation,
  SetChannelPictureUrlMutationVariables
>;
export const CreateVideoCallDocument = gql`
    mutation createVideoCall($input: CreateVideoCallInput!) {
  createVideoCall(input: $input) {
    id
    title
    chatRoomId
    dailyRoomId
  }
}
    `;
export type CreateVideoCallMutationFn = Apollo.MutationFunction<
  CreateVideoCallMutation,
  CreateVideoCallMutationVariables
>;

/**
 * __useCreateVideoCallMutation__
 *
 * To run a mutation, you first call `useCreateVideoCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoCallMutation, { data, loading, error }] = useCreateVideoCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVideoCallMutation,
    CreateVideoCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateVideoCallMutation, CreateVideoCallMutationVariables>(
    CreateVideoCallDocument,
    options,
  );
}
export type CreateVideoCallMutationHookResult = ReturnType<typeof useCreateVideoCallMutation>;
export type CreateVideoCallMutationResult = Apollo.MutationResult<CreateVideoCallMutation>;
export type CreateVideoCallMutationOptions = Apollo.BaseMutationOptions<
  CreateVideoCallMutation,
  CreateVideoCallMutationVariables
>;
export const ChatSendDirectMessageDocument = gql`
    mutation chatSendDirectMessage($input: SendDirectChatMessageInput!) {
  chatSendDirectMessage(input: $input) {
    status
  }
}
    `;
export type ChatSendDirectMessageMutationFn = Apollo.MutationFunction<
  ChatSendDirectMessageMutation,
  ChatSendDirectMessageMutationVariables
>;

/**
 * __useChatSendDirectMessageMutation__
 *
 * To run a mutation, you first call `useChatSendDirectMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatSendDirectMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatSendDirectMessageMutation, { data, loading, error }] = useChatSendDirectMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatSendDirectMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatSendDirectMessageMutation,
    ChatSendDirectMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChatSendDirectMessageMutation, ChatSendDirectMessageMutationVariables>(
    ChatSendDirectMessageDocument,
    options,
  );
}
export type ChatSendDirectMessageMutationHookResult = ReturnType<
  typeof useChatSendDirectMessageMutation
>;
export type ChatSendDirectMessageMutationResult =
  Apollo.MutationResult<ChatSendDirectMessageMutation>;
export type ChatSendDirectMessageMutationOptions = Apollo.BaseMutationOptions<
  ChatSendDirectMessageMutation,
  ChatSendDirectMessageMutationVariables
>;
export const ChatUpdateUserChannelPermissionDocument = gql`
    mutation chatUpdateUserChannelPermission($input: UpdateUserChannelPermissionInput!) {
  chatUpdateUserChannelPermission(input: $input) {
    status
  }
}
    `;
export type ChatUpdateUserChannelPermissionMutationFn = Apollo.MutationFunction<
  ChatUpdateUserChannelPermissionMutation,
  ChatUpdateUserChannelPermissionMutationVariables
>;

/**
 * __useChatUpdateUserChannelPermissionMutation__
 *
 * To run a mutation, you first call `useChatUpdateUserChannelPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatUpdateUserChannelPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatUpdateUserChannelPermissionMutation, { data, loading, error }] = useChatUpdateUserChannelPermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatUpdateUserChannelPermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChatUpdateUserChannelPermissionMutation,
    ChatUpdateUserChannelPermissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChatUpdateUserChannelPermissionMutation,
    ChatUpdateUserChannelPermissionMutationVariables
  >(ChatUpdateUserChannelPermissionDocument, options);
}
export type ChatUpdateUserChannelPermissionMutationHookResult = ReturnType<
  typeof useChatUpdateUserChannelPermissionMutation
>;
export type ChatUpdateUserChannelPermissionMutationResult =
  Apollo.MutationResult<ChatUpdateUserChannelPermissionMutation>;
export type ChatUpdateUserChannelPermissionMutationOptions = Apollo.BaseMutationOptions<
  ChatUpdateUserChannelPermissionMutation,
  ChatUpdateUserChannelPermissionMutationVariables
>;
export const AcceptChannelInviteDocument = gql`
    mutation acceptChannelInvite($channelCid: String!) {
  acceptChannelInvite(channelCid: $channelCid) {
    status
  }
}
    `;
export type AcceptChannelInviteMutationFn = Apollo.MutationFunction<
  AcceptChannelInviteMutation,
  AcceptChannelInviteMutationVariables
>;

/**
 * __useAcceptChannelInviteMutation__
 *
 * To run a mutation, you first call `useAcceptChannelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptChannelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptChannelInviteMutation, { data, loading, error }] = useAcceptChannelInviteMutation({
 *   variables: {
 *      channelCid: // value for 'channelCid'
 *   },
 * });
 */
export function useAcceptChannelInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptChannelInviteMutation,
    AcceptChannelInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AcceptChannelInviteMutation, AcceptChannelInviteMutationVariables>(
    AcceptChannelInviteDocument,
    options,
  );
}
export type AcceptChannelInviteMutationHookResult = ReturnType<
  typeof useAcceptChannelInviteMutation
>;
export type AcceptChannelInviteMutationResult = Apollo.MutationResult<AcceptChannelInviteMutation>;
export type AcceptChannelInviteMutationOptions = Apollo.BaseMutationOptions<
  AcceptChannelInviteMutation,
  AcceptChannelInviteMutationVariables
>;
export const DeclineChannelInviteDocument = gql`
    mutation declineChannelInvite($channelCid: String!) {
  declineChannelInvite(channelCid: $channelCid) {
    status
  }
}
    `;
export type DeclineChannelInviteMutationFn = Apollo.MutationFunction<
  DeclineChannelInviteMutation,
  DeclineChannelInviteMutationVariables
>;

/**
 * __useDeclineChannelInviteMutation__
 *
 * To run a mutation, you first call `useDeclineChannelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineChannelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineChannelInviteMutation, { data, loading, error }] = useDeclineChannelInviteMutation({
 *   variables: {
 *      channelCid: // value for 'channelCid'
 *   },
 * });
 */
export function useDeclineChannelInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineChannelInviteMutation,
    DeclineChannelInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeclineChannelInviteMutation, DeclineChannelInviteMutationVariables>(
    DeclineChannelInviteDocument,
    options,
  );
}
export type DeclineChannelInviteMutationHookResult = ReturnType<
  typeof useDeclineChannelInviteMutation
>;
export type DeclineChannelInviteMutationResult =
  Apollo.MutationResult<DeclineChannelInviteMutation>;
export type DeclineChannelInviteMutationOptions = Apollo.BaseMutationOptions<
  DeclineChannelInviteMutation,
  DeclineChannelInviteMutationVariables
>;
export const SendManyChatInvitesDocument = gql`
    mutation sendManyChatInvites($input: ChatInviteInput!) {
  sendManyChatInvites(input: $input) {
    status
  }
}
    `;
export type SendManyChatInvitesMutationFn = Apollo.MutationFunction<
  SendManyChatInvitesMutation,
  SendManyChatInvitesMutationVariables
>;

/**
 * __useSendManyChatInvitesMutation__
 *
 * To run a mutation, you first call `useSendManyChatInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManyChatInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManyChatInvitesMutation, { data, loading, error }] = useSendManyChatInvitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendManyChatInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendManyChatInvitesMutation,
    SendManyChatInvitesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendManyChatInvitesMutation, SendManyChatInvitesMutationVariables>(
    SendManyChatInvitesDocument,
    options,
  );
}
export type SendManyChatInvitesMutationHookResult = ReturnType<
  typeof useSendManyChatInvitesMutation
>;
export type SendManyChatInvitesMutationResult = Apollo.MutationResult<SendManyChatInvitesMutation>;
export type SendManyChatInvitesMutationOptions = Apollo.BaseMutationOptions<
  SendManyChatInvitesMutation,
  SendManyChatInvitesMutationVariables
>;
export const DeleteChannelInviteDocument = gql`
    mutation deleteChannelInvite($channelCid: String!, $userId: String!) {
  deleteChannelInvite(channelCid: $channelCid, userId: $userId) {
    status
  }
}
    `;
export type DeleteChannelInviteMutationFn = Apollo.MutationFunction<
  DeleteChannelInviteMutation,
  DeleteChannelInviteMutationVariables
>;

/**
 * __useDeleteChannelInviteMutation__
 *
 * To run a mutation, you first call `useDeleteChannelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelInviteMutation, { data, loading, error }] = useDeleteChannelInviteMutation({
 *   variables: {
 *      channelCid: // value for 'channelCid'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteChannelInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteChannelInviteMutation,
    DeleteChannelInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteChannelInviteMutation, DeleteChannelInviteMutationVariables>(
    DeleteChannelInviteDocument,
    options,
  );
}
export type DeleteChannelInviteMutationHookResult = ReturnType<
  typeof useDeleteChannelInviteMutation
>;
export type DeleteChannelInviteMutationResult = Apollo.MutationResult<DeleteChannelInviteMutation>;
export type DeleteChannelInviteMutationOptions = Apollo.BaseMutationOptions<
  DeleteChannelInviteMutation,
  DeleteChannelInviteMutationVariables
>;
export const CreateCommentDocument = gql`
    mutation createComment($targetId: String!, $targetType: CommentTargetType!, $input: CreateCommentInput!) {
  createComment(targetId: $targetId, targetType: $targetType, input: $input) {
    id
    createdAt
    message
    author {
      id
      name
      avatarUrl
    }
    replies {
      id
      createdAt
      message
      author {
        id
        name
        avatarUrl
      }
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      targetType: // value for 'targetType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(
    CreateCommentDocument,
    options,
  );
}
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($commentID: String!) {
  deleteComment(commentID: $commentID) {
    status
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentID: // value for 'commentID'
 *   },
 * });
 */
export function useDeleteCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(
    DeleteCommentDocument,
    options,
  );
}
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommentMutation,
  DeleteCommentMutationVariables
>;
export const CreateReactionDocument = gql`
    mutation createReaction($input: CreateReactionInput!) {
  createReaction(input: $input) {
    id
    unifiedId
  }
}
    `;
export type CreateReactionMutationFn = Apollo.MutationFunction<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateReactionMutation, CreateReactionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateReactionMutation, CreateReactionMutationVariables>(
    CreateReactionDocument,
    options,
  );
}
export type CreateReactionMutationHookResult = ReturnType<typeof useCreateReactionMutation>;
export type CreateReactionMutationResult = Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<
  CreateReactionMutation,
  CreateReactionMutationVariables
>;
export const DeleteReactionDocument = gql`
    mutation deleteReaction($id: String!) {
  deleteReaction(id: $id) {
    status
  }
}
    `;
export type DeleteReactionMutationFn = Apollo.MutationFunction<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteReactionMutation, DeleteReactionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(
    DeleteReactionDocument,
    options,
  );
}
export type DeleteReactionMutationHookResult = ReturnType<typeof useDeleteReactionMutation>;
export type DeleteReactionMutationResult = Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;
export const CreateEventDocument = gql`
    mutation createEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    id
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<
  CreateEventMutation,
  CreateEventMutationVariables
>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(
    CreateEventDocument,
    options,
  );
}
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<
  CreateEventMutation,
  CreateEventMutationVariables
>;
export const PublishEventDocument = gql`
    mutation publishEvent($id: String!) {
  publishEvent(id: $id) {
    id
  }
}
    `;
export type PublishEventMutationFn = Apollo.MutationFunction<
  PublishEventMutation,
  PublishEventMutationVariables
>;

/**
 * __usePublishEventMutation__
 *
 * To run a mutation, you first call `usePublishEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishEventMutation, { data, loading, error }] = usePublishEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishEventMutation(
  baseOptions?: Apollo.MutationHookOptions<PublishEventMutation, PublishEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PublishEventMutation, PublishEventMutationVariables>(
    PublishEventDocument,
    options,
  );
}
export type PublishEventMutationHookResult = ReturnType<typeof usePublishEventMutation>;
export type PublishEventMutationResult = Apollo.MutationResult<PublishEventMutation>;
export type PublishEventMutationOptions = Apollo.BaseMutationOptions<
  PublishEventMutation,
  PublishEventMutationVariables
>;
export const DuplicateEventDocument = gql`
    mutation duplicateEvent($id: String!) {
  duplicateEvent(id: $id) {
    id
  }
}
    `;
export type DuplicateEventMutationFn = Apollo.MutationFunction<
  DuplicateEventMutation,
  DuplicateEventMutationVariables
>;

/**
 * __useDuplicateEventMutation__
 *
 * To run a mutation, you first call `useDuplicateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEventMutation, { data, loading, error }] = useDuplicateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<DuplicateEventMutation, DuplicateEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DuplicateEventMutation, DuplicateEventMutationVariables>(
    DuplicateEventDocument,
    options,
  );
}
export type DuplicateEventMutationHookResult = ReturnType<typeof useDuplicateEventMutation>;
export type DuplicateEventMutationResult = Apollo.MutationResult<DuplicateEventMutation>;
export type DuplicateEventMutationOptions = Apollo.BaseMutationOptions<
  DuplicateEventMutation,
  DuplicateEventMutationVariables
>;
export const CreateInviteDocument = gql`
    mutation createInvite($input: CreateInviteInput!) {
  createInvite(input: $input) {
    id
    status
    isHost
    user {
      id
      name
      avatarUrl
    }
  }
}
    `;
export type CreateInviteMutationFn = Apollo.MutationFunction<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInviteMutation, CreateInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateInviteMutation, CreateInviteMutationVariables>(
    CreateInviteDocument,
    options,
  );
}
export type CreateInviteMutationHookResult = ReturnType<typeof useCreateInviteMutation>;
export type CreateInviteMutationResult = Apollo.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;
export const DeleteInviteDocument = gql`
    mutation deleteInvite($id: String!) {
  deleteInvite(inviteId: $id) {
    status
  }
}
    `;
export type DeleteInviteMutationFn = Apollo.MutationFunction<
  DeleteInviteMutation,
  DeleteInviteMutationVariables
>;

/**
 * __useDeleteInviteMutation__
 *
 * To run a mutation, you first call `useDeleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInviteMutation, { data, loading, error }] = useDeleteInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteInviteMutation, DeleteInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteInviteMutation, DeleteInviteMutationVariables>(
    DeleteInviteDocument,
    options,
  );
}
export type DeleteInviteMutationHookResult = ReturnType<typeof useDeleteInviteMutation>;
export type DeleteInviteMutationResult = Apollo.MutationResult<DeleteInviteMutation>;
export type DeleteInviteMutationOptions = Apollo.BaseMutationOptions<
  DeleteInviteMutation,
  DeleteInviteMutationVariables
>;
export const GenerateAttachmentUploadUrlDocument = gql`
    mutation generateAttachmentUploadUrl($filename: String!, $eventID: String!) {
  generateAttachmentUploadUrl(filename: $filename, eventID: $eventID) {
    contentURL
    uploadURL
  }
}
    `;
export type GenerateAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
  GenerateAttachmentUploadUrlMutation,
  GenerateAttachmentUploadUrlMutationVariables
>;

/**
 * __useGenerateAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateAttachmentUploadUrlMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      eventID: // value for 'eventID'
 *   },
 * });
 */
export function useGenerateAttachmentUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateAttachmentUploadUrlMutation,
    GenerateAttachmentUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateAttachmentUploadUrlMutation,
    GenerateAttachmentUploadUrlMutationVariables
  >(GenerateAttachmentUploadUrlDocument, options);
}
export type GenerateAttachmentUploadUrlMutationHookResult = ReturnType<
  typeof useGenerateAttachmentUploadUrlMutation
>;
export type GenerateAttachmentUploadUrlMutationResult =
  Apollo.MutationResult<GenerateAttachmentUploadUrlMutation>;
export type GenerateAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  GenerateAttachmentUploadUrlMutation,
  GenerateAttachmentUploadUrlMutationVariables
>;
export const CreateAttachmentDocument = gql`
    mutation createAttachment($eventID: String!, $input: CreateEventAttachmentInput!) {
  createAttachment(eventID: $eventID, input: $input) {
    id
    url
    meta {
      name
      extension
      size
    }
  }
}
    `;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables
>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      eventID: // value for 'eventID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAttachmentMutation,
    CreateAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(
    CreateAttachmentDocument,
    options,
  );
}
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateAttachmentMutation,
  CreateAttachmentMutationVariables
>;
export const DeleteAttachmentDocument = gql`
    mutation deleteAttachment($attachmentID: String!) {
  deleteAttachment(attachmentID: $attachmentID) {
    id
  }
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables
>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      attachmentID: // value for 'attachmentID'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAttachmentMutation,
    DeleteAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(
    DeleteAttachmentDocument,
    options,
  );
}
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables
>;
export const DeleteEventDocument = gql`
    mutation deleteEvent($id: String!, $deleteScope: RecurringEditScope, $selectedEventIds: [String!], $deletedNote: String) {
  deleteEvent(
    id: $id
    deleteScope: $deleteScope
    selectedEventIds: $selectedEventIds
    deletedNote: $deletedNote
  ) {
    status
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<
  DeleteEventMutation,
  DeleteEventMutationVariables
>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteScope: // value for 'deleteScope'
 *      selectedEventIds: // value for 'selectedEventIds'
 *      deletedNote: // value for 'deletedNote'
 *   },
 * });
 */
export function useDeleteEventMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(
    DeleteEventDocument,
    options,
  );
}
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<
  DeleteEventMutation,
  DeleteEventMutationVariables
>;
export const AttendEventDocument = gql`
    mutation attendEvent($input: AttendEventInput!) {
  attendEvent(input: $input) {
    id
    status
  }
}
    `;
export type AttendEventMutationFn = Apollo.MutationFunction<
  AttendEventMutation,
  AttendEventMutationVariables
>;

/**
 * __useAttendEventMutation__
 *
 * To run a mutation, you first call `useAttendEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendEventMutation, { data, loading, error }] = useAttendEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendEventMutation(
  baseOptions?: Apollo.MutationHookOptions<AttendEventMutation, AttendEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AttendEventMutation, AttendEventMutationVariables>(
    AttendEventDocument,
    options,
  );
}
export type AttendEventMutationHookResult = ReturnType<typeof useAttendEventMutation>;
export type AttendEventMutationResult = Apollo.MutationResult<AttendEventMutation>;
export type AttendEventMutationOptions = Apollo.BaseMutationOptions<
  AttendEventMutation,
  AttendEventMutationVariables
>;
export const AttendMultipleEventsDocument = gql`
    mutation attendMultipleEvents($eventIds: [String!]!) {
  attendMultipleEvents(eventIds: $eventIds) {
    status
  }
}
    `;
export type AttendMultipleEventsMutationFn = Apollo.MutationFunction<
  AttendMultipleEventsMutation,
  AttendMultipleEventsMutationVariables
>;

/**
 * __useAttendMultipleEventsMutation__
 *
 * To run a mutation, you first call `useAttendMultipleEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttendMultipleEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attendMultipleEventsMutation, { data, loading, error }] = useAttendMultipleEventsMutation({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useAttendMultipleEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AttendMultipleEventsMutation,
    AttendMultipleEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AttendMultipleEventsMutation, AttendMultipleEventsMutationVariables>(
    AttendMultipleEventsDocument,
    options,
  );
}
export type AttendMultipleEventsMutationHookResult = ReturnType<
  typeof useAttendMultipleEventsMutation
>;
export type AttendMultipleEventsMutationResult =
  Apollo.MutationResult<AttendMultipleEventsMutation>;
export type AttendMultipleEventsMutationOptions = Apollo.BaseMutationOptions<
  AttendMultipleEventsMutation,
  AttendMultipleEventsMutationVariables
>;
export const RespondToRecurringInvitesDocument = gql`
    mutation respondToRecurringInvites($seriesId: String!, $acceptEventIds: [String!]!, $declineEventIds: [String!]!) {
  respondToRecurringInvites(
    seriesId: $seriesId
    acceptEventIds: $acceptEventIds
    declineEventIds: $declineEventIds
  ) {
    status
  }
}
    `;
export type RespondToRecurringInvitesMutationFn = Apollo.MutationFunction<
  RespondToRecurringInvitesMutation,
  RespondToRecurringInvitesMutationVariables
>;

/**
 * __useRespondToRecurringInvitesMutation__
 *
 * To run a mutation, you first call `useRespondToRecurringInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToRecurringInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToRecurringInvitesMutation, { data, loading, error }] = useRespondToRecurringInvitesMutation({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *      acceptEventIds: // value for 'acceptEventIds'
 *      declineEventIds: // value for 'declineEventIds'
 *   },
 * });
 */
export function useRespondToRecurringInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RespondToRecurringInvitesMutation,
    RespondToRecurringInvitesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RespondToRecurringInvitesMutation,
    RespondToRecurringInvitesMutationVariables
  >(RespondToRecurringInvitesDocument, options);
}
export type RespondToRecurringInvitesMutationHookResult = ReturnType<
  typeof useRespondToRecurringInvitesMutation
>;
export type RespondToRecurringInvitesMutationResult =
  Apollo.MutationResult<RespondToRecurringInvitesMutation>;
export type RespondToRecurringInvitesMutationOptions = Apollo.BaseMutationOptions<
  RespondToRecurringInvitesMutation,
  RespondToRecurringInvitesMutationVariables
>;
export const CancelAttendanceDocument = gql`
    mutation cancelAttendance($input: CancelAttendanceInput!) {
  cancelAttendance(input: $input) {
    id
    status
  }
}
    `;
export type CancelAttendanceMutationFn = Apollo.MutationFunction<
  CancelAttendanceMutation,
  CancelAttendanceMutationVariables
>;

/**
 * __useCancelAttendanceMutation__
 *
 * To run a mutation, you first call `useCancelAttendanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAttendanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAttendanceMutation, { data, loading, error }] = useCancelAttendanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAttendanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelAttendanceMutation,
    CancelAttendanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelAttendanceMutation, CancelAttendanceMutationVariables>(
    CancelAttendanceDocument,
    options,
  );
}
export type CancelAttendanceMutationHookResult = ReturnType<typeof useCancelAttendanceMutation>;
export type CancelAttendanceMutationResult = Apollo.MutationResult<CancelAttendanceMutation>;
export type CancelAttendanceMutationOptions = Apollo.BaseMutationOptions<
  CancelAttendanceMutation,
  CancelAttendanceMutationVariables
>;
export const DeclineInviteDocument = gql`
    mutation declineInvite($input: DeclineInviteInput!) {
  declineInvite(input: $input) {
    id
    status
  }
}
    `;
export type DeclineInviteMutationFn = Apollo.MutationFunction<
  DeclineInviteMutation,
  DeclineInviteMutationVariables
>;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInviteMutation, { data, loading, error }] = useDeclineInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeclineInviteMutation, DeclineInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(
    DeclineInviteDocument,
    options,
  );
}
export type DeclineInviteMutationHookResult = ReturnType<typeof useDeclineInviteMutation>;
export type DeclineInviteMutationResult = Apollo.MutationResult<DeclineInviteMutation>;
export type DeclineInviteMutationOptions = Apollo.BaseMutationOptions<
  DeclineInviteMutation,
  DeclineInviteMutationVariables
>;
export const UpdateEventDocument = gql`
    mutation updateEvent($id: String!, $input: UpdateEventInput!) {
  updateEvent(id: $id, input: $input) {
    title
    description
    kind
    conversationKind
    startDate
    endDate
    host {
      id
      firstName
      lastName
      avatarUrl
    }
    topic {
      id
    }
    organizer {
      id
      firstName
      lastName
      avatarUrl
    }
    isPublic
    isLargeCall
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<
  UpdateEventMutation,
  UpdateEventMutationVariables
>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(
    UpdateEventDocument,
    options,
  );
}
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateEventMutation,
  UpdateEventMutationVariables
>;
export const CloseDoorDocument = gql`
    mutation closeDoor($id: String!) {
  closeDoor(id: $id) {
    id
    closedDoorAt
  }
}
    `;
export type CloseDoorMutationFn = Apollo.MutationFunction<
  CloseDoorMutation,
  CloseDoorMutationVariables
>;

/**
 * __useCloseDoorMutation__
 *
 * To run a mutation, you first call `useCloseDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeDoorMutation, { data, loading, error }] = useCloseDoorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<CloseDoorMutation, CloseDoorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseDoorMutation, CloseDoorMutationVariables>(
    CloseDoorDocument,
    options,
  );
}
export type CloseDoorMutationHookResult = ReturnType<typeof useCloseDoorMutation>;
export type CloseDoorMutationResult = Apollo.MutationResult<CloseDoorMutation>;
export type CloseDoorMutationOptions = Apollo.BaseMutationOptions<
  CloseDoorMutation,
  CloseDoorMutationVariables
>;
export const OpenDoorDocument = gql`
    mutation openDoor($id: String!) {
  openDoor(id: $id) {
    id
    closedDoorAt
  }
}
    `;
export type OpenDoorMutationFn = Apollo.MutationFunction<
  OpenDoorMutation,
  OpenDoorMutationVariables
>;

/**
 * __useOpenDoorMutation__
 *
 * To run a mutation, you first call `useOpenDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openDoorMutation, { data, loading, error }] = useOpenDoorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<OpenDoorMutation, OpenDoorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OpenDoorMutation, OpenDoorMutationVariables>(OpenDoorDocument, options);
}
export type OpenDoorMutationHookResult = ReturnType<typeof useOpenDoorMutation>;
export type OpenDoorMutationResult = Apollo.MutationResult<OpenDoorMutation>;
export type OpenDoorMutationOptions = Apollo.BaseMutationOptions<
  OpenDoorMutation,
  OpenDoorMutationVariables
>;
export const AddEventToGoogleCalendarDocument = gql`
    mutation addEventToGoogleCalendar($input: AddEventCalendarInput!) {
  addEventToGoogleCalendar(input: $input) {
    status
    url
    reason
  }
}
    `;
export type AddEventToGoogleCalendarMutationFn = Apollo.MutationFunction<
  AddEventToGoogleCalendarMutation,
  AddEventToGoogleCalendarMutationVariables
>;

/**
 * __useAddEventToGoogleCalendarMutation__
 *
 * To run a mutation, you first call `useAddEventToGoogleCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventToGoogleCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventToGoogleCalendarMutation, { data, loading, error }] = useAddEventToGoogleCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEventToGoogleCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddEventToGoogleCalendarMutation,
    AddEventToGoogleCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddEventToGoogleCalendarMutation,
    AddEventToGoogleCalendarMutationVariables
  >(AddEventToGoogleCalendarDocument, options);
}
export type AddEventToGoogleCalendarMutationHookResult = ReturnType<
  typeof useAddEventToGoogleCalendarMutation
>;
export type AddEventToGoogleCalendarMutationResult =
  Apollo.MutationResult<AddEventToGoogleCalendarMutation>;
export type AddEventToGoogleCalendarMutationOptions = Apollo.BaseMutationOptions<
  AddEventToGoogleCalendarMutation,
  AddEventToGoogleCalendarMutationVariables
>;
export const AddMultipleEventsToGoogleCalendarDocument = gql`
    mutation addMultipleEventsToGoogleCalendar($eventIds: [String!]!, $calendarType: CalendarType!) {
  addMultipleEventsToGoogleCalendar(
    eventIds: $eventIds
    calendarType: $calendarType
  ) {
    status
    url
    reason
  }
}
    `;
export type AddMultipleEventsToGoogleCalendarMutationFn = Apollo.MutationFunction<
  AddMultipleEventsToGoogleCalendarMutation,
  AddMultipleEventsToGoogleCalendarMutationVariables
>;

/**
 * __useAddMultipleEventsToGoogleCalendarMutation__
 *
 * To run a mutation, you first call `useAddMultipleEventsToGoogleCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultipleEventsToGoogleCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultipleEventsToGoogleCalendarMutation, { data, loading, error }] = useAddMultipleEventsToGoogleCalendarMutation({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *      calendarType: // value for 'calendarType'
 *   },
 * });
 */
export function useAddMultipleEventsToGoogleCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddMultipleEventsToGoogleCalendarMutation,
    AddMultipleEventsToGoogleCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddMultipleEventsToGoogleCalendarMutation,
    AddMultipleEventsToGoogleCalendarMutationVariables
  >(AddMultipleEventsToGoogleCalendarDocument, options);
}
export type AddMultipleEventsToGoogleCalendarMutationHookResult = ReturnType<
  typeof useAddMultipleEventsToGoogleCalendarMutation
>;
export type AddMultipleEventsToGoogleCalendarMutationResult =
  Apollo.MutationResult<AddMultipleEventsToGoogleCalendarMutation>;
export type AddMultipleEventsToGoogleCalendarMutationOptions = Apollo.BaseMutationOptions<
  AddMultipleEventsToGoogleCalendarMutation,
  AddMultipleEventsToGoogleCalendarMutationVariables
>;
export const EventMeetingTokenDocument = gql`
    mutation eventMeetingToken($input: DailyMeetingInput!) {
  eventMeetingToken(input: $input) {
    token
    exp
  }
}
    `;
export type EventMeetingTokenMutationFn = Apollo.MutationFunction<
  EventMeetingTokenMutation,
  EventMeetingTokenMutationVariables
>;

/**
 * __useEventMeetingTokenMutation__
 *
 * To run a mutation, you first call `useEventMeetingTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventMeetingTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventMeetingTokenMutation, { data, loading, error }] = useEventMeetingTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventMeetingTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EventMeetingTokenMutation,
    EventMeetingTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EventMeetingTokenMutation, EventMeetingTokenMutationVariables>(
    EventMeetingTokenDocument,
    options,
  );
}
export type EventMeetingTokenMutationHookResult = ReturnType<typeof useEventMeetingTokenMutation>;
export type EventMeetingTokenMutationResult = Apollo.MutationResult<EventMeetingTokenMutation>;
export type EventMeetingTokenMutationOptions = Apollo.BaseMutationOptions<
  EventMeetingTokenMutation,
  EventMeetingTokenMutationVariables
>;
export const MarkJoinEventDocument = gql`
    mutation markJoinEvent($eventId: String!) {
  markJoinEvent(eventId: $eventId) {
    status
  }
}
    `;
export type MarkJoinEventMutationFn = Apollo.MutationFunction<
  MarkJoinEventMutation,
  MarkJoinEventMutationVariables
>;

/**
 * __useMarkJoinEventMutation__
 *
 * To run a mutation, you first call `useMarkJoinEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkJoinEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markJoinEventMutation, { data, loading, error }] = useMarkJoinEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMarkJoinEventMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkJoinEventMutation, MarkJoinEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkJoinEventMutation, MarkJoinEventMutationVariables>(
    MarkJoinEventDocument,
    options,
  );
}
export type MarkJoinEventMutationHookResult = ReturnType<typeof useMarkJoinEventMutation>;
export type MarkJoinEventMutationResult = Apollo.MutationResult<MarkJoinEventMutation>;
export type MarkJoinEventMutationOptions = Apollo.BaseMutationOptions<
  MarkJoinEventMutation,
  MarkJoinEventMutationVariables
>;
export const SaveParticipantSessionDocument = gql`
    mutation saveParticipantSession($participantId: String!, $meetingSessionId: String!) {
  saveParticipantSession(
    participantId: $participantId
    meetingSessionId: $meetingSessionId
  ) {
    status
  }
}
    `;
export type SaveParticipantSessionMutationFn = Apollo.MutationFunction<
  SaveParticipantSessionMutation,
  SaveParticipantSessionMutationVariables
>;

/**
 * __useSaveParticipantSessionMutation__
 *
 * To run a mutation, you first call `useSaveParticipantSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveParticipantSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveParticipantSessionMutation, { data, loading, error }] = useSaveParticipantSessionMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      meetingSessionId: // value for 'meetingSessionId'
 *   },
 * });
 */
export function useSaveParticipantSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveParticipantSessionMutation,
    SaveParticipantSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveParticipantSessionMutation,
    SaveParticipantSessionMutationVariables
  >(SaveParticipantSessionDocument, options);
}
export type SaveParticipantSessionMutationHookResult = ReturnType<
  typeof useSaveParticipantSessionMutation
>;
export type SaveParticipantSessionMutationResult =
  Apollo.MutationResult<SaveParticipantSessionMutation>;
export type SaveParticipantSessionMutationOptions = Apollo.BaseMutationOptions<
  SaveParticipantSessionMutation,
  SaveParticipantSessionMutationVariables
>;
export const UploadEventDescriptionImageDocument = gql`
    mutation uploadEventDescriptionImage($id: String!, $input: UploadEventImageInput!) {
  uploadEventDescriptionImage(id: $id, input: $input) {
    contentURL
  }
}
    `;
export type UploadEventDescriptionImageMutationFn = Apollo.MutationFunction<
  UploadEventDescriptionImageMutation,
  UploadEventDescriptionImageMutationVariables
>;

/**
 * __useUploadEventDescriptionImageMutation__
 *
 * To run a mutation, you first call `useUploadEventDescriptionImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEventDescriptionImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEventDescriptionImageMutation, { data, loading, error }] = useUploadEventDescriptionImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEventDescriptionImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadEventDescriptionImageMutation,
    UploadEventDescriptionImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadEventDescriptionImageMutation,
    UploadEventDescriptionImageMutationVariables
  >(UploadEventDescriptionImageDocument, options);
}
export type UploadEventDescriptionImageMutationHookResult = ReturnType<
  typeof useUploadEventDescriptionImageMutation
>;
export type UploadEventDescriptionImageMutationResult =
  Apollo.MutationResult<UploadEventDescriptionImageMutation>;
export type UploadEventDescriptionImageMutationOptions = Apollo.BaseMutationOptions<
  UploadEventDescriptionImageMutation,
  UploadEventDescriptionImageMutationVariables
>;
export const UploadEventCoverDocument = gql`
    mutation uploadEventCover($id: String!, $input: UploadEventImageInput!) {
  uploadEventCover(id: $id, input: $input) {
    contentURL
  }
}
    `;
export type UploadEventCoverMutationFn = Apollo.MutationFunction<
  UploadEventCoverMutation,
  UploadEventCoverMutationVariables
>;

/**
 * __useUploadEventCoverMutation__
 *
 * To run a mutation, you first call `useUploadEventCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEventCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEventCoverMutation, { data, loading, error }] = useUploadEventCoverMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEventCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadEventCoverMutation,
    UploadEventCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadEventCoverMutation, UploadEventCoverMutationVariables>(
    UploadEventCoverDocument,
    options,
  );
}
export type UploadEventCoverMutationHookResult = ReturnType<typeof useUploadEventCoverMutation>;
export type UploadEventCoverMutationResult = Apollo.MutationResult<UploadEventCoverMutation>;
export type UploadEventCoverMutationOptions = Apollo.BaseMutationOptions<
  UploadEventCoverMutation,
  UploadEventCoverMutationVariables
>;
export const DeleteInvitesDocument = gql`
    mutation deleteInvites($input: DeleteInvitesInput!) {
  deleteInvites(input: $input) {
    status
  }
}
    `;
export type DeleteInvitesMutationFn = Apollo.MutationFunction<
  DeleteInvitesMutation,
  DeleteInvitesMutationVariables
>;

/**
 * __useDeleteInvitesMutation__
 *
 * To run a mutation, you first call `useDeleteInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitesMutation, { data, loading, error }] = useDeleteInvitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteInvitesMutation, DeleteInvitesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteInvitesMutation, DeleteInvitesMutationVariables>(
    DeleteInvitesDocument,
    options,
  );
}
export type DeleteInvitesMutationHookResult = ReturnType<typeof useDeleteInvitesMutation>;
export type DeleteInvitesMutationResult = Apollo.MutationResult<DeleteInvitesMutation>;
export type DeleteInvitesMutationOptions = Apollo.BaseMutationOptions<
  DeleteInvitesMutation,
  DeleteInvitesMutationVariables
>;
export const ConfirmInPersonEventDocument = gql`
    mutation confirmInPersonEvent($id: String!, $input: ConfirmInPersonEventInput!) {
  confirmInPersonEvent(id: $id, input: $input) {
    status
  }
}
    `;
export type ConfirmInPersonEventMutationFn = Apollo.MutationFunction<
  ConfirmInPersonEventMutation,
  ConfirmInPersonEventMutationVariables
>;

/**
 * __useConfirmInPersonEventMutation__
 *
 * To run a mutation, you first call `useConfirmInPersonEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmInPersonEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmInPersonEventMutation, { data, loading, error }] = useConfirmInPersonEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmInPersonEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmInPersonEventMutation,
    ConfirmInPersonEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmInPersonEventMutation, ConfirmInPersonEventMutationVariables>(
    ConfirmInPersonEventDocument,
    options,
  );
}
export type ConfirmInPersonEventMutationHookResult = ReturnType<
  typeof useConfirmInPersonEventMutation
>;
export type ConfirmInPersonEventMutationResult =
  Apollo.MutationResult<ConfirmInPersonEventMutation>;
export type ConfirmInPersonEventMutationOptions = Apollo.BaseMutationOptions<
  ConfirmInPersonEventMutation,
  ConfirmInPersonEventMutationVariables
>;
export const ShareEventDocument = gql`
    mutation shareEvent($eventId: String!, $userIds: [String!]!) {
  shareEvent(eventId: $eventId, userIds: $userIds) {
    status
  }
}
    `;
export type ShareEventMutationFn = Apollo.MutationFunction<
  ShareEventMutation,
  ShareEventMutationVariables
>;

/**
 * __useShareEventMutation__
 *
 * To run a mutation, you first call `useShareEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareEventMutation, { data, loading, error }] = useShareEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useShareEventMutation(
  baseOptions?: Apollo.MutationHookOptions<ShareEventMutation, ShareEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ShareEventMutation, ShareEventMutationVariables>(
    ShareEventDocument,
    options,
  );
}
export type ShareEventMutationHookResult = ReturnType<typeof useShareEventMutation>;
export type ShareEventMutationResult = Apollo.MutationResult<ShareEventMutation>;
export type ShareEventMutationOptions = Apollo.BaseMutationOptions<
  ShareEventMutation,
  ShareEventMutationVariables
>;
export const DeclineSharedEventDocument = gql`
    mutation declineSharedEvent($eventId: String!) {
  declineSharedEvent(eventId: $eventId) {
    status
  }
}
    `;
export type DeclineSharedEventMutationFn = Apollo.MutationFunction<
  DeclineSharedEventMutation,
  DeclineSharedEventMutationVariables
>;

/**
 * __useDeclineSharedEventMutation__
 *
 * To run a mutation, you first call `useDeclineSharedEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineSharedEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineSharedEventMutation, { data, loading, error }] = useDeclineSharedEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeclineSharedEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineSharedEventMutation,
    DeclineSharedEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeclineSharedEventMutation, DeclineSharedEventMutationVariables>(
    DeclineSharedEventDocument,
    options,
  );
}
export type DeclineSharedEventMutationHookResult = ReturnType<typeof useDeclineSharedEventMutation>;
export type DeclineSharedEventMutationResult = Apollo.MutationResult<DeclineSharedEventMutation>;
export type DeclineSharedEventMutationOptions = Apollo.BaseMutationOptions<
  DeclineSharedEventMutation,
  DeclineSharedEventMutationVariables
>;
export const SendEventCalendarInvitesDocument = gql`
    mutation sendEventCalendarInvites($eventIds: [String!]!) {
  sendEventCalendarInvites(eventIds: $eventIds) {
    status
  }
}
    `;
export type SendEventCalendarInvitesMutationFn = Apollo.MutationFunction<
  SendEventCalendarInvitesMutation,
  SendEventCalendarInvitesMutationVariables
>;

/**
 * __useSendEventCalendarInvitesMutation__
 *
 * To run a mutation, you first call `useSendEventCalendarInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventCalendarInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventCalendarInvitesMutation, { data, loading, error }] = useSendEventCalendarInvitesMutation({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useSendEventCalendarInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendEventCalendarInvitesMutation,
    SendEventCalendarInvitesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendEventCalendarInvitesMutation,
    SendEventCalendarInvitesMutationVariables
  >(SendEventCalendarInvitesDocument, options);
}
export type SendEventCalendarInvitesMutationHookResult = ReturnType<
  typeof useSendEventCalendarInvitesMutation
>;
export type SendEventCalendarInvitesMutationResult =
  Apollo.MutationResult<SendEventCalendarInvitesMutation>;
export type SendEventCalendarInvitesMutationOptions = Apollo.BaseMutationOptions<
  SendEventCalendarInvitesMutation,
  SendEventCalendarInvitesMutationVariables
>;
export const AgreeToConversationPactPromiseDocument = gql`
    mutation agreeToConversationPactPromise($promise: ConversationPactPromise!) {
  agreeToConversationPactPromise(promise: $promise) {
    ...ConversationPactFields
  }
}
    ${ConversationPactFieldsFragmentDoc}`;
export type AgreeToConversationPactPromiseMutationFn = Apollo.MutationFunction<
  AgreeToConversationPactPromiseMutation,
  AgreeToConversationPactPromiseMutationVariables
>;

/**
 * __useAgreeToConversationPactPromiseMutation__
 *
 * To run a mutation, you first call `useAgreeToConversationPactPromiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToConversationPactPromiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToConversationPactPromiseMutation, { data, loading, error }] = useAgreeToConversationPactPromiseMutation({
 *   variables: {
 *      promise: // value for 'promise'
 *   },
 * });
 */
export function useAgreeToConversationPactPromiseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AgreeToConversationPactPromiseMutation,
    AgreeToConversationPactPromiseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AgreeToConversationPactPromiseMutation,
    AgreeToConversationPactPromiseMutationVariables
  >(AgreeToConversationPactPromiseDocument, options);
}
export type AgreeToConversationPactPromiseMutationHookResult = ReturnType<
  typeof useAgreeToConversationPactPromiseMutation
>;
export type AgreeToConversationPactPromiseMutationResult =
  Apollo.MutationResult<AgreeToConversationPactPromiseMutation>;
export type AgreeToConversationPactPromiseMutationOptions = Apollo.BaseMutationOptions<
  AgreeToConversationPactPromiseMutation,
  AgreeToConversationPactPromiseMutationVariables
>;
export const AnswerHomeCheckInDocument = gql`
    mutation answerHomeCheckIn($input: AnswerHomeCheckInInput!) {
  answerHomeCheckIn(input: $input) {
    ...HomeCheckInFields
  }
}
    ${HomeCheckInFieldsFragmentDoc}`;
export type AnswerHomeCheckInMutationFn = Apollo.MutationFunction<
  AnswerHomeCheckInMutation,
  AnswerHomeCheckInMutationVariables
>;

/**
 * __useAnswerHomeCheckInMutation__
 *
 * To run a mutation, you first call `useAnswerHomeCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerHomeCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerHomeCheckInMutation, { data, loading, error }] = useAnswerHomeCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerHomeCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnswerHomeCheckInMutation,
    AnswerHomeCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AnswerHomeCheckInMutation, AnswerHomeCheckInMutationVariables>(
    AnswerHomeCheckInDocument,
    options,
  );
}
export type AnswerHomeCheckInMutationHookResult = ReturnType<typeof useAnswerHomeCheckInMutation>;
export type AnswerHomeCheckInMutationResult = Apollo.MutationResult<AnswerHomeCheckInMutation>;
export type AnswerHomeCheckInMutationOptions = Apollo.BaseMutationOptions<
  AnswerHomeCheckInMutation,
  AnswerHomeCheckInMutationVariables
>;
export const AnswerHomeCheckInFollowUpDocument = gql`
    mutation answerHomeCheckInFollowUp($input: AnswerHomeCheckInFollowUpInput!) {
  answerHomeCheckInFollowUp(input: $input) {
    ...HomeCheckInFields
  }
}
    ${HomeCheckInFieldsFragmentDoc}`;
export type AnswerHomeCheckInFollowUpMutationFn = Apollo.MutationFunction<
  AnswerHomeCheckInFollowUpMutation,
  AnswerHomeCheckInFollowUpMutationVariables
>;

/**
 * __useAnswerHomeCheckInFollowUpMutation__
 *
 * To run a mutation, you first call `useAnswerHomeCheckInFollowUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerHomeCheckInFollowUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerHomeCheckInFollowUpMutation, { data, loading, error }] = useAnswerHomeCheckInFollowUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerHomeCheckInFollowUpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnswerHomeCheckInFollowUpMutation,
    AnswerHomeCheckInFollowUpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnswerHomeCheckInFollowUpMutation,
    AnswerHomeCheckInFollowUpMutationVariables
  >(AnswerHomeCheckInFollowUpDocument, options);
}
export type AnswerHomeCheckInFollowUpMutationHookResult = ReturnType<
  typeof useAnswerHomeCheckInFollowUpMutation
>;
export type AnswerHomeCheckInFollowUpMutationResult =
  Apollo.MutationResult<AnswerHomeCheckInFollowUpMutation>;
export type AnswerHomeCheckInFollowUpMutationOptions = Apollo.BaseMutationOptions<
  AnswerHomeCheckInFollowUpMutation,
  AnswerHomeCheckInFollowUpMutationVariables
>;
export const DismissHomeCheckInDocument = gql`
    mutation dismissHomeCheckIn($kind: HomeCheckInKind!) {
  dismissHomeCheckIn(kind: $kind) {
    ...HomeCheckInFields
  }
}
    ${HomeCheckInFieldsFragmentDoc}`;
export type DismissHomeCheckInMutationFn = Apollo.MutationFunction<
  DismissHomeCheckInMutation,
  DismissHomeCheckInMutationVariables
>;

/**
 * __useDismissHomeCheckInMutation__
 *
 * To run a mutation, you first call `useDismissHomeCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissHomeCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissHomeCheckInMutation, { data, loading, error }] = useDismissHomeCheckInMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useDismissHomeCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissHomeCheckInMutation,
    DismissHomeCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DismissHomeCheckInMutation, DismissHomeCheckInMutationVariables>(
    DismissHomeCheckInDocument,
    options,
  );
}
export type DismissHomeCheckInMutationHookResult = ReturnType<typeof useDismissHomeCheckInMutation>;
export type DismissHomeCheckInMutationResult = Apollo.MutationResult<DismissHomeCheckInMutation>;
export type DismissHomeCheckInMutationOptions = Apollo.BaseMutationOptions<
  DismissHomeCheckInMutation,
  DismissHomeCheckInMutationVariables
>;
export const TeamBookingTicketDocument = gql`
    mutation teamBookingTicket {
  teamBookingTicket
}
    `;
export type TeamBookingTicketMutationFn = Apollo.MutationFunction<
  TeamBookingTicketMutation,
  TeamBookingTicketMutationVariables
>;

/**
 * __useTeamBookingTicketMutation__
 *
 * To run a mutation, you first call `useTeamBookingTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamBookingTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamBookingTicketMutation, { data, loading, error }] = useTeamBookingTicketMutation({
 *   variables: {
 *   },
 * });
 */
export function useTeamBookingTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TeamBookingTicketMutation,
    TeamBookingTicketMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TeamBookingTicketMutation, TeamBookingTicketMutationVariables>(
    TeamBookingTicketDocument,
    options,
  );
}
export type TeamBookingTicketMutationHookResult = ReturnType<typeof useTeamBookingTicketMutation>;
export type TeamBookingTicketMutationResult = Apollo.MutationResult<TeamBookingTicketMutation>;
export type TeamBookingTicketMutationOptions = Apollo.BaseMutationOptions<
  TeamBookingTicketMutation,
  TeamBookingTicketMutationVariables
>;
export const RequestHomeCheckInChatDocument = gql`
    mutation requestHomeCheckInChat($kind: HomeCheckInKind!) {
  requestHomeCheckInChat(kind: $kind) {
    ...HomeCheckInFields
  }
}
    ${HomeCheckInFieldsFragmentDoc}`;
export type RequestHomeCheckInChatMutationFn = Apollo.MutationFunction<
  RequestHomeCheckInChatMutation,
  RequestHomeCheckInChatMutationVariables
>;

/**
 * __useRequestHomeCheckInChatMutation__
 *
 * To run a mutation, you first call `useRequestHomeCheckInChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestHomeCheckInChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestHomeCheckInChatMutation, { data, loading, error }] = useRequestHomeCheckInChatMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useRequestHomeCheckInChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestHomeCheckInChatMutation,
    RequestHomeCheckInChatMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestHomeCheckInChatMutation,
    RequestHomeCheckInChatMutationVariables
  >(RequestHomeCheckInChatDocument, options);
}
export type RequestHomeCheckInChatMutationHookResult = ReturnType<
  typeof useRequestHomeCheckInChatMutation
>;
export type RequestHomeCheckInChatMutationResult =
  Apollo.MutationResult<RequestHomeCheckInChatMutation>;
export type RequestHomeCheckInChatMutationOptions = Apollo.BaseMutationOptions<
  RequestHomeCheckInChatMutation,
  RequestHomeCheckInChatMutationVariables
>;
export const CreateLiveTableDocument = gql`
    mutation createLiveTable($input: CreateLiveTableInput!) {
  createLiveTable(input: $input) {
    id
    title
    dailyRoomId
  }
}
    `;
export type CreateLiveTableMutationFn = Apollo.MutationFunction<
  CreateLiveTableMutation,
  CreateLiveTableMutationVariables
>;

/**
 * __useCreateLiveTableMutation__
 *
 * To run a mutation, you first call `useCreateLiveTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiveTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiveTableMutation, { data, loading, error }] = useCreateLiveTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLiveTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLiveTableMutation,
    CreateLiveTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLiveTableMutation, CreateLiveTableMutationVariables>(
    CreateLiveTableDocument,
    options,
  );
}
export type CreateLiveTableMutationHookResult = ReturnType<typeof useCreateLiveTableMutation>;
export type CreateLiveTableMutationResult = Apollo.MutationResult<CreateLiveTableMutation>;
export type CreateLiveTableMutationOptions = Apollo.BaseMutationOptions<
  CreateLiveTableMutation,
  CreateLiveTableMutationVariables
>;
export const UpdateLiveTableDocument = gql`
    mutation updateLiveTable($input: UpdateLiveTableInput!, $id: String!) {
  updateLiveTable(input: $input, id: $id) {
    status
  }
}
    `;
export type UpdateLiveTableMutationFn = Apollo.MutationFunction<
  UpdateLiveTableMutation,
  UpdateLiveTableMutationVariables
>;

/**
 * __useUpdateLiveTableMutation__
 *
 * To run a mutation, you first call `useUpdateLiveTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiveTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiveTableMutation, { data, loading, error }] = useUpdateLiveTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLiveTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLiveTableMutation,
    UpdateLiveTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLiveTableMutation, UpdateLiveTableMutationVariables>(
    UpdateLiveTableDocument,
    options,
  );
}
export type UpdateLiveTableMutationHookResult = ReturnType<typeof useUpdateLiveTableMutation>;
export type UpdateLiveTableMutationResult = Apollo.MutationResult<UpdateLiveTableMutation>;
export type UpdateLiveTableMutationOptions = Apollo.BaseMutationOptions<
  UpdateLiveTableMutation,
  UpdateLiveTableMutationVariables
>;
export const LiveTableMeetingTokenDocument = gql`
    mutation liveTableMeetingToken($input: DailyMeetingInput!) {
  liveTableMeetingToken(input: $input) {
    token
    exp
  }
}
    `;
export type LiveTableMeetingTokenMutationFn = Apollo.MutationFunction<
  LiveTableMeetingTokenMutation,
  LiveTableMeetingTokenMutationVariables
>;

/**
 * __useLiveTableMeetingTokenMutation__
 *
 * To run a mutation, you first call `useLiveTableMeetingTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLiveTableMeetingTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [liveTableMeetingTokenMutation, { data, loading, error }] = useLiveTableMeetingTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLiveTableMeetingTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LiveTableMeetingTokenMutation,
    LiveTableMeetingTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LiveTableMeetingTokenMutation, LiveTableMeetingTokenMutationVariables>(
    LiveTableMeetingTokenDocument,
    options,
  );
}
export type LiveTableMeetingTokenMutationHookResult = ReturnType<
  typeof useLiveTableMeetingTokenMutation
>;
export type LiveTableMeetingTokenMutationResult =
  Apollo.MutationResult<LiveTableMeetingTokenMutation>;
export type LiveTableMeetingTokenMutationOptions = Apollo.BaseMutationOptions<
  LiveTableMeetingTokenMutation,
  LiveTableMeetingTokenMutationVariables
>;
export const SendLiveTablesFeedbackDocument = gql`
    mutation sendLiveTablesFeedback($input: LiveTablesFeedbackInput!) {
  sendLiveTablesFeedback(input: $input) {
    status
  }
}
    `;
export type SendLiveTablesFeedbackMutationFn = Apollo.MutationFunction<
  SendLiveTablesFeedbackMutation,
  SendLiveTablesFeedbackMutationVariables
>;

/**
 * __useSendLiveTablesFeedbackMutation__
 *
 * To run a mutation, you first call `useSendLiveTablesFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLiveTablesFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLiveTablesFeedbackMutation, { data, loading, error }] = useSendLiveTablesFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendLiveTablesFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendLiveTablesFeedbackMutation,
    SendLiveTablesFeedbackMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendLiveTablesFeedbackMutation,
    SendLiveTablesFeedbackMutationVariables
  >(SendLiveTablesFeedbackDocument, options);
}
export type SendLiveTablesFeedbackMutationHookResult = ReturnType<
  typeof useSendLiveTablesFeedbackMutation
>;
export type SendLiveTablesFeedbackMutationResult =
  Apollo.MutationResult<SendLiveTablesFeedbackMutation>;
export type SendLiveTablesFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SendLiveTablesFeedbackMutation,
  SendLiveTablesFeedbackMutationVariables
>;
export const NotifyAboutStartedLiveTableDocument = gql`
    mutation notifyAboutStartedLiveTable($input: LiveTableStartedMessageInput!) {
  notifyAboutStartedLiveTable(input: $input) {
    status
  }
}
    `;
export type NotifyAboutStartedLiveTableMutationFn = Apollo.MutationFunction<
  NotifyAboutStartedLiveTableMutation,
  NotifyAboutStartedLiveTableMutationVariables
>;

/**
 * __useNotifyAboutStartedLiveTableMutation__
 *
 * To run a mutation, you first call `useNotifyAboutStartedLiveTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyAboutStartedLiveTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyAboutStartedLiveTableMutation, { data, loading, error }] = useNotifyAboutStartedLiveTableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotifyAboutStartedLiveTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NotifyAboutStartedLiveTableMutation,
    NotifyAboutStartedLiveTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NotifyAboutStartedLiveTableMutation,
    NotifyAboutStartedLiveTableMutationVariables
  >(NotifyAboutStartedLiveTableDocument, options);
}
export type NotifyAboutStartedLiveTableMutationHookResult = ReturnType<
  typeof useNotifyAboutStartedLiveTableMutation
>;
export type NotifyAboutStartedLiveTableMutationResult =
  Apollo.MutationResult<NotifyAboutStartedLiveTableMutation>;
export type NotifyAboutStartedLiveTableMutationOptions = Apollo.BaseMutationOptions<
  NotifyAboutStartedLiveTableMutation,
  NotifyAboutStartedLiveTableMutationVariables
>;
export const DeleteArticleDocument = gql`
    mutation deleteArticle($id: String!) {
  deleteArticle(id: $id) {
    id
  }
}
    `;
export type DeleteArticleMutationFn = Apollo.MutationFunction<
  DeleteArticleMutation,
  DeleteArticleMutationVariables
>;

/**
 * __useDeleteArticleMutation__
 *
 * To run a mutation, you first call `useDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleMutation, { data, loading, error }] = useDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteArticleMutation, DeleteArticleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteArticleMutation, DeleteArticleMutationVariables>(
    DeleteArticleDocument,
    options,
  );
}
export type DeleteArticleMutationHookResult = ReturnType<typeof useDeleteArticleMutation>;
export type DeleteArticleMutationResult = Apollo.MutationResult<DeleteArticleMutation>;
export type DeleteArticleMutationOptions = Apollo.BaseMutationOptions<
  DeleteArticleMutation,
  DeleteArticleMutationVariables
>;
export const CreateArticleDocument = gql`
    mutation createArticle {
  createArticle {
    id
  }
}
    `;
export type CreateArticleMutationFn = Apollo.MutationFunction<
  CreateArticleMutation,
  CreateArticleMutationVariables
>;

/**
 * __useCreateArticleMutation__
 *
 * To run a mutation, you first call `useCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleMutation, { data, loading, error }] = useCreateArticleMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateArticleMutation, CreateArticleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateArticleMutation, CreateArticleMutationVariables>(
    CreateArticleDocument,
    options,
  );
}
export type CreateArticleMutationHookResult = ReturnType<typeof useCreateArticleMutation>;
export type CreateArticleMutationResult = Apollo.MutationResult<CreateArticleMutation>;
export type CreateArticleMutationOptions = Apollo.BaseMutationOptions<
  CreateArticleMutation,
  CreateArticleMutationVariables
>;
export const PublishOrScheduleArticleDocument = gql`
    mutation publishOrScheduleArticle($id: String!, $input: PublishArticleInput!) {
  publishOrScheduleArticle(id: $id, input: $input) {
    id
  }
}
    `;
export type PublishOrScheduleArticleMutationFn = Apollo.MutationFunction<
  PublishOrScheduleArticleMutation,
  PublishOrScheduleArticleMutationVariables
>;

/**
 * __usePublishOrScheduleArticleMutation__
 *
 * To run a mutation, you first call `usePublishOrScheduleArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishOrScheduleArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishOrScheduleArticleMutation, { data, loading, error }] = usePublishOrScheduleArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishOrScheduleArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishOrScheduleArticleMutation,
    PublishOrScheduleArticleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishOrScheduleArticleMutation,
    PublishOrScheduleArticleMutationVariables
  >(PublishOrScheduleArticleDocument, options);
}
export type PublishOrScheduleArticleMutationHookResult = ReturnType<
  typeof usePublishOrScheduleArticleMutation
>;
export type PublishOrScheduleArticleMutationResult =
  Apollo.MutationResult<PublishOrScheduleArticleMutation>;
export type PublishOrScheduleArticleMutationOptions = Apollo.BaseMutationOptions<
  PublishOrScheduleArticleMutation,
  PublishOrScheduleArticleMutationVariables
>;
export const SaveArticleDocument = gql`
    mutation saveArticle($id: String!, $input: SaveDraftArticleInput!) {
  saveArticle(id: $id, input: $input) {
    id
    tags
  }
}
    `;
export type SaveArticleMutationFn = Apollo.MutationFunction<
  SaveArticleMutation,
  SaveArticleMutationVariables
>;

/**
 * __useSaveArticleMutation__
 *
 * To run a mutation, you first call `useSaveArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveArticleMutation, { data, loading, error }] = useSaveArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveArticleMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveArticleMutation, SaveArticleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveArticleMutation, SaveArticleMutationVariables>(
    SaveArticleDocument,
    options,
  );
}
export type SaveArticleMutationHookResult = ReturnType<typeof useSaveArticleMutation>;
export type SaveArticleMutationResult = Apollo.MutationResult<SaveArticleMutation>;
export type SaveArticleMutationOptions = Apollo.BaseMutationOptions<
  SaveArticleMutation,
  SaveArticleMutationVariables
>;
export const DeleteLikeDocument = gql`
    mutation deleteLike($id: String!) {
  deleteLike(id: $id) {
    status
  }
}
    `;
export type DeleteLikeMutationFn = Apollo.MutationFunction<
  DeleteLikeMutation,
  DeleteLikeMutationVariables
>;

/**
 * __useDeleteLikeMutation__
 *
 * To run a mutation, you first call `useDeleteLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLikeMutation, { data, loading, error }] = useDeleteLikeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteLikeMutation, DeleteLikeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteLikeMutation, DeleteLikeMutationVariables>(
    DeleteLikeDocument,
    options,
  );
}
export type DeleteLikeMutationHookResult = ReturnType<typeof useDeleteLikeMutation>;
export type DeleteLikeMutationResult = Apollo.MutationResult<DeleteLikeMutation>;
export type DeleteLikeMutationOptions = Apollo.BaseMutationOptions<
  DeleteLikeMutation,
  DeleteLikeMutationVariables
>;
export const CreateLikeDocument = gql`
    mutation createLike($input: CreateLikeInput!) {
  createLike(input: $input) {
    id
  }
}
    `;
export type CreateLikeMutationFn = Apollo.MutationFunction<
  CreateLikeMutation,
  CreateLikeMutationVariables
>;

/**
 * __useCreateLikeMutation__
 *
 * To run a mutation, you first call `useCreateLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLikeMutation, { data, loading, error }] = useCreateLikeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateLikeMutation, CreateLikeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLikeMutation, CreateLikeMutationVariables>(
    CreateLikeDocument,
    options,
  );
}
export type CreateLikeMutationHookResult = ReturnType<typeof useCreateLikeMutation>;
export type CreateLikeMutationResult = Apollo.MutationResult<CreateLikeMutation>;
export type CreateLikeMutationOptions = Apollo.BaseMutationOptions<
  CreateLikeMutation,
  CreateLikeMutationVariables
>;
export const GenerateArticlesAttachmentUploadUrlDocument = gql`
    mutation generateArticlesAttachmentUploadUrl($id: String!, $filename: String!) {
  generateArticlesAttachmentUploadUrl(articleId: $id, filename: $filename) {
    contentURL
    uploadURL
  }
}
    `;
export type GenerateArticlesAttachmentUploadUrlMutationFn = Apollo.MutationFunction<
  GenerateArticlesAttachmentUploadUrlMutation,
  GenerateArticlesAttachmentUploadUrlMutationVariables
>;

/**
 * __useGenerateArticlesAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateArticlesAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateArticlesAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateArticlesAttachmentUploadUrlMutation, { data, loading, error }] = useGenerateArticlesAttachmentUploadUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateArticlesAttachmentUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateArticlesAttachmentUploadUrlMutation,
    GenerateArticlesAttachmentUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateArticlesAttachmentUploadUrlMutation,
    GenerateArticlesAttachmentUploadUrlMutationVariables
  >(GenerateArticlesAttachmentUploadUrlDocument, options);
}
export type GenerateArticlesAttachmentUploadUrlMutationHookResult = ReturnType<
  typeof useGenerateArticlesAttachmentUploadUrlMutation
>;
export type GenerateArticlesAttachmentUploadUrlMutationResult =
  Apollo.MutationResult<GenerateArticlesAttachmentUploadUrlMutation>;
export type GenerateArticlesAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  GenerateArticlesAttachmentUploadUrlMutation,
  GenerateArticlesAttachmentUploadUrlMutationVariables
>;
export const CreateArticleAttachmentDocument = gql`
    mutation createArticleAttachment($id: String!, $input: CreateArticlesAttachmentInput!) {
  createArticleAttachment(articleId: $id, input: $input) {
    id
    url
  }
}
    `;
export type CreateArticleAttachmentMutationFn = Apollo.MutationFunction<
  CreateArticleAttachmentMutation,
  CreateArticleAttachmentMutationVariables
>;

/**
 * __useCreateArticleAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateArticleAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArticleAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArticleAttachmentMutation, { data, loading, error }] = useCreateArticleAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArticleAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateArticleAttachmentMutation,
    CreateArticleAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateArticleAttachmentMutation,
    CreateArticleAttachmentMutationVariables
  >(CreateArticleAttachmentDocument, options);
}
export type CreateArticleAttachmentMutationHookResult = ReturnType<
  typeof useCreateArticleAttachmentMutation
>;
export type CreateArticleAttachmentMutationResult =
  Apollo.MutationResult<CreateArticleAttachmentMutation>;
export type CreateArticleAttachmentMutationOptions = Apollo.BaseMutationOptions<
  CreateArticleAttachmentMutation,
  CreateArticleAttachmentMutationVariables
>;
export const DeleteArticleAttachmentDocument = gql`
    mutation deleteArticleAttachment($id: String!) {
  deleteArticleAttachment(attachmentId: $id) {
    id
  }
}
    `;
export type DeleteArticleAttachmentMutationFn = Apollo.MutationFunction<
  DeleteArticleAttachmentMutation,
  DeleteArticleAttachmentMutationVariables
>;

/**
 * __useDeleteArticleAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteArticleAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArticleAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArticleAttachmentMutation, { data, loading, error }] = useDeleteArticleAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArticleAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteArticleAttachmentMutation,
    DeleteArticleAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteArticleAttachmentMutation,
    DeleteArticleAttachmentMutationVariables
  >(DeleteArticleAttachmentDocument, options);
}
export type DeleteArticleAttachmentMutationHookResult = ReturnType<
  typeof useDeleteArticleAttachmentMutation
>;
export type DeleteArticleAttachmentMutationResult =
  Apollo.MutationResult<DeleteArticleAttachmentMutation>;
export type DeleteArticleAttachmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteArticleAttachmentMutation,
  DeleteArticleAttachmentMutationVariables
>;
export const UploadArticleImageDocument = gql`
    mutation uploadArticleImage($input: UploadImageArticleInput!) {
  uploadArticleImage(input: $input) {
    contentURL
  }
}
    `;
export type UploadArticleImageMutationFn = Apollo.MutationFunction<
  UploadArticleImageMutation,
  UploadArticleImageMutationVariables
>;

/**
 * __useUploadArticleImageMutation__
 *
 * To run a mutation, you first call `useUploadArticleImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadArticleImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadArticleImageMutation, { data, loading, error }] = useUploadArticleImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadArticleImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadArticleImageMutation,
    UploadArticleImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadArticleImageMutation, UploadArticleImageMutationVariables>(
    UploadArticleImageDocument,
    options,
  );
}
export type UploadArticleImageMutationHookResult = ReturnType<typeof useUploadArticleImageMutation>;
export type UploadArticleImageMutationResult = Apollo.MutationResult<UploadArticleImageMutation>;
export type UploadArticleImageMutationOptions = Apollo.BaseMutationOptions<
  UploadArticleImageMutation,
  UploadArticleImageMutationVariables
>;
export const NotificationSeenDocument = gql`
    mutation notificationSeen($id: String!) {
  notificationSeen(id: $id) {
    id
    notificationSeen {
      id
      seenAt
    }
  }
}
    `;
export type NotificationSeenMutationFn = Apollo.MutationFunction<
  NotificationSeenMutation,
  NotificationSeenMutationVariables
>;

/**
 * __useNotificationSeenMutation__
 *
 * To run a mutation, you first call `useNotificationSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationSeenMutation, { data, loading, error }] = useNotificationSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NotificationSeenMutation,
    NotificationSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<NotificationSeenMutation, NotificationSeenMutationVariables>(
    NotificationSeenDocument,
    options,
  );
}
export type NotificationSeenMutationHookResult = ReturnType<typeof useNotificationSeenMutation>;
export type NotificationSeenMutationResult = Apollo.MutationResult<NotificationSeenMutation>;
export type NotificationSeenMutationOptions = Apollo.BaseMutationOptions<
  NotificationSeenMutation,
  NotificationSeenMutationVariables
>;
export const MarkAllAsSeenDocument = gql`
    mutation markAllAsSeen {
  markAllAsSeen {
    status
  }
}
    `;
export type MarkAllAsSeenMutationFn = Apollo.MutationFunction<
  MarkAllAsSeenMutation,
  MarkAllAsSeenMutationVariables
>;

/**
 * __useMarkAllAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkAllAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsSeenMutation, { data, loading, error }] = useMarkAllAsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllAsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<MarkAllAsSeenMutation, MarkAllAsSeenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkAllAsSeenMutation, MarkAllAsSeenMutationVariables>(
    MarkAllAsSeenDocument,
    options,
  );
}
export type MarkAllAsSeenMutationHookResult = ReturnType<typeof useMarkAllAsSeenMutation>;
export type MarkAllAsSeenMutationResult = Apollo.MutationResult<MarkAllAsSeenMutation>;
export type MarkAllAsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkAllAsSeenMutation,
  MarkAllAsSeenMutationVariables
>;
export const SubscribePaymentsDocument = gql`
    mutation subscribePayments($input: SubscribeInput!) {
  subscribe(input: $input)
}
    `;
export type SubscribePaymentsMutationFn = Apollo.MutationFunction<
  SubscribePaymentsMutation,
  SubscribePaymentsMutationVariables
>;

/**
 * __useSubscribePaymentsMutation__
 *
 * To run a mutation, you first call `useSubscribePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribePaymentsMutation, { data, loading, error }] = useSubscribePaymentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribePaymentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubscribePaymentsMutation,
    SubscribePaymentsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubscribePaymentsMutation, SubscribePaymentsMutationVariables>(
    SubscribePaymentsDocument,
    options,
  );
}
export type SubscribePaymentsMutationHookResult = ReturnType<typeof useSubscribePaymentsMutation>;
export type SubscribePaymentsMutationResult = Apollo.MutationResult<SubscribePaymentsMutation>;
export type SubscribePaymentsMutationOptions = Apollo.BaseMutationOptions<
  SubscribePaymentsMutation,
  SubscribePaymentsMutationVariables
>;
export const ConfirmGuestPassSignupDocument = gql`
    mutation confirmGuestPassSignup($input: ConfirmGuestPassSignupInput!) {
  confirmGuestPassSignup(input: $input) {
    email
    hasVerifiedEmail
    guestPass {
      id
      startsAt
      endsAt
      daysRemaining
      tokenAllowance
      tokensUsed
      tokensRemaining
      isActive
    }
  }
}
    `;
export type ConfirmGuestPassSignupMutationFn = Apollo.MutationFunction<
  ConfirmGuestPassSignupMutation,
  ConfirmGuestPassSignupMutationVariables
>;

/**
 * __useConfirmGuestPassSignupMutation__
 *
 * To run a mutation, you first call `useConfirmGuestPassSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmGuestPassSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmGuestPassSignupMutation, { data, loading, error }] = useConfirmGuestPassSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmGuestPassSignupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmGuestPassSignupMutation,
    ConfirmGuestPassSignupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfirmGuestPassSignupMutation,
    ConfirmGuestPassSignupMutationVariables
  >(ConfirmGuestPassSignupDocument, options);
}
export type ConfirmGuestPassSignupMutationHookResult = ReturnType<
  typeof useConfirmGuestPassSignupMutation
>;
export type ConfirmGuestPassSignupMutationResult =
  Apollo.MutationResult<ConfirmGuestPassSignupMutation>;
export type ConfirmGuestPassSignupMutationOptions = Apollo.BaseMutationOptions<
  ConfirmGuestPassSignupMutation,
  ConfirmGuestPassSignupMutationVariables
>;
export const GetHostedPageDocument = gql`
    mutation getHostedPage($id: String!) {
  getHostedPage(id: $id)
}
    `;
export type GetHostedPageMutationFn = Apollo.MutationFunction<
  GetHostedPageMutation,
  GetHostedPageMutationVariables
>;

/**
 * __useGetHostedPageMutation__
 *
 * To run a mutation, you first call `useGetHostedPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetHostedPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getHostedPageMutation, { data, loading, error }] = useGetHostedPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHostedPageMutation(
  baseOptions?: Apollo.MutationHookOptions<GetHostedPageMutation, GetHostedPageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GetHostedPageMutation, GetHostedPageMutationVariables>(
    GetHostedPageDocument,
    options,
  );
}
export type GetHostedPageMutationHookResult = ReturnType<typeof useGetHostedPageMutation>;
export type GetHostedPageMutationResult = Apollo.MutationResult<GetHostedPageMutation>;
export type GetHostedPageMutationOptions = Apollo.BaseMutationOptions<
  GetHostedPageMutation,
  GetHostedPageMutationVariables
>;
export const SwitchDocument = gql`
    mutation switch($input: SubscribeInput!) {
  switch(input: $input)
}
    `;
export type SwitchMutationFn = Apollo.MutationFunction<SwitchMutation, SwitchMutationVariables>;

/**
 * __useSwitchMutation__
 *
 * To run a mutation, you first call `useSwitchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchMutation, { data, loading, error }] = useSwitchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchMutation(
  baseOptions?: Apollo.MutationHookOptions<SwitchMutation, SwitchMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SwitchMutation, SwitchMutationVariables>(SwitchDocument, options);
}
export type SwitchMutationHookResult = ReturnType<typeof useSwitchMutation>;
export type SwitchMutationResult = Apollo.MutationResult<SwitchMutation>;
export type SwitchMutationOptions = Apollo.BaseMutationOptions<
  SwitchMutation,
  SwitchMutationVariables
>;
export const ChooseSubscriptionDocument = gql`
    mutation chooseSubscription($input: SubscribeInput!) {
  chooseSubscription(input: $input)
}
    `;
export type ChooseSubscriptionMutationFn = Apollo.MutationFunction<
  ChooseSubscriptionMutation,
  ChooseSubscriptionMutationVariables
>;

/**
 * __useChooseSubscriptionMutation__
 *
 * To run a mutation, you first call `useChooseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseSubscriptionMutation, { data, loading, error }] = useChooseSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChooseSubscriptionMutation,
    ChooseSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChooseSubscriptionMutation, ChooseSubscriptionMutationVariables>(
    ChooseSubscriptionDocument,
    options,
  );
}
export type ChooseSubscriptionMutationHookResult = ReturnType<typeof useChooseSubscriptionMutation>;
export type ChooseSubscriptionMutationResult = Apollo.MutationResult<ChooseSubscriptionMutation>;
export type ChooseSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  ChooseSubscriptionMutation,
  ChooseSubscriptionMutationVariables
>;
export const CancelScheduleCancelSubscriptionDocument = gql`
    mutation cancelScheduleCancelSubscription {
  cancelScheduleCancelSubscription {
    status
  }
}
    `;
export type CancelScheduleCancelSubscriptionMutationFn = Apollo.MutationFunction<
  CancelScheduleCancelSubscriptionMutation,
  CancelScheduleCancelSubscriptionMutationVariables
>;

/**
 * __useCancelScheduleCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelScheduleCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduleCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduleCancelSubscriptionMutation, { data, loading, error }] = useCancelScheduleCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelScheduleCancelSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelScheduleCancelSubscriptionMutation,
    CancelScheduleCancelSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelScheduleCancelSubscriptionMutation,
    CancelScheduleCancelSubscriptionMutationVariables
  >(CancelScheduleCancelSubscriptionDocument, options);
}
export type CancelScheduleCancelSubscriptionMutationHookResult = ReturnType<
  typeof useCancelScheduleCancelSubscriptionMutation
>;
export type CancelScheduleCancelSubscriptionMutationResult =
  Apollo.MutationResult<CancelScheduleCancelSubscriptionMutation>;
export type CancelScheduleCancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CancelScheduleCancelSubscriptionMutation,
  CancelScheduleCancelSubscriptionMutationVariables
>;
export const GetPrecancelPageDocument = gql`
    mutation getPrecancelPage {
  getPrecancelPage
}
    `;
export type GetPrecancelPageMutationFn = Apollo.MutationFunction<
  GetPrecancelPageMutation,
  GetPrecancelPageMutationVariables
>;

/**
 * __useGetPrecancelPageMutation__
 *
 * To run a mutation, you first call `useGetPrecancelPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPrecancelPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPrecancelPageMutation, { data, loading, error }] = useGetPrecancelPageMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetPrecancelPageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetPrecancelPageMutation,
    GetPrecancelPageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GetPrecancelPageMutation, GetPrecancelPageMutationVariables>(
    GetPrecancelPageDocument,
    options,
  );
}
export type GetPrecancelPageMutationHookResult = ReturnType<typeof useGetPrecancelPageMutation>;
export type GetPrecancelPageMutationResult = Apollo.MutationResult<GetPrecancelPageMutation>;
export type GetPrecancelPageMutationOptions = Apollo.BaseMutationOptions<
  GetPrecancelPageMutation,
  GetPrecancelPageMutationVariables
>;
export const UpdatePaymentMethodDocument = gql`
    mutation updatePaymentMethod {
  updatePaymentMethod
}
    `;
export type UpdatePaymentMethodMutationFn = Apollo.MutationFunction<
  UpdatePaymentMethodMutation,
  UpdatePaymentMethodMutationVariables
>;

/**
 * __useUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodMutation, { data, loading, error }] = useUpdatePaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdatePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePaymentMethodMutation,
    UpdatePaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>(
    UpdatePaymentMethodDocument,
    options,
  );
}
export type UpdatePaymentMethodMutationHookResult = ReturnType<
  typeof useUpdatePaymentMethodMutation
>;
export type UpdatePaymentMethodMutationResult = Apollo.MutationResult<UpdatePaymentMethodMutation>;
export type UpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  UpdatePaymentMethodMutation,
  UpdatePaymentMethodMutationVariables
>;
export const ActivateTrialSubscriptionDocument = gql`
    mutation activateTrialSubscription {
  activateTrialSubscription {
    status
  }
}
    `;
export type ActivateTrialSubscriptionMutationFn = Apollo.MutationFunction<
  ActivateTrialSubscriptionMutation,
  ActivateTrialSubscriptionMutationVariables
>;

/**
 * __useActivateTrialSubscriptionMutation__
 *
 * To run a mutation, you first call `useActivateTrialSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTrialSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTrialSubscriptionMutation, { data, loading, error }] = useActivateTrialSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useActivateTrialSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateTrialSubscriptionMutation,
    ActivateTrialSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ActivateTrialSubscriptionMutation,
    ActivateTrialSubscriptionMutationVariables
  >(ActivateTrialSubscriptionDocument, options);
}
export type ActivateTrialSubscriptionMutationHookResult = ReturnType<
  typeof useActivateTrialSubscriptionMutation
>;
export type ActivateTrialSubscriptionMutationResult =
  Apollo.MutationResult<ActivateTrialSubscriptionMutation>;
export type ActivateTrialSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  ActivateTrialSubscriptionMutation,
  ActivateTrialSubscriptionMutationVariables
>;
export const ActivateGuestPassDocument = gql`
    mutation activateGuestPass($planId: String!) {
  activateGuestPass(planId: $planId)
}
    `;
export type ActivateGuestPassMutationFn = Apollo.MutationFunction<
  ActivateGuestPassMutation,
  ActivateGuestPassMutationVariables
>;

/**
 * __useActivateGuestPassMutation__
 *
 * To run a mutation, you first call `useActivateGuestPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateGuestPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateGuestPassMutation, { data, loading, error }] = useActivateGuestPassMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useActivateGuestPassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateGuestPassMutation,
    ActivateGuestPassMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateGuestPassMutation, ActivateGuestPassMutationVariables>(
    ActivateGuestPassDocument,
    options,
  );
}
export type ActivateGuestPassMutationHookResult = ReturnType<typeof useActivateGuestPassMutation>;
export type ActivateGuestPassMutationResult = Apollo.MutationResult<ActivateGuestPassMutation>;
export type ActivateGuestPassMutationOptions = Apollo.BaseMutationOptions<
  ActivateGuestPassMutation,
  ActivateGuestPassMutationVariables
>;
export const RevokeMySessionDocument = gql`
    mutation revokeMySession($sessionId: String!) {
  revokeMySession(sessionId: $sessionId) {
    status
  }
}
    `;
export type RevokeMySessionMutationFn = Apollo.MutationFunction<
  RevokeMySessionMutation,
  RevokeMySessionMutationVariables
>;

/**
 * __useRevokeMySessionMutation__
 *
 * To run a mutation, you first call `useRevokeMySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMySessionMutation, { data, loading, error }] = useRevokeMySessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useRevokeMySessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeMySessionMutation,
    RevokeMySessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeMySessionMutation, RevokeMySessionMutationVariables>(
    RevokeMySessionDocument,
    options,
  );
}
export type RevokeMySessionMutationHookResult = ReturnType<typeof useRevokeMySessionMutation>;
export type RevokeMySessionMutationResult = Apollo.MutationResult<RevokeMySessionMutation>;
export type RevokeMySessionMutationOptions = Apollo.BaseMutationOptions<
  RevokeMySessionMutation,
  RevokeMySessionMutationVariables
>;
export const RevokeOtherMySessionsDocument = gql`
    mutation revokeOtherMySessions {
  revokeOtherMySessions {
    status
  }
}
    `;
export type RevokeOtherMySessionsMutationFn = Apollo.MutationFunction<
  RevokeOtherMySessionsMutation,
  RevokeOtherMySessionsMutationVariables
>;

/**
 * __useRevokeOtherMySessionsMutation__
 *
 * To run a mutation, you first call `useRevokeOtherMySessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOtherMySessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOtherMySessionsMutation, { data, loading, error }] = useRevokeOtherMySessionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeOtherMySessionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeOtherMySessionsMutation,
    RevokeOtherMySessionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeOtherMySessionsMutation, RevokeOtherMySessionsMutationVariables>(
    RevokeOtherMySessionsDocument,
    options,
  );
}
export type RevokeOtherMySessionsMutationHookResult = ReturnType<
  typeof useRevokeOtherMySessionsMutation
>;
export type RevokeOtherMySessionsMutationResult =
  Apollo.MutationResult<RevokeOtherMySessionsMutation>;
export type RevokeOtherMySessionsMutationOptions = Apollo.BaseMutationOptions<
  RevokeOtherMySessionsMutation,
  RevokeOtherMySessionsMutationVariables
>;
export const CreateSparkDocument = gql`
    mutation createSpark($input: CreateSparkInput!) {
  createSpark(input: $input) {
    status
  }
}
    `;
export type CreateSparkMutationFn = Apollo.MutationFunction<
  CreateSparkMutation,
  CreateSparkMutationVariables
>;

/**
 * __useCreateSparkMutation__
 *
 * To run a mutation, you first call `useCreateSparkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSparkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSparkMutation, { data, loading, error }] = useCreateSparkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSparkMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSparkMutation, CreateSparkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateSparkMutation, CreateSparkMutationVariables>(
    CreateSparkDocument,
    options,
  );
}
export type CreateSparkMutationHookResult = ReturnType<typeof useCreateSparkMutation>;
export type CreateSparkMutationResult = Apollo.MutationResult<CreateSparkMutation>;
export type CreateSparkMutationOptions = Apollo.BaseMutationOptions<
  CreateSparkMutation,
  CreateSparkMutationVariables
>;
export const UpdateWeeklyGoalDocument = gql`
    mutation updateWeeklyGoal($goal: Int!) {
  updateWeeklyGoal(goal: $goal) {
    status
  }
}
    `;
export type UpdateWeeklyGoalMutationFn = Apollo.MutationFunction<
  UpdateWeeklyGoalMutation,
  UpdateWeeklyGoalMutationVariables
>;

/**
 * __useUpdateWeeklyGoalMutation__
 *
 * To run a mutation, you first call `useUpdateWeeklyGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeeklyGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeeklyGoalMutation, { data, loading, error }] = useUpdateWeeklyGoalMutation({
 *   variables: {
 *      goal: // value for 'goal'
 *   },
 * });
 */
export function useUpdateWeeklyGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWeeklyGoalMutation,
    UpdateWeeklyGoalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateWeeklyGoalMutation, UpdateWeeklyGoalMutationVariables>(
    UpdateWeeklyGoalDocument,
    options,
  );
}
export type UpdateWeeklyGoalMutationHookResult = ReturnType<typeof useUpdateWeeklyGoalMutation>;
export type UpdateWeeklyGoalMutationResult = Apollo.MutationResult<UpdateWeeklyGoalMutation>;
export type UpdateWeeklyGoalMutationOptions = Apollo.BaseMutationOptions<
  UpdateWeeklyGoalMutation,
  UpdateWeeklyGoalMutationVariables
>;
export const MarkStreakResetSeenDocument = gql`
    mutation markStreakResetSeen {
  markStreakResetSeen {
    status
  }
}
    `;
export type MarkStreakResetSeenMutationFn = Apollo.MutationFunction<
  MarkStreakResetSeenMutation,
  MarkStreakResetSeenMutationVariables
>;

/**
 * __useMarkStreakResetSeenMutation__
 *
 * To run a mutation, you first call `useMarkStreakResetSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStreakResetSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStreakResetSeenMutation, { data, loading, error }] = useMarkStreakResetSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkStreakResetSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkStreakResetSeenMutation,
    MarkStreakResetSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkStreakResetSeenMutation, MarkStreakResetSeenMutationVariables>(
    MarkStreakResetSeenDocument,
    options,
  );
}
export type MarkStreakResetSeenMutationHookResult = ReturnType<
  typeof useMarkStreakResetSeenMutation
>;
export type MarkStreakResetSeenMutationResult = Apollo.MutationResult<MarkStreakResetSeenMutation>;
export type MarkStreakResetSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkStreakResetSeenMutation,
  MarkStreakResetSeenMutationVariables
>;
export const ApplyPowerUpDocument = gql`
    mutation applyPowerUp {
  applyPowerUp {
    status
  }
}
    `;
export type ApplyPowerUpMutationFn = Apollo.MutationFunction<
  ApplyPowerUpMutation,
  ApplyPowerUpMutationVariables
>;

/**
 * __useApplyPowerUpMutation__
 *
 * To run a mutation, you first call `useApplyPowerUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyPowerUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyPowerUpMutation, { data, loading, error }] = useApplyPowerUpMutation({
 *   variables: {
 *   },
 * });
 */
export function useApplyPowerUpMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplyPowerUpMutation, ApplyPowerUpMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApplyPowerUpMutation, ApplyPowerUpMutationVariables>(
    ApplyPowerUpDocument,
    options,
  );
}
export type ApplyPowerUpMutationHookResult = ReturnType<typeof useApplyPowerUpMutation>;
export type ApplyPowerUpMutationResult = Apollo.MutationResult<ApplyPowerUpMutation>;
export type ApplyPowerUpMutationOptions = Apollo.BaseMutationOptions<
  ApplyPowerUpMutation,
  ApplyPowerUpMutationVariables
>;
export const MarkPowerUpRevealedDocument = gql`
    mutation markPowerUpRevealed {
  markPowerUpRevealed {
    status
  }
}
    `;
export type MarkPowerUpRevealedMutationFn = Apollo.MutationFunction<
  MarkPowerUpRevealedMutation,
  MarkPowerUpRevealedMutationVariables
>;

/**
 * __useMarkPowerUpRevealedMutation__
 *
 * To run a mutation, you first call `useMarkPowerUpRevealedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPowerUpRevealedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPowerUpRevealedMutation, { data, loading, error }] = useMarkPowerUpRevealedMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkPowerUpRevealedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPowerUpRevealedMutation,
    MarkPowerUpRevealedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkPowerUpRevealedMutation, MarkPowerUpRevealedMutationVariables>(
    MarkPowerUpRevealedDocument,
    options,
  );
}
export type MarkPowerUpRevealedMutationHookResult = ReturnType<
  typeof useMarkPowerUpRevealedMutation
>;
export type MarkPowerUpRevealedMutationResult = Apollo.MutationResult<MarkPowerUpRevealedMutation>;
export type MarkPowerUpRevealedMutationOptions = Apollo.BaseMutationOptions<
  MarkPowerUpRevealedMutation,
  MarkPowerUpRevealedMutationVariables
>;
export const MarkStreaksExplainerSeenDocument = gql`
    mutation markStreaksExplainerSeen {
  markStreaksExplainerSeen {
    status
  }
}
    `;
export type MarkStreaksExplainerSeenMutationFn = Apollo.MutationFunction<
  MarkStreaksExplainerSeenMutation,
  MarkStreaksExplainerSeenMutationVariables
>;

/**
 * __useMarkStreaksExplainerSeenMutation__
 *
 * To run a mutation, you first call `useMarkStreaksExplainerSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkStreaksExplainerSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markStreaksExplainerSeenMutation, { data, loading, error }] = useMarkStreaksExplainerSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkStreaksExplainerSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkStreaksExplainerSeenMutation,
    MarkStreaksExplainerSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkStreaksExplainerSeenMutation,
    MarkStreaksExplainerSeenMutationVariables
  >(MarkStreaksExplainerSeenDocument, options);
}
export type MarkStreaksExplainerSeenMutationHookResult = ReturnType<
  typeof useMarkStreaksExplainerSeenMutation
>;
export type MarkStreaksExplainerSeenMutationResult =
  Apollo.MutationResult<MarkStreaksExplainerSeenMutation>;
export type MarkStreaksExplainerSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkStreaksExplainerSeenMutation,
  MarkStreaksExplainerSeenMutationVariables
>;
export const MarkRechargeExplainerSeenDocument = gql`
    mutation markRechargeExplainerSeen {
  markRechargeExplainerSeen {
    status
  }
}
    `;
export type MarkRechargeExplainerSeenMutationFn = Apollo.MutationFunction<
  MarkRechargeExplainerSeenMutation,
  MarkRechargeExplainerSeenMutationVariables
>;

/**
 * __useMarkRechargeExplainerSeenMutation__
 *
 * To run a mutation, you first call `useMarkRechargeExplainerSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRechargeExplainerSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRechargeExplainerSeenMutation, { data, loading, error }] = useMarkRechargeExplainerSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkRechargeExplainerSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkRechargeExplainerSeenMutation,
    MarkRechargeExplainerSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkRechargeExplainerSeenMutation,
    MarkRechargeExplainerSeenMutationVariables
  >(MarkRechargeExplainerSeenDocument, options);
}
export type MarkRechargeExplainerSeenMutationHookResult = ReturnType<
  typeof useMarkRechargeExplainerSeenMutation
>;
export type MarkRechargeExplainerSeenMutationResult =
  Apollo.MutationResult<MarkRechargeExplainerSeenMutation>;
export type MarkRechargeExplainerSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkRechargeExplainerSeenMutation,
  MarkRechargeExplainerSeenMutationVariables
>;
export const ConfirmStreakCelebrationDocument = gql`
    mutation confirmStreakCelebration {
  confirmStreakCelebration {
    status
  }
}
    `;
export type ConfirmStreakCelebrationMutationFn = Apollo.MutationFunction<
  ConfirmStreakCelebrationMutation,
  ConfirmStreakCelebrationMutationVariables
>;

/**
 * __useConfirmStreakCelebrationMutation__
 *
 * To run a mutation, you first call `useConfirmStreakCelebrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmStreakCelebrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmStreakCelebrationMutation, { data, loading, error }] = useConfirmStreakCelebrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useConfirmStreakCelebrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmStreakCelebrationMutation,
    ConfirmStreakCelebrationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfirmStreakCelebrationMutation,
    ConfirmStreakCelebrationMutationVariables
  >(ConfirmStreakCelebrationDocument, options);
}
export type ConfirmStreakCelebrationMutationHookResult = ReturnType<
  typeof useConfirmStreakCelebrationMutation
>;
export type ConfirmStreakCelebrationMutationResult =
  Apollo.MutationResult<ConfirmStreakCelebrationMutation>;
export type ConfirmStreakCelebrationMutationOptions = Apollo.BaseMutationOptions<
  ConfirmStreakCelebrationMutation,
  ConfirmStreakCelebrationMutationVariables
>;
export const ActivateUserDocument = gql`
    mutation activateUser($input: ActivateUserInput!) {
  activateUser(input: $input) {
    status
  }
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<
  ActivateUserMutation,
  ActivateUserMutationVariables
>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(
    ActivateUserDocument,
    options,
  );
}
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<
  ActivateUserMutation,
  ActivateUserMutationVariables
>;
export const ResendConfirmationEmailDocument = gql`
    mutation resendConfirmationEmail($input: ResendConfirmationEmailInput!) {
  resendConfirmationEmail(input: $input) {
    status
  }
}
    `;
export type ResendConfirmationEmailMutationFn = Apollo.MutationFunction<
  ResendConfirmationEmailMutation,
  ResendConfirmationEmailMutationVariables
>;

/**
 * __useResendConfirmationEmailMutation__
 *
 * To run a mutation, you first call `useResendConfirmationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmationEmailMutation, { data, loading, error }] = useResendConfirmationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendConfirmationEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendConfirmationEmailMutation,
    ResendConfirmationEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResendConfirmationEmailMutation,
    ResendConfirmationEmailMutationVariables
  >(ResendConfirmationEmailDocument, options);
}
export type ResendConfirmationEmailMutationHookResult = ReturnType<
  typeof useResendConfirmationEmailMutation
>;
export type ResendConfirmationEmailMutationResult =
  Apollo.MutationResult<ResendConfirmationEmailMutation>;
export type ResendConfirmationEmailMutationOptions = Apollo.BaseMutationOptions<
  ResendConfirmationEmailMutation,
  ResendConfirmationEmailMutationVariables
>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options,
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const VerifyUserDocument = gql`
    mutation verifyUser($id: String!, $input: VerifyUserInput!) {
  verifyUser(id: $id, input: $input) {
    status
  }
}
    `;
export type VerifyUserMutationFn = Apollo.MutationFunction<
  VerifyUserMutation,
  VerifyUserMutationVariables
>;

/**
 * __useVerifyUserMutation__
 *
 * To run a mutation, you first call `useVerifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserMutation, { data, loading, error }] = useVerifyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyUserMutation, VerifyUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyUserMutation, VerifyUserMutationVariables>(
    VerifyUserDocument,
    options,
  );
}
export type VerifyUserMutationHookResult = ReturnType<typeof useVerifyUserMutation>;
export type VerifyUserMutationResult = Apollo.MutationResult<VerifyUserMutation>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<
  VerifyUserMutation,
  VerifyUserMutationVariables
>;
export const HeartbeatDocument = gql`
    mutation heartbeat($input: UpdateUserInput!) {
  heartbeat(input: $input) {
    status
  }
}
    `;
export type HeartbeatMutationFn = Apollo.MutationFunction<
  HeartbeatMutation,
  HeartbeatMutationVariables
>;

/**
 * __useHeartbeatMutation__
 *
 * To run a mutation, you first call `useHeartbeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeartbeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heartbeatMutation, { data, loading, error }] = useHeartbeatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeartbeatMutation(
  baseOptions?: Apollo.MutationHookOptions<HeartbeatMutation, HeartbeatMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<HeartbeatMutation, HeartbeatMutationVariables>(
    HeartbeatDocument,
    options,
  );
}
export type HeartbeatMutationHookResult = ReturnType<typeof useHeartbeatMutation>;
export type HeartbeatMutationResult = Apollo.MutationResult<HeartbeatMutation>;
export type HeartbeatMutationOptions = Apollo.BaseMutationOptions<
  HeartbeatMutation,
  HeartbeatMutationVariables
>;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateUserInput!) {
  updateMe(input: $input) {
    id
    avatarUrl
    needSpeakingPartner
    otherLanguage
    cambridgeEnglishLevel
    firstName
    englishSkills
    interests
    occupation {
      id
    }
    isComplete
    lastName
    city
    country
    story
    birthday
    showBirthday
    nativeLanguage
    wantsNewsletter
    completedPercentage
    availability {
      from
      until
    }
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<
  UpdateMeMutation,
  UpdateMeMutationVariables
>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
}
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<
  UpdateMeMutation,
  UpdateMeMutationVariables
>;
export const GenerateUserUploadUrlDocument = gql`
    mutation generateUserUploadUrl($input: UploadPhotoInput!) {
  generateUserUploadUrl(input: $input) {
    contentURL
    uploadURL
  }
}
    `;
export type GenerateUserUploadUrlMutationFn = Apollo.MutationFunction<
  GenerateUserUploadUrlMutation,
  GenerateUserUploadUrlMutationVariables
>;

/**
 * __useGenerateUserUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUserUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUserUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUserUploadUrlMutation, { data, loading, error }] = useGenerateUserUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUserUploadUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateUserUploadUrlMutation,
    GenerateUserUploadUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateUserUploadUrlMutation, GenerateUserUploadUrlMutationVariables>(
    GenerateUserUploadUrlDocument,
    options,
  );
}
export type GenerateUserUploadUrlMutationHookResult = ReturnType<
  typeof useGenerateUserUploadUrlMutation
>;
export type GenerateUserUploadUrlMutationResult =
  Apollo.MutationResult<GenerateUserUploadUrlMutation>;
export type GenerateUserUploadUrlMutationOptions = Apollo.BaseMutationOptions<
  GenerateUserUploadUrlMutation,
  GenerateUserUploadUrlMutationVariables
>;
export const CreateUserPhotoDocument = gql`
    mutation createUserPhoto($input: UpdatePhotoInput!) {
  createUserPhoto(input: $input) {
    id
    url
    createdAt
    updatedAt
  }
}
    `;
export type CreateUserPhotoMutationFn = Apollo.MutationFunction<
  CreateUserPhotoMutation,
  CreateUserPhotoMutationVariables
>;

/**
 * __useCreateUserPhotoMutation__
 *
 * To run a mutation, you first call `useCreateUserPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPhotoMutation, { data, loading, error }] = useCreateUserPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserPhotoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserPhotoMutation,
    CreateUserPhotoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserPhotoMutation, CreateUserPhotoMutationVariables>(
    CreateUserPhotoDocument,
    options,
  );
}
export type CreateUserPhotoMutationHookResult = ReturnType<typeof useCreateUserPhotoMutation>;
export type CreateUserPhotoMutationResult = Apollo.MutationResult<CreateUserPhotoMutation>;
export type CreateUserPhotoMutationOptions = Apollo.BaseMutationOptions<
  CreateUserPhotoMutation,
  CreateUserPhotoMutationVariables
>;
export const DeleteUserPhotoDocument = gql`
    mutation deleteUserPhoto($input: DeletePhotoInput!) {
  deleteUserPhoto(input: $input) {
    id
  }
}
    `;
export type DeleteUserPhotoMutationFn = Apollo.MutationFunction<
  DeleteUserPhotoMutation,
  DeleteUserPhotoMutationVariables
>;

/**
 * __useDeleteUserPhotoMutation__
 *
 * To run a mutation, you first call `useDeleteUserPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPhotoMutation, { data, loading, error }] = useDeleteUserPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserPhotoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserPhotoMutation,
    DeleteUserPhotoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserPhotoMutation, DeleteUserPhotoMutationVariables>(
    DeleteUserPhotoDocument,
    options,
  );
}
export type DeleteUserPhotoMutationHookResult = ReturnType<typeof useDeleteUserPhotoMutation>;
export type DeleteUserPhotoMutationResult = Apollo.MutationResult<DeleteUserPhotoMutation>;
export type DeleteUserPhotoMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserPhotoMutation,
  DeleteUserPhotoMutationVariables
>;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($input: RequestPasswordInput!) {
  requestResetPassword(input: $input) {
    status
  }
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables
>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestResetPasswordMutation,
    RequestResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(
    RequestResetPasswordDocument,
    options,
  );
}
export type RequestResetPasswordMutationHookResult = ReturnType<
  typeof useRequestResetPasswordMutation
>;
export type RequestResetPasswordMutationResult =
  Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables
>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    status
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(
    ResetPasswordDocument,
    options,
  );
}
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($input: UpdateSettingsInput!) {
  updateUserSettings(input: $input) {
    status
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserSettingsMutation,
    UpdateUserSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(
    UpdateUserSettingsDocument,
    options,
  );
}
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables
>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    status
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(
    UpdatePasswordDocument,
    options,
  );
}
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<
  UpdatePasswordMutation,
  UpdatePasswordMutationVariables
>;
export const DeactivateDocument = gql`
    mutation deactivate($input: DeactivateInput!) {
  deactivate(input: $input) {
    reason
    status
  }
}
    `;
export type DeactivateMutationFn = Apollo.MutationFunction<
  DeactivateMutation,
  DeactivateMutationVariables
>;

/**
 * __useDeactivateMutation__
 *
 * To run a mutation, you first call `useDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateMutation, { data, loading, error }] = useDeactivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateMutation(
  baseOptions?: Apollo.MutationHookOptions<DeactivateMutation, DeactivateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeactivateMutation, DeactivateMutationVariables>(
    DeactivateDocument,
    options,
  );
}
export type DeactivateMutationHookResult = ReturnType<typeof useDeactivateMutation>;
export type DeactivateMutationResult = Apollo.MutationResult<DeactivateMutation>;
export type DeactivateMutationOptions = Apollo.BaseMutationOptions<
  DeactivateMutation,
  DeactivateMutationVariables
>;
export const RecoverAccountDocument = gql`
    mutation recoverAccount {
  recoverAccount {
    status
  }
}
    `;
export type RecoverAccountMutationFn = Apollo.MutationFunction<
  RecoverAccountMutation,
  RecoverAccountMutationVariables
>;

/**
 * __useRecoverAccountMutation__
 *
 * To run a mutation, you first call `useRecoverAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverAccountMutation, { data, loading, error }] = useRecoverAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useRecoverAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<RecoverAccountMutation, RecoverAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RecoverAccountMutation, RecoverAccountMutationVariables>(
    RecoverAccountDocument,
    options,
  );
}
export type RecoverAccountMutationHookResult = ReturnType<typeof useRecoverAccountMutation>;
export type RecoverAccountMutationResult = Apollo.MutationResult<RecoverAccountMutation>;
export type RecoverAccountMutationOptions = Apollo.BaseMutationOptions<
  RecoverAccountMutation,
  RecoverAccountMutationVariables
>;
export const CreateAbuseDocument = gql`
    mutation createAbuse($input: ReportAbuseInput!) {
  createAbuse(input: $input) {
    reason
    description
  }
}
    `;
export type CreateAbuseMutationFn = Apollo.MutationFunction<
  CreateAbuseMutation,
  CreateAbuseMutationVariables
>;

/**
 * __useCreateAbuseMutation__
 *
 * To run a mutation, you first call `useCreateAbuseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbuseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbuseMutation, { data, loading, error }] = useCreateAbuseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAbuseMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAbuseMutation, CreateAbuseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAbuseMutation, CreateAbuseMutationVariables>(
    CreateAbuseDocument,
    options,
  );
}
export type CreateAbuseMutationHookResult = ReturnType<typeof useCreateAbuseMutation>;
export type CreateAbuseMutationResult = Apollo.MutationResult<CreateAbuseMutation>;
export type CreateAbuseMutationOptions = Apollo.BaseMutationOptions<
  CreateAbuseMutation,
  CreateAbuseMutationVariables
>;
export const ContactUsDocument = gql`
    mutation contactUs($input: ContactUsInput!) {
  contactUs(input: $input) {
    status
  }
}
    `;
export type ContactUsMutationFn = Apollo.MutationFunction<
  ContactUsMutation,
  ContactUsMutationVariables
>;

/**
 * __useContactUsMutation__
 *
 * To run a mutation, you first call `useContactUsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsMutation, { data, loading, error }] = useContactUsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactUsMutation(
  baseOptions?: Apollo.MutationHookOptions<ContactUsMutation, ContactUsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ContactUsMutation, ContactUsMutationVariables>(
    ContactUsDocument,
    options,
  );
}
export type ContactUsMutationHookResult = ReturnType<typeof useContactUsMutation>;
export type ContactUsMutationResult = Apollo.MutationResult<ContactUsMutation>;
export type ContactUsMutationOptions = Apollo.BaseMutationOptions<
  ContactUsMutation,
  ContactUsMutationVariables
>;
export const AddZoomLicenseToUserDocument = gql`
    mutation addZoomLicenseToUser($userID: String!) {
  addZoomLicenseToUser(userID: $userID) {
    status
  }
}
    `;
export type AddZoomLicenseToUserMutationFn = Apollo.MutationFunction<
  AddZoomLicenseToUserMutation,
  AddZoomLicenseToUserMutationVariables
>;

/**
 * __useAddZoomLicenseToUserMutation__
 *
 * To run a mutation, you first call `useAddZoomLicenseToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddZoomLicenseToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addZoomLicenseToUserMutation, { data, loading, error }] = useAddZoomLicenseToUserMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useAddZoomLicenseToUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddZoomLicenseToUserMutation,
    AddZoomLicenseToUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddZoomLicenseToUserMutation, AddZoomLicenseToUserMutationVariables>(
    AddZoomLicenseToUserDocument,
    options,
  );
}
export type AddZoomLicenseToUserMutationHookResult = ReturnType<
  typeof useAddZoomLicenseToUserMutation
>;
export type AddZoomLicenseToUserMutationResult =
  Apollo.MutationResult<AddZoomLicenseToUserMutation>;
export type AddZoomLicenseToUserMutationOptions = Apollo.BaseMutationOptions<
  AddZoomLicenseToUserMutation,
  AddZoomLicenseToUserMutationVariables
>;
export const FollowDocument = gql`
    mutation follow($input: FollowInput!) {
  follow(input: $input) {
    status
  }
}
    `;
export type FollowMutationFn = Apollo.MutationFunction<FollowMutation, FollowMutationVariables>;

/**
 * __useFollowMutation__
 *
 * To run a mutation, you first call `useFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMutation, { data, loading, error }] = useFollowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFollowMutation(
  baseOptions?: Apollo.MutationHookOptions<FollowMutation, FollowMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FollowMutation, FollowMutationVariables>(FollowDocument, options);
}
export type FollowMutationHookResult = ReturnType<typeof useFollowMutation>;
export type FollowMutationResult = Apollo.MutationResult<FollowMutation>;
export type FollowMutationOptions = Apollo.BaseMutationOptions<
  FollowMutation,
  FollowMutationVariables
>;
export const UnFollowDocument = gql`
    mutation unFollow($input: FollowInput!) {
  unFollow(input: $input) {
    status
  }
}
    `;
export type UnFollowMutationFn = Apollo.MutationFunction<
  UnFollowMutation,
  UnFollowMutationVariables
>;

/**
 * __useUnFollowMutation__
 *
 * To run a mutation, you first call `useUnFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unFollowMutation, { data, loading, error }] = useUnFollowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnFollowMutation(
  baseOptions?: Apollo.MutationHookOptions<UnFollowMutation, UnFollowMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnFollowMutation, UnFollowMutationVariables>(UnFollowDocument, options);
}
export type UnFollowMutationHookResult = ReturnType<typeof useUnFollowMutation>;
export type UnFollowMutationResult = Apollo.MutationResult<UnFollowMutation>;
export type UnFollowMutationOptions = Apollo.BaseMutationOptions<
  UnFollowMutation,
  UnFollowMutationVariables
>;
export const PauseDocument = gql`
    mutation pause($input: PauseInput!) {
  pause(input: $input) {
    status
  }
}
    `;
export type PauseMutationFn = Apollo.MutationFunction<PauseMutation, PauseMutationVariables>;

/**
 * __usePauseMutation__
 *
 * To run a mutation, you first call `usePauseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseMutation, { data, loading, error }] = usePauseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseMutation(
  baseOptions?: Apollo.MutationHookOptions<PauseMutation, PauseMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PauseMutation, PauseMutationVariables>(PauseDocument, options);
}
export type PauseMutationHookResult = ReturnType<typeof usePauseMutation>;
export type PauseMutationResult = Apollo.MutationResult<PauseMutation>;
export type PauseMutationOptions = Apollo.BaseMutationOptions<
  PauseMutation,
  PauseMutationVariables
>;
export const ResumeDocument = gql`
    mutation resume {
  resume {
    status
  }
}
    `;
export type ResumeMutationFn = Apollo.MutationFunction<ResumeMutation, ResumeMutationVariables>;

/**
 * __useResumeMutation__
 *
 * To run a mutation, you first call `useResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeMutation, { data, loading, error }] = useResumeMutation({
 *   variables: {
 *   },
 * });
 */
export function useResumeMutation(
  baseOptions?: Apollo.MutationHookOptions<ResumeMutation, ResumeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResumeMutation, ResumeMutationVariables>(ResumeDocument, options);
}
export type ResumeMutationHookResult = ReturnType<typeof useResumeMutation>;
export type ResumeMutationResult = Apollo.MutationResult<ResumeMutation>;
export type ResumeMutationOptions = Apollo.BaseMutationOptions<
  ResumeMutation,
  ResumeMutationVariables
>;
export const SubscribeDocument = gql`
    mutation subscribe($input: SubscribeInput!) {
  subscribe(input: $input)
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<
  SubscribeMutation,
  SubscribeMutationVariables
>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeMutation(
  baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(
    SubscribeDocument,
    options,
  );
}
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<
  SubscribeMutation,
  SubscribeMutationVariables
>;
export const SetTokenDocument = gql`
    mutation setToken($input: String!) {
  setToken(input: $input) {
    status
  }
}
    `;
export type SetTokenMutationFn = Apollo.MutationFunction<
  SetTokenMutation,
  SetTokenMutationVariables
>;

/**
 * __useSetTokenMutation__
 *
 * To run a mutation, you first call `useSetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTokenMutation, { data, loading, error }] = useSetTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<SetTokenMutation, SetTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTokenMutation, SetTokenMutationVariables>(SetTokenDocument, options);
}
export type SetTokenMutationHookResult = ReturnType<typeof useSetTokenMutation>;
export type SetTokenMutationResult = Apollo.MutationResult<SetTokenMutation>;
export type SetTokenMutationOptions = Apollo.BaseMutationOptions<
  SetTokenMutation,
  SetTokenMutationVariables
>;
export const MarkReportAsSeenDocument = gql`
    mutation markReportAsSeen {
  markReportAsSeen {
    status
  }
}
    `;
export type MarkReportAsSeenMutationFn = Apollo.MutationFunction<
  MarkReportAsSeenMutation,
  MarkReportAsSeenMutationVariables
>;

/**
 * __useMarkReportAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkReportAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReportAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReportAsSeenMutation, { data, loading, error }] = useMarkReportAsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkReportAsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkReportAsSeenMutation,
    MarkReportAsSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkReportAsSeenMutation, MarkReportAsSeenMutationVariables>(
    MarkReportAsSeenDocument,
    options,
  );
}
export type MarkReportAsSeenMutationHookResult = ReturnType<typeof useMarkReportAsSeenMutation>;
export type MarkReportAsSeenMutationResult = Apollo.MutationResult<MarkReportAsSeenMutation>;
export type MarkReportAsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkReportAsSeenMutation,
  MarkReportAsSeenMutationVariables
>;
export const AssignCompleteOnboardingQuizBadgeDocument = gql`
    mutation assignCompleteOnboardingQuizBadge {
  assignCompleteOnboardingQuizBadge {
    status
  }
}
    `;
export type AssignCompleteOnboardingQuizBadgeMutationFn = Apollo.MutationFunction<
  AssignCompleteOnboardingQuizBadgeMutation,
  AssignCompleteOnboardingQuizBadgeMutationVariables
>;

/**
 * __useAssignCompleteOnboardingQuizBadgeMutation__
 *
 * To run a mutation, you first call `useAssignCompleteOnboardingQuizBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCompleteOnboardingQuizBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCompleteOnboardingQuizBadgeMutation, { data, loading, error }] = useAssignCompleteOnboardingQuizBadgeMutation({
 *   variables: {
 *   },
 * });
 */
export function useAssignCompleteOnboardingQuizBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignCompleteOnboardingQuizBadgeMutation,
    AssignCompleteOnboardingQuizBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignCompleteOnboardingQuizBadgeMutation,
    AssignCompleteOnboardingQuizBadgeMutationVariables
  >(AssignCompleteOnboardingQuizBadgeDocument, options);
}
export type AssignCompleteOnboardingQuizBadgeMutationHookResult = ReturnType<
  typeof useAssignCompleteOnboardingQuizBadgeMutation
>;
export type AssignCompleteOnboardingQuizBadgeMutationResult =
  Apollo.MutationResult<AssignCompleteOnboardingQuizBadgeMutation>;
export type AssignCompleteOnboardingQuizBadgeMutationOptions = Apollo.BaseMutationOptions<
  AssignCompleteOnboardingQuizBadgeMutation,
  AssignCompleteOnboardingQuizBadgeMutationVariables
>;
export const WatchedWelcomeVideoDocument = gql`
    mutation watchedWelcomeVideo {
  watchedWelcomeVideo {
    status
  }
}
    `;
export type WatchedWelcomeVideoMutationFn = Apollo.MutationFunction<
  WatchedWelcomeVideoMutation,
  WatchedWelcomeVideoMutationVariables
>;

/**
 * __useWatchedWelcomeVideoMutation__
 *
 * To run a mutation, you first call `useWatchedWelcomeVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchedWelcomeVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchedWelcomeVideoMutation, { data, loading, error }] = useWatchedWelcomeVideoMutation({
 *   variables: {
 *   },
 * });
 */
export function useWatchedWelcomeVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WatchedWelcomeVideoMutation,
    WatchedWelcomeVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WatchedWelcomeVideoMutation, WatchedWelcomeVideoMutationVariables>(
    WatchedWelcomeVideoDocument,
    options,
  );
}
export type WatchedWelcomeVideoMutationHookResult = ReturnType<
  typeof useWatchedWelcomeVideoMutation
>;
export type WatchedWelcomeVideoMutationResult = Apollo.MutationResult<WatchedWelcomeVideoMutation>;
export type WatchedWelcomeVideoMutationOptions = Apollo.BaseMutationOptions<
  WatchedWelcomeVideoMutation,
  WatchedWelcomeVideoMutationVariables
>;
export const WatchedValuesVideoDocument = gql`
    mutation watchedValuesVideo {
  watchedValuesVideo {
    status
  }
}
    `;
export type WatchedValuesVideoMutationFn = Apollo.MutationFunction<
  WatchedValuesVideoMutation,
  WatchedValuesVideoMutationVariables
>;

/**
 * __useWatchedValuesVideoMutation__
 *
 * To run a mutation, you first call `useWatchedValuesVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchedValuesVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchedValuesVideoMutation, { data, loading, error }] = useWatchedValuesVideoMutation({
 *   variables: {
 *   },
 * });
 */
export function useWatchedValuesVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WatchedValuesVideoMutation,
    WatchedValuesVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WatchedValuesVideoMutation, WatchedValuesVideoMutationVariables>(
    WatchedValuesVideoDocument,
    options,
  );
}
export type WatchedValuesVideoMutationHookResult = ReturnType<typeof useWatchedValuesVideoMutation>;
export type WatchedValuesVideoMutationResult = Apollo.MutationResult<WatchedValuesVideoMutation>;
export type WatchedValuesVideoMutationOptions = Apollo.BaseMutationOptions<
  WatchedValuesVideoMutation,
  WatchedValuesVideoMutationVariables
>;
export const MarkEventsTabAsSeenDocument = gql`
    mutation markEventsTabAsSeen {
  markEventsTabAsSeen {
    status
  }
}
    `;
export type MarkEventsTabAsSeenMutationFn = Apollo.MutationFunction<
  MarkEventsTabAsSeenMutation,
  MarkEventsTabAsSeenMutationVariables
>;

/**
 * __useMarkEventsTabAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkEventsTabAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEventsTabAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEventsTabAsSeenMutation, { data, loading, error }] = useMarkEventsTabAsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkEventsTabAsSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkEventsTabAsSeenMutation,
    MarkEventsTabAsSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkEventsTabAsSeenMutation, MarkEventsTabAsSeenMutationVariables>(
    MarkEventsTabAsSeenDocument,
    options,
  );
}
export type MarkEventsTabAsSeenMutationHookResult = ReturnType<
  typeof useMarkEventsTabAsSeenMutation
>;
export type MarkEventsTabAsSeenMutationResult = Apollo.MutationResult<MarkEventsTabAsSeenMutation>;
export type MarkEventsTabAsSeenMutationOptions = Apollo.BaseMutationOptions<
  MarkEventsTabAsSeenMutation,
  MarkEventsTabAsSeenMutationVariables
>;
export const MarkEventsTabAsSeenAfterAttendedThreeEventsDocument = gql`
    mutation markEventsTabAsSeenAfterAttendedThreeEvents {
  markEventsTabAsSeenAfterAttendedThreeEvents {
    status
  }
}
    `;
export type MarkEventsTabAsSeenAfterAttendedThreeEventsMutationFn = Apollo.MutationFunction<
  MarkEventsTabAsSeenAfterAttendedThreeEventsMutation,
  MarkEventsTabAsSeenAfterAttendedThreeEventsMutationVariables
>;

/**
 * __useMarkEventsTabAsSeenAfterAttendedThreeEventsMutation__
 *
 * To run a mutation, you first call `useMarkEventsTabAsSeenAfterAttendedThreeEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEventsTabAsSeenAfterAttendedThreeEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEventsTabAsSeenAfterAttendedThreeEventsMutation, { data, loading, error }] = useMarkEventsTabAsSeenAfterAttendedThreeEventsMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkEventsTabAsSeenAfterAttendedThreeEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkEventsTabAsSeenAfterAttendedThreeEventsMutation,
    MarkEventsTabAsSeenAfterAttendedThreeEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkEventsTabAsSeenAfterAttendedThreeEventsMutation,
    MarkEventsTabAsSeenAfterAttendedThreeEventsMutationVariables
  >(MarkEventsTabAsSeenAfterAttendedThreeEventsDocument, options);
}
export type MarkEventsTabAsSeenAfterAttendedThreeEventsMutationHookResult = ReturnType<
  typeof useMarkEventsTabAsSeenAfterAttendedThreeEventsMutation
>;
export type MarkEventsTabAsSeenAfterAttendedThreeEventsMutationResult =
  Apollo.MutationResult<MarkEventsTabAsSeenAfterAttendedThreeEventsMutation>;
export type MarkEventsTabAsSeenAfterAttendedThreeEventsMutationOptions = Apollo.BaseMutationOptions<
  MarkEventsTabAsSeenAfterAttendedThreeEventsMutation,
  MarkEventsTabAsSeenAfterAttendedThreeEventsMutationVariables
>;
export const SendLinkDocument = gql`
    mutation sendLink($input: FriendInput!) {
  sendLink(input: $input) {
    status
  }
}
    `;
export type SendLinkMutationFn = Apollo.MutationFunction<
  SendLinkMutation,
  SendLinkMutationVariables
>;

/**
 * __useSendLinkMutation__
 *
 * To run a mutation, you first call `useSendLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLinkMutation, { data, loading, error }] = useSendLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<SendLinkMutation, SendLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendLinkMutation, SendLinkMutationVariables>(SendLinkDocument, options);
}
export type SendLinkMutationHookResult = ReturnType<typeof useSendLinkMutation>;
export type SendLinkMutationResult = Apollo.MutationResult<SendLinkMutation>;
export type SendLinkMutationOptions = Apollo.BaseMutationOptions<
  SendLinkMutation,
  SendLinkMutationVariables
>;
export const CloseVideoCallDoorDocument = gql`
    mutation closeVideoCallDoor($id: String!) {
  closeVideoCallDoor(id: $id) {
    id
    closedDoorAt
  }
}
    `;
export type CloseVideoCallDoorMutationFn = Apollo.MutationFunction<
  CloseVideoCallDoorMutation,
  CloseVideoCallDoorMutationVariables
>;

/**
 * __useCloseVideoCallDoorMutation__
 *
 * To run a mutation, you first call `useCloseVideoCallDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseVideoCallDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeVideoCallDoorMutation, { data, loading, error }] = useCloseVideoCallDoorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseVideoCallDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseVideoCallDoorMutation,
    CloseVideoCallDoorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseVideoCallDoorMutation, CloseVideoCallDoorMutationVariables>(
    CloseVideoCallDoorDocument,
    options,
  );
}
export type CloseVideoCallDoorMutationHookResult = ReturnType<typeof useCloseVideoCallDoorMutation>;
export type CloseVideoCallDoorMutationResult = Apollo.MutationResult<CloseVideoCallDoorMutation>;
export type CloseVideoCallDoorMutationOptions = Apollo.BaseMutationOptions<
  CloseVideoCallDoorMutation,
  CloseVideoCallDoorMutationVariables
>;
export const OpenVideoCallDoorDocument = gql`
    mutation openVideoCallDoor($id: String!) {
  openVideoCallDoor(id: $id) {
    id
    closedDoorAt
  }
}
    `;
export type OpenVideoCallDoorMutationFn = Apollo.MutationFunction<
  OpenVideoCallDoorMutation,
  OpenVideoCallDoorMutationVariables
>;

/**
 * __useOpenVideoCallDoorMutation__
 *
 * To run a mutation, you first call `useOpenVideoCallDoorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenVideoCallDoorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openVideoCallDoorMutation, { data, loading, error }] = useOpenVideoCallDoorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpenVideoCallDoorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OpenVideoCallDoorMutation,
    OpenVideoCallDoorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OpenVideoCallDoorMutation, OpenVideoCallDoorMutationVariables>(
    OpenVideoCallDoorDocument,
    options,
  );
}
export type OpenVideoCallDoorMutationHookResult = ReturnType<typeof useOpenVideoCallDoorMutation>;
export type OpenVideoCallDoorMutationResult = Apollo.MutationResult<OpenVideoCallDoorMutation>;
export type OpenVideoCallDoorMutationOptions = Apollo.BaseMutationOptions<
  OpenVideoCallDoorMutation,
  OpenVideoCallDoorMutationVariables
>;
export const VideoMeetingTokenDocument = gql`
    mutation videoMeetingToken($input: DailyMeetingInput!) {
  videoMeetingToken(input: $input) {
    token
    exp
  }
}
    `;
export type VideoMeetingTokenMutationFn = Apollo.MutationFunction<
  VideoMeetingTokenMutation,
  VideoMeetingTokenMutationVariables
>;

/**
 * __useVideoMeetingTokenMutation__
 *
 * To run a mutation, you first call `useVideoMeetingTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoMeetingTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoMeetingTokenMutation, { data, loading, error }] = useVideoMeetingTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoMeetingTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VideoMeetingTokenMutation,
    VideoMeetingTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VideoMeetingTokenMutation, VideoMeetingTokenMutationVariables>(
    VideoMeetingTokenDocument,
    options,
  );
}
export type VideoMeetingTokenMutationHookResult = ReturnType<typeof useVideoMeetingTokenMutation>;
export type VideoMeetingTokenMutationResult = Apollo.MutationResult<VideoMeetingTokenMutation>;
export type VideoMeetingTokenMutationOptions = Apollo.BaseMutationOptions<
  VideoMeetingTokenMutation,
  VideoMeetingTokenMutationVariables
>;
export const CompleteVideoDocument = gql`
    mutation completeVideo($id: String!) {
  completeVideo(id: $id) {
    id
  }
}
    `;
export type CompleteVideoMutationFn = Apollo.MutationFunction<
  CompleteVideoMutation,
  CompleteVideoMutationVariables
>;

/**
 * __useCompleteVideoMutation__
 *
 * To run a mutation, you first call `useCompleteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeVideoMutation, { data, loading, error }] = useCompleteVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompleteVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<CompleteVideoMutation, CompleteVideoMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CompleteVideoMutation, CompleteVideoMutationVariables>(
    CompleteVideoDocument,
    options,
  );
}
export type CompleteVideoMutationHookResult = ReturnType<typeof useCompleteVideoMutation>;
export type CompleteVideoMutationResult = Apollo.MutationResult<CompleteVideoMutation>;
export type CompleteVideoMutationOptions = Apollo.BaseMutationOptions<
  CompleteVideoMutation,
  CompleteVideoMutationVariables
>;
export const CreateWebpushSubscriptionDocument = gql`
    mutation createWebpushSubscription($input: CreateWebpushSubscriptionInput!) {
  createWebpushSubscription(input: $input) {
    status
  }
}
    `;
export type CreateWebpushSubscriptionMutationFn = Apollo.MutationFunction<
  CreateWebpushSubscriptionMutation,
  CreateWebpushSubscriptionMutationVariables
>;

/**
 * __useCreateWebpushSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateWebpushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebpushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebpushSubscriptionMutation, { data, loading, error }] = useCreateWebpushSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebpushSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWebpushSubscriptionMutation,
    CreateWebpushSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWebpushSubscriptionMutation,
    CreateWebpushSubscriptionMutationVariables
  >(CreateWebpushSubscriptionDocument, options);
}
export type CreateWebpushSubscriptionMutationHookResult = ReturnType<
  typeof useCreateWebpushSubscriptionMutation
>;
export type CreateWebpushSubscriptionMutationResult =
  Apollo.MutationResult<CreateWebpushSubscriptionMutation>;
export type CreateWebpushSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  CreateWebpushSubscriptionMutation,
  CreateWebpushSubscriptionMutationVariables
>;
export const VerifyWebpushSubscriptionDocument = gql`
    mutation verifyWebpushSubscription($input: VerifyWebpushSubscriptionInput!) {
  verifyWebpushSubscription(input: $input)
}
    `;
export type VerifyWebpushSubscriptionMutationFn = Apollo.MutationFunction<
  VerifyWebpushSubscriptionMutation,
  VerifyWebpushSubscriptionMutationVariables
>;

/**
 * __useVerifyWebpushSubscriptionMutation__
 *
 * To run a mutation, you first call `useVerifyWebpushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyWebpushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyWebpushSubscriptionMutation, { data, loading, error }] = useVerifyWebpushSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyWebpushSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyWebpushSubscriptionMutation,
    VerifyWebpushSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyWebpushSubscriptionMutation,
    VerifyWebpushSubscriptionMutationVariables
  >(VerifyWebpushSubscriptionDocument, options);
}
export type VerifyWebpushSubscriptionMutationHookResult = ReturnType<
  typeof useVerifyWebpushSubscriptionMutation
>;
export type VerifyWebpushSubscriptionMutationResult =
  Apollo.MutationResult<VerifyWebpushSubscriptionMutation>;
export type VerifyWebpushSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  VerifyWebpushSubscriptionMutation,
  VerifyWebpushSubscriptionMutationVariables
>;
export const GetAssessmentChargesDocument = gql`
    query getAssessmentCharges {
  me {
    id
    availableAssessmentCharges
  }
}
    `;

/**
 * __useGetAssessmentChargesQuery__
 *
 * To run a query within a React component, call `useGetAssessmentChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentChargesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssessmentChargesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAssessmentChargesQuery,
    GetAssessmentChargesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssessmentChargesQuery, GetAssessmentChargesQueryVariables>(
    GetAssessmentChargesDocument,
    options,
  );
}
export function useGetAssessmentChargesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentChargesQuery,
    GetAssessmentChargesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssessmentChargesQuery, GetAssessmentChargesQueryVariables>(
    GetAssessmentChargesDocument,
    options,
  );
}
// @ts-expect-error
export function useGetAssessmentChargesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentChargesQuery,
    GetAssessmentChargesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAssessmentChargesQuery, GetAssessmentChargesQueryVariables>;
export function useGetAssessmentChargesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentChargesQuery,
        GetAssessmentChargesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentChargesQuery | undefined,
  GetAssessmentChargesQueryVariables
>;
export function useGetAssessmentChargesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentChargesQuery,
        GetAssessmentChargesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAssessmentChargesQuery, GetAssessmentChargesQueryVariables>(
    GetAssessmentChargesDocument,
    options,
  );
}
export type GetAssessmentChargesQueryHookResult = ReturnType<typeof useGetAssessmentChargesQuery>;
export type GetAssessmentChargesLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentChargesLazyQuery
>;
export type GetAssessmentChargesSuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentChargesSuspenseQuery
>;
export type GetAssessmentChargesQueryResult = Apollo.QueryResult<
  GetAssessmentChargesQuery,
  GetAssessmentChargesQueryVariables
>;
export const GetAssessmentResultByIdDocument = gql`
    query getAssessmentResultById($assessmentResultId: String!) {
  getAssessmentResultById(assessmentResultId: $assessmentResultId) {
    halloScore
    cefrScore
    improvements
    createdAt
    coherenceScore
    fluencyScore
    grammarScore
    pronunciationScore
    vocabularyScore
    isAddedByAdmin
  }
}
    `;

/**
 * __useGetAssessmentResultByIdQuery__
 *
 * To run a query within a React component, call `useGetAssessmentResultByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentResultByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentResultByIdQuery({
 *   variables: {
 *      assessmentResultId: // value for 'assessmentResultId'
 *   },
 * });
 */
export function useGetAssessmentResultByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAssessmentResultByIdQuery,
    GetAssessmentResultByIdQueryVariables
  > &
    ({ variables: GetAssessmentResultByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssessmentResultByIdQuery, GetAssessmentResultByIdQueryVariables>(
    GetAssessmentResultByIdDocument,
    options,
  );
}
export function useGetAssessmentResultByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentResultByIdQuery,
    GetAssessmentResultByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAssessmentResultByIdQuery, GetAssessmentResultByIdQueryVariables>(
    GetAssessmentResultByIdDocument,
    options,
  );
}
// @ts-expect-error
export function useGetAssessmentResultByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentResultByIdQuery,
    GetAssessmentResultByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentResultByIdQuery,
  GetAssessmentResultByIdQueryVariables
>;
export function useGetAssessmentResultByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentResultByIdQuery,
        GetAssessmentResultByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentResultByIdQuery | undefined,
  GetAssessmentResultByIdQueryVariables
>;
export function useGetAssessmentResultByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentResultByIdQuery,
        GetAssessmentResultByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssessmentResultByIdQuery,
    GetAssessmentResultByIdQueryVariables
  >(GetAssessmentResultByIdDocument, options);
}
export type GetAssessmentResultByIdQueryHookResult = ReturnType<
  typeof useGetAssessmentResultByIdQuery
>;
export type GetAssessmentResultByIdLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentResultByIdLazyQuery
>;
export type GetAssessmentResultByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentResultByIdSuspenseQuery
>;
export type GetAssessmentResultByIdQueryResult = Apollo.QueryResult<
  GetAssessmentResultByIdQuery,
  GetAssessmentResultByIdQueryVariables
>;
export const GetPreviousAssessmentScoreDocument = gql`
    query getPreviousAssessmentScore($assessmentDate: Date!) {
  getPreviousAssessmentScore(assessmentDate: $assessmentDate)
}
    `;

/**
 * __useGetPreviousAssessmentScoreQuery__
 *
 * To run a query within a React component, call `useGetPreviousAssessmentScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousAssessmentScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousAssessmentScoreQuery({
 *   variables: {
 *      assessmentDate: // value for 'assessmentDate'
 *   },
 * });
 */
export function useGetPreviousAssessmentScoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPreviousAssessmentScoreQuery,
    GetPreviousAssessmentScoreQueryVariables
  > &
    ({ variables: GetPreviousAssessmentScoreQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPreviousAssessmentScoreQuery, GetPreviousAssessmentScoreQueryVariables>(
    GetPreviousAssessmentScoreDocument,
    options,
  );
}
export function useGetPreviousAssessmentScoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPreviousAssessmentScoreQuery,
    GetPreviousAssessmentScoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPreviousAssessmentScoreQuery,
    GetPreviousAssessmentScoreQueryVariables
  >(GetPreviousAssessmentScoreDocument, options);
}
// @ts-expect-error
export function useGetPreviousAssessmentScoreSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPreviousAssessmentScoreQuery,
    GetPreviousAssessmentScoreQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPreviousAssessmentScoreQuery,
  GetPreviousAssessmentScoreQueryVariables
>;
export function useGetPreviousAssessmentScoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPreviousAssessmentScoreQuery,
        GetPreviousAssessmentScoreQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPreviousAssessmentScoreQuery | undefined,
  GetPreviousAssessmentScoreQueryVariables
>;
export function useGetPreviousAssessmentScoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPreviousAssessmentScoreQuery,
        GetPreviousAssessmentScoreQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPreviousAssessmentScoreQuery,
    GetPreviousAssessmentScoreQueryVariables
  >(GetPreviousAssessmentScoreDocument, options);
}
export type GetPreviousAssessmentScoreQueryHookResult = ReturnType<
  typeof useGetPreviousAssessmentScoreQuery
>;
export type GetPreviousAssessmentScoreLazyQueryHookResult = ReturnType<
  typeof useGetPreviousAssessmentScoreLazyQuery
>;
export type GetPreviousAssessmentScoreSuspenseQueryHookResult = ReturnType<
  typeof useGetPreviousAssessmentScoreSuspenseQuery
>;
export type GetPreviousAssessmentScoreQueryResult = Apollo.QueryResult<
  GetPreviousAssessmentScoreQuery,
  GetPreviousAssessmentScoreQueryVariables
>;
export const GetLastAssessmentResultDocument = gql`
    query getLastAssessmentResult {
  getLastAssessmentResult {
    halloScore
    createdAt
    fluencyScore
    vocabularyScore
    grammarScore
    pronunciationScore
    coherenceScore
    assessmentId
    isAddedByAdmin
  }
}
    `;

/**
 * __useGetLastAssessmentResultQuery__
 *
 * To run a query within a React component, call `useGetLastAssessmentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAssessmentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAssessmentResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastAssessmentResultQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLastAssessmentResultQuery,
    GetLastAssessmentResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLastAssessmentResultQuery, GetLastAssessmentResultQueryVariables>(
    GetLastAssessmentResultDocument,
    options,
  );
}
export function useGetLastAssessmentResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLastAssessmentResultQuery,
    GetLastAssessmentResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLastAssessmentResultQuery, GetLastAssessmentResultQueryVariables>(
    GetLastAssessmentResultDocument,
    options,
  );
}
// @ts-expect-error
export function useGetLastAssessmentResultSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLastAssessmentResultQuery,
    GetLastAssessmentResultQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetLastAssessmentResultQuery,
  GetLastAssessmentResultQueryVariables
>;
export function useGetLastAssessmentResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLastAssessmentResultQuery,
        GetLastAssessmentResultQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLastAssessmentResultQuery | undefined,
  GetLastAssessmentResultQueryVariables
>;
export function useGetLastAssessmentResultSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLastAssessmentResultQuery,
        GetLastAssessmentResultQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetLastAssessmentResultQuery,
    GetLastAssessmentResultQueryVariables
  >(GetLastAssessmentResultDocument, options);
}
export type GetLastAssessmentResultQueryHookResult = ReturnType<
  typeof useGetLastAssessmentResultQuery
>;
export type GetLastAssessmentResultLazyQueryHookResult = ReturnType<
  typeof useGetLastAssessmentResultLazyQuery
>;
export type GetLastAssessmentResultSuspenseQueryHookResult = ReturnType<
  typeof useGetLastAssessmentResultSuspenseQuery
>;
export type GetLastAssessmentResultQueryResult = Apollo.QueryResult<
  GetLastAssessmentResultQuery,
  GetLastAssessmentResultQueryVariables
>;
export const GetAssessmentResultsCountDocument = gql`
    query getAssessmentResultsCount {
  getAssessmentResultsCount
}
    `;

/**
 * __useGetAssessmentResultsCountQuery__
 *
 * To run a query within a React component, call `useGetAssessmentResultsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentResultsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentResultsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssessmentResultsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAssessmentResultsCountQuery,
    GetAssessmentResultsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAssessmentResultsCountQuery, GetAssessmentResultsCountQueryVariables>(
    GetAssessmentResultsCountDocument,
    options,
  );
}
export function useGetAssessmentResultsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAssessmentResultsCountQuery,
    GetAssessmentResultsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAssessmentResultsCountQuery,
    GetAssessmentResultsCountQueryVariables
  >(GetAssessmentResultsCountDocument, options);
}
// @ts-expect-error
export function useGetAssessmentResultsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAssessmentResultsCountQuery,
    GetAssessmentResultsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentResultsCountQuery,
  GetAssessmentResultsCountQueryVariables
>;
export function useGetAssessmentResultsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentResultsCountQuery,
        GetAssessmentResultsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAssessmentResultsCountQuery | undefined,
  GetAssessmentResultsCountQueryVariables
>;
export function useGetAssessmentResultsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAssessmentResultsCountQuery,
        GetAssessmentResultsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAssessmentResultsCountQuery,
    GetAssessmentResultsCountQueryVariables
  >(GetAssessmentResultsCountDocument, options);
}
export type GetAssessmentResultsCountQueryHookResult = ReturnType<
  typeof useGetAssessmentResultsCountQuery
>;
export type GetAssessmentResultsCountLazyQueryHookResult = ReturnType<
  typeof useGetAssessmentResultsCountLazyQuery
>;
export type GetAssessmentResultsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetAssessmentResultsCountSuspenseQuery
>;
export type GetAssessmentResultsCountQueryResult = Apollo.QueryResult<
  GetAssessmentResultsCountQuery,
  GetAssessmentResultsCountQueryVariables
>;
export const ListPaginatedAssessmentResultsDocument = gql`
    query listPaginatedAssessmentResults($filters: PaginatedAssessmentResultInput!) {
  listPaginatedAssessmentResults(filters: $filters) {
    total
    items {
      id
      assessmentId
      halloScore
      createdAt
    }
  }
}
    `;

/**
 * __useListPaginatedAssessmentResultsQuery__
 *
 * To run a query within a React component, call `useListPaginatedAssessmentResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaginatedAssessmentResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaginatedAssessmentResultsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListPaginatedAssessmentResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  > &
    (
      | { variables: ListPaginatedAssessmentResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >(ListPaginatedAssessmentResultsDocument, options);
}
export function useListPaginatedAssessmentResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >(ListPaginatedAssessmentResultsDocument, options);
}
// @ts-expect-error
export function useListPaginatedAssessmentResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListPaginatedAssessmentResultsQuery,
  ListPaginatedAssessmentResultsQueryVariables
>;
export function useListPaginatedAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPaginatedAssessmentResultsQuery,
        ListPaginatedAssessmentResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListPaginatedAssessmentResultsQuery | undefined,
  ListPaginatedAssessmentResultsQueryVariables
>;
export function useListPaginatedAssessmentResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPaginatedAssessmentResultsQuery,
        ListPaginatedAssessmentResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListPaginatedAssessmentResultsQuery,
    ListPaginatedAssessmentResultsQueryVariables
  >(ListPaginatedAssessmentResultsDocument, options);
}
export type ListPaginatedAssessmentResultsQueryHookResult = ReturnType<
  typeof useListPaginatedAssessmentResultsQuery
>;
export type ListPaginatedAssessmentResultsLazyQueryHookResult = ReturnType<
  typeof useListPaginatedAssessmentResultsLazyQuery
>;
export type ListPaginatedAssessmentResultsSuspenseQueryHookResult = ReturnType<
  typeof useListPaginatedAssessmentResultsSuspenseQuery
>;
export type ListPaginatedAssessmentResultsQueryResult = Apollo.QueryResult<
  ListPaginatedAssessmentResultsQuery,
  ListPaginatedAssessmentResultsQueryVariables
>;
export const GetCurrentBannerDocument = gql`
    query getCurrentBanner {
  getCurrentBanner {
    id
    title
    isActive
    sliders {
      id
      title
      subtitle
      buttonText
      buttonURL
      background {
        mobile
        desktop
      }
      featureImage
      titleStyle
      textColour
      imageAlignment
    }
  }
}
    `;

/**
 * __useGetCurrentBannerQuery__
 *
 * To run a query within a React component, call `useGetCurrentBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentBannerQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>(
    GetCurrentBannerDocument,
    options,
  );
}
export function useGetCurrentBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>(
    GetCurrentBannerDocument,
    options,
  );
}
// @ts-expect-error
export function useGetCurrentBannerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentBannerQuery,
    GetCurrentBannerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>;
export function useGetCurrentBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCurrentBannerQuery | undefined, GetCurrentBannerQueryVariables>;
export function useGetCurrentBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCurrentBannerQuery, GetCurrentBannerQueryVariables>(
    GetCurrentBannerDocument,
    options,
  );
}
export type GetCurrentBannerQueryHookResult = ReturnType<typeof useGetCurrentBannerQuery>;
export type GetCurrentBannerLazyQueryHookResult = ReturnType<typeof useGetCurrentBannerLazyQuery>;
export type GetCurrentBannerSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentBannerSuspenseQuery
>;
export type GetCurrentBannerQueryResult = Apollo.QueryResult<
  GetCurrentBannerQuery,
  GetCurrentBannerQueryVariables
>;
export const ChatCreateUserTokenDocument = gql`
    query chatCreateUserToken {
  chatCreateUserToken
}
    `;

/**
 * __useChatCreateUserTokenQuery__
 *
 * To run a query within a React component, call `useChatCreateUserTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatCreateUserTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatCreateUserTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatCreateUserTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ChatCreateUserTokenQuery,
    ChatCreateUserTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatCreateUserTokenQuery, ChatCreateUserTokenQueryVariables>(
    ChatCreateUserTokenDocument,
    options,
  );
}
export function useChatCreateUserTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChatCreateUserTokenQuery,
    ChatCreateUserTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChatCreateUserTokenQuery, ChatCreateUserTokenQueryVariables>(
    ChatCreateUserTokenDocument,
    options,
  );
}
// @ts-expect-error
export function useChatCreateUserTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ChatCreateUserTokenQuery,
    ChatCreateUserTokenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ChatCreateUserTokenQuery, ChatCreateUserTokenQueryVariables>;
export function useChatCreateUserTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChatCreateUserTokenQuery, ChatCreateUserTokenQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ChatCreateUserTokenQuery | undefined,
  ChatCreateUserTokenQueryVariables
>;
export function useChatCreateUserTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ChatCreateUserTokenQuery, ChatCreateUserTokenQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ChatCreateUserTokenQuery, ChatCreateUserTokenQueryVariables>(
    ChatCreateUserTokenDocument,
    options,
  );
}
export type ChatCreateUserTokenQueryHookResult = ReturnType<typeof useChatCreateUserTokenQuery>;
export type ChatCreateUserTokenLazyQueryHookResult = ReturnType<
  typeof useChatCreateUserTokenLazyQuery
>;
export type ChatCreateUserTokenSuspenseQueryHookResult = ReturnType<
  typeof useChatCreateUserTokenSuspenseQuery
>;
export type ChatCreateUserTokenQueryResult = Apollo.QueryResult<
  ChatCreateUserTokenQuery,
  ChatCreateUserTokenQueryVariables
>;
export const GetChannelInviteDocument = gql`
    query getChannelInvite($channelCid: String!) {
  getChannelInvite(channelCid: $channelCid) {
    channelId
    status
    actor {
      firstName
      lastName
      name
      avatarUrl
    }
  }
}
    `;

/**
 * __useGetChannelInviteQuery__
 *
 * To run a query within a React component, call `useGetChannelInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInviteQuery({
 *   variables: {
 *      channelCid: // value for 'channelCid'
 *   },
 * });
 */
export function useGetChannelInviteQuery(
  baseOptions: Apollo.QueryHookOptions<GetChannelInviteQuery, GetChannelInviteQueryVariables> &
    ({ variables: GetChannelInviteQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelInviteQuery, GetChannelInviteQueryVariables>(
    GetChannelInviteDocument,
    options,
  );
}
export function useGetChannelInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChannelInviteQuery, GetChannelInviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelInviteQuery, GetChannelInviteQueryVariables>(
    GetChannelInviteDocument,
    options,
  );
}
// @ts-expect-error
export function useGetChannelInviteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChannelInviteQuery,
    GetChannelInviteQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetChannelInviteQuery, GetChannelInviteQueryVariables>;
export function useGetChannelInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelInviteQuery, GetChannelInviteQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetChannelInviteQuery | undefined, GetChannelInviteQueryVariables>;
export function useGetChannelInviteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelInviteQuery, GetChannelInviteQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelInviteQuery, GetChannelInviteQueryVariables>(
    GetChannelInviteDocument,
    options,
  );
}
export type GetChannelInviteQueryHookResult = ReturnType<typeof useGetChannelInviteQuery>;
export type GetChannelInviteLazyQueryHookResult = ReturnType<typeof useGetChannelInviteLazyQuery>;
export type GetChannelInviteSuspenseQueryHookResult = ReturnType<
  typeof useGetChannelInviteSuspenseQuery
>;
export type GetChannelInviteQueryResult = Apollo.QueryResult<
  GetChannelInviteQuery,
  GetChannelInviteQueryVariables
>;
export const GetChannelInvitesForUsersDocument = gql`
    query getChannelInvitesForUsers($input: ChatInvitesForUsersInput!) {
  getChannelInvitesForUsers(input: $input) {
    channelId
    status
    userId
    updatedAt
  }
}
    `;

/**
 * __useGetChannelInvitesForUsersQuery__
 *
 * To run a query within a React component, call `useGetChannelInvitesForUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelInvitesForUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelInvitesForUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChannelInvitesForUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChannelInvitesForUsersQuery,
    GetChannelInvitesForUsersQueryVariables
  > &
    ({ variables: GetChannelInvitesForUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelInvitesForUsersQuery, GetChannelInvitesForUsersQueryVariables>(
    GetChannelInvitesForUsersDocument,
    options,
  );
}
export function useGetChannelInvitesForUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChannelInvitesForUsersQuery,
    GetChannelInvitesForUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChannelInvitesForUsersQuery,
    GetChannelInvitesForUsersQueryVariables
  >(GetChannelInvitesForUsersDocument, options);
}
// @ts-expect-error
export function useGetChannelInvitesForUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChannelInvitesForUsersQuery,
    GetChannelInvitesForUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetChannelInvitesForUsersQuery,
  GetChannelInvitesForUsersQueryVariables
>;
export function useGetChannelInvitesForUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetChannelInvitesForUsersQuery,
        GetChannelInvitesForUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetChannelInvitesForUsersQuery | undefined,
  GetChannelInvitesForUsersQueryVariables
>;
export function useGetChannelInvitesForUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetChannelInvitesForUsersQuery,
        GetChannelInvitesForUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetChannelInvitesForUsersQuery,
    GetChannelInvitesForUsersQueryVariables
  >(GetChannelInvitesForUsersDocument, options);
}
export type GetChannelInvitesForUsersQueryHookResult = ReturnType<
  typeof useGetChannelInvitesForUsersQuery
>;
export type GetChannelInvitesForUsersLazyQueryHookResult = ReturnType<
  typeof useGetChannelInvitesForUsersLazyQuery
>;
export type GetChannelInvitesForUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetChannelInvitesForUsersSuspenseQuery
>;
export type GetChannelInvitesForUsersQueryResult = Apollo.QueryResult<
  GetChannelInvitesForUsersQuery,
  GetChannelInvitesForUsersQueryVariables
>;
export const GetPendingChannelInvitesDocument = gql`
    query getPendingChannelInvites($channelCid: String!) {
  getPendingChannelInvites(channelCid: $channelCid) {
    userId
    createdAt
    actorId
  }
}
    `;

/**
 * __useGetPendingChannelInvitesQuery__
 *
 * To run a query within a React component, call `useGetPendingChannelInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingChannelInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingChannelInvitesQuery({
 *   variables: {
 *      channelCid: // value for 'channelCid'
 *   },
 * });
 */
export function useGetPendingChannelInvitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPendingChannelInvitesQuery,
    GetPendingChannelInvitesQueryVariables
  > &
    ({ variables: GetPendingChannelInvitesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPendingChannelInvitesQuery, GetPendingChannelInvitesQueryVariables>(
    GetPendingChannelInvitesDocument,
    options,
  );
}
export function useGetPendingChannelInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingChannelInvitesQuery,
    GetPendingChannelInvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPendingChannelInvitesQuery, GetPendingChannelInvitesQueryVariables>(
    GetPendingChannelInvitesDocument,
    options,
  );
}
// @ts-expect-error
export function useGetPendingChannelInvitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingChannelInvitesQuery,
    GetPendingChannelInvitesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPendingChannelInvitesQuery,
  GetPendingChannelInvitesQueryVariables
>;
export function useGetPendingChannelInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingChannelInvitesQuery,
        GetPendingChannelInvitesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPendingChannelInvitesQuery | undefined,
  GetPendingChannelInvitesQueryVariables
>;
export function useGetPendingChannelInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingChannelInvitesQuery,
        GetPendingChannelInvitesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPendingChannelInvitesQuery,
    GetPendingChannelInvitesQueryVariables
  >(GetPendingChannelInvitesDocument, options);
}
export type GetPendingChannelInvitesQueryHookResult = ReturnType<
  typeof useGetPendingChannelInvitesQuery
>;
export type GetPendingChannelInvitesLazyQueryHookResult = ReturnType<
  typeof useGetPendingChannelInvitesLazyQuery
>;
export type GetPendingChannelInvitesSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingChannelInvitesSuspenseQuery
>;
export type GetPendingChannelInvitesQueryResult = Apollo.QueryResult<
  GetPendingChannelInvitesQuery,
  GetPendingChannelInvitesQueryVariables
>;
export const ListPendingChatInvitesDocument = gql`
    query listPendingChatInvites($filters: FilterChatInvitesInput!) {
  listPendingChatInvites(filters: $filters) {
    total
    items {
      id
      channelId
      createdAt
      updatedAt
      actorId
      userId
    }
  }
}
    `;

/**
 * __useListPendingChatInvitesQuery__
 *
 * To run a query within a React component, call `useListPendingChatInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPendingChatInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPendingChatInvitesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListPendingChatInvitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPendingChatInvitesQuery,
    ListPendingChatInvitesQueryVariables
  > &
    ({ variables: ListPendingChatInvitesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPendingChatInvitesQuery, ListPendingChatInvitesQueryVariables>(
    ListPendingChatInvitesDocument,
    options,
  );
}
export function useListPendingChatInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPendingChatInvitesQuery,
    ListPendingChatInvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPendingChatInvitesQuery, ListPendingChatInvitesQueryVariables>(
    ListPendingChatInvitesDocument,
    options,
  );
}
// @ts-expect-error
export function useListPendingChatInvitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPendingChatInvitesQuery,
    ListPendingChatInvitesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListPendingChatInvitesQuery, ListPendingChatInvitesQueryVariables>;
export function useListPendingChatInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingChatInvitesQuery,
        ListPendingChatInvitesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListPendingChatInvitesQuery | undefined,
  ListPendingChatInvitesQueryVariables
>;
export function useListPendingChatInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListPendingChatInvitesQuery,
        ListPendingChatInvitesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPendingChatInvitesQuery, ListPendingChatInvitesQueryVariables>(
    ListPendingChatInvitesDocument,
    options,
  );
}
export type ListPendingChatInvitesQueryHookResult = ReturnType<
  typeof useListPendingChatInvitesQuery
>;
export type ListPendingChatInvitesLazyQueryHookResult = ReturnType<
  typeof useListPendingChatInvitesLazyQuery
>;
export type ListPendingChatInvitesSuspenseQueryHookResult = ReturnType<
  typeof useListPendingChatInvitesSuspenseQuery
>;
export type ListPendingChatInvitesQueryResult = Apollo.QueryResult<
  ListPendingChatInvitesQuery,
  ListPendingChatInvitesQueryVariables
>;
export const CrispIdentityDocument = gql`
    query CrispIdentity {
  crispIdentity {
    email
    signature
  }
}
    `;

/**
 * __useCrispIdentityQuery__
 *
 * To run a query within a React component, call `useCrispIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrispIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrispIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCrispIdentityQuery(
  baseOptions?: Apollo.QueryHookOptions<CrispIdentityQuery, CrispIdentityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CrispIdentityQuery, CrispIdentityQueryVariables>(
    CrispIdentityDocument,
    options,
  );
}
export function useCrispIdentityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CrispIdentityQuery, CrispIdentityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CrispIdentityQuery, CrispIdentityQueryVariables>(
    CrispIdentityDocument,
    options,
  );
}
// @ts-expect-error
export function useCrispIdentitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CrispIdentityQuery, CrispIdentityQueryVariables>,
): Apollo.UseSuspenseQueryResult<CrispIdentityQuery, CrispIdentityQueryVariables>;
export function useCrispIdentitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CrispIdentityQuery, CrispIdentityQueryVariables>,
): Apollo.UseSuspenseQueryResult<CrispIdentityQuery | undefined, CrispIdentityQueryVariables>;
export function useCrispIdentitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CrispIdentityQuery, CrispIdentityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CrispIdentityQuery, CrispIdentityQueryVariables>(
    CrispIdentityDocument,
    options,
  );
}
export type CrispIdentityQueryHookResult = ReturnType<typeof useCrispIdentityQuery>;
export type CrispIdentityLazyQueryHookResult = ReturnType<typeof useCrispIdentityLazyQuery>;
export type CrispIdentitySuspenseQueryHookResult = ReturnType<typeof useCrispIdentitySuspenseQuery>;
export type CrispIdentityQueryResult = Apollo.QueryResult<
  CrispIdentityQuery,
  CrispIdentityQueryVariables
>;
export const ListPaginatedEventsDocument = gql`
    query listPaginatedEvents($filters: FilterPaginatedEventInput!, $order: OrderEventInput) {
  listPaginatedEvents(filters: $filters, order: $order) {
    items {
      id
      kind
      title
      description
      format
      conversationKind
      coverUrl
      illustrationUrl
      englishLevel
      eventCategory
      startDate
      endDate
      isForUnverified
      isCoachEvent
      isLargeCall
      isProfessional
      guestPassAccess {
        status
        consumesToken
      }
      isFull
      topic {
        id
      }
      maxParticipants
      noParticipants
      participants {
        id
        avatarUrl
        badge
      }
      cohosts {
        id
        firstName
        lastName
        avatarUrl
        kind
        badge
      }
      host {
        id
        name
        firstName
        lastName
        avatarUrl
        kind
        badge
      }
      organizer {
        id
        name
        kind
      }
      invites {
        id
        status
        isHost
        user {
          id
        }
      }
      isDraft
      permissions
      occupations {
        id
      }
      hasSharedEventNotification
      recurring
      seriesId
      series {
        id
        recurrenceType
        recurrenceInterval
        recurrenceDays
        recurrenceEndType
        recurrenceEndDate
        recurrenceCount
        inviteToAllRecurring
        parentEventId
      }
      seriesEvents {
        id
        startDate
        endDate
      }
    }
    total
  }
}
    `;

/**
 * __useListPaginatedEventsQuery__
 *
 * To run a query within a React component, call `useListPaginatedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaginatedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaginatedEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListPaginatedEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListPaginatedEventsQuery,
    ListPaginatedEventsQueryVariables
  > &
    ({ variables: ListPaginatedEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPaginatedEventsQuery, ListPaginatedEventsQueryVariables>(
    ListPaginatedEventsDocument,
    options,
  );
}
export function useListPaginatedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListPaginatedEventsQuery,
    ListPaginatedEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPaginatedEventsQuery, ListPaginatedEventsQueryVariables>(
    ListPaginatedEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useListPaginatedEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListPaginatedEventsQuery,
    ListPaginatedEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListPaginatedEventsQuery, ListPaginatedEventsQueryVariables>;
export function useListPaginatedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaginatedEventsQuery, ListPaginatedEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListPaginatedEventsQuery | undefined,
  ListPaginatedEventsQueryVariables
>;
export function useListPaginatedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListPaginatedEventsQuery, ListPaginatedEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPaginatedEventsQuery, ListPaginatedEventsQueryVariables>(
    ListPaginatedEventsDocument,
    options,
  );
}
export type ListPaginatedEventsQueryHookResult = ReturnType<typeof useListPaginatedEventsQuery>;
export type ListPaginatedEventsLazyQueryHookResult = ReturnType<
  typeof useListPaginatedEventsLazyQuery
>;
export type ListPaginatedEventsSuspenseQueryHookResult = ReturnType<
  typeof useListPaginatedEventsSuspenseQuery
>;
export type ListPaginatedEventsQueryResult = Apollo.QueryResult<
  ListPaginatedEventsQuery,
  ListPaginatedEventsQueryVariables
>;
export const UserHostedEventsDocument = gql`
    query userHostedEvents($filters: FilterPaginatedEventInput!, $order: OrderEventInput) {
  userHostedEvents(filters: $filters, order: $order) {
    items {
      id
      title
      isFull
      startDate
    }
    total
  }
}
    `;

/**
 * __useUserHostedEventsQuery__
 *
 * To run a query within a React component, call `useUserHostedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHostedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHostedEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserHostedEventsQuery(
  baseOptions: Apollo.QueryHookOptions<UserHostedEventsQuery, UserHostedEventsQueryVariables> &
    ({ variables: UserHostedEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserHostedEventsQuery, UserHostedEventsQueryVariables>(
    UserHostedEventsDocument,
    options,
  );
}
export function useUserHostedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserHostedEventsQuery, UserHostedEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserHostedEventsQuery, UserHostedEventsQueryVariables>(
    UserHostedEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useUserHostedEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserHostedEventsQuery,
    UserHostedEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserHostedEventsQuery, UserHostedEventsQueryVariables>;
export function useUserHostedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserHostedEventsQuery, UserHostedEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserHostedEventsQuery | undefined, UserHostedEventsQueryVariables>;
export function useUserHostedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UserHostedEventsQuery, UserHostedEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserHostedEventsQuery, UserHostedEventsQueryVariables>(
    UserHostedEventsDocument,
    options,
  );
}
export type UserHostedEventsQueryHookResult = ReturnType<typeof useUserHostedEventsQuery>;
export type UserHostedEventsLazyQueryHookResult = ReturnType<typeof useUserHostedEventsLazyQuery>;
export type UserHostedEventsSuspenseQueryHookResult = ReturnType<
  typeof useUserHostedEventsSuspenseQuery
>;
export type UserHostedEventsQueryResult = Apollo.QueryResult<
  UserHostedEventsQuery,
  UserHostedEventsQueryVariables
>;
export const UserHostedEventsToShareCountDocument = gql`
    query userHostedEventsToShareCount {
  userHostedEventsToShareCount
}
    `;

/**
 * __useUserHostedEventsToShareCountQuery__
 *
 * To run a query within a React component, call `useUserHostedEventsToShareCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHostedEventsToShareCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHostedEventsToShareCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserHostedEventsToShareCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserHostedEventsToShareCountQuery,
    UserHostedEventsToShareCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserHostedEventsToShareCountQuery,
    UserHostedEventsToShareCountQueryVariables
  >(UserHostedEventsToShareCountDocument, options);
}
export function useUserHostedEventsToShareCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserHostedEventsToShareCountQuery,
    UserHostedEventsToShareCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserHostedEventsToShareCountQuery,
    UserHostedEventsToShareCountQueryVariables
  >(UserHostedEventsToShareCountDocument, options);
}
// @ts-expect-error
export function useUserHostedEventsToShareCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserHostedEventsToShareCountQuery,
    UserHostedEventsToShareCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserHostedEventsToShareCountQuery,
  UserHostedEventsToShareCountQueryVariables
>;
export function useUserHostedEventsToShareCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserHostedEventsToShareCountQuery,
        UserHostedEventsToShareCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserHostedEventsToShareCountQuery | undefined,
  UserHostedEventsToShareCountQueryVariables
>;
export function useUserHostedEventsToShareCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserHostedEventsToShareCountQuery,
        UserHostedEventsToShareCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserHostedEventsToShareCountQuery,
    UserHostedEventsToShareCountQueryVariables
  >(UserHostedEventsToShareCountDocument, options);
}
export type UserHostedEventsToShareCountQueryHookResult = ReturnType<
  typeof useUserHostedEventsToShareCountQuery
>;
export type UserHostedEventsToShareCountLazyQueryHookResult = ReturnType<
  typeof useUserHostedEventsToShareCountLazyQuery
>;
export type UserHostedEventsToShareCountSuspenseQueryHookResult = ReturnType<
  typeof useUserHostedEventsToShareCountSuspenseQuery
>;
export type UserHostedEventsToShareCountQueryResult = Apollo.QueryResult<
  UserHostedEventsToShareCountQuery,
  UserHostedEventsToShareCountQueryVariables
>;
export const EventDocument = gql`
    query event($id: String!) {
  getEvent(id: $id) {
    id
    coverUrl
    illustrationUrl
    createdAt
    format
    conversationKind
    englishLevel
    englishSkills
    eventCategory
    duplicateOf
    isForUnverified
    description
    endDate
    isPublic
    isCoachEvent
    isLargeCall
    isProfessional
    guestPassAccess {
      status
      consumesToken
    }
    isDraft
    isDeleted
    confirmationStatus
    interests
    kind
    meta
    location
    locationId
    locationLat
    locationLong
    noParticipants
    occupations {
      id
      name
    }
    recurring
    seriesId
    series {
      id
      recurrenceType
      recurrenceInterval
      recurrenceDays
      recurrenceEndType
      recurrenceEndDate
      recurrenceCount
      inviteToAllRecurring
      parentEventId
    }
    seriesEvents {
      id
      guestPassAccess {
        status
        consumesToken
      }
      startDate
      endDate
      title
      isFull
      maxParticipants
      noParticipants
      hasSharedEventNotification
      host {
        id
      }
      invites {
        id
        status
        isHost
        user {
          id
        }
      }
    }
    startDate
    title
    updatedAt
    closedDoorAt
    videoUrl
    maxParticipants
    eventLessonKind
    permissions
    ideasToDiscuss
    customTopic
    createdFromTopic
    links {
      url
      description
    }
    organizer {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
    }
    host {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
    }
    cohosts {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
    }
    topic {
      id
      title
      illustration {
        id
        url
      }
      ideasToDiscuss
      lessons {
        id
        kind
        deepDiveKind
      }
      theme {
        id
        title
        isTopicLibrary
      }
    }
    participants {
      id
      avatarUrl
      badge
      createdAt
      firstName
      lastName
      isVerified
      kind
    }
    invites {
      id
      isHost
      status
      isConfirmed
      user {
        id
        name
        firstName
        lastName
        createdAt
        badge
        avatarUrl
      }
    }
    attachments {
      id
      url
      meta {
        extension
        name
        size
      }
    }
    comments {
      id
      createdAt
      message
      author {
        id
        name
        avatarUrl
      }
      reactions {
        id
        unifiedId
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
      replies {
        id
        createdAt
        message
        author {
          id
          name
          avatarUrl
        }
        reactions {
          id
          unifiedId
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
      }
    }
    hasSharedEventNotification
  }
}
    `;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(
  baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables> &
    ({ variables: EventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
}
export function useEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
}
// @ts-expect-error
export function useEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
): Apollo.UseSuspenseQueryResult<EventQuery, EventQueryVariables>;
export function useEventSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
): Apollo.UseSuspenseQueryResult<EventQuery | undefined, EventQueryVariables>;
export function useEventSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EventQuery, EventQueryVariables>(EventDocument, options);
}
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventSuspenseQueryHookResult = ReturnType<typeof useEventSuspenseQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export const GetEventWithCacheDocument = gql`
    query getEventWithCache($id: String!) {
  getEventWithCache(id: $id) {
    id
    coverUrl
    illustrationUrl
    createdAt
    format
    conversationKind
    englishLevel
    englishSkills
    eventCategory
    duplicateOf
    isForUnverified
    description
    endDate
    isDraft
    isDeleted
    confirmationStatus
    interests
    kind
    meta
    location
    locationId
    locationLat
    locationLong
    noParticipants
    isPublic
    isCoachEvent
    isLargeCall
    isProfessional
    guestPassAccess {
      status
      consumesToken
    }
    occupations {
      id
      name
    }
    recurring
    seriesId
    series {
      id
      recurrenceType
      recurrenceInterval
      recurrenceDays
      recurrenceEndType
      recurrenceEndDate
      recurrenceCount
      inviteToAllRecurring
      parentEventId
    }
    seriesEvents {
      id
      guestPassAccess {
        status
        consumesToken
      }
      startDate
      endDate
      title
      isFull
      maxParticipants
      noParticipants
      hasSharedEventNotification
      host {
        id
      }
      invites {
        id
        status
        isHost
        user {
          id
        }
      }
    }
    startDate
    title
    updatedAt
    closedDoorAt
    videoUrl
    maxParticipants
    eventLessonKind
    permissions
    ideasToDiscuss
    customTopic
    createdFromTopic
    links {
      url
      description
    }
    organizer {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
    }
    host {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
    }
    cohosts {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
    }
    topic {
      id
      title
      illustration {
        id
        url
      }
      ideasToDiscuss
      lessons {
        id
        kind
        deepDiveKind
      }
      theme {
        id
        title
        isTopicLibrary
      }
    }
    participants {
      id
      avatarUrl
      badge
      createdAt
      firstName
      lastName
      isVerified
      kind
    }
    invites {
      id
      isHost
      status
      isConfirmed
      user {
        id
        name
        firstName
        lastName
        createdAt
        badge
        avatarUrl
        kind
      }
    }
    attachments {
      id
      url
      meta {
        extension
        name
        size
      }
    }
    comments {
      id
      createdAt
      message
      author {
        id
        name
        avatarUrl
      }
      reactions {
        id
        unifiedId
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
      replies {
        id
        createdAt
        message
        author {
          id
          name
          avatarUrl
        }
        reactions {
          id
          unifiedId
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
      }
    }
    hasSharedEventNotification
  }
}
    `;

/**
 * __useGetEventWithCacheQuery__
 *
 * To run a query within a React component, call `useGetEventWithCacheQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventWithCacheQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventWithCacheQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventWithCacheQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventWithCacheQuery, GetEventWithCacheQueryVariables> &
    ({ variables: GetEventWithCacheQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventWithCacheQuery, GetEventWithCacheQueryVariables>(
    GetEventWithCacheDocument,
    options,
  );
}
export function useGetEventWithCacheLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventWithCacheQuery,
    GetEventWithCacheQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventWithCacheQuery, GetEventWithCacheQueryVariables>(
    GetEventWithCacheDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventWithCacheSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventWithCacheQuery,
    GetEventWithCacheQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventWithCacheQuery, GetEventWithCacheQueryVariables>;
export function useGetEventWithCacheSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventWithCacheQuery, GetEventWithCacheQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetEventWithCacheQuery | undefined,
  GetEventWithCacheQueryVariables
>;
export function useGetEventWithCacheSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventWithCacheQuery, GetEventWithCacheQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventWithCacheQuery, GetEventWithCacheQueryVariables>(
    GetEventWithCacheDocument,
    options,
  );
}
export type GetEventWithCacheQueryHookResult = ReturnType<typeof useGetEventWithCacheQuery>;
export type GetEventWithCacheLazyQueryHookResult = ReturnType<typeof useGetEventWithCacheLazyQuery>;
export type GetEventWithCacheSuspenseQueryHookResult = ReturnType<
  typeof useGetEventWithCacheSuspenseQuery
>;
export type GetEventWithCacheQueryResult = Apollo.QueryResult<
  GetEventWithCacheQuery,
  GetEventWithCacheQueryVariables
>;
export const GetEventForMeetingDocument = gql`
    query getEventForMeeting($id: String!) {
  getEventForMeeting(id: $id) {
    id
    title
    kind
    format
    closedDoorAt
    meta
    host {
      id
      kind
    }
    participants {
      id
      kind
    }
    cohosts {
      id
      kind
    }
    invites {
      id
      isHost
      user {
        id
        kind
      }
    }
  }
}
    `;

/**
 * __useGetEventForMeetingQuery__
 *
 * To run a query within a React component, call `useGetEventForMeetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForMeetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForMeetingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventForMeetingQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventForMeetingQuery, GetEventForMeetingQueryVariables> &
    ({ variables: GetEventForMeetingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventForMeetingQuery, GetEventForMeetingQueryVariables>(
    GetEventForMeetingDocument,
    options,
  );
}
export function useGetEventForMeetingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventForMeetingQuery,
    GetEventForMeetingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventForMeetingQuery, GetEventForMeetingQueryVariables>(
    GetEventForMeetingDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventForMeetingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventForMeetingQuery,
    GetEventForMeetingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventForMeetingQuery, GetEventForMeetingQueryVariables>;
export function useGetEventForMeetingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventForMeetingQuery, GetEventForMeetingQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetEventForMeetingQuery | undefined,
  GetEventForMeetingQueryVariables
>;
export function useGetEventForMeetingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventForMeetingQuery, GetEventForMeetingQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventForMeetingQuery, GetEventForMeetingQueryVariables>(
    GetEventForMeetingDocument,
    options,
  );
}
export type GetEventForMeetingQueryHookResult = ReturnType<typeof useGetEventForMeetingQuery>;
export type GetEventForMeetingLazyQueryHookResult = ReturnType<
  typeof useGetEventForMeetingLazyQuery
>;
export type GetEventForMeetingSuspenseQueryHookResult = ReturnType<
  typeof useGetEventForMeetingSuspenseQuery
>;
export type GetEventForMeetingQueryResult = Apollo.QueryResult<
  GetEventForMeetingQuery,
  GetEventForMeetingQueryVariables
>;
export const TopicsAndThemesDocument = gql`
    query topicsAndThemes {
  listThemes(filters: {}) {
    id
    title
    createdAt
    description
    isCurrent
    isStandard
    isTopicLibrary
    isGrammarLibrary
    title
    updatedAt
    cover {
      id
      title
      primary {
        mobile
        desktop
      }
      secondary {
        mobile
        desktop
      }
      tertiary {
        mobile
        desktop
      }
    }
    topics {
      id
      title
      illustration {
        id
        title
        url
      }
    }
  }
}
    `;

/**
 * __useTopicsAndThemesQuery__
 *
 * To run a query within a React component, call `useTopicsAndThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsAndThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsAndThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopicsAndThemesQuery(
  baseOptions?: Apollo.QueryHookOptions<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>(
    TopicsAndThemesDocument,
    options,
  );
}
export function useTopicsAndThemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>(
    TopicsAndThemesDocument,
    options,
  );
}
// @ts-expect-error
export function useTopicsAndThemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TopicsAndThemesQuery,
    TopicsAndThemesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>;
export function useTopicsAndThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>,
): Apollo.UseSuspenseQueryResult<TopicsAndThemesQuery | undefined, TopicsAndThemesQueryVariables>;
export function useTopicsAndThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TopicsAndThemesQuery, TopicsAndThemesQueryVariables>(
    TopicsAndThemesDocument,
    options,
  );
}
export type TopicsAndThemesQueryHookResult = ReturnType<typeof useTopicsAndThemesQuery>;
export type TopicsAndThemesLazyQueryHookResult = ReturnType<typeof useTopicsAndThemesLazyQuery>;
export type TopicsAndThemesSuspenseQueryHookResult = ReturnType<
  typeof useTopicsAndThemesSuspenseQuery
>;
export type TopicsAndThemesQueryResult = Apollo.QueryResult<
  TopicsAndThemesQuery,
  TopicsAndThemesQueryVariables
>;
export const GetEventForConnectDocument = gql`
    query getEventForConnect($id: String!) {
  getEventForConnect(id: $id) {
    id
    isDeleted
    host {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
      city
      country
      interests
    }
    cohosts {
      id
      name
      firstName
      lastName
      avatarUrl
      createdAt
      badge
      kind
      city
      country
      interests
    }
    participants {
      id
      avatarUrl
      badge
      createdAt
      firstName
      lastName
      isVerified
      kind
      city
      country
      interests
    }
  }
}
    `;

/**
 * __useGetEventForConnectQuery__
 *
 * To run a query within a React component, call `useGetEventForConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForConnectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventForConnectQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventForConnectQuery, GetEventForConnectQueryVariables> &
    ({ variables: GetEventForConnectQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventForConnectQuery, GetEventForConnectQueryVariables>(
    GetEventForConnectDocument,
    options,
  );
}
export function useGetEventForConnectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventForConnectQuery,
    GetEventForConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventForConnectQuery, GetEventForConnectQueryVariables>(
    GetEventForConnectDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventForConnectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventForConnectQuery,
    GetEventForConnectQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventForConnectQuery, GetEventForConnectQueryVariables>;
export function useGetEventForConnectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventForConnectQuery, GetEventForConnectQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetEventForConnectQuery | undefined,
  GetEventForConnectQueryVariables
>;
export function useGetEventForConnectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventForConnectQuery, GetEventForConnectQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventForConnectQuery, GetEventForConnectQueryVariables>(
    GetEventForConnectDocument,
    options,
  );
}
export type GetEventForConnectQueryHookResult = ReturnType<typeof useGetEventForConnectQuery>;
export type GetEventForConnectLazyQueryHookResult = ReturnType<
  typeof useGetEventForConnectLazyQuery
>;
export type GetEventForConnectSuspenseQueryHookResult = ReturnType<
  typeof useGetEventForConnectSuspenseQuery
>;
export type GetEventForConnectQueryResult = Apollo.QueryResult<
  GetEventForConnectQuery,
  GetEventForConnectQueryVariables
>;
export const GetEventForSeriesDocument = gql`
    query getEventForSeries($id: String!) {
  getEvent(id: $id) {
    id
    seriesId
    seriesEvents {
      id
      guestPassAccess {
        status
        consumesToken
      }
      startDate
      endDate
      title
      isFull
      maxParticipants
      noParticipants
      hasSharedEventNotification
      host {
        id
      }
      invites {
        id
        status
        isHost
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventForSeriesQuery__
 *
 * To run a query within a React component, call `useGetEventForSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventForSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventForSeriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventForSeriesQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventForSeriesQuery, GetEventForSeriesQueryVariables> &
    ({ variables: GetEventForSeriesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventForSeriesQuery, GetEventForSeriesQueryVariables>(
    GetEventForSeriesDocument,
    options,
  );
}
export function useGetEventForSeriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventForSeriesQuery,
    GetEventForSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventForSeriesQuery, GetEventForSeriesQueryVariables>(
    GetEventForSeriesDocument,
    options,
  );
}
// @ts-expect-error
export function useGetEventForSeriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEventForSeriesQuery,
    GetEventForSeriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetEventForSeriesQuery, GetEventForSeriesQueryVariables>;
export function useGetEventForSeriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventForSeriesQuery, GetEventForSeriesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetEventForSeriesQuery | undefined,
  GetEventForSeriesQueryVariables
>;
export function useGetEventForSeriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventForSeriesQuery, GetEventForSeriesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventForSeriesQuery, GetEventForSeriesQueryVariables>(
    GetEventForSeriesDocument,
    options,
  );
}
export type GetEventForSeriesQueryHookResult = ReturnType<typeof useGetEventForSeriesQuery>;
export type GetEventForSeriesLazyQueryHookResult = ReturnType<typeof useGetEventForSeriesLazyQuery>;
export type GetEventForSeriesSuspenseQueryHookResult = ReturnType<
  typeof useGetEventForSeriesSuspenseQuery
>;
export type GetEventForSeriesQueryResult = Apollo.QueryResult<
  GetEventForSeriesQuery,
  GetEventForSeriesQueryVariables
>;
export const GuestHomeNextEventDocument = gql`
    query guestHomeNextEvent($filters: FilterPaginatedEventInput!, $order: OrderEventInput) {
  listPaginatedEvents(filters: $filters, order: $order) {
    total
    items {
      id
      kind
      title
      format
      conversationKind
      coverUrl
      illustrationUrl
      englishLevel
      startDate
      endDate
      isPublic
      isCoachEvent
      maxParticipants
      noParticipants
      confirmationStatus
      closedDoorAt
      addedToCalendar
      meta
      guestPassAccess {
        status
        consumesToken
      }
      host {
        id
        name
        firstName
        avatarUrl
        kind
        badge
      }
      cohosts {
        id
        kind
      }
    }
  }
}
    `;

/**
 * __useGuestHomeNextEventQuery__
 *
 * To run a query within a React component, call `useGuestHomeNextEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestHomeNextEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestHomeNextEventQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGuestHomeNextEventQuery(
  baseOptions: Apollo.QueryHookOptions<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables> &
    ({ variables: GuestHomeNextEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables>(
    GuestHomeNextEventDocument,
    options,
  );
}
export function useGuestHomeNextEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GuestHomeNextEventQuery,
    GuestHomeNextEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables>(
    GuestHomeNextEventDocument,
    options,
  );
}
// @ts-expect-error
export function useGuestHomeNextEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GuestHomeNextEventQuery,
    GuestHomeNextEventQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables>;
export function useGuestHomeNextEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GuestHomeNextEventQuery | undefined,
  GuestHomeNextEventQueryVariables
>;
export function useGuestHomeNextEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GuestHomeNextEventQuery, GuestHomeNextEventQueryVariables>(
    GuestHomeNextEventDocument,
    options,
  );
}
export type GuestHomeNextEventQueryHookResult = ReturnType<typeof useGuestHomeNextEventQuery>;
export type GuestHomeNextEventLazyQueryHookResult = ReturnType<
  typeof useGuestHomeNextEventLazyQuery
>;
export type GuestHomeNextEventSuspenseQueryHookResult = ReturnType<
  typeof useGuestHomeNextEventSuspenseQuery
>;
export type GuestHomeNextEventQueryResult = Apollo.QueryResult<
  GuestHomeNextEventQuery,
  GuestHomeNextEventQueryVariables
>;
export const GuestHomeCurrentThemeDocument = gql`
    query guestHomeCurrentTheme {
  listThemes(filters: {isCurrent: true}) {
    id
    title
  }
}
    `;

/**
 * __useGuestHomeCurrentThemeQuery__
 *
 * To run a query within a React component, call `useGuestHomeCurrentThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestHomeCurrentThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestHomeCurrentThemeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestHomeCurrentThemeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GuestHomeCurrentThemeQuery,
    GuestHomeCurrentThemeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GuestHomeCurrentThemeQuery, GuestHomeCurrentThemeQueryVariables>(
    GuestHomeCurrentThemeDocument,
    options,
  );
}
export function useGuestHomeCurrentThemeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GuestHomeCurrentThemeQuery,
    GuestHomeCurrentThemeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GuestHomeCurrentThemeQuery, GuestHomeCurrentThemeQueryVariables>(
    GuestHomeCurrentThemeDocument,
    options,
  );
}
// @ts-expect-error
export function useGuestHomeCurrentThemeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GuestHomeCurrentThemeQuery,
    GuestHomeCurrentThemeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GuestHomeCurrentThemeQuery, GuestHomeCurrentThemeQueryVariables>;
export function useGuestHomeCurrentThemeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GuestHomeCurrentThemeQuery,
        GuestHomeCurrentThemeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GuestHomeCurrentThemeQuery | undefined,
  GuestHomeCurrentThemeQueryVariables
>;
export function useGuestHomeCurrentThemeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GuestHomeCurrentThemeQuery,
        GuestHomeCurrentThemeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GuestHomeCurrentThemeQuery, GuestHomeCurrentThemeQueryVariables>(
    GuestHomeCurrentThemeDocument,
    options,
  );
}
export type GuestHomeCurrentThemeQueryHookResult = ReturnType<typeof useGuestHomeCurrentThemeQuery>;
export type GuestHomeCurrentThemeLazyQueryHookResult = ReturnType<
  typeof useGuestHomeCurrentThemeLazyQuery
>;
export type GuestHomeCurrentThemeSuspenseQueryHookResult = ReturnType<
  typeof useGuestHomeCurrentThemeSuspenseQuery
>;
export type GuestHomeCurrentThemeQueryResult = Apollo.QueryResult<
  GuestHomeCurrentThemeQuery,
  GuestHomeCurrentThemeQueryVariables
>;
export const GuestPassSummaryDocument = gql`
    query guestPassSummary {
  guestPassSummary {
    id
    startsAt
    endsAt
    daysRemaining
    tokenAllowance
    tokensUsed
    tokensRemaining
    isActive
    canActivateMembership
    canRestartGuestPass
    shouldShowCompletionModal
  }
}
    `;

/**
 * __useGuestPassSummaryQuery__
 *
 * To run a query within a React component, call `useGuestPassSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPassSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPassSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestPassSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>(
    GuestPassSummaryDocument,
    options,
  );
}
export function useGuestPassSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>(
    GuestPassSummaryDocument,
    options,
  );
}
// @ts-expect-error
export function useGuestPassSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GuestPassSummaryQuery,
    GuestPassSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>;
export function useGuestPassSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>,
): Apollo.UseSuspenseQueryResult<GuestPassSummaryQuery | undefined, GuestPassSummaryQueryVariables>;
export function useGuestPassSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GuestPassSummaryQuery, GuestPassSummaryQueryVariables>(
    GuestPassSummaryDocument,
    options,
  );
}
export type GuestPassSummaryQueryHookResult = ReturnType<typeof useGuestPassSummaryQuery>;
export type GuestPassSummaryLazyQueryHookResult = ReturnType<typeof useGuestPassSummaryLazyQuery>;
export type GuestPassSummarySuspenseQueryHookResult = ReturnType<
  typeof useGuestPassSummarySuspenseQuery
>;
export type GuestPassSummaryQueryResult = Apollo.QueryResult<
  GuestPassSummaryQuery,
  GuestPassSummaryQueryVariables
>;
export const GuestPassRestartBookingEventsDocument = gql`
    query guestPassRestartBookingEvents($timezone: String!) {
  guestPassRestartBookingEvents(timezone: $timezone) {
    id
    title
    startDate
    endDate
    durationMinutes
    kind
    format
  }
}
    `;

/**
 * __useGuestPassRestartBookingEventsQuery__
 *
 * To run a query within a React component, call `useGuestPassRestartBookingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPassRestartBookingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPassRestartBookingEventsQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGuestPassRestartBookingEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GuestPassRestartBookingEventsQuery,
    GuestPassRestartBookingEventsQueryVariables
  > &
    (
      | { variables: GuestPassRestartBookingEventsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GuestPassRestartBookingEventsQuery,
    GuestPassRestartBookingEventsQueryVariables
  >(GuestPassRestartBookingEventsDocument, options);
}
export function useGuestPassRestartBookingEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GuestPassRestartBookingEventsQuery,
    GuestPassRestartBookingEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GuestPassRestartBookingEventsQuery,
    GuestPassRestartBookingEventsQueryVariables
  >(GuestPassRestartBookingEventsDocument, options);
}
// @ts-expect-error
export function useGuestPassRestartBookingEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GuestPassRestartBookingEventsQuery,
    GuestPassRestartBookingEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GuestPassRestartBookingEventsQuery,
  GuestPassRestartBookingEventsQueryVariables
>;
export function useGuestPassRestartBookingEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GuestPassRestartBookingEventsQuery,
        GuestPassRestartBookingEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GuestPassRestartBookingEventsQuery | undefined,
  GuestPassRestartBookingEventsQueryVariables
>;
export function useGuestPassRestartBookingEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GuestPassRestartBookingEventsQuery,
        GuestPassRestartBookingEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GuestPassRestartBookingEventsQuery,
    GuestPassRestartBookingEventsQueryVariables
  >(GuestPassRestartBookingEventsDocument, options);
}
export type GuestPassRestartBookingEventsQueryHookResult = ReturnType<
  typeof useGuestPassRestartBookingEventsQuery
>;
export type GuestPassRestartBookingEventsLazyQueryHookResult = ReturnType<
  typeof useGuestPassRestartBookingEventsLazyQuery
>;
export type GuestPassRestartBookingEventsSuspenseQueryHookResult = ReturnType<
  typeof useGuestPassRestartBookingEventsSuspenseQuery
>;
export type GuestPassRestartBookingEventsQueryResult = Apollo.QueryResult<
  GuestPassRestartBookingEventsQuery,
  GuestPassRestartBookingEventsQueryVariables
>;
export const RestartGuestPassDocument = gql`
    mutation restartGuestPass($input: RestartGuestPassInput) {
  restartGuestPass(input: $input) {
    id
    daysRemaining
    isActive
    tokenAllowance
    tokensRemaining
    tokensUsed
  }
}
    `;
export type RestartGuestPassMutationFn = Apollo.MutationFunction<
  RestartGuestPassMutation,
  RestartGuestPassMutationVariables
>;

/**
 * __useRestartGuestPassMutation__
 *
 * To run a mutation, you first call `useRestartGuestPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartGuestPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartGuestPassMutation, { data, loading, error }] = useRestartGuestPassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestartGuestPassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestartGuestPassMutation,
    RestartGuestPassMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RestartGuestPassMutation, RestartGuestPassMutationVariables>(
    RestartGuestPassDocument,
    options,
  );
}
export type RestartGuestPassMutationHookResult = ReturnType<typeof useRestartGuestPassMutation>;
export type RestartGuestPassMutationResult = Apollo.MutationResult<RestartGuestPassMutation>;
export type RestartGuestPassMutationOptions = Apollo.BaseMutationOptions<
  RestartGuestPassMutation,
  RestartGuestPassMutationVariables
>;
export const DismissGuestPassCompletionModalDocument = gql`
    mutation dismissGuestPassCompletionModal {
  dismissGuestPassCompletionModal {
    id
    shouldShowCompletionModal
  }
}
    `;
export type DismissGuestPassCompletionModalMutationFn = Apollo.MutationFunction<
  DismissGuestPassCompletionModalMutation,
  DismissGuestPassCompletionModalMutationVariables
>;

/**
 * __useDismissGuestPassCompletionModalMutation__
 *
 * To run a mutation, you first call `useDismissGuestPassCompletionModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissGuestPassCompletionModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissGuestPassCompletionModalMutation, { data, loading, error }] = useDismissGuestPassCompletionModalMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissGuestPassCompletionModalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissGuestPassCompletionModalMutation,
    DismissGuestPassCompletionModalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissGuestPassCompletionModalMutation,
    DismissGuestPassCompletionModalMutationVariables
  >(DismissGuestPassCompletionModalDocument, options);
}
export type DismissGuestPassCompletionModalMutationHookResult = ReturnType<
  typeof useDismissGuestPassCompletionModalMutation
>;
export type DismissGuestPassCompletionModalMutationResult =
  Apollo.MutationResult<DismissGuestPassCompletionModalMutation>;
export type DismissGuestPassCompletionModalMutationOptions = Apollo.BaseMutationOptions<
  DismissGuestPassCompletionModalMutation,
  DismissGuestPassCompletionModalMutationVariables
>;
export const CreateGuestPassFlowUserDocument = gql`
    mutation createGuestPassFlowUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;
export type CreateGuestPassFlowUserMutationFn = Apollo.MutationFunction<
  CreateGuestPassFlowUserMutation,
  CreateGuestPassFlowUserMutationVariables
>;

/**
 * __useCreateGuestPassFlowUserMutation__
 *
 * To run a mutation, you first call `useCreateGuestPassFlowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuestPassFlowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuestPassFlowUserMutation, { data, loading, error }] = useCreateGuestPassFlowUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGuestPassFlowUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGuestPassFlowUserMutation,
    CreateGuestPassFlowUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateGuestPassFlowUserMutation,
    CreateGuestPassFlowUserMutationVariables
  >(CreateGuestPassFlowUserDocument, options);
}
export type CreateGuestPassFlowUserMutationHookResult = ReturnType<
  typeof useCreateGuestPassFlowUserMutation
>;
export type CreateGuestPassFlowUserMutationResult =
  Apollo.MutationResult<CreateGuestPassFlowUserMutation>;
export type CreateGuestPassFlowUserMutationOptions = Apollo.BaseMutationOptions<
  CreateGuestPassFlowUserMutation,
  CreateGuestPassFlowUserMutationVariables
>;
export const UpdateGuestPassBookingDocument = gql`
    mutation updateGuestPassBooking($input: UpdateGuestPassBookingInput!) {
  updateGuestPassBooking(input: $input) {
    id
    selectedTimezone
    selectedFirstEventId
    selectedFirstEventTime
    firstEventBookingSkipped
  }
}
    `;
export type UpdateGuestPassBookingMutationFn = Apollo.MutationFunction<
  UpdateGuestPassBookingMutation,
  UpdateGuestPassBookingMutationVariables
>;

/**
 * __useUpdateGuestPassBookingMutation__
 *
 * To run a mutation, you first call `useUpdateGuestPassBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestPassBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestPassBookingMutation, { data, loading, error }] = useUpdateGuestPassBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGuestPassBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateGuestPassBookingMutation,
    UpdateGuestPassBookingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateGuestPassBookingMutation,
    UpdateGuestPassBookingMutationVariables
  >(UpdateGuestPassBookingDocument, options);
}
export type UpdateGuestPassBookingMutationHookResult = ReturnType<
  typeof useUpdateGuestPassBookingMutation
>;
export type UpdateGuestPassBookingMutationResult =
  Apollo.MutationResult<UpdateGuestPassBookingMutation>;
export type UpdateGuestPassBookingMutationOptions = Apollo.BaseMutationOptions<
  UpdateGuestPassBookingMutation,
  UpdateGuestPassBookingMutationVariables
>;
export const GuestPassBookingEventsDocument = gql`
    query guestPassBookingEvents($englishLevel: EnglishLevel!, $timezone: String!, $mainSpeakingPracticeChallenge: SpeakingPracticeChallenge) {
  guestPassBookingEvents(
    englishLevel: $englishLevel
    timezone: $timezone
    mainSpeakingPracticeChallenge: $mainSpeakingPracticeChallenge
  ) {
    id
    title
    startDate
    endDate
    durationMinutes
    kind
    format
  }
}
    `;

/**
 * __useGuestPassBookingEventsQuery__
 *
 * To run a query within a React component, call `useGuestPassBookingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestPassBookingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPassBookingEventsQuery({
 *   variables: {
 *      englishLevel: // value for 'englishLevel'
 *      timezone: // value for 'timezone'
 *      mainSpeakingPracticeChallenge: // value for 'mainSpeakingPracticeChallenge'
 *   },
 * });
 */
export function useGuestPassBookingEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GuestPassBookingEventsQuery,
    GuestPassBookingEventsQueryVariables
  > &
    ({ variables: GuestPassBookingEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GuestPassBookingEventsQuery, GuestPassBookingEventsQueryVariables>(
    GuestPassBookingEventsDocument,
    options,
  );
}
export function useGuestPassBookingEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GuestPassBookingEventsQuery,
    GuestPassBookingEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GuestPassBookingEventsQuery, GuestPassBookingEventsQueryVariables>(
    GuestPassBookingEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useGuestPassBookingEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GuestPassBookingEventsQuery,
    GuestPassBookingEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GuestPassBookingEventsQuery, GuestPassBookingEventsQueryVariables>;
export function useGuestPassBookingEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GuestPassBookingEventsQuery,
        GuestPassBookingEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GuestPassBookingEventsQuery | undefined,
  GuestPassBookingEventsQueryVariables
>;
export function useGuestPassBookingEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GuestPassBookingEventsQuery,
        GuestPassBookingEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GuestPassBookingEventsQuery, GuestPassBookingEventsQueryVariables>(
    GuestPassBookingEventsDocument,
    options,
  );
}
export type GuestPassBookingEventsQueryHookResult = ReturnType<
  typeof useGuestPassBookingEventsQuery
>;
export type GuestPassBookingEventsLazyQueryHookResult = ReturnType<
  typeof useGuestPassBookingEventsLazyQuery
>;
export type GuestPassBookingEventsSuspenseQueryHookResult = ReturnType<
  typeof useGuestPassBookingEventsSuspenseQuery
>;
export type GuestPassBookingEventsQueryResult = Apollo.QueryResult<
  GuestPassBookingEventsQuery,
  GuestPassBookingEventsQueryVariables
>;
export const ConversationPactDocument = gql`
    query conversationPact {
  conversationPact {
    ...ConversationPactFields
  }
}
    ${ConversationPactFieldsFragmentDoc}`;

/**
 * __useConversationPactQuery__
 *
 * To run a query within a React component, call `useConversationPactQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationPactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationPactQuery({
 *   variables: {
 *   },
 * });
 */
export function useConversationPactQuery(
  baseOptions?: Apollo.QueryHookOptions<ConversationPactQuery, ConversationPactQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ConversationPactQuery, ConversationPactQueryVariables>(
    ConversationPactDocument,
    options,
  );
}
export function useConversationPactLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ConversationPactQuery, ConversationPactQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ConversationPactQuery, ConversationPactQueryVariables>(
    ConversationPactDocument,
    options,
  );
}
// @ts-expect-error
export function useConversationPactSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ConversationPactQuery,
    ConversationPactQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ConversationPactQuery, ConversationPactQueryVariables>;
export function useConversationPactSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConversationPactQuery, ConversationPactQueryVariables>,
): Apollo.UseSuspenseQueryResult<ConversationPactQuery | undefined, ConversationPactQueryVariables>;
export function useConversationPactSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ConversationPactQuery, ConversationPactQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ConversationPactQuery, ConversationPactQueryVariables>(
    ConversationPactDocument,
    options,
  );
}
export type ConversationPactQueryHookResult = ReturnType<typeof useConversationPactQuery>;
export type ConversationPactLazyQueryHookResult = ReturnType<typeof useConversationPactLazyQuery>;
export type ConversationPactSuspenseQueryHookResult = ReturnType<
  typeof useConversationPactSuspenseQuery
>;
export type ConversationPactQueryResult = Apollo.QueryResult<
  ConversationPactQuery,
  ConversationPactQueryVariables
>;
export const TeamCallMoveEnabledDocument = gql`
    query teamCallMoveEnabled {
  teamCallMoveEnabled
}
    `;

/**
 * __useTeamCallMoveEnabledQuery__
 *
 * To run a query within a React component, call `useTeamCallMoveEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamCallMoveEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamCallMoveEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamCallMoveEnabledQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TeamCallMoveEnabledQuery,
    TeamCallMoveEnabledQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TeamCallMoveEnabledQuery, TeamCallMoveEnabledQueryVariables>(
    TeamCallMoveEnabledDocument,
    options,
  );
}
export function useTeamCallMoveEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamCallMoveEnabledQuery,
    TeamCallMoveEnabledQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TeamCallMoveEnabledQuery, TeamCallMoveEnabledQueryVariables>(
    TeamCallMoveEnabledDocument,
    options,
  );
}
// @ts-expect-error
export function useTeamCallMoveEnabledSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamCallMoveEnabledQuery,
    TeamCallMoveEnabledQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TeamCallMoveEnabledQuery, TeamCallMoveEnabledQueryVariables>;
export function useTeamCallMoveEnabledSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamCallMoveEnabledQuery, TeamCallMoveEnabledQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  TeamCallMoveEnabledQuery | undefined,
  TeamCallMoveEnabledQueryVariables
>;
export function useTeamCallMoveEnabledSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamCallMoveEnabledQuery, TeamCallMoveEnabledQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TeamCallMoveEnabledQuery, TeamCallMoveEnabledQueryVariables>(
    TeamCallMoveEnabledDocument,
    options,
  );
}
export type TeamCallMoveEnabledQueryHookResult = ReturnType<typeof useTeamCallMoveEnabledQuery>;
export type TeamCallMoveEnabledLazyQueryHookResult = ReturnType<
  typeof useTeamCallMoveEnabledLazyQuery
>;
export type TeamCallMoveEnabledSuspenseQueryHookResult = ReturnType<
  typeof useTeamCallMoveEnabledSuspenseQuery
>;
export type TeamCallMoveEnabledQueryResult = Apollo.QueryResult<
  TeamCallMoveEnabledQuery,
  TeamCallMoveEnabledQueryVariables
>;
export const HomeCheckInsDocument = gql`
    query homeCheckIns {
  homeCheckIns {
    ...HomeCheckInFields
  }
}
    ${HomeCheckInFieldsFragmentDoc}`;

/**
 * __useHomeCheckInsQuery__
 *
 * To run a query within a React component, call `useHomeCheckInsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeCheckInsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeCheckInsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeCheckInsQuery(
  baseOptions?: Apollo.QueryHookOptions<HomeCheckInsQuery, HomeCheckInsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HomeCheckInsQuery, HomeCheckInsQueryVariables>(
    HomeCheckInsDocument,
    options,
  );
}
export function useHomeCheckInsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HomeCheckInsQuery, HomeCheckInsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HomeCheckInsQuery, HomeCheckInsQueryVariables>(
    HomeCheckInsDocument,
    options,
  );
}
// @ts-expect-error
export function useHomeCheckInsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HomeCheckInsQuery, HomeCheckInsQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomeCheckInsQuery, HomeCheckInsQueryVariables>;
export function useHomeCheckInsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HomeCheckInsQuery, HomeCheckInsQueryVariables>,
): Apollo.UseSuspenseQueryResult<HomeCheckInsQuery | undefined, HomeCheckInsQueryVariables>;
export function useHomeCheckInsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HomeCheckInsQuery, HomeCheckInsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HomeCheckInsQuery, HomeCheckInsQueryVariables>(
    HomeCheckInsDocument,
    options,
  );
}
export type HomeCheckInsQueryHookResult = ReturnType<typeof useHomeCheckInsQuery>;
export type HomeCheckInsLazyQueryHookResult = ReturnType<typeof useHomeCheckInsLazyQuery>;
export type HomeCheckInsSuspenseQueryHookResult = ReturnType<typeof useHomeCheckInsSuspenseQuery>;
export type HomeCheckInsQueryResult = Apollo.QueryResult<
  HomeCheckInsQuery,
  HomeCheckInsQueryVariables
>;
export const GetLiveTablesDocument = gql`
    query getLiveTables {
  getLiveTables {
    id
    title
    englishLevel
    maxParticipants
    dailyRoomId
    endDate
    timeLimit
    createdAt
    question {
      id
      question
      type
    }
    participants {
      id
      user {
        id
        firstName
        lastName
        avatarUrl
        badge
      }
    }
  }
}
    `;

/**
 * __useGetLiveTablesQuery__
 *
 * To run a query within a React component, call `useGetLiveTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLiveTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLiveTablesQuery, GetLiveTablesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLiveTablesQuery, GetLiveTablesQueryVariables>(
    GetLiveTablesDocument,
    options,
  );
}
export function useGetLiveTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLiveTablesQuery, GetLiveTablesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLiveTablesQuery, GetLiveTablesQueryVariables>(
    GetLiveTablesDocument,
    options,
  );
}
// @ts-expect-error
export function useGetLiveTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiveTablesQuery, GetLiveTablesQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLiveTablesQuery, GetLiveTablesQueryVariables>;
export function useGetLiveTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLiveTablesQuery, GetLiveTablesQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLiveTablesQuery | undefined, GetLiveTablesQueryVariables>;
export function useGetLiveTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLiveTablesQuery, GetLiveTablesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLiveTablesQuery, GetLiveTablesQueryVariables>(
    GetLiveTablesDocument,
    options,
  );
}
export type GetLiveTablesQueryHookResult = ReturnType<typeof useGetLiveTablesQuery>;
export type GetLiveTablesLazyQueryHookResult = ReturnType<typeof useGetLiveTablesLazyQuery>;
export type GetLiveTablesSuspenseQueryHookResult = ReturnType<typeof useGetLiveTablesSuspenseQuery>;
export type GetLiveTablesQueryResult = Apollo.QueryResult<
  GetLiveTablesQuery,
  GetLiveTablesQueryVariables
>;
export const GetLiveTableByIdDocument = gql`
    query getLiveTableById($id: String!) {
  getLiveTableById(id: $id) {
    id
    title
    englishLevel
    dailyRoomId
    isActive
    endedAt
    timeLimit
    creatorId
    endDate
    question {
      id
      question
      type
    }
    participants {
      id
      user {
        id
        firstName
        lastName
        avatarUrl
        badge
      }
    }
  }
}
    `;

/**
 * __useGetLiveTableByIdQuery__
 *
 * To run a query within a React component, call `useGetLiveTableByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveTableByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveTableByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLiveTableByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables> &
    ({ variables: GetLiveTableByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>(
    GetLiveTableByIdDocument,
    options,
  );
}
export function useGetLiveTableByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>(
    GetLiveTableByIdDocument,
    options,
  );
}
// @ts-expect-error
export function useGetLiveTableByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLiveTableByIdQuery,
    GetLiveTableByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>;
export function useGetLiveTableByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLiveTableByIdQuery | undefined, GetLiveTableByIdQueryVariables>;
export function useGetLiveTableByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLiveTableByIdQuery, GetLiveTableByIdQueryVariables>(
    GetLiveTableByIdDocument,
    options,
  );
}
export type GetLiveTableByIdQueryHookResult = ReturnType<typeof useGetLiveTableByIdQuery>;
export type GetLiveTableByIdLazyQueryHookResult = ReturnType<typeof useGetLiveTableByIdLazyQuery>;
export type GetLiveTableByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetLiveTableByIdSuspenseQuery
>;
export type GetLiveTableByIdQueryResult = Apollo.QueryResult<
  GetLiveTableByIdQuery,
  GetLiveTableByIdQueryVariables
>;
export const GetCurrentTopicQuestionsDocument = gql`
    query getCurrentTopicQuestions {
  getCurrentTopicQuestions {
    id
    question
    updatedAt
    topic {
      id
      title
      illustration {
        id
        title
        url
      }
    }
  }
}
    `;

/**
 * __useGetCurrentTopicQuestionsQuery__
 *
 * To run a query within a React component, call `useGetCurrentTopicQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentTopicQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentTopicQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentTopicQuestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentTopicQuestionsQuery, GetCurrentTopicQuestionsQueryVariables>(
    GetCurrentTopicQuestionsDocument,
    options,
  );
}
export function useGetCurrentTopicQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentTopicQuestionsQuery, GetCurrentTopicQuestionsQueryVariables>(
    GetCurrentTopicQuestionsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetCurrentTopicQuestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentTopicQuestionsQuery,
  GetCurrentTopicQuestionsQueryVariables
>;
export function useGetCurrentTopicQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentTopicQuestionsQuery,
        GetCurrentTopicQuestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetCurrentTopicQuestionsQuery | undefined,
  GetCurrentTopicQuestionsQueryVariables
>;
export function useGetCurrentTopicQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentTopicQuestionsQuery,
        GetCurrentTopicQuestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentTopicQuestionsQuery,
    GetCurrentTopicQuestionsQueryVariables
  >(GetCurrentTopicQuestionsDocument, options);
}
export type GetCurrentTopicQuestionsQueryHookResult = ReturnType<
  typeof useGetCurrentTopicQuestionsQuery
>;
export type GetCurrentTopicQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetCurrentTopicQuestionsLazyQuery
>;
export type GetCurrentTopicQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentTopicQuestionsSuspenseQuery
>;
export type GetCurrentTopicQuestionsQueryResult = Apollo.QueryResult<
  GetCurrentTopicQuestionsQuery,
  GetCurrentTopicQuestionsQueryVariables
>;
export const MemberzineDocument = gql`
    query memberzine {
  getCurrentZine {
    coverUrl
  }
  listFeatured: listArticles(filters: {limit: 3, category: Featured}) {
    items {
      id
      coverUrl
      title
      isFeatured
      noComments
      noLikes
      author {
        id
        name
        firstName
        lastName
        avatarUrl
      }
    }
    total
  }
  followingAuthorsArticles: listArticles(filters: {limit: 6, byAuthor: Follow}) {
    items {
      id
      coverUrl
      title
      isFeatured
      noComments
      noLikes
      author {
        id
        name
        firstName
        lastName
        avatarUrl
      }
    }
    total
  }
  recommendedArticles: listArticles(filters: {limit: 3, category: Recommended}) {
    items {
      id
      coverUrl
      title
      isFeatured
      noComments
      noLikes
      author {
        id
        name
        firstName
        lastName
        avatarUrl
      }
    }
  }
  allArticles: listArticles(filters: {limit: 6}) {
    items {
      id
      coverUrl
      title
      isFeatured
      noComments
      noLikes
      author {
        id
        name
        firstName
        lastName
        avatarUrl
      }
    }
    total
  }
}
    `;

/**
 * __useMemberzineQuery__
 *
 * To run a query within a React component, call `useMemberzineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberzineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberzineQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberzineQuery(
  baseOptions?: Apollo.QueryHookOptions<MemberzineQuery, MemberzineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MemberzineQuery, MemberzineQueryVariables>(MemberzineDocument, options);
}
export function useMemberzineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MemberzineQuery, MemberzineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MemberzineQuery, MemberzineQueryVariables>(
    MemberzineDocument,
    options,
  );
}
// @ts-expect-error
export function useMemberzineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MemberzineQuery, MemberzineQueryVariables>,
): Apollo.UseSuspenseQueryResult<MemberzineQuery, MemberzineQueryVariables>;
export function useMemberzineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberzineQuery, MemberzineQueryVariables>,
): Apollo.UseSuspenseQueryResult<MemberzineQuery | undefined, MemberzineQueryVariables>;
export function useMemberzineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MemberzineQuery, MemberzineQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MemberzineQuery, MemberzineQueryVariables>(
    MemberzineDocument,
    options,
  );
}
export type MemberzineQueryHookResult = ReturnType<typeof useMemberzineQuery>;
export type MemberzineLazyQueryHookResult = ReturnType<typeof useMemberzineLazyQuery>;
export type MemberzineSuspenseQueryHookResult = ReturnType<typeof useMemberzineSuspenseQuery>;
export type MemberzineQueryResult = Apollo.QueryResult<MemberzineQuery, MemberzineQueryVariables>;
export const UploadArticleCoverDocument = gql`
    mutation uploadArticleCover($input: UploadImageArticleInput!) {
  uploadArticleCover(input: $input) {
    id
    coverUrl
  }
}
    `;
export type UploadArticleCoverMutationFn = Apollo.MutationFunction<
  UploadArticleCoverMutation,
  UploadArticleCoverMutationVariables
>;

/**
 * __useUploadArticleCoverMutation__
 *
 * To run a mutation, you first call `useUploadArticleCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadArticleCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadArticleCoverMutation, { data, loading, error }] = useUploadArticleCoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadArticleCoverMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadArticleCoverMutation,
    UploadArticleCoverMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadArticleCoverMutation, UploadArticleCoverMutationVariables>(
    UploadArticleCoverDocument,
    options,
  );
}
export type UploadArticleCoverMutationHookResult = ReturnType<typeof useUploadArticleCoverMutation>;
export type UploadArticleCoverMutationResult = Apollo.MutationResult<UploadArticleCoverMutation>;
export type UploadArticleCoverMutationOptions = Apollo.BaseMutationOptions<
  UploadArticleCoverMutation,
  UploadArticleCoverMutationVariables
>;
export const GetArticleDocument = gql`
    query getArticle($id: String!) {
  getArticle(id: $id) {
    likedByMe {
      id
    }
    noComments
    noLikes
    author {
      id
      name
      avatarUrl
    }
    attachments {
      id
      description
      url
      meta {
        name
        size
        extension
      }
      createdAt
      updatedAt
    }
    comments {
      id
      createdAt
      message
      author {
        id
        name
        avatarUrl
      }
      reactions {
        id
        unifiedId
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
      replies {
        id
        createdAt
        message
        author {
          id
          name
          avatarUrl
        }
        reactions {
          id
          unifiedId
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
      }
    }
    content
    coverUrl
    createdAt
    id
    isDraft
    isFeatured
    publishedAt
    scheduledFor
    tags
    myEnglishJourney
    title
    theme
    updatedAt
  }
}
    `;

/**
 * __useGetArticleQuery__
 *
 * To run a query within a React component, call `useGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArticleQuery(
  baseOptions: Apollo.QueryHookOptions<GetArticleQuery, GetArticleQueryVariables> &
    ({ variables: GetArticleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetArticleQuery, GetArticleQueryVariables>(GetArticleDocument, options);
}
export function useGetArticleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetArticleQuery, GetArticleQueryVariables>(
    GetArticleDocument,
    options,
  );
}
// @ts-expect-error
export function useGetArticleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetArticleQuery, GetArticleQueryVariables>;
export function useGetArticleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetArticleQuery | undefined, GetArticleQueryVariables>;
export function useGetArticleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetArticleQuery, GetArticleQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetArticleQuery, GetArticleQueryVariables>(
    GetArticleDocument,
    options,
  );
}
export type GetArticleQueryHookResult = ReturnType<typeof useGetArticleQuery>;
export type GetArticleLazyQueryHookResult = ReturnType<typeof useGetArticleLazyQuery>;
export type GetArticleSuspenseQueryHookResult = ReturnType<typeof useGetArticleSuspenseQuery>;
export type GetArticleQueryResult = Apollo.QueryResult<GetArticleQuery, GetArticleQueryVariables>;
export const ListArticlesDocument = gql`
    query listArticles($filters: FilterArticlesInput!) {
  listArticles(filters: $filters) {
    items {
      id
      coverUrl
      title
      isFeatured
      isDraft
      publishedAt
      noComments
      noLikes
      author {
        id
        firstName
        lastName
        name
        avatarUrl
      }
    }
    total
  }
}
    `;

/**
 * __useListArticlesQuery__
 *
 * To run a query within a React component, call `useListArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListArticlesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables> &
    ({ variables: ListArticlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListArticlesQuery, ListArticlesQueryVariables>(
    ListArticlesDocument,
    options,
  );
}
export function useListArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListArticlesQuery, ListArticlesQueryVariables>(
    ListArticlesDocument,
    options,
  );
}
// @ts-expect-error
export function useListArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListArticlesQuery, ListArticlesQueryVariables>;
export function useListArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListArticlesQuery | undefined, ListArticlesQueryVariables>;
export function useListArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListArticlesQuery, ListArticlesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListArticlesQuery, ListArticlesQueryVariables>(
    ListArticlesDocument,
    options,
  );
}
export type ListArticlesQueryHookResult = ReturnType<typeof useListArticlesQuery>;
export type ListArticlesLazyQueryHookResult = ReturnType<typeof useListArticlesLazyQuery>;
export type ListArticlesSuspenseQueryHookResult = ReturnType<typeof useListArticlesSuspenseQuery>;
export type ListArticlesQueryResult = Apollo.QueryResult<
  ListArticlesQuery,
  ListArticlesQueryVariables
>;
export const ListNotificationsForUserDocument = gql`
    query listNotificationsForUser($cursor: NotificationCursorPaginatedInput!, $unreadOnly: Boolean!) {
  listNotificationsForUser(cursor: $cursor, unreadOnly: $unreadOnly) {
    items {
      id
      type
      createdAt
      notificationSeen {
        id
        seenAt
      }
      chatNotification {
        ...ChatNotificationFields
      }
      commentNotification {
        ...CommentNotificationFields
      }
      eventNotification {
        ...EventNotificationFields
      }
      articleNotification {
        ...ArticleNotificationFields
      }
      friendJoinedNotification {
        ...FriendJoinedNotificationFields
      }
    }
    total
    nextCursor
  }
}
    ${ChatNotificationFieldsFragmentDoc}
${CommentNotificationFieldsFragmentDoc}
${EventNotificationFieldsFragmentDoc}
${ArticleNotificationFieldsFragmentDoc}
${FriendJoinedNotificationFieldsFragmentDoc}`;

/**
 * __useListNotificationsForUserQuery__
 *
 * To run a query within a React component, call `useListNotificationsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotificationsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotificationsForUserQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      unreadOnly: // value for 'unreadOnly'
 *   },
 * });
 */
export function useListNotificationsForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListNotificationsForUserQuery,
    ListNotificationsForUserQueryVariables
  > &
    ({ variables: ListNotificationsForUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListNotificationsForUserQuery, ListNotificationsForUserQueryVariables>(
    ListNotificationsForUserDocument,
    options,
  );
}
export function useListNotificationsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListNotificationsForUserQuery,
    ListNotificationsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListNotificationsForUserQuery, ListNotificationsForUserQueryVariables>(
    ListNotificationsForUserDocument,
    options,
  );
}
// @ts-expect-error
export function useListNotificationsForUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListNotificationsForUserQuery,
    ListNotificationsForUserQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsForUserQuery,
  ListNotificationsForUserQueryVariables
>;
export function useListNotificationsForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsForUserQuery,
        ListNotificationsForUserQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListNotificationsForUserQuery | undefined,
  ListNotificationsForUserQueryVariables
>;
export function useListNotificationsForUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListNotificationsForUserQuery,
        ListNotificationsForUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ListNotificationsForUserQuery,
    ListNotificationsForUserQueryVariables
  >(ListNotificationsForUserDocument, options);
}
export type ListNotificationsForUserQueryHookResult = ReturnType<
  typeof useListNotificationsForUserQuery
>;
export type ListNotificationsForUserLazyQueryHookResult = ReturnType<
  typeof useListNotificationsForUserLazyQuery
>;
export type ListNotificationsForUserSuspenseQueryHookResult = ReturnType<
  typeof useListNotificationsForUserSuspenseQuery
>;
export type ListNotificationsForUserQueryResult = Apollo.QueryResult<
  ListNotificationsForUserQuery,
  ListNotificationsForUserQueryVariables
>;
export const GetPopupNotificationsDocument = gql`
    query getPopupNotifications {
  getPopupNotifications {
    id
    type
    createdAt
    notificationSeen {
      id
      seenAt
    }
    badgeNotification {
      ...BadgeNotificationFields
    }
    eventNotification {
      ...EventNotificationFields
    }
    profileUpdateNotification {
      ...ProfileUpdateNotificationFields
    }
    monthlyReportNotification {
      ...MonthlyReportNotificationFields
    }
    friendJoinedNotification {
      ...FriendJoinedNotificationFields
    }
    customNotification {
      ...CustomNotificationFields
    }
  }
}
    ${BadgeNotificationFieldsFragmentDoc}
${EventNotificationFieldsFragmentDoc}
${ProfileUpdateNotificationFieldsFragmentDoc}
${MonthlyReportNotificationFieldsFragmentDoc}
${FriendJoinedNotificationFieldsFragmentDoc}
${CustomNotificationFieldsFragmentDoc}`;

/**
 * __useGetPopupNotificationsQuery__
 *
 * To run a query within a React component, call `useGetPopupNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopupNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopupNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopupNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPopupNotificationsQuery,
    GetPopupNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPopupNotificationsQuery, GetPopupNotificationsQueryVariables>(
    GetPopupNotificationsDocument,
    options,
  );
}
export function useGetPopupNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPopupNotificationsQuery,
    GetPopupNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPopupNotificationsQuery, GetPopupNotificationsQueryVariables>(
    GetPopupNotificationsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetPopupNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPopupNotificationsQuery,
    GetPopupNotificationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetPopupNotificationsQuery, GetPopupNotificationsQueryVariables>;
export function useGetPopupNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPopupNotificationsQuery,
        GetPopupNotificationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPopupNotificationsQuery | undefined,
  GetPopupNotificationsQueryVariables
>;
export function useGetPopupNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPopupNotificationsQuery,
        GetPopupNotificationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPopupNotificationsQuery, GetPopupNotificationsQueryVariables>(
    GetPopupNotificationsDocument,
    options,
  );
}
export type GetPopupNotificationsQueryHookResult = ReturnType<typeof useGetPopupNotificationsQuery>;
export type GetPopupNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetPopupNotificationsLazyQuery
>;
export type GetPopupNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useGetPopupNotificationsSuspenseQuery
>;
export type GetPopupNotificationsQueryResult = Apollo.QueryResult<
  GetPopupNotificationsQuery,
  GetPopupNotificationsQueryVariables
>;
export const GetInvitedFriendsCountDocument = gql`
    query getInvitedFriendsCount {
  getInvitedFriendsCount
}
    `;

/**
 * __useGetInvitedFriendsCountQuery__
 *
 * To run a query within a React component, call `useGetInvitedFriendsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitedFriendsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitedFriendsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvitedFriendsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInvitedFriendsCountQuery,
    GetInvitedFriendsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvitedFriendsCountQuery, GetInvitedFriendsCountQueryVariables>(
    GetInvitedFriendsCountDocument,
    options,
  );
}
export function useGetInvitedFriendsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInvitedFriendsCountQuery,
    GetInvitedFriendsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvitedFriendsCountQuery, GetInvitedFriendsCountQueryVariables>(
    GetInvitedFriendsCountDocument,
    options,
  );
}
// @ts-expect-error
export function useGetInvitedFriendsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInvitedFriendsCountQuery,
    GetInvitedFriendsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInvitedFriendsCountQuery, GetInvitedFriendsCountQueryVariables>;
export function useGetInvitedFriendsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInvitedFriendsCountQuery,
        GetInvitedFriendsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetInvitedFriendsCountQuery | undefined,
  GetInvitedFriendsCountQueryVariables
>;
export function useGetInvitedFriendsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetInvitedFriendsCountQuery,
        GetInvitedFriendsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInvitedFriendsCountQuery, GetInvitedFriendsCountQueryVariables>(
    GetInvitedFriendsCountDocument,
    options,
  );
}
export type GetInvitedFriendsCountQueryHookResult = ReturnType<
  typeof useGetInvitedFriendsCountQuery
>;
export type GetInvitedFriendsCountLazyQueryHookResult = ReturnType<
  typeof useGetInvitedFriendsCountLazyQuery
>;
export type GetInvitedFriendsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetInvitedFriendsCountSuspenseQuery
>;
export type GetInvitedFriendsCountQueryResult = Apollo.QueryResult<
  GetInvitedFriendsCountQuery,
  GetInvitedFriendsCountQueryVariables
>;
export const SearchUsersDocument = gql`
    query searchUsers($query: String!, $eventId: String, $isVerified: Boolean, $permissions: [String!]) {
  searchUsers(
    query: $query
    eventId: $eventId
    isVerified: $isVerified
    permissions: $permissions
  ) {
    item {
      id
      name
      avatarUrl
      badge
    }
    matches {
      indices
      value
    }
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      eventId: // value for 'eventId'
 *      isVerified: // value for 'isVerified'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useSearchUsersQuery(
  baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables> &
    ({ variables: SearchUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
}
export function useSearchUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(
    SearchUsersDocument,
    options,
  );
}
// @ts-expect-error
export function useSearchUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(
    SearchUsersDocument,
    options,
  );
}
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<
  SearchUsersQuery,
  SearchUsersQueryVariables
>;
export const SearchMemberzineDocument = gql`
    query searchMemberzine($query: String!) {
  searchMemberzine(query: $query) {
    item {
      id
      title
      author {
        id
        name
        avatarUrl
      }
    }
    matches {
      indices
      value
      key
    }
  }
}
    `;

/**
 * __useSearchMemberzineQuery__
 *
 * To run a query within a React component, call `useSearchMemberzineQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMemberzineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMemberzineQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchMemberzineQuery(
  baseOptions: Apollo.QueryHookOptions<SearchMemberzineQuery, SearchMemberzineQueryVariables> &
    ({ variables: SearchMemberzineQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchMemberzineQuery, SearchMemberzineQueryVariables>(
    SearchMemberzineDocument,
    options,
  );
}
export function useSearchMemberzineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchMemberzineQuery, SearchMemberzineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchMemberzineQuery, SearchMemberzineQueryVariables>(
    SearchMemberzineDocument,
    options,
  );
}
// @ts-expect-error
export function useSearchMemberzineSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchMemberzineQuery,
    SearchMemberzineQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchMemberzineQuery, SearchMemberzineQueryVariables>;
export function useSearchMemberzineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchMemberzineQuery, SearchMemberzineQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchMemberzineQuery | undefined, SearchMemberzineQueryVariables>;
export function useSearchMemberzineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchMemberzineQuery, SearchMemberzineQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchMemberzineQuery, SearchMemberzineQueryVariables>(
    SearchMemberzineDocument,
    options,
  );
}
export type SearchMemberzineQueryHookResult = ReturnType<typeof useSearchMemberzineQuery>;
export type SearchMemberzineLazyQueryHookResult = ReturnType<typeof useSearchMemberzineLazyQuery>;
export type SearchMemberzineSuspenseQueryHookResult = ReturnType<
  typeof useSearchMemberzineSuspenseQuery
>;
export type SearchMemberzineQueryResult = Apollo.QueryResult<
  SearchMemberzineQuery,
  SearchMemberzineQueryVariables
>;
export const SearchTopicsDocument = gql`
    query searchTopics($query: String!) {
  searchTopics(query: $query) {
    item {
      id
      title
    }
    matches {
      indices
      value
      key
    }
  }
}
    `;

/**
 * __useSearchTopicsQuery__
 *
 * To run a query within a React component, call `useSearchTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTopicsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables> &
    ({ variables: SearchTopicsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchTopicsQuery, SearchTopicsQueryVariables>(
    SearchTopicsDocument,
    options,
  );
}
export function useSearchTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchTopicsQuery, SearchTopicsQueryVariables>(
    SearchTopicsDocument,
    options,
  );
}
// @ts-expect-error
export function useSearchTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchTopicsQuery, SearchTopicsQueryVariables>;
export function useSearchTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchTopicsQuery | undefined, SearchTopicsQueryVariables>;
export function useSearchTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchTopicsQuery, SearchTopicsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchTopicsQuery, SearchTopicsQueryVariables>(
    SearchTopicsDocument,
    options,
  );
}
export type SearchTopicsQueryHookResult = ReturnType<typeof useSearchTopicsQuery>;
export type SearchTopicsLazyQueryHookResult = ReturnType<typeof useSearchTopicsLazyQuery>;
export type SearchTopicsSuspenseQueryHookResult = ReturnType<typeof useSearchTopicsSuspenseQuery>;
export type SearchTopicsQueryResult = Apollo.QueryResult<
  SearchTopicsQuery,
  SearchTopicsQueryVariables
>;
export const MySessionsDocument = gql`
    query mySessions {
  mySessions {
    id
    device
    browser
    os
    ip
    method
    createdAt
    lastSeenAt
    current
  }
}
    `;

/**
 * __useMySessionsQuery__
 *
 * To run a query within a React component, call `useMySessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySessionsQuery(
  baseOptions?: Apollo.QueryHookOptions<MySessionsQuery, MySessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MySessionsQuery, MySessionsQueryVariables>(MySessionsDocument, options);
}
export function useMySessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MySessionsQuery, MySessionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MySessionsQuery, MySessionsQueryVariables>(
    MySessionsDocument,
    options,
  );
}
// @ts-expect-error
export function useMySessionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MySessionsQuery, MySessionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MySessionsQuery, MySessionsQueryVariables>;
export function useMySessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MySessionsQuery, MySessionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MySessionsQuery | undefined, MySessionsQueryVariables>;
export function useMySessionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MySessionsQuery, MySessionsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MySessionsQuery, MySessionsQueryVariables>(
    MySessionsDocument,
    options,
  );
}
export type MySessionsQueryHookResult = ReturnType<typeof useMySessionsQuery>;
export type MySessionsLazyQueryHookResult = ReturnType<typeof useMySessionsLazyQuery>;
export type MySessionsSuspenseQueryHookResult = ReturnType<typeof useMySessionsSuspenseQuery>;
export type MySessionsQueryResult = Apollo.QueryResult<MySessionsQuery, MySessionsQueryVariables>;
export const GetUserSignUpDocument = gql`
    query getUserSignUp($id: String!) {
  getUserSignUp(id: $id) {
    id
    firstName
    lastName
    email
    requiresEmailVerification
    verificationResendAt
    guestPassEligible
    hasVerifiedEmail
    selectedTimezone
    selectedFirstEventId
    selectedFirstEventTime
    firstEventBookingSkipped
    needsLatinName
  }
}
    `;

/**
 * __useGetUserSignUpQuery__
 *
 * To run a query within a React component, call `useGetUserSignUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSignUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSignUpQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSignUpQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserSignUpQuery, GetUserSignUpQueryVariables> &
    ({ variables: GetUserSignUpQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserSignUpQuery, GetUserSignUpQueryVariables>(
    GetUserSignUpDocument,
    options,
  );
}
export function useGetUserSignUpLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSignUpQuery, GetUserSignUpQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserSignUpQuery, GetUserSignUpQueryVariables>(
    GetUserSignUpDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserSignUpSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSignUpQuery, GetUserSignUpQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserSignUpQuery, GetUserSignUpQueryVariables>;
export function useGetUserSignUpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserSignUpQuery, GetUserSignUpQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserSignUpQuery | undefined, GetUserSignUpQueryVariables>;
export function useGetUserSignUpSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserSignUpQuery, GetUserSignUpQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserSignUpQuery, GetUserSignUpQueryVariables>(
    GetUserSignUpDocument,
    options,
  );
}
export type GetUserSignUpQueryHookResult = ReturnType<typeof useGetUserSignUpQuery>;
export type GetUserSignUpLazyQueryHookResult = ReturnType<typeof useGetUserSignUpLazyQuery>;
export type GetUserSignUpSuspenseQueryHookResult = ReturnType<typeof useGetUserSignUpSuspenseQuery>;
export type GetUserSignUpQueryResult = Apollo.QueryResult<
  GetUserSignUpQuery,
  GetUserSignUpQueryVariables
>;
export const UpdateSignupNameDocument = gql`
    mutation updateSignupName($input: UpdateSignupNameInput!) {
  updateSignupName(input: $input) {
    id
    firstName
    lastName
    needsLatinName
  }
}
    `;
export type UpdateSignupNameMutationFn = Apollo.MutationFunction<
  UpdateSignupNameMutation,
  UpdateSignupNameMutationVariables
>;

/**
 * __useUpdateSignupNameMutation__
 *
 * To run a mutation, you first call `useUpdateSignupNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignupNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignupNameMutation, { data, loading, error }] = useUpdateSignupNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignupNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSignupNameMutation,
    UpdateSignupNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSignupNameMutation, UpdateSignupNameMutationVariables>(
    UpdateSignupNameDocument,
    options,
  );
}
export type UpdateSignupNameMutationHookResult = ReturnType<typeof useUpdateSignupNameMutation>;
export type UpdateSignupNameMutationResult = Apollo.MutationResult<UpdateSignupNameMutation>;
export type UpdateSignupNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateSignupNameMutation,
  UpdateSignupNameMutationVariables
>;
export const VerifySignupEmailDocument = gql`
    mutation verifySignupEmail($id: String!, $code: String!) {
  verifySignupEmail(id: $id, code: $code) {
    id
    email
    hasVerifiedEmail
    verificationResendAt
  }
}
    `;
export type VerifySignupEmailMutationFn = Apollo.MutationFunction<
  VerifySignupEmailMutation,
  VerifySignupEmailMutationVariables
>;

/**
 * __useVerifySignupEmailMutation__
 *
 * To run a mutation, you first call `useVerifySignupEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySignupEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySignupEmailMutation, { data, loading, error }] = useVerifySignupEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifySignupEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifySignupEmailMutation,
    VerifySignupEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifySignupEmailMutation, VerifySignupEmailMutationVariables>(
    VerifySignupEmailDocument,
    options,
  );
}
export type VerifySignupEmailMutationHookResult = ReturnType<typeof useVerifySignupEmailMutation>;
export type VerifySignupEmailMutationResult = Apollo.MutationResult<VerifySignupEmailMutation>;
export type VerifySignupEmailMutationOptions = Apollo.BaseMutationOptions<
  VerifySignupEmailMutation,
  VerifySignupEmailMutationVariables
>;
export const ResendSignupEmailCodeDocument = gql`
    mutation resendSignupEmailCode($id: String!, $email: String) {
  resendSignupEmailCode(id: $id, email: $email) {
    id
    email
    hasVerifiedEmail
    verificationResendAt
  }
}
    `;
export type ResendSignupEmailCodeMutationFn = Apollo.MutationFunction<
  ResendSignupEmailCodeMutation,
  ResendSignupEmailCodeMutationVariables
>;

/**
 * __useResendSignupEmailCodeMutation__
 *
 * To run a mutation, you first call `useResendSignupEmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSignupEmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSignupEmailCodeMutation, { data, loading, error }] = useResendSignupEmailCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendSignupEmailCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendSignupEmailCodeMutation,
    ResendSignupEmailCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendSignupEmailCodeMutation, ResendSignupEmailCodeMutationVariables>(
    ResendSignupEmailCodeDocument,
    options,
  );
}
export type ResendSignupEmailCodeMutationHookResult = ReturnType<
  typeof useResendSignupEmailCodeMutation
>;
export type ResendSignupEmailCodeMutationResult =
  Apollo.MutationResult<ResendSignupEmailCodeMutation>;
export type ResendSignupEmailCodeMutationOptions = Apollo.BaseMutationOptions<
  ResendSignupEmailCodeMutation,
  ResendSignupEmailCodeMutationVariables
>;
export const GetTotalDistinctSparksDocument = gql`
    query getTotalDistinctSparks {
  getTotalDistinctSparks
}
    `;

/**
 * __useGetTotalDistinctSparksQuery__
 *
 * To run a query within a React component, call `useGetTotalDistinctSparksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalDistinctSparksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalDistinctSparksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalDistinctSparksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTotalDistinctSparksQuery,
    GetTotalDistinctSparksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTotalDistinctSparksQuery, GetTotalDistinctSparksQueryVariables>(
    GetTotalDistinctSparksDocument,
    options,
  );
}
export function useGetTotalDistinctSparksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTotalDistinctSparksQuery,
    GetTotalDistinctSparksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTotalDistinctSparksQuery, GetTotalDistinctSparksQueryVariables>(
    GetTotalDistinctSparksDocument,
    options,
  );
}
// @ts-expect-error
export function useGetTotalDistinctSparksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTotalDistinctSparksQuery,
    GetTotalDistinctSparksQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetTotalDistinctSparksQuery, GetTotalDistinctSparksQueryVariables>;
export function useGetTotalDistinctSparksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTotalDistinctSparksQuery,
        GetTotalDistinctSparksQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTotalDistinctSparksQuery | undefined,
  GetTotalDistinctSparksQueryVariables
>;
export function useGetTotalDistinctSparksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTotalDistinctSparksQuery,
        GetTotalDistinctSparksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTotalDistinctSparksQuery, GetTotalDistinctSparksQueryVariables>(
    GetTotalDistinctSparksDocument,
    options,
  );
}
export type GetTotalDistinctSparksQueryHookResult = ReturnType<
  typeof useGetTotalDistinctSparksQuery
>;
export type GetTotalDistinctSparksLazyQueryHookResult = ReturnType<
  typeof useGetTotalDistinctSparksLazyQuery
>;
export type GetTotalDistinctSparksSuspenseQueryHookResult = ReturnType<
  typeof useGetTotalDistinctSparksSuspenseQuery
>;
export type GetTotalDistinctSparksQueryResult = Apollo.QueryResult<
  GetTotalDistinctSparksQuery,
  GetTotalDistinctSparksQueryVariables
>;
export const UserGaveSparkInEventDocument = gql`
    query userGaveSparkInEvent($eventId: String!) {
  userGaveSparkInEvent(eventId: $eventId)
}
    `;

/**
 * __useUserGaveSparkInEventQuery__
 *
 * To run a query within a React component, call `useUserGaveSparkInEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGaveSparkInEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGaveSparkInEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUserGaveSparkInEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserGaveSparkInEventQuery,
    UserGaveSparkInEventQueryVariables
  > &
    ({ variables: UserGaveSparkInEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserGaveSparkInEventQuery, UserGaveSparkInEventQueryVariables>(
    UserGaveSparkInEventDocument,
    options,
  );
}
export function useUserGaveSparkInEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserGaveSparkInEventQuery,
    UserGaveSparkInEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserGaveSparkInEventQuery, UserGaveSparkInEventQueryVariables>(
    UserGaveSparkInEventDocument,
    options,
  );
}
// @ts-expect-error
export function useUserGaveSparkInEventSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserGaveSparkInEventQuery,
    UserGaveSparkInEventQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<UserGaveSparkInEventQuery, UserGaveSparkInEventQueryVariables>;
export function useUserGaveSparkInEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserGaveSparkInEventQuery,
        UserGaveSparkInEventQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserGaveSparkInEventQuery | undefined,
  UserGaveSparkInEventQueryVariables
>;
export function useUserGaveSparkInEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserGaveSparkInEventQuery,
        UserGaveSparkInEventQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserGaveSparkInEventQuery, UserGaveSparkInEventQueryVariables>(
    UserGaveSparkInEventDocument,
    options,
  );
}
export type UserGaveSparkInEventQueryHookResult = ReturnType<typeof useUserGaveSparkInEventQuery>;
export type UserGaveSparkInEventLazyQueryHookResult = ReturnType<
  typeof useUserGaveSparkInEventLazyQuery
>;
export type UserGaveSparkInEventSuspenseQueryHookResult = ReturnType<
  typeof useUserGaveSparkInEventSuspenseQuery
>;
export type UserGaveSparkInEventQueryResult = Apollo.QueryResult<
  UserGaveSparkInEventQuery,
  UserGaveSparkInEventQueryVariables
>;
export const GetMyStreakDocument = gql`
    query getMyStreak {
  getMyStreak {
    weeklyGoal
    nextWeeklyGoal
    connectionStreak
    goalStreak
    eventsThisWeek
    connectionWeekCompletedThisWeek
    goalCompletedThisWeek
    connectionStreakBrokeLastWeek
    goalStreakBrokeLastWeek
    powerUpCount
    powerUpRevealed
    powerUpProgress
    connectionStreakIncrementedThisWeek
    streaksExplainerSeen
    rechargeExplainerSeen
  }
}
    `;

/**
 * __useGetMyStreakQuery__
 *
 * To run a query within a React component, call `useGetMyStreakQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyStreakQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyStreakQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyStreakQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyStreakQuery, GetMyStreakQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyStreakQuery, GetMyStreakQueryVariables>(GetMyStreakDocument, options);
}
export function useGetMyStreakLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMyStreakQuery, GetMyStreakQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyStreakQuery, GetMyStreakQueryVariables>(
    GetMyStreakDocument,
    options,
  );
}
// @ts-expect-error
export function useGetMyStreakSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyStreakQuery, GetMyStreakQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMyStreakQuery, GetMyStreakQueryVariables>;
export function useGetMyStreakSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyStreakQuery, GetMyStreakQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetMyStreakQuery | undefined, GetMyStreakQueryVariables>;
export function useGetMyStreakSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetMyStreakQuery, GetMyStreakQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyStreakQuery, GetMyStreakQueryVariables>(
    GetMyStreakDocument,
    options,
  );
}
export type GetMyStreakQueryHookResult = ReturnType<typeof useGetMyStreakQuery>;
export type GetMyStreakLazyQueryHookResult = ReturnType<typeof useGetMyStreakLazyQuery>;
export type GetMyStreakSuspenseQueryHookResult = ReturnType<typeof useGetMyStreakSuspenseQuery>;
export type GetMyStreakQueryResult = Apollo.QueryResult<
  GetMyStreakQuery,
  GetMyStreakQueryVariables
>;
export const GetUserConnectionStreakDocument = gql`
    query getUserConnectionStreak($userId: String!) {
  getUserConnectionStreak(userId: $userId)
}
    `;

/**
 * __useGetUserConnectionStreakQuery__
 *
 * To run a query within a React component, call `useGetUserConnectionStreakQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConnectionStreakQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConnectionStreakQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserConnectionStreakQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserConnectionStreakQuery,
    GetUserConnectionStreakQueryVariables
  > &
    ({ variables: GetUserConnectionStreakQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserConnectionStreakQuery, GetUserConnectionStreakQueryVariables>(
    GetUserConnectionStreakDocument,
    options,
  );
}
export function useGetUserConnectionStreakLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserConnectionStreakQuery,
    GetUserConnectionStreakQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserConnectionStreakQuery, GetUserConnectionStreakQueryVariables>(
    GetUserConnectionStreakDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserConnectionStreakSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserConnectionStreakQuery,
    GetUserConnectionStreakQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUserConnectionStreakQuery,
  GetUserConnectionStreakQueryVariables
>;
export function useGetUserConnectionStreakSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserConnectionStreakQuery,
        GetUserConnectionStreakQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUserConnectionStreakQuery | undefined,
  GetUserConnectionStreakQueryVariables
>;
export function useGetUserConnectionStreakSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUserConnectionStreakQuery,
        GetUserConnectionStreakQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserConnectionStreakQuery,
    GetUserConnectionStreakQueryVariables
  >(GetUserConnectionStreakDocument, options);
}
export type GetUserConnectionStreakQueryHookResult = ReturnType<
  typeof useGetUserConnectionStreakQuery
>;
export type GetUserConnectionStreakLazyQueryHookResult = ReturnType<
  typeof useGetUserConnectionStreakLazyQuery
>;
export type GetUserConnectionStreakSuspenseQueryHookResult = ReturnType<
  typeof useGetUserConnectionStreakSuspenseQuery
>;
export type GetUserConnectionStreakQueryResult = Apollo.QueryResult<
  GetUserConnectionStreakQuery,
  GetUserConnectionStreakQueryVariables
>;
export const ThemesDocument = gql`
    query themes($filters: FilterThemesInput!) {
  listThemes(filters: $filters) {
    id
    title
    createdAt
    description
    isCurrent
    isStandard
    isTopicLibrary
    isGrammarLibrary
    isResource
    title
    updatedAt
    cover {
      id
      title
      primary {
        mobile
        desktop
      }
      secondary {
        mobile
        desktop
      }
      tertiary {
        mobile
        desktop
      }
    }
    topics {
      id
      title
      status
      illustration {
        id
        title
        url
      }
    }
  }
}
    `;

/**
 * __useThemesQuery__
 *
 * To run a query within a React component, call `useThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useThemesQuery(
  baseOptions: Apollo.QueryHookOptions<ThemesQuery, ThemesQueryVariables> &
    ({ variables: ThemesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThemesQuery, ThemesQueryVariables>(ThemesDocument, options);
}
export function useThemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThemesQuery, ThemesQueryVariables>(ThemesDocument, options);
}
// @ts-expect-error
export function useThemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ThemesQuery, ThemesQueryVariables>;
export function useThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ThemesQuery | undefined, ThemesQueryVariables>;
export function useThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ThemesQuery, ThemesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ThemesQuery, ThemesQueryVariables>(ThemesDocument, options);
}
export type ThemesQueryHookResult = ReturnType<typeof useThemesQuery>;
export type ThemesLazyQueryHookResult = ReturnType<typeof useThemesLazyQuery>;
export type ThemesSuspenseQueryHookResult = ReturnType<typeof useThemesSuspenseQuery>;
export type ThemesQueryResult = Apollo.QueryResult<ThemesQuery, ThemesQueryVariables>;
export const ThemeDocument = gql`
    query theme($id: String!) {
  getTheme(id: $id) {
    id
    isResource
    topics {
      id
      title
      illustration {
        id
        title
        url
      }
    }
  }
}
    `;

/**
 * __useThemeQuery__
 *
 * To run a query within a React component, call `useThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThemeQuery(
  baseOptions: Apollo.QueryHookOptions<ThemeQuery, ThemeQueryVariables> &
    ({ variables: ThemeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThemeQuery, ThemeQueryVariables>(ThemeDocument, options);
}
export function useThemeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThemeQuery, ThemeQueryVariables>(ThemeDocument, options);
}
// @ts-expect-error
export function useThemeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
): Apollo.UseSuspenseQueryResult<ThemeQuery, ThemeQueryVariables>;
export function useThemeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
): Apollo.UseSuspenseQueryResult<ThemeQuery | undefined, ThemeQueryVariables>;
export function useThemeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemeQuery, ThemeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ThemeQuery, ThemeQueryVariables>(ThemeDocument, options);
}
export type ThemeQueryHookResult = ReturnType<typeof useThemeQuery>;
export type ThemeLazyQueryHookResult = ReturnType<typeof useThemeLazyQuery>;
export type ThemeSuspenseQueryHookResult = ReturnType<typeof useThemeSuspenseQuery>;
export type ThemeQueryResult = Apollo.QueryResult<ThemeQuery, ThemeQueryVariables>;
export const TopicsDocument = gql`
    query topics($filters: FilterTopicsInput!) {
  listTopics(filters: $filters) {
    id
    title
    illustration {
      id
      title
      url
    }
    theme {
      id
      title
    }
  }
}
    `;

/**
 * __useTopicsQuery__
 *
 * To run a query within a React component, call `useTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTopicsQuery(
  baseOptions: Apollo.QueryHookOptions<TopicsQuery, TopicsQueryVariables> &
    ({ variables: TopicsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
}
export function useTopicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TopicsQuery, TopicsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
}
// @ts-expect-error
export function useTopicsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TopicsQuery, TopicsQueryVariables>,
): Apollo.UseSuspenseQueryResult<TopicsQuery, TopicsQueryVariables>;
export function useTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TopicsQuery, TopicsQueryVariables>,
): Apollo.UseSuspenseQueryResult<TopicsQuery | undefined, TopicsQueryVariables>;
export function useTopicsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TopicsQuery, TopicsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
}
export type TopicsQueryHookResult = ReturnType<typeof useTopicsQuery>;
export type TopicsLazyQueryHookResult = ReturnType<typeof useTopicsLazyQuery>;
export type TopicsSuspenseQueryHookResult = ReturnType<typeof useTopicsSuspenseQuery>;
export type TopicsQueryResult = Apollo.QueryResult<TopicsQuery, TopicsQueryVariables>;
export const TopicDocument = gql`
    query topic($id: String!) {
  getTopic(id: $id) {
    id
    stars
    title
    ideasToDiscuss
    comments {
      id
      createdAt
      message
      author {
        id
        name
        avatarUrl
      }
      reactions {
        id
        unifiedId
        user {
          id
          firstName
          lastName
          avatarUrl
        }
      }
      replies {
        id
        createdAt
        message
        author {
          id
          name
          avatarUrl
        }
        reactions {
          id
          unifiedId
          user {
            id
            firstName
            lastName
            avatarUrl
          }
        }
      }
    }
    theme {
      id
      isResource
      isGrammarLibrary
      cover {
        id
        primary {
          desktop
          mobile
        }
        secondary {
          desktop
          mobile
        }
        tertiary {
          desktop
          mobile
        }
      }
    }
    illustration {
      id
      title
      url
    }
    lessons {
      id
      kind
      title
      sections {
        id
        order
        elements {
          kind
          value
          meta
        }
      }
    }
  }
}
    `;

/**
 * __useTopicQuery__
 *
 * To run a query within a React component, call `useTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTopicQuery(
  baseOptions: Apollo.QueryHookOptions<TopicQuery, TopicQueryVariables> &
    ({ variables: TopicQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TopicQuery, TopicQueryVariables>(TopicDocument, options);
}
export function useTopicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TopicQuery, TopicQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TopicQuery, TopicQueryVariables>(TopicDocument, options);
}
// @ts-expect-error
export function useTopicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TopicQuery, TopicQueryVariables>,
): Apollo.UseSuspenseQueryResult<TopicQuery, TopicQueryVariables>;
export function useTopicSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopicQuery, TopicQueryVariables>,
): Apollo.UseSuspenseQueryResult<TopicQuery | undefined, TopicQueryVariables>;
export function useTopicSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopicQuery, TopicQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TopicQuery, TopicQueryVariables>(TopicDocument, options);
}
export type TopicQueryHookResult = ReturnType<typeof useTopicQuery>;
export type TopicLazyQueryHookResult = ReturnType<typeof useTopicLazyQuery>;
export type TopicSuspenseQueryHookResult = ReturnType<typeof useTopicSuspenseQuery>;
export type TopicQueryResult = Apollo.QueryResult<TopicQuery, TopicQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    email
    subscriptionTier
    avatarUrl
    isActive
    isVerified
    firstName
    isComplete
    completedPercentage
    completedHomeTour
    badge
    createdAt
    lastName
    name
    hasActivePlan
    kind
    timezone
    timezoneChosenAt
    hasGoogleRefreshToken
    badges {
      id
      type
      achievedDate
    }
    following {
      id
    }
    followers {
      id
    }
    city
    country
    cityId
    countryId
    lat
    long
    cambridgeEnglishLevel
    speakingLevelScore
    speakingLevel
    birthday
    showBirthday
    showBirthdayYear
    needSpeakingPartner
    englishSkills
    interests
    occupation {
      id
      name
    }
    story
    availabilityFrom
    availabilityUntil
    availability {
      from
      until
    }
    planSlug
    deletedAt
    anonymisedAt
    anonymisationStartedAt
    promotionalCredits
    impersonated
    seenCompletedAt
    welcomeVideoWatchedAt
    valuesVideoWatchedAt
    quizPassedAt
    stepsCompleted
    lastOnlineAt
    availableAssessmentCharges
    takenSpeakingAssessment
    eventStatistics {
      totalAttendedScheduledEvents
      updatedAt
    }
    pauseStartAt
    pauseUntil
    pauseEligibleFrom
    userSettings {
      receiveChatMentionsWebNotifications
      receiveChatThreadWebNotifications
      receiveEventUpdatesAndInvitationsWebNotifications
      receiveEventRemindersWebNotifications
      receiveEventRsvpWebNotifications
      receiveFollowsWebNotifications
      receiveMentionsAndCommentsWebNotifications
      receiveChatMentionsWebNotifications
      receiveChatThreadWebNotifications
      receiveChannelInviteWebNotifications
      receiveLiveTableStartedWebNotifications
      receivePersonalMessagesWebNotifications
      receiveGroupMessagesWebNotifications
      receivePublicChannelsMessagesWebNotifications
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
// @ts-expect-error
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyProfileDocument = gql`
    query myProfile {
  me {
    id
    email
    avatarUrl
    subscriptionTier
    needSpeakingPartner
    cambridgeEnglishLevel
    speakingLevelScore
    speakingLevel
    completedPercentage
    isVerified
    firstName
    nationality
    otherLanguage
    isComplete
    badge
    createdAt
    lastName
    city
    country
    cityId
    countryId
    lat
    long
    story
    birthday
    englishSkills
    interests
    occupation {
      id
      name
    }
    badges {
      id
      type
      achievedDate
      createdAt
    }
    showBirthday
    showBirthdayYear
    nativeLanguage
    name
    wantsNewsletter
    completedPercentage
    completedHomeTour
    speakingPartners
    hasActivePlan
    kind
    timezone
    hasGoogleRefreshToken
    following {
      id
    }
    followers {
      id
    }
    availabilityFrom
    availabilityUntil
    availability {
      from
      until
    }
    photos {
      id
      url
    }
    planSlug
    deletedAt
    promotionalCredits
    impersonated
    seenCompletedAt
    stepsCompleted
    eventStatistics {
      totalAttendedScheduledEvents
      updatedAt
    }
    pauseStartAt
    pauseUntil
    pauseEligibleFrom
    userSettings {
      receiveChatMentionsWebNotifications
      receiveChatThreadWebNotifications
      receiveEventUpdatesAndInvitationsWebNotifications
      receiveEventRemindersWebNotifications
      receiveEventRsvpWebNotifications
      receiveFollowsWebNotifications
      receiveMentionsAndCommentsWebNotifications
      receiveChatMentionsWebNotifications
      receiveChatThreadWebNotifications
      receiveChannelInviteWebNotifications
      receiveLiveTableStartedWebNotifications
      receivePersonalMessagesWebNotifications
      receiveGroupMessagesWebNotifications
      receivePublicChannelsMessagesWebNotifications
    }
  }
}
    `;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
}
export function useMyProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
}
// @ts-expect-error
export function useMyProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyProfileQuery, MyProfileQueryVariables>;
export function useMyProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>,
): Apollo.UseSuspenseQueryResult<MyProfileQuery | undefined, MyProfileQueryVariables>;
export function useMyProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MyProfileQuery, MyProfileQueryVariables>(
    MyProfileDocument,
    options,
  );
}
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileSuspenseQueryHookResult = ReturnType<typeof useMyProfileSuspenseQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const GetUserSettingsDocument = gql`
    query getUserSettings {
  getUserSettings {
    id
    receiveEventUpdatesAndInvitationsNotifications
    receiveEventUpdatesAndInvitationsEmails
    receiveEventRemindersNotifications
    receiveEventRemindersEmails
    receiveEventRsvpNotifications
    receiveEventRsvpEmails
    receiveFollowsNotifications
    receiveFollowsEmails
    receiveMentionsAndCommentsNotifications
    receiveMentionsAndCommentsEmails
    receiveChatMentionsNotifications
    receiveChatMentionsEmails
    receiveLiveTableStartedNotifications
    receivePlatformStatusEmails
    receiveSubscriptionChangesEmails
    receiveChatThreadNotifications
    receiveChatThreadEmails
    receiveChannelInviteNotifications
    receiveChannelInviteEmails
    receiveEventUpdatesAndInvitationsWebNotifications
    receiveEventRemindersWebNotifications
    receiveEventRsvpWebNotifications
    receiveFollowsWebNotifications
    receiveMentionsAndCommentsWebNotifications
    receiveChatMentionsWebNotifications
    receiveChatThreadWebNotifications
    receiveChannelInviteWebNotifications
    receiveLiveTableStartedWebNotifications
    receivePersonalMessagesWebNotifications
    receiveGroupMessagesWebNotifications
    receivePublicChannelsMessagesWebNotifications
    emailNotifications
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(
    GetUserSettingsDocument,
    options,
  );
}
export function useGetUserSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(
    GetUserSettingsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserSettingsQuery,
    GetUserSettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetUserSettingsQuery, GetUserSettingsQueryVariables>;
export function useGetUserSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserSettingsQuery | undefined, GetUserSettingsQueryVariables>;
export function useGetUserSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(
    GetUserSettingsDocument,
    options,
  );
}
export type GetUserSettingsQueryHookResult = ReturnType<typeof useGetUserSettingsQuery>;
export type GetUserSettingsLazyQueryHookResult = ReturnType<typeof useGetUserSettingsLazyQuery>;
export type GetUserSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetUserSettingsSuspenseQuery
>;
export type GetUserSettingsQueryResult = Apollo.QueryResult<
  GetUserSettingsQuery,
  GetUserSettingsQueryVariables
>;
export const UserDocument = gql`
    query user($id: String!) {
  getUser(id: $id) {
    id
    email
    avatarUrl
    needSpeakingPartner
    cambridgeEnglishLevel
    speakingLevelScore
    speakingLevel
    firstName
    otherLanguage
    isComplete
    badge
    createdAt
    lastOnlineAt
    lastName
    city
    name
    country
    story
    birthday
    englishSkills
    interests
    occupation {
      id
      name
    }
    showBirthday
    nativeLanguage
    completedPercentage
    followers {
      follower {
        id
        name
      }
    }
    availability {
      from
      until
    }
    photos {
      id
      url
    }
    pauseStartAt
    pauseUntil
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> &
    ({ variables: UserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
// @ts-expect-error
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const SimpleUserDocument = gql`
    query simpleUser($id: String!) {
  getUser(id: $id) {
    id
    firstName
  }
}
    `;

/**
 * __useSimpleUserQuery__
 *
 * To run a query within a React component, call `useSimpleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSimpleUserQuery(
  baseOptions: Apollo.QueryHookOptions<SimpleUserQuery, SimpleUserQueryVariables> &
    ({ variables: SimpleUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SimpleUserQuery, SimpleUserQueryVariables>(SimpleUserDocument, options);
}
export function useSimpleUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SimpleUserQuery, SimpleUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SimpleUserQuery, SimpleUserQueryVariables>(
    SimpleUserDocument,
    options,
  );
}
// @ts-expect-error
export function useSimpleUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SimpleUserQuery, SimpleUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<SimpleUserQuery, SimpleUserQueryVariables>;
export function useSimpleUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SimpleUserQuery, SimpleUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<SimpleUserQuery | undefined, SimpleUserQueryVariables>;
export function useSimpleUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SimpleUserQuery, SimpleUserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SimpleUserQuery, SimpleUserQueryVariables>(
    SimpleUserDocument,
    options,
  );
}
export type SimpleUserQueryHookResult = ReturnType<typeof useSimpleUserQuery>;
export type SimpleUserLazyQueryHookResult = ReturnType<typeof useSimpleUserLazyQuery>;
export type SimpleUserSuspenseQueryHookResult = ReturnType<typeof useSimpleUserSuspenseQuery>;
export type SimpleUserQueryResult = Apollo.QueryResult<SimpleUserQuery, SimpleUserQueryVariables>;
export const PlanDetailsAndPaymentMethodDocument = gql`
    query planDetailsAndPaymentMethod {
  planDetails {
    itemPriceId
    userAmount
    start
    end
    status
    resumesAt
    cancelledAt
    recoveryStartedAt
    scheduledPlan
  }
  paymentMethod {
    last4Digits
    expYear
    expMonth
    type
    email
  }
  invoices {
    id
    created
    description
    amount
    currency
    downloadUrl
    status
  }
}
    `;

/**
 * __usePlanDetailsAndPaymentMethodQuery__
 *
 * To run a query within a React component, call `usePlanDetailsAndPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanDetailsAndPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanDetailsAndPaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlanDetailsAndPaymentMethodQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PlanDetailsAndPaymentMethodQuery,
    PlanDetailsAndPaymentMethodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PlanDetailsAndPaymentMethodQuery,
    PlanDetailsAndPaymentMethodQueryVariables
  >(PlanDetailsAndPaymentMethodDocument, options);
}
export function usePlanDetailsAndPaymentMethodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PlanDetailsAndPaymentMethodQuery,
    PlanDetailsAndPaymentMethodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PlanDetailsAndPaymentMethodQuery,
    PlanDetailsAndPaymentMethodQueryVariables
  >(PlanDetailsAndPaymentMethodDocument, options);
}
// @ts-expect-error
export function usePlanDetailsAndPaymentMethodSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PlanDetailsAndPaymentMethodQuery,
    PlanDetailsAndPaymentMethodQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PlanDetailsAndPaymentMethodQuery,
  PlanDetailsAndPaymentMethodQueryVariables
>;
export function usePlanDetailsAndPaymentMethodSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PlanDetailsAndPaymentMethodQuery,
        PlanDetailsAndPaymentMethodQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PlanDetailsAndPaymentMethodQuery | undefined,
  PlanDetailsAndPaymentMethodQueryVariables
>;
export function usePlanDetailsAndPaymentMethodSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PlanDetailsAndPaymentMethodQuery,
        PlanDetailsAndPaymentMethodQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PlanDetailsAndPaymentMethodQuery,
    PlanDetailsAndPaymentMethodQueryVariables
  >(PlanDetailsAndPaymentMethodDocument, options);
}
export type PlanDetailsAndPaymentMethodQueryHookResult = ReturnType<
  typeof usePlanDetailsAndPaymentMethodQuery
>;
export type PlanDetailsAndPaymentMethodLazyQueryHookResult = ReturnType<
  typeof usePlanDetailsAndPaymentMethodLazyQuery
>;
export type PlanDetailsAndPaymentMethodSuspenseQueryHookResult = ReturnType<
  typeof usePlanDetailsAndPaymentMethodSuspenseQuery
>;
export type PlanDetailsAndPaymentMethodQueryResult = Apollo.QueryResult<
  PlanDetailsAndPaymentMethodQuery,
  PlanDetailsAndPaymentMethodQueryVariables
>;
export const GetPlanStatusDocument = gql`
    query getPlanStatus {
  planDetails {
    itemPriceId
    status
    dunning
    plan
    end
  }
}
    `;

/**
 * __useGetPlanStatusQuery__
 *
 * To run a query within a React component, call `useGetPlanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlanStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPlanStatusQuery, GetPlanStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlanStatusQuery, GetPlanStatusQueryVariables>(
    GetPlanStatusDocument,
    options,
  );
}
export function useGetPlanStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlanStatusQuery, GetPlanStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlanStatusQuery, GetPlanStatusQueryVariables>(
    GetPlanStatusDocument,
    options,
  );
}
// @ts-expect-error
export function useGetPlanStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlanStatusQuery, GetPlanStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPlanStatusQuery, GetPlanStatusQueryVariables>;
export function useGetPlanStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlanStatusQuery, GetPlanStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPlanStatusQuery | undefined, GetPlanStatusQueryVariables>;
export function useGetPlanStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlanStatusQuery, GetPlanStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPlanStatusQuery, GetPlanStatusQueryVariables>(
    GetPlanStatusDocument,
    options,
  );
}
export type GetPlanStatusQueryHookResult = ReturnType<typeof useGetPlanStatusQuery>;
export type GetPlanStatusLazyQueryHookResult = ReturnType<typeof useGetPlanStatusLazyQuery>;
export type GetPlanStatusSuspenseQueryHookResult = ReturnType<typeof useGetPlanStatusSuspenseQuery>;
export type GetPlanStatusQueryResult = Apollo.QueryResult<
  GetPlanStatusQuery,
  GetPlanStatusQueryVariables
>;
export const GetItemPriceDocument = gql`
    query getItemPrice($itemPriceId: String!) {
  itemPrice(itemPriceId: $itemPriceId) {
    name
    interval
    intervalCount
    amount
    meta
  }
}
    `;

/**
 * __useGetItemPriceQuery__
 *
 * To run a query within a React component, call `useGetItemPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemPriceQuery({
 *   variables: {
 *      itemPriceId: // value for 'itemPriceId'
 *   },
 * });
 */
export function useGetItemPriceQuery(
  baseOptions: Apollo.QueryHookOptions<GetItemPriceQuery, GetItemPriceQueryVariables> &
    ({ variables: GetItemPriceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetItemPriceQuery, GetItemPriceQueryVariables>(
    GetItemPriceDocument,
    options,
  );
}
export function useGetItemPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetItemPriceQuery, GetItemPriceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetItemPriceQuery, GetItemPriceQueryVariables>(
    GetItemPriceDocument,
    options,
  );
}
// @ts-expect-error
export function useGetItemPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetItemPriceQuery, GetItemPriceQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetItemPriceQuery, GetItemPriceQueryVariables>;
export function useGetItemPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetItemPriceQuery, GetItemPriceQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetItemPriceQuery | undefined, GetItemPriceQueryVariables>;
export function useGetItemPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetItemPriceQuery, GetItemPriceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetItemPriceQuery, GetItemPriceQueryVariables>(
    GetItemPriceDocument,
    options,
  );
}
export type GetItemPriceQueryHookResult = ReturnType<typeof useGetItemPriceQuery>;
export type GetItemPriceLazyQueryHookResult = ReturnType<typeof useGetItemPriceLazyQuery>;
export type GetItemPriceSuspenseQueryHookResult = ReturnType<typeof useGetItemPriceSuspenseQuery>;
export type GetItemPriceQueryResult = Apollo.QueryResult<
  GetItemPriceQuery,
  GetItemPriceQueryVariables
>;
export const PausePreviewDocument = gql`
    query pausePreview($durationDays: Int!) {
  pausePreview(durationDays: $durationDays) {
    intendedPauseEndDate
    nextBillingAt
    durationDays
  }
}
    `;

/**
 * __usePausePreviewQuery__
 *
 * To run a query within a React component, call `usePausePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePausePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePausePreviewQuery({
 *   variables: {
 *      durationDays: // value for 'durationDays'
 *   },
 * });
 */
export function usePausePreviewQuery(
  baseOptions: Apollo.QueryHookOptions<PausePreviewQuery, PausePreviewQueryVariables> &
    ({ variables: PausePreviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PausePreviewQuery, PausePreviewQueryVariables>(
    PausePreviewDocument,
    options,
  );
}
export function usePausePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PausePreviewQuery, PausePreviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PausePreviewQuery, PausePreviewQueryVariables>(
    PausePreviewDocument,
    options,
  );
}
// @ts-expect-error
export function usePausePreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PausePreviewQuery, PausePreviewQueryVariables>,
): Apollo.UseSuspenseQueryResult<PausePreviewQuery, PausePreviewQueryVariables>;
export function usePausePreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PausePreviewQuery, PausePreviewQueryVariables>,
): Apollo.UseSuspenseQueryResult<PausePreviewQuery | undefined, PausePreviewQueryVariables>;
export function usePausePreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PausePreviewQuery, PausePreviewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PausePreviewQuery, PausePreviewQueryVariables>(
    PausePreviewDocument,
    options,
  );
}
export type PausePreviewQueryHookResult = ReturnType<typeof usePausePreviewQuery>;
export type PausePreviewLazyQueryHookResult = ReturnType<typeof usePausePreviewLazyQuery>;
export type PausePreviewSuspenseQueryHookResult = ReturnType<typeof usePausePreviewSuspenseQuery>;
export type PausePreviewQueryResult = Apollo.QueryResult<
  PausePreviewQuery,
  PausePreviewQueryVariables
>;
export const GetOccupationsDocument = gql`
    query getOccupations {
  getOccupations {
    id
    name
  }
}
    `;

/**
 * __useGetOccupationsQuery__
 *
 * To run a query within a React component, call `useGetOccupationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOccupationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOccupationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOccupationsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOccupationsQuery, GetOccupationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOccupationsQuery, GetOccupationsQueryVariables>(
    GetOccupationsDocument,
    options,
  );
}
export function useGetOccupationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOccupationsQuery, GetOccupationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOccupationsQuery, GetOccupationsQueryVariables>(
    GetOccupationsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetOccupationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetOccupationsQuery, GetOccupationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetOccupationsQuery, GetOccupationsQueryVariables>;
export function useGetOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOccupationsQuery, GetOccupationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetOccupationsQuery | undefined, GetOccupationsQueryVariables>;
export function useGetOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOccupationsQuery, GetOccupationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetOccupationsQuery, GetOccupationsQueryVariables>(
    GetOccupationsDocument,
    options,
  );
}
export type GetOccupationsQueryHookResult = ReturnType<typeof useGetOccupationsQuery>;
export type GetOccupationsLazyQueryHookResult = ReturnType<typeof useGetOccupationsLazyQuery>;
export type GetOccupationsSuspenseQueryHookResult = ReturnType<
  typeof useGetOccupationsSuspenseQuery
>;
export type GetOccupationsQueryResult = Apollo.QueryResult<
  GetOccupationsQuery,
  GetOccupationsQueryVariables
>;
export const UserHasNoAcceptedInvitesDocument = gql`
    query userHasNoAcceptedInvites {
  userHasNoAcceptedInvites
}
    `;

/**
 * __useUserHasNoAcceptedInvitesQuery__
 *
 * To run a query within a React component, call `useUserHasNoAcceptedInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserHasNoAcceptedInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserHasNoAcceptedInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserHasNoAcceptedInvitesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserHasNoAcceptedInvitesQuery,
    UserHasNoAcceptedInvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserHasNoAcceptedInvitesQuery, UserHasNoAcceptedInvitesQueryVariables>(
    UserHasNoAcceptedInvitesDocument,
    options,
  );
}
export function useUserHasNoAcceptedInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserHasNoAcceptedInvitesQuery,
    UserHasNoAcceptedInvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserHasNoAcceptedInvitesQuery, UserHasNoAcceptedInvitesQueryVariables>(
    UserHasNoAcceptedInvitesDocument,
    options,
  );
}
// @ts-expect-error
export function useUserHasNoAcceptedInvitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    UserHasNoAcceptedInvitesQuery,
    UserHasNoAcceptedInvitesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  UserHasNoAcceptedInvitesQuery,
  UserHasNoAcceptedInvitesQueryVariables
>;
export function useUserHasNoAcceptedInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserHasNoAcceptedInvitesQuery,
        UserHasNoAcceptedInvitesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  UserHasNoAcceptedInvitesQuery | undefined,
  UserHasNoAcceptedInvitesQueryVariables
>;
export function useUserHasNoAcceptedInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserHasNoAcceptedInvitesQuery,
        UserHasNoAcceptedInvitesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UserHasNoAcceptedInvitesQuery,
    UserHasNoAcceptedInvitesQueryVariables
  >(UserHasNoAcceptedInvitesDocument, options);
}
export type UserHasNoAcceptedInvitesQueryHookResult = ReturnType<
  typeof useUserHasNoAcceptedInvitesQuery
>;
export type UserHasNoAcceptedInvitesLazyQueryHookResult = ReturnType<
  typeof useUserHasNoAcceptedInvitesLazyQuery
>;
export type UserHasNoAcceptedInvitesSuspenseQueryHookResult = ReturnType<
  typeof useUserHasNoAcceptedInvitesSuspenseQuery
>;
export type UserHasNoAcceptedInvitesQueryResult = Apollo.QueryResult<
  UserHasNoAcceptedInvitesQuery,
  UserHasNoAcceptedInvitesQueryVariables
>;
export const HasSeenEventsTabDocument = gql`
    query hasSeenEventsTab {
  hasSeenEventsTab
}
    `;

/**
 * __useHasSeenEventsTabQuery__
 *
 * To run a query within a React component, call `useHasSeenEventsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSeenEventsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSeenEventsTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasSeenEventsTabQuery(
  baseOptions?: Apollo.QueryHookOptions<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>(
    HasSeenEventsTabDocument,
    options,
  );
}
export function useHasSeenEventsTabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>(
    HasSeenEventsTabDocument,
    options,
  );
}
// @ts-expect-error
export function useHasSeenEventsTabSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HasSeenEventsTabQuery,
    HasSeenEventsTabQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>;
export function useHasSeenEventsTabSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>,
): Apollo.UseSuspenseQueryResult<HasSeenEventsTabQuery | undefined, HasSeenEventsTabQueryVariables>;
export function useHasSeenEventsTabSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HasSeenEventsTabQuery, HasSeenEventsTabQueryVariables>(
    HasSeenEventsTabDocument,
    options,
  );
}
export type HasSeenEventsTabQueryHookResult = ReturnType<typeof useHasSeenEventsTabQuery>;
export type HasSeenEventsTabLazyQueryHookResult = ReturnType<typeof useHasSeenEventsTabLazyQuery>;
export type HasSeenEventsTabSuspenseQueryHookResult = ReturnType<
  typeof useHasSeenEventsTabSuspenseQuery
>;
export type HasSeenEventsTabQueryResult = Apollo.QueryResult<
  HasSeenEventsTabQuery,
  HasSeenEventsTabQueryVariables
>;
export const HasSeenEventsTabAfterAttendedThreeEventsDocument = gql`
    query hasSeenEventsTabAfterAttendedThreeEvents {
  hasSeenEventsTabAfterAttendedThreeEvents
}
    `;

/**
 * __useHasSeenEventsTabAfterAttendedThreeEventsQuery__
 *
 * To run a query within a React component, call `useHasSeenEventsTabAfterAttendedThreeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSeenEventsTabAfterAttendedThreeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSeenEventsTabAfterAttendedThreeEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasSeenEventsTabAfterAttendedThreeEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HasSeenEventsTabAfterAttendedThreeEventsQuery,
    HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HasSeenEventsTabAfterAttendedThreeEventsQuery,
    HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
  >(HasSeenEventsTabAfterAttendedThreeEventsDocument, options);
}
export function useHasSeenEventsTabAfterAttendedThreeEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HasSeenEventsTabAfterAttendedThreeEventsQuery,
    HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HasSeenEventsTabAfterAttendedThreeEventsQuery,
    HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
  >(HasSeenEventsTabAfterAttendedThreeEventsDocument, options);
}
// @ts-expect-error
export function useHasSeenEventsTabAfterAttendedThreeEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HasSeenEventsTabAfterAttendedThreeEventsQuery,
    HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HasSeenEventsTabAfterAttendedThreeEventsQuery,
  HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
>;
export function useHasSeenEventsTabAfterAttendedThreeEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HasSeenEventsTabAfterAttendedThreeEventsQuery,
        HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HasSeenEventsTabAfterAttendedThreeEventsQuery | undefined,
  HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
>;
export function useHasSeenEventsTabAfterAttendedThreeEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HasSeenEventsTabAfterAttendedThreeEventsQuery,
        HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HasSeenEventsTabAfterAttendedThreeEventsQuery,
    HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
  >(HasSeenEventsTabAfterAttendedThreeEventsDocument, options);
}
export type HasSeenEventsTabAfterAttendedThreeEventsQueryHookResult = ReturnType<
  typeof useHasSeenEventsTabAfterAttendedThreeEventsQuery
>;
export type HasSeenEventsTabAfterAttendedThreeEventsLazyQueryHookResult = ReturnType<
  typeof useHasSeenEventsTabAfterAttendedThreeEventsLazyQuery
>;
export type HasSeenEventsTabAfterAttendedThreeEventsSuspenseQueryHookResult = ReturnType<
  typeof useHasSeenEventsTabAfterAttendedThreeEventsSuspenseQuery
>;
export type HasSeenEventsTabAfterAttendedThreeEventsQueryResult = Apollo.QueryResult<
  HasSeenEventsTabAfterAttendedThreeEventsQuery,
  HasSeenEventsTabAfterAttendedThreeEventsQueryVariables
>;
export const AttendedEventsDocument = gql`
    query attendedEvents($input: StatisticsInput!) {
  attendedEvents(input: $input) {
    oneToOnes
    groupEvents
    webinars
    inPersonEvents
    other
  }
}
    `;

/**
 * __useAttendedEventsQuery__
 *
 * To run a query within a React component, call `useAttendedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendedEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendedEventsQuery(
  baseOptions: Apollo.QueryHookOptions<AttendedEventsQuery, AttendedEventsQueryVariables> &
    ({ variables: AttendedEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttendedEventsQuery, AttendedEventsQueryVariables>(
    AttendedEventsDocument,
    options,
  );
}
export function useAttendedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AttendedEventsQuery, AttendedEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttendedEventsQuery, AttendedEventsQueryVariables>(
    AttendedEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useAttendedEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AttendedEventsQuery, AttendedEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AttendedEventsQuery, AttendedEventsQueryVariables>;
export function useAttendedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendedEventsQuery, AttendedEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AttendedEventsQuery | undefined, AttendedEventsQueryVariables>;
export function useAttendedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendedEventsQuery, AttendedEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttendedEventsQuery, AttendedEventsQueryVariables>(
    AttendedEventsDocument,
    options,
  );
}
export type AttendedEventsQueryHookResult = ReturnType<typeof useAttendedEventsQuery>;
export type AttendedEventsLazyQueryHookResult = ReturnType<typeof useAttendedEventsLazyQuery>;
export type AttendedEventsSuspenseQueryHookResult = ReturnType<
  typeof useAttendedEventsSuspenseQuery
>;
export type AttendedEventsQueryResult = Apollo.QueryResult<
  AttendedEventsQuery,
  AttendedEventsQueryVariables
>;
export const AttendanceRecordDocument = gql`
    query attendanceRecord($input: StatisticsInput!) {
  attendanceRecord(input: $input) {
    attendanceRatio
    totalRsvps
    attended
  }
}
    `;

/**
 * __useAttendanceRecordQuery__
 *
 * To run a query within a React component, call `useAttendanceRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceRecordQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttendanceRecordQuery(
  baseOptions: Apollo.QueryHookOptions<AttendanceRecordQuery, AttendanceRecordQueryVariables> &
    ({ variables: AttendanceRecordQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttendanceRecordQuery, AttendanceRecordQueryVariables>(
    AttendanceRecordDocument,
    options,
  );
}
export function useAttendanceRecordLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AttendanceRecordQuery, AttendanceRecordQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttendanceRecordQuery, AttendanceRecordQueryVariables>(
    AttendanceRecordDocument,
    options,
  );
}
// @ts-expect-error
export function useAttendanceRecordSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttendanceRecordQuery,
    AttendanceRecordQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AttendanceRecordQuery, AttendanceRecordQueryVariables>;
export function useAttendanceRecordSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceRecordQuery, AttendanceRecordQueryVariables>,
): Apollo.UseSuspenseQueryResult<AttendanceRecordQuery | undefined, AttendanceRecordQueryVariables>;
export function useAttendanceRecordSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceRecordQuery, AttendanceRecordQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttendanceRecordQuery, AttendanceRecordQueryVariables>(
    AttendanceRecordDocument,
    options,
  );
}
export type AttendanceRecordQueryHookResult = ReturnType<typeof useAttendanceRecordQuery>;
export type AttendanceRecordLazyQueryHookResult = ReturnType<typeof useAttendanceRecordLazyQuery>;
export type AttendanceRecordSuspenseQueryHookResult = ReturnType<
  typeof useAttendanceRecordSuspenseQuery
>;
export type AttendanceRecordQueryResult = Apollo.QueryResult<
  AttendanceRecordQuery,
  AttendanceRecordQueryVariables
>;
export const ParticipationTimeDocument = gql`
    query participationTime($input: StatisticsInput!) {
  participationTime(input: $input)
}
    `;

/**
 * __useParticipationTimeQuery__
 *
 * To run a query within a React component, call `useParticipationTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipationTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipationTimeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useParticipationTimeQuery(
  baseOptions: Apollo.QueryHookOptions<ParticipationTimeQuery, ParticipationTimeQueryVariables> &
    ({ variables: ParticipationTimeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ParticipationTimeQuery, ParticipationTimeQueryVariables>(
    ParticipationTimeDocument,
    options,
  );
}
export function useParticipationTimeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ParticipationTimeQuery,
    ParticipationTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ParticipationTimeQuery, ParticipationTimeQueryVariables>(
    ParticipationTimeDocument,
    options,
  );
}
// @ts-expect-error
export function useParticipationTimeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ParticipationTimeQuery,
    ParticipationTimeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ParticipationTimeQuery, ParticipationTimeQueryVariables>;
export function useParticipationTimeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ParticipationTimeQuery, ParticipationTimeQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ParticipationTimeQuery | undefined,
  ParticipationTimeQueryVariables
>;
export function useParticipationTimeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ParticipationTimeQuery, ParticipationTimeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ParticipationTimeQuery, ParticipationTimeQueryVariables>(
    ParticipationTimeDocument,
    options,
  );
}
export type ParticipationTimeQueryHookResult = ReturnType<typeof useParticipationTimeQuery>;
export type ParticipationTimeLazyQueryHookResult = ReturnType<typeof useParticipationTimeLazyQuery>;
export type ParticipationTimeSuspenseQueryHookResult = ReturnType<
  typeof useParticipationTimeSuspenseQuery
>;
export type ParticipationTimeQueryResult = Apollo.QueryResult<
  ParticipationTimeQuery,
  ParticipationTimeQueryVariables
>;
export const HostedEventsDocument = gql`
    query hostedEvents($input: StatisticsInput!) {
  hostedEvents(input: $input)
}
    `;

/**
 * __useHostedEventsQuery__
 *
 * To run a query within a React component, call `useHostedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostedEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHostedEventsQuery(
  baseOptions: Apollo.QueryHookOptions<HostedEventsQuery, HostedEventsQueryVariables> &
    ({ variables: HostedEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HostedEventsQuery, HostedEventsQueryVariables>(
    HostedEventsDocument,
    options,
  );
}
export function useHostedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HostedEventsQuery, HostedEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HostedEventsQuery, HostedEventsQueryVariables>(
    HostedEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useHostedEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<HostedEventsQuery, HostedEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<HostedEventsQuery, HostedEventsQueryVariables>;
export function useHostedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HostedEventsQuery, HostedEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<HostedEventsQuery | undefined, HostedEventsQueryVariables>;
export function useHostedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<HostedEventsQuery, HostedEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HostedEventsQuery, HostedEventsQueryVariables>(
    HostedEventsDocument,
    options,
  );
}
export type HostedEventsQueryHookResult = ReturnType<typeof useHostedEventsQuery>;
export type HostedEventsLazyQueryHookResult = ReturnType<typeof useHostedEventsLazyQuery>;
export type HostedEventsSuspenseQueryHookResult = ReturnType<typeof useHostedEventsSuspenseQuery>;
export type HostedEventsQueryResult = Apollo.QueryResult<
  HostedEventsQuery,
  HostedEventsQueryVariables
>;
export const HostedParticipationTimeDocument = gql`
    query hostedParticipationTime($input: StatisticsInput!) {
  hostedParticipationTime(input: $input)
}
    `;

/**
 * __useHostedParticipationTimeQuery__
 *
 * To run a query within a React component, call `useHostedParticipationTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostedParticipationTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostedParticipationTimeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHostedParticipationTimeQuery(
  baseOptions: Apollo.QueryHookOptions<
    HostedParticipationTimeQuery,
    HostedParticipationTimeQueryVariables
  > &
    ({ variables: HostedParticipationTimeQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HostedParticipationTimeQuery, HostedParticipationTimeQueryVariables>(
    HostedParticipationTimeDocument,
    options,
  );
}
export function useHostedParticipationTimeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HostedParticipationTimeQuery,
    HostedParticipationTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HostedParticipationTimeQuery, HostedParticipationTimeQueryVariables>(
    HostedParticipationTimeDocument,
    options,
  );
}
// @ts-expect-error
export function useHostedParticipationTimeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HostedParticipationTimeQuery,
    HostedParticipationTimeQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  HostedParticipationTimeQuery,
  HostedParticipationTimeQueryVariables
>;
export function useHostedParticipationTimeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HostedParticipationTimeQuery,
        HostedParticipationTimeQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HostedParticipationTimeQuery | undefined,
  HostedParticipationTimeQueryVariables
>;
export function useHostedParticipationTimeSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HostedParticipationTimeQuery,
        HostedParticipationTimeQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HostedParticipationTimeQuery,
    HostedParticipationTimeQueryVariables
  >(HostedParticipationTimeDocument, options);
}
export type HostedParticipationTimeQueryHookResult = ReturnType<
  typeof useHostedParticipationTimeQuery
>;
export type HostedParticipationTimeLazyQueryHookResult = ReturnType<
  typeof useHostedParticipationTimeLazyQuery
>;
export type HostedParticipationTimeSuspenseQueryHookResult = ReturnType<
  typeof useHostedParticipationTimeSuspenseQuery
>;
export type HostedParticipationTimeQueryResult = Apollo.QueryResult<
  HostedParticipationTimeQuery,
  HostedParticipationTimeQueryVariables
>;
export const GlobalNetworkDocument = gql`
    query globalNetwork($input: StatisticsInput!) {
  globalNetwork(input: $input) {
    lat
    long
  }
}
    `;

/**
 * __useGlobalNetworkQuery__
 *
 * To run a query within a React component, call `useGlobalNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalNetworkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGlobalNetworkQuery(
  baseOptions: Apollo.QueryHookOptions<GlobalNetworkQuery, GlobalNetworkQueryVariables> &
    ({ variables: GlobalNetworkQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GlobalNetworkQuery, GlobalNetworkQueryVariables>(
    GlobalNetworkDocument,
    options,
  );
}
export function useGlobalNetworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GlobalNetworkQuery, GlobalNetworkQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GlobalNetworkQuery, GlobalNetworkQueryVariables>(
    GlobalNetworkDocument,
    options,
  );
}
// @ts-expect-error
export function useGlobalNetworkSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GlobalNetworkQuery, GlobalNetworkQueryVariables>,
): Apollo.UseSuspenseQueryResult<GlobalNetworkQuery, GlobalNetworkQueryVariables>;
export function useGlobalNetworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GlobalNetworkQuery, GlobalNetworkQueryVariables>,
): Apollo.UseSuspenseQueryResult<GlobalNetworkQuery | undefined, GlobalNetworkQueryVariables>;
export function useGlobalNetworkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GlobalNetworkQuery, GlobalNetworkQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GlobalNetworkQuery, GlobalNetworkQueryVariables>(
    GlobalNetworkDocument,
    options,
  );
}
export type GlobalNetworkQueryHookResult = ReturnType<typeof useGlobalNetworkQuery>;
export type GlobalNetworkLazyQueryHookResult = ReturnType<typeof useGlobalNetworkLazyQuery>;
export type GlobalNetworkSuspenseQueryHookResult = ReturnType<typeof useGlobalNetworkSuspenseQuery>;
export type GlobalNetworkQueryResult = Apollo.QueryResult<
  GlobalNetworkQuery,
  GlobalNetworkQueryVariables
>;
export const FriendlyFacesDocument = gql`
    query friendlyFaces($input: StatisticsInput!) {
  friendlyFaces(input: $input) {
    userId
    firstName
    lastName
    avatarUrl
  }
}
    `;

/**
 * __useFriendlyFacesQuery__
 *
 * To run a query within a React component, call `useFriendlyFacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFriendlyFacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFriendlyFacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFriendlyFacesQuery(
  baseOptions: Apollo.QueryHookOptions<FriendlyFacesQuery, FriendlyFacesQueryVariables> &
    ({ variables: FriendlyFacesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FriendlyFacesQuery, FriendlyFacesQueryVariables>(
    FriendlyFacesDocument,
    options,
  );
}
export function useFriendlyFacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FriendlyFacesQuery, FriendlyFacesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FriendlyFacesQuery, FriendlyFacesQueryVariables>(
    FriendlyFacesDocument,
    options,
  );
}
// @ts-expect-error
export function useFriendlyFacesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<FriendlyFacesQuery, FriendlyFacesQueryVariables>,
): Apollo.UseSuspenseQueryResult<FriendlyFacesQuery, FriendlyFacesQueryVariables>;
export function useFriendlyFacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FriendlyFacesQuery, FriendlyFacesQueryVariables>,
): Apollo.UseSuspenseQueryResult<FriendlyFacesQuery | undefined, FriendlyFacesQueryVariables>;
export function useFriendlyFacesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FriendlyFacesQuery, FriendlyFacesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FriendlyFacesQuery, FriendlyFacesQueryVariables>(
    FriendlyFacesDocument,
    options,
  );
}
export type FriendlyFacesQueryHookResult = ReturnType<typeof useFriendlyFacesQuery>;
export type FriendlyFacesLazyQueryHookResult = ReturnType<typeof useFriendlyFacesLazyQuery>;
export type FriendlyFacesSuspenseQueryHookResult = ReturnType<typeof useFriendlyFacesSuspenseQuery>;
export type FriendlyFacesQueryResult = Apollo.QueryResult<
  FriendlyFacesQuery,
  FriendlyFacesQueryVariables
>;
export const ArticlesWrittenDocument = gql`
    query articlesWritten($input: StatisticsInput!) {
  articlesWritten(input: $input)
}
    `;

/**
 * __useArticlesWrittenQuery__
 *
 * To run a query within a React component, call `useArticlesWrittenQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesWrittenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesWrittenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArticlesWrittenQuery(
  baseOptions: Apollo.QueryHookOptions<ArticlesWrittenQuery, ArticlesWrittenQueryVariables> &
    ({ variables: ArticlesWrittenQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>(
    ArticlesWrittenDocument,
    options,
  );
}
export function useArticlesWrittenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>(
    ArticlesWrittenDocument,
    options,
  );
}
// @ts-expect-error
export function useArticlesWrittenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticlesWrittenQuery,
    ArticlesWrittenQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>;
export function useArticlesWrittenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>,
): Apollo.UseSuspenseQueryResult<ArticlesWrittenQuery | undefined, ArticlesWrittenQueryVariables>;
export function useArticlesWrittenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ArticlesWrittenQuery, ArticlesWrittenQueryVariables>(
    ArticlesWrittenDocument,
    options,
  );
}
export type ArticlesWrittenQueryHookResult = ReturnType<typeof useArticlesWrittenQuery>;
export type ArticlesWrittenLazyQueryHookResult = ReturnType<typeof useArticlesWrittenLazyQuery>;
export type ArticlesWrittenSuspenseQueryHookResult = ReturnType<
  typeof useArticlesWrittenSuspenseQuery
>;
export type ArticlesWrittenQueryResult = Apollo.QueryResult<
  ArticlesWrittenQuery,
  ArticlesWrittenQueryVariables
>;
export const DailyEventsDocument = gql`
    query dailyEvents($input: StatisticsInput!) {
  dailyEvents(input: $input) {
    day
    count
  }
}
    `;

/**
 * __useDailyEventsQuery__
 *
 * To run a query within a React component, call `useDailyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDailyEventsQuery(
  baseOptions: Apollo.QueryHookOptions<DailyEventsQuery, DailyEventsQueryVariables> &
    ({ variables: DailyEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DailyEventsQuery, DailyEventsQueryVariables>(DailyEventsDocument, options);
}
export function useDailyEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DailyEventsQuery, DailyEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DailyEventsQuery, DailyEventsQueryVariables>(
    DailyEventsDocument,
    options,
  );
}
// @ts-expect-error
export function useDailyEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DailyEventsQuery, DailyEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<DailyEventsQuery, DailyEventsQueryVariables>;
export function useDailyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DailyEventsQuery, DailyEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<DailyEventsQuery | undefined, DailyEventsQueryVariables>;
export function useDailyEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DailyEventsQuery, DailyEventsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DailyEventsQuery, DailyEventsQueryVariables>(
    DailyEventsDocument,
    options,
  );
}
export type DailyEventsQueryHookResult = ReturnType<typeof useDailyEventsQuery>;
export type DailyEventsLazyQueryHookResult = ReturnType<typeof useDailyEventsLazyQuery>;
export type DailyEventsSuspenseQueryHookResult = ReturnType<typeof useDailyEventsSuspenseQuery>;
export type DailyEventsQueryResult = Apollo.QueryResult<
  DailyEventsQuery,
  DailyEventsQueryVariables
>;
export const HostedEventsStatisticsDocument = gql`
    query hostedEventsStatistics($input: StatisticsInput!, $prevInput: StatisticsInput!) {
  hostedEvents(input: $input)
  previousHostedEvents: hostedEvents(input: $prevInput)
  ladiesAttended(input: $input)
  userHostedDistinctSparks(input: $input)
}
    `;

/**
 * __useHostedEventsStatisticsQuery__
 *
 * To run a query within a React component, call `useHostedEventsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostedEventsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostedEventsStatisticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      prevInput: // value for 'prevInput'
 *   },
 * });
 */
export function useHostedEventsStatisticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HostedEventsStatisticsQuery,
    HostedEventsStatisticsQueryVariables
  > &
    ({ variables: HostedEventsStatisticsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HostedEventsStatisticsQuery, HostedEventsStatisticsQueryVariables>(
    HostedEventsStatisticsDocument,
    options,
  );
}
export function useHostedEventsStatisticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HostedEventsStatisticsQuery,
    HostedEventsStatisticsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HostedEventsStatisticsQuery, HostedEventsStatisticsQueryVariables>(
    HostedEventsStatisticsDocument,
    options,
  );
}
// @ts-expect-error
export function useHostedEventsStatisticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HostedEventsStatisticsQuery,
    HostedEventsStatisticsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<HostedEventsStatisticsQuery, HostedEventsStatisticsQueryVariables>;
export function useHostedEventsStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HostedEventsStatisticsQuery,
        HostedEventsStatisticsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  HostedEventsStatisticsQuery | undefined,
  HostedEventsStatisticsQueryVariables
>;
export function useHostedEventsStatisticsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HostedEventsStatisticsQuery,
        HostedEventsStatisticsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<HostedEventsStatisticsQuery, HostedEventsStatisticsQueryVariables>(
    HostedEventsStatisticsDocument,
    options,
  );
}
export type HostedEventsStatisticsQueryHookResult = ReturnType<
  typeof useHostedEventsStatisticsQuery
>;
export type HostedEventsStatisticsLazyQueryHookResult = ReturnType<
  typeof useHostedEventsStatisticsLazyQuery
>;
export type HostedEventsStatisticsSuspenseQueryHookResult = ReturnType<
  typeof useHostedEventsStatisticsSuspenseQuery
>;
export type HostedEventsStatisticsQueryResult = Apollo.QueryResult<
  HostedEventsStatisticsQuery,
  HostedEventsStatisticsQueryVariables
>;
export const MonthlyRecapStepsDocument = gql`
    query monthlyRecapSteps($input: StatisticsInput!) {
  monthlyRecapSteps(input: $input)
}
    `;

/**
 * __useMonthlyRecapStepsQuery__
 *
 * To run a query within a React component, call `useMonthlyRecapStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyRecapStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyRecapStepsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMonthlyRecapStepsQuery(
  baseOptions: Apollo.QueryHookOptions<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables> &
    ({ variables: MonthlyRecapStepsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables>(
    MonthlyRecapStepsDocument,
    options,
  );
}
export function useMonthlyRecapStepsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MonthlyRecapStepsQuery,
    MonthlyRecapStepsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables>(
    MonthlyRecapStepsDocument,
    options,
  );
}
// @ts-expect-error
export function useMonthlyRecapStepsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MonthlyRecapStepsQuery,
    MonthlyRecapStepsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables>;
export function useMonthlyRecapStepsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  MonthlyRecapStepsQuery | undefined,
  MonthlyRecapStepsQueryVariables
>;
export function useMonthlyRecapStepsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MonthlyRecapStepsQuery, MonthlyRecapStepsQueryVariables>(
    MonthlyRecapStepsDocument,
    options,
  );
}
export type MonthlyRecapStepsQueryHookResult = ReturnType<typeof useMonthlyRecapStepsQuery>;
export type MonthlyRecapStepsLazyQueryHookResult = ReturnType<typeof useMonthlyRecapStepsLazyQuery>;
export type MonthlyRecapStepsSuspenseQueryHookResult = ReturnType<
  typeof useMonthlyRecapStepsSuspenseQuery
>;
export type MonthlyRecapStepsQueryResult = Apollo.QueryResult<
  MonthlyRecapStepsQuery,
  MonthlyRecapStepsQueryVariables
>;
export const SeenMonthlyReportDocument = gql`
    query seenMonthlyReport {
  seenMonthlyReport
}
    `;

/**
 * __useSeenMonthlyReportQuery__
 *
 * To run a query within a React component, call `useSeenMonthlyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeenMonthlyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeenMonthlyReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeenMonthlyReportQuery(
  baseOptions?: Apollo.QueryHookOptions<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>(
    SeenMonthlyReportDocument,
    options,
  );
}
export function useSeenMonthlyReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SeenMonthlyReportQuery,
    SeenMonthlyReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>(
    SeenMonthlyReportDocument,
    options,
  );
}
// @ts-expect-error
export function useSeenMonthlyReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SeenMonthlyReportQuery,
    SeenMonthlyReportQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>;
export function useSeenMonthlyReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  SeenMonthlyReportQuery | undefined,
  SeenMonthlyReportQueryVariables
>;
export function useSeenMonthlyReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SeenMonthlyReportQuery, SeenMonthlyReportQueryVariables>(
    SeenMonthlyReportDocument,
    options,
  );
}
export type SeenMonthlyReportQueryHookResult = ReturnType<typeof useSeenMonthlyReportQuery>;
export type SeenMonthlyReportLazyQueryHookResult = ReturnType<typeof useSeenMonthlyReportLazyQuery>;
export type SeenMonthlyReportSuspenseQueryHookResult = ReturnType<
  typeof useSeenMonthlyReportSuspenseQuery
>;
export type SeenMonthlyReportQueryResult = Apollo.QueryResult<
  SeenMonthlyReportQuery,
  SeenMonthlyReportQueryVariables
>;
export const GetGroupedOccupationsDocument = gql`
    query getGroupedOccupations {
  getGroupedOccupations {
    id
    name
    industry {
      id
      name
    }
  }
}
    `;

/**
 * __useGetGroupedOccupationsQuery__
 *
 * To run a query within a React component, call `useGetGroupedOccupationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupedOccupationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupedOccupationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupedOccupationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupedOccupationsQuery,
    GetGroupedOccupationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupedOccupationsQuery, GetGroupedOccupationsQueryVariables>(
    GetGroupedOccupationsDocument,
    options,
  );
}
export function useGetGroupedOccupationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupedOccupationsQuery,
    GetGroupedOccupationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupedOccupationsQuery, GetGroupedOccupationsQueryVariables>(
    GetGroupedOccupationsDocument,
    options,
  );
}
// @ts-expect-error
export function useGetGroupedOccupationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupedOccupationsQuery,
    GetGroupedOccupationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetGroupedOccupationsQuery, GetGroupedOccupationsQueryVariables>;
export function useGetGroupedOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupedOccupationsQuery,
        GetGroupedOccupationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetGroupedOccupationsQuery | undefined,
  GetGroupedOccupationsQueryVariables
>;
export function useGetGroupedOccupationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetGroupedOccupationsQuery,
        GetGroupedOccupationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetGroupedOccupationsQuery, GetGroupedOccupationsQueryVariables>(
    GetGroupedOccupationsDocument,
    options,
  );
}
export type GetGroupedOccupationsQueryHookResult = ReturnType<typeof useGetGroupedOccupationsQuery>;
export type GetGroupedOccupationsLazyQueryHookResult = ReturnType<
  typeof useGetGroupedOccupationsLazyQuery
>;
export type GetGroupedOccupationsSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupedOccupationsSuspenseQuery
>;
export type GetGroupedOccupationsQueryResult = Apollo.QueryResult<
  GetGroupedOccupationsQuery,
  GetGroupedOccupationsQueryVariables
>;
export const GetSparksDocument = gql`
    query getSparks($input: StatisticsInput!) {
  userDistinctSparks(input: $input)
  userAttendedDistinctSparks(input: $input)
  communityDistinctSparks(input: $input)
}
    `;

/**
 * __useGetSparksQuery__
 *
 * To run a query within a React component, call `useGetSparksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSparksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSparksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSparksQuery(
  baseOptions: Apollo.QueryHookOptions<GetSparksQuery, GetSparksQueryVariables> &
    ({ variables: GetSparksQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSparksQuery, GetSparksQueryVariables>(GetSparksDocument, options);
}
export function useGetSparksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSparksQuery, GetSparksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSparksQuery, GetSparksQueryVariables>(GetSparksDocument, options);
}
// @ts-expect-error
export function useGetSparksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSparksQuery, GetSparksQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetSparksQuery, GetSparksQueryVariables>;
export function useGetSparksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSparksQuery, GetSparksQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetSparksQuery | undefined, GetSparksQueryVariables>;
export function useGetSparksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSparksQuery, GetSparksQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSparksQuery, GetSparksQueryVariables>(
    GetSparksDocument,
    options,
  );
}
export type GetSparksQueryHookResult = ReturnType<typeof useGetSparksQuery>;
export type GetSparksLazyQueryHookResult = ReturnType<typeof useGetSparksLazyQuery>;
export type GetSparksSuspenseQueryHookResult = ReturnType<typeof useGetSparksSuspenseQuery>;
export type GetSparksQueryResult = Apollo.QueryResult<GetSparksQuery, GetSparksQueryVariables>;
export const GetUserInfoDocument = gql`
    query getUserInfo($id: String!) {
  getUserInfo(id: $id) {
    firstName
    avatarUrl
  }
}
    `;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserInfoQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables> &
    ({ variables: GetUserInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
}
export function useGetUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export function useGetUserInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserInfoQuery | undefined, GetUserInfoQueryVariables>;
export function useGetUserInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options,
  );
}
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetUserInfoSuspenseQuery>;
export type GetUserInfoQueryResult = Apollo.QueryResult<
  GetUserInfoQuery,
  GetUserInfoQueryVariables
>;
export const GetUsersWithSameSpeakingLevelDocument = gql`
    query getUsersWithSameSpeakingLevel($speakingLevel: SpeakingLevelCategories!) {
  getUsersWithSameSpeakingLevel(speakingLevel: $speakingLevel) {
    total
    randomUsersAvatars
  }
}
    `;

/**
 * __useGetUsersWithSameSpeakingLevelQuery__
 *
 * To run a query within a React component, call `useGetUsersWithSameSpeakingLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithSameSpeakingLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithSameSpeakingLevelQuery({
 *   variables: {
 *      speakingLevel: // value for 'speakingLevel'
 *   },
 * });
 */
export function useGetUsersWithSameSpeakingLevelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUsersWithSameSpeakingLevelQuery,
    GetUsersWithSameSpeakingLevelQueryVariables
  > &
    (
      | { variables: GetUsersWithSameSpeakingLevelQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUsersWithSameSpeakingLevelQuery,
    GetUsersWithSameSpeakingLevelQueryVariables
  >(GetUsersWithSameSpeakingLevelDocument, options);
}
export function useGetUsersWithSameSpeakingLevelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersWithSameSpeakingLevelQuery,
    GetUsersWithSameSpeakingLevelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUsersWithSameSpeakingLevelQuery,
    GetUsersWithSameSpeakingLevelQueryVariables
  >(GetUsersWithSameSpeakingLevelDocument, options);
}
// @ts-expect-error
export function useGetUsersWithSameSpeakingLevelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUsersWithSameSpeakingLevelQuery,
    GetUsersWithSameSpeakingLevelQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetUsersWithSameSpeakingLevelQuery,
  GetUsersWithSameSpeakingLevelQueryVariables
>;
export function useGetUsersWithSameSpeakingLevelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUsersWithSameSpeakingLevelQuery,
        GetUsersWithSameSpeakingLevelQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetUsersWithSameSpeakingLevelQuery | undefined,
  GetUsersWithSameSpeakingLevelQueryVariables
>;
export function useGetUsersWithSameSpeakingLevelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetUsersWithSameSpeakingLevelQuery,
        GetUsersWithSameSpeakingLevelQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUsersWithSameSpeakingLevelQuery,
    GetUsersWithSameSpeakingLevelQueryVariables
  >(GetUsersWithSameSpeakingLevelDocument, options);
}
export type GetUsersWithSameSpeakingLevelQueryHookResult = ReturnType<
  typeof useGetUsersWithSameSpeakingLevelQuery
>;
export type GetUsersWithSameSpeakingLevelLazyQueryHookResult = ReturnType<
  typeof useGetUsersWithSameSpeakingLevelLazyQuery
>;
export type GetUsersWithSameSpeakingLevelSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersWithSameSpeakingLevelSuspenseQuery
>;
export type GetUsersWithSameSpeakingLevelQueryResult = Apollo.QueryResult<
  GetUsersWithSameSpeakingLevelQuery,
  GetUsersWithSameSpeakingLevelQueryVariables
>;
export const AttendanceMetricsDocument = gql`
    query attendanceMetrics($userId: String!) {
  attendanceMetrics(userId: $userId) {
    totalEvents
    totalOneToOnes
    totalGroup
    totalWebinars
    totalInPerson
    totalOther
    totalDuration
    hostedEvents
    hostedOneToOnes
    hostedGroup
    hostedWebinars
    hostedInPerson
    hostedOther
    hostedDuration
    attendedEvents
    totalAttendedScheduledEvents
    attendedOneToOnes
    attendedGroup
    attendedWebinars
    attendedInPerson
    attendedOther
    attendedDuration
    videoCalls
  }
}
    `;

/**
 * __useAttendanceMetricsQuery__
 *
 * To run a query within a React component, call `useAttendanceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendanceMetricsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAttendanceMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables> &
    ({ variables: AttendanceMetricsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(
    AttendanceMetricsDocument,
    options,
  );
}
export function useAttendanceMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AttendanceMetricsQuery,
    AttendanceMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(
    AttendanceMetricsDocument,
    options,
  );
}
// @ts-expect-error
export function useAttendanceMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AttendanceMetricsQuery,
    AttendanceMetricsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>;
export function useAttendanceMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  AttendanceMetricsQuery | undefined,
  AttendanceMetricsQueryVariables
>;
export function useAttendanceMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AttendanceMetricsQuery, AttendanceMetricsQueryVariables>(
    AttendanceMetricsDocument,
    options,
  );
}
export type AttendanceMetricsQueryHookResult = ReturnType<typeof useAttendanceMetricsQuery>;
export type AttendanceMetricsLazyQueryHookResult = ReturnType<typeof useAttendanceMetricsLazyQuery>;
export type AttendanceMetricsSuspenseQueryHookResult = ReturnType<
  typeof useAttendanceMetricsSuspenseQuery
>;
export type AttendanceMetricsQueryResult = Apollo.QueryResult<
  AttendanceMetricsQuery,
  AttendanceMetricsQueryVariables
>;
export const TotalHostedParticipantsDocument = gql`
    query totalHostedParticipants($userId: String!) {
  totalHostedParticipants(userId: $userId)
}
    `;

/**
 * __useTotalHostedParticipantsQuery__
 *
 * To run a query within a React component, call `useTotalHostedParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalHostedParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalHostedParticipantsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTotalHostedParticipantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  > &
    ({ variables: TotalHostedParticipantsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalHostedParticipantsQuery, TotalHostedParticipantsQueryVariables>(
    TotalHostedParticipantsDocument,
    options,
  );
}
export function useTotalHostedParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalHostedParticipantsQuery, TotalHostedParticipantsQueryVariables>(
    TotalHostedParticipantsDocument,
    options,
  );
}
// @ts-expect-error
export function useTotalHostedParticipantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TotalHostedParticipantsQuery,
  TotalHostedParticipantsQueryVariables
>;
export function useTotalHostedParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalHostedParticipantsQuery,
        TotalHostedParticipantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TotalHostedParticipantsQuery | undefined,
  TotalHostedParticipantsQueryVariables
>;
export function useTotalHostedParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalHostedParticipantsQuery,
        TotalHostedParticipantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TotalHostedParticipantsQuery,
    TotalHostedParticipantsQueryVariables
  >(TotalHostedParticipantsDocument, options);
}
export type TotalHostedParticipantsQueryHookResult = ReturnType<
  typeof useTotalHostedParticipantsQuery
>;
export type TotalHostedParticipantsLazyQueryHookResult = ReturnType<
  typeof useTotalHostedParticipantsLazyQuery
>;
export type TotalHostedParticipantsSuspenseQueryHookResult = ReturnType<
  typeof useTotalHostedParticipantsSuspenseQuery
>;
export type TotalHostedParticipantsQueryResult = Apollo.QueryResult<
  TotalHostedParticipantsQuery,
  TotalHostedParticipantsQueryVariables
>;
export const TotalPublishedArticlesDocument = gql`
    query totalPublishedArticles($userId: String!) {
  totalPublishedArticles(userId: $userId)
}
    `;

/**
 * __useTotalPublishedArticlesQuery__
 *
 * To run a query within a React component, call `useTotalPublishedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalPublishedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalPublishedArticlesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTotalPublishedArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    TotalPublishedArticlesQuery,
    TotalPublishedArticlesQueryVariables
  > &
    ({ variables: TotalPublishedArticlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>(
    TotalPublishedArticlesDocument,
    options,
  );
}
export function useTotalPublishedArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TotalPublishedArticlesQuery,
    TotalPublishedArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>(
    TotalPublishedArticlesDocument,
    options,
  );
}
// @ts-expect-error
export function useTotalPublishedArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TotalPublishedArticlesQuery,
    TotalPublishedArticlesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>;
export function useTotalPublishedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalPublishedArticlesQuery,
        TotalPublishedArticlesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TotalPublishedArticlesQuery | undefined,
  TotalPublishedArticlesQueryVariables
>;
export function useTotalPublishedArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TotalPublishedArticlesQuery,
        TotalPublishedArticlesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TotalPublishedArticlesQuery, TotalPublishedArticlesQueryVariables>(
    TotalPublishedArticlesDocument,
    options,
  );
}
export type TotalPublishedArticlesQueryHookResult = ReturnType<
  typeof useTotalPublishedArticlesQuery
>;
export type TotalPublishedArticlesLazyQueryHookResult = ReturnType<
  typeof useTotalPublishedArticlesLazyQuery
>;
export type TotalPublishedArticlesSuspenseQueryHookResult = ReturnType<
  typeof useTotalPublishedArticlesSuspenseQuery
>;
export type TotalPublishedArticlesQueryResult = Apollo.QueryResult<
  TotalPublishedArticlesQuery,
  TotalPublishedArticlesQueryVariables
>;
export const RecentArticlesDocument = gql`
    query recentArticles($userId: String!) {
  recentArticles(userId: $userId) {
    id
    title
    coverUrl
    noLikes
    likes {
      id
    }
  }
}
    `;

/**
 * __useRecentArticlesQuery__
 *
 * To run a query within a React component, call `useRecentArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentArticlesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRecentArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<RecentArticlesQuery, RecentArticlesQueryVariables> &
    ({ variables: RecentArticlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecentArticlesQuery, RecentArticlesQueryVariables>(
    RecentArticlesDocument,
    options,
  );
}
export function useRecentArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RecentArticlesQuery, RecentArticlesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RecentArticlesQuery, RecentArticlesQueryVariables>(
    RecentArticlesDocument,
    options,
  );
}
// @ts-expect-error
export function useRecentArticlesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<RecentArticlesQuery, RecentArticlesQueryVariables>,
): Apollo.UseSuspenseQueryResult<RecentArticlesQuery, RecentArticlesQueryVariables>;
export function useRecentArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecentArticlesQuery, RecentArticlesQueryVariables>,
): Apollo.UseSuspenseQueryResult<RecentArticlesQuery | undefined, RecentArticlesQueryVariables>;
export function useRecentArticlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RecentArticlesQuery, RecentArticlesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RecentArticlesQuery, RecentArticlesQueryVariables>(
    RecentArticlesDocument,
    options,
  );
}
export type RecentArticlesQueryHookResult = ReturnType<typeof useRecentArticlesQuery>;
export type RecentArticlesLazyQueryHookResult = ReturnType<typeof useRecentArticlesLazyQuery>;
export type RecentArticlesSuspenseQueryHookResult = ReturnType<
  typeof useRecentArticlesSuspenseQuery
>;
export type RecentArticlesQueryResult = Apollo.QueryResult<
  RecentArticlesQuery,
  RecentArticlesQueryVariables
>;
export const ListRecommendedUsersDocument = gql`
    query listRecommendedUsers {
  listRecommendedUsers {
    userId
    user {
      id
      firstName
      lastName
      avatarUrl
      badge
      city
      country
      story
    }
  }
}
    `;

/**
 * __useListRecommendedUsersQuery__
 *
 * To run a query within a React component, call `useListRecommendedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecommendedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecommendedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRecommendedUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListRecommendedUsersQuery,
    ListRecommendedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListRecommendedUsersQuery, ListRecommendedUsersQueryVariables>(
    ListRecommendedUsersDocument,
    options,
  );
}
export function useListRecommendedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListRecommendedUsersQuery,
    ListRecommendedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListRecommendedUsersQuery, ListRecommendedUsersQueryVariables>(
    ListRecommendedUsersDocument,
    options,
  );
}
// @ts-expect-error
export function useListRecommendedUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListRecommendedUsersQuery,
    ListRecommendedUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListRecommendedUsersQuery, ListRecommendedUsersQueryVariables>;
export function useListRecommendedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRecommendedUsersQuery,
        ListRecommendedUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ListRecommendedUsersQuery | undefined,
  ListRecommendedUsersQueryVariables
>;
export function useListRecommendedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListRecommendedUsersQuery,
        ListRecommendedUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListRecommendedUsersQuery, ListRecommendedUsersQueryVariables>(
    ListRecommendedUsersDocument,
    options,
  );
}
export type ListRecommendedUsersQueryHookResult = ReturnType<typeof useListRecommendedUsersQuery>;
export type ListRecommendedUsersLazyQueryHookResult = ReturnType<
  typeof useListRecommendedUsersLazyQuery
>;
export type ListRecommendedUsersSuspenseQueryHookResult = ReturnType<
  typeof useListRecommendedUsersSuspenseQuery
>;
export type ListRecommendedUsersQueryResult = Apollo.QueryResult<
  ListRecommendedUsersQuery,
  ListRecommendedUsersQueryVariables
>;
export const ListMatchedUsersDocument = gql`
    query listMatchedUsers($filters: FilterUsersInput!) {
  listMatchedUsers(filters: $filters) {
    items {
      userId
      user {
        id
        firstName
        lastName
        badge
        createdAt
        lastOnlineAt
        avatarUrl
        interests
        englishSkills
        occupation {
          id
          name
        }
        city
        country
        cambridgeEnglishLevel
        speakingLevelScore
        speakingLevel
        availabilityFrom
        availabilityUntil
        needSpeakingPartner
        availability {
          from
          until
        }
        pauseUntil
        pauseStartAt
      }
      matchDetails {
        commonInterests
        commonEnglishSkills
        sameCity
        availabilityMatch
      }
      matchScores {
        interestScore
        englishInterestScore
        englishLevelScore
        availabilityScore
        eventParticipationScore
        locationScore
      }
      matchWeights {
        interestScore
        englishInterestScore
        englishLevelScore
        availabilityScore
        eventParticipationScore
        locationScore
      }
      score
      defaultMatchScore
    }
    total
  }
}
    `;

/**
 * __useListMatchedUsersQuery__
 *
 * To run a query within a React component, call `useListMatchedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMatchedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMatchedUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListMatchedUsersQuery(
  baseOptions: Apollo.QueryHookOptions<ListMatchedUsersQuery, ListMatchedUsersQueryVariables> &
    ({ variables: ListMatchedUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>(
    ListMatchedUsersDocument,
    options,
  );
}
export function useListMatchedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>(
    ListMatchedUsersDocument,
    options,
  );
}
// @ts-expect-error
export function useListMatchedUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListMatchedUsersQuery,
    ListMatchedUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>;
export function useListMatchedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListMatchedUsersQuery | undefined, ListMatchedUsersQueryVariables>;
export function useListMatchedUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListMatchedUsersQuery, ListMatchedUsersQueryVariables>(
    ListMatchedUsersDocument,
    options,
  );
}
export type ListMatchedUsersQueryHookResult = ReturnType<typeof useListMatchedUsersQuery>;
export type ListMatchedUsersLazyQueryHookResult = ReturnType<typeof useListMatchedUsersLazyQuery>;
export type ListMatchedUsersSuspenseQueryHookResult = ReturnType<
  typeof useListMatchedUsersSuspenseQuery
>;
export type ListMatchedUsersQueryResult = Apollo.QueryResult<
  ListMatchedUsersQuery,
  ListMatchedUsersQueryVariables
>;
export const GetUserMatchingInfoDocument = gql`
    query getUserMatchingInfo($id: String!) {
  getUserMatchingInfo(id: $id) {
    userId
    user {
      id
      availabilityFrom
      availabilityUntil
      email
      avatarUrl
      needSpeakingPartner
      cambridgeEnglishLevel
      speakingLevelScore
      speakingLevel
      firstName
      nationality
      otherLanguage
      isComplete
      badge
      createdAt
      lastOnlineAt
      lastName
      city
      name
      country
      story
      birthday
      englishSkills
      interests
      occupation {
        id
        name
      }
      badges {
        id
        type
        achievedDate
      }
      showBirthday
      showBirthdayYear
      nativeLanguage
      completedPercentage
      pauseUntil
      pauseStartAt
      followers {
        follower {
          id
          name
        }
      }
      availability {
        from
        until
      }
      photos {
        id
        url
      }
    }
    matchDetails {
      availabilityMatch
      commonInterests
      commonEnglishSkills
      sameCity
    }
    defaultMatchScore
  }
}
    `;

/**
 * __useGetUserMatchingInfoQuery__
 *
 * To run a query within a React component, call `useGetUserMatchingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMatchingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMatchingInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserMatchingInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserMatchingInfoQuery,
    GetUserMatchingInfoQueryVariables
  > &
    ({ variables: GetUserMatchingInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserMatchingInfoQuery, GetUserMatchingInfoQueryVariables>(
    GetUserMatchingInfoDocument,
    options,
  );
}
export function useGetUserMatchingInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserMatchingInfoQuery,
    GetUserMatchingInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserMatchingInfoQuery, GetUserMatchingInfoQueryVariables>(
    GetUserMatchingInfoDocument,
    options,
  );
}
// @ts-expect-error
export function useGetUserMatchingInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserMatchingInfoQuery,
    GetUserMatchingInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetUserMatchingInfoQuery, GetUserMatchingInfoQueryVariables>;
export function useGetUserMatchingInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserMatchingInfoQuery, GetUserMatchingInfoQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetUserMatchingInfoQuery | undefined,
  GetUserMatchingInfoQueryVariables
>;
export function useGetUserMatchingInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserMatchingInfoQuery, GetUserMatchingInfoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserMatchingInfoQuery, GetUserMatchingInfoQueryVariables>(
    GetUserMatchingInfoDocument,
    options,
  );
}
export type GetUserMatchingInfoQueryHookResult = ReturnType<typeof useGetUserMatchingInfoQuery>;
export type GetUserMatchingInfoLazyQueryHookResult = ReturnType<
  typeof useGetUserMatchingInfoLazyQuery
>;
export type GetUserMatchingInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetUserMatchingInfoSuspenseQuery
>;
export type GetUserMatchingInfoQueryResult = Apollo.QueryResult<
  GetUserMatchingInfoQuery,
  GetUserMatchingInfoQueryVariables
>;
export const GetAvalibilityMatchForUsersDocument = gql`
    query getAvalibilityMatchForUsers($input: AvailabilityForUsersInput!) {
  getAvalibilityMatchForUsers(input: $input) {
    userId
    availabilityMatch
  }
}
    `;

/**
 * __useGetAvalibilityMatchForUsersQuery__
 *
 * To run a query within a React component, call `useGetAvalibilityMatchForUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvalibilityMatchForUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvalibilityMatchForUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvalibilityMatchForUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvalibilityMatchForUsersQuery,
    GetAvalibilityMatchForUsersQueryVariables
  > &
    ({ variables: GetAvalibilityMatchForUsersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvalibilityMatchForUsersQuery,
    GetAvalibilityMatchForUsersQueryVariables
  >(GetAvalibilityMatchForUsersDocument, options);
}
export function useGetAvalibilityMatchForUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvalibilityMatchForUsersQuery,
    GetAvalibilityMatchForUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvalibilityMatchForUsersQuery,
    GetAvalibilityMatchForUsersQueryVariables
  >(GetAvalibilityMatchForUsersDocument, options);
}
// @ts-expect-error
export function useGetAvalibilityMatchForUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvalibilityMatchForUsersQuery,
    GetAvalibilityMatchForUsersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetAvalibilityMatchForUsersQuery,
  GetAvalibilityMatchForUsersQueryVariables
>;
export function useGetAvalibilityMatchForUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvalibilityMatchForUsersQuery,
        GetAvalibilityMatchForUsersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetAvalibilityMatchForUsersQuery | undefined,
  GetAvalibilityMatchForUsersQueryVariables
>;
export function useGetAvalibilityMatchForUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAvalibilityMatchForUsersQuery,
        GetAvalibilityMatchForUsersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvalibilityMatchForUsersQuery,
    GetAvalibilityMatchForUsersQueryVariables
  >(GetAvalibilityMatchForUsersDocument, options);
}
export type GetAvalibilityMatchForUsersQueryHookResult = ReturnType<
  typeof useGetAvalibilityMatchForUsersQuery
>;
export type GetAvalibilityMatchForUsersLazyQueryHookResult = ReturnType<
  typeof useGetAvalibilityMatchForUsersLazyQuery
>;
export type GetAvalibilityMatchForUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetAvalibilityMatchForUsersSuspenseQuery
>;
export type GetAvalibilityMatchForUsersQueryResult = Apollo.QueryResult<
  GetAvalibilityMatchForUsersQuery,
  GetAvalibilityMatchForUsersQueryVariables
>;
export const CompletedVerificationFormDocument = gql`
    query completedVerificationForm {
  completedVerificationForm {
    id
  }
}
    `;

/**
 * __useCompletedVerificationFormQuery__
 *
 * To run a query within a React component, call `useCompletedVerificationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedVerificationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedVerificationFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompletedVerificationFormQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompletedVerificationFormQuery,
    CompletedVerificationFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CompletedVerificationFormQuery, CompletedVerificationFormQueryVariables>(
    CompletedVerificationFormDocument,
    options,
  );
}
export function useCompletedVerificationFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompletedVerificationFormQuery,
    CompletedVerificationFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompletedVerificationFormQuery,
    CompletedVerificationFormQueryVariables
  >(CompletedVerificationFormDocument, options);
}
// @ts-expect-error
export function useCompletedVerificationFormSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CompletedVerificationFormQuery,
    CompletedVerificationFormQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CompletedVerificationFormQuery,
  CompletedVerificationFormQueryVariables
>;
export function useCompletedVerificationFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CompletedVerificationFormQuery,
        CompletedVerificationFormQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CompletedVerificationFormQuery | undefined,
  CompletedVerificationFormQueryVariables
>;
export function useCompletedVerificationFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CompletedVerificationFormQuery,
        CompletedVerificationFormQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CompletedVerificationFormQuery,
    CompletedVerificationFormQueryVariables
  >(CompletedVerificationFormDocument, options);
}
export type CompletedVerificationFormQueryHookResult = ReturnType<
  typeof useCompletedVerificationFormQuery
>;
export type CompletedVerificationFormLazyQueryHookResult = ReturnType<
  typeof useCompletedVerificationFormLazyQuery
>;
export type CompletedVerificationFormSuspenseQueryHookResult = ReturnType<
  typeof useCompletedVerificationFormSuspenseQuery
>;
export type CompletedVerificationFormQueryResult = Apollo.QueryResult<
  CompletedVerificationFormQuery,
  CompletedVerificationFormQueryVariables
>;
export const GetVideoCallDocument = gql`
    query getVideoCall($id: String!) {
  getVideoCall(id: $id) {
    id
    title
    dailyRoomId
    closedDoorAt
    endedAt
    chatRoomId
    participants {
      id
      isHost
      userId
    }
  }
}
    `;

/**
 * __useGetVideoCallQuery__
 *
 * To run a query within a React component, call `useGetVideoCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVideoCallQuery(
  baseOptions: Apollo.QueryHookOptions<GetVideoCallQuery, GetVideoCallQueryVariables> &
    ({ variables: GetVideoCallQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVideoCallQuery, GetVideoCallQueryVariables>(
    GetVideoCallDocument,
    options,
  );
}
export function useGetVideoCallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetVideoCallQuery, GetVideoCallQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVideoCallQuery, GetVideoCallQueryVariables>(
    GetVideoCallDocument,
    options,
  );
}
// @ts-expect-error
export function useGetVideoCallSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetVideoCallQuery, GetVideoCallQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetVideoCallQuery, GetVideoCallQueryVariables>;
export function useGetVideoCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVideoCallQuery, GetVideoCallQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetVideoCallQuery | undefined, GetVideoCallQueryVariables>;
export function useGetVideoCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVideoCallQuery, GetVideoCallQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetVideoCallQuery, GetVideoCallQueryVariables>(
    GetVideoCallDocument,
    options,
  );
}
export type GetVideoCallQueryHookResult = ReturnType<typeof useGetVideoCallQuery>;
export type GetVideoCallLazyQueryHookResult = ReturnType<typeof useGetVideoCallLazyQuery>;
export type GetVideoCallSuspenseQueryHookResult = ReturnType<typeof useGetVideoCallSuspenseQuery>;
export type GetVideoCallQueryResult = Apollo.QueryResult<
  GetVideoCallQuery,
  GetVideoCallQueryVariables
>;
export const GetChannelVideoCallDocument = gql`
    query getChannelVideoCall($id: String!) {
  getChannelVideoCall(id: $id) {
    id
    title
    dailyRoomId
    closedDoorAt
    endedAt
    chatRoomId
  }
}
    `;

/**
 * __useGetChannelVideoCallQuery__
 *
 * To run a query within a React component, call `useGetChannelVideoCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelVideoCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelVideoCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChannelVideoCallQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChannelVideoCallQuery,
    GetChannelVideoCallQueryVariables
  > &
    ({ variables: GetChannelVideoCallQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChannelVideoCallQuery, GetChannelVideoCallQueryVariables>(
    GetChannelVideoCallDocument,
    options,
  );
}
export function useGetChannelVideoCallLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChannelVideoCallQuery,
    GetChannelVideoCallQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetChannelVideoCallQuery, GetChannelVideoCallQueryVariables>(
    GetChannelVideoCallDocument,
    options,
  );
}
// @ts-expect-error
export function useGetChannelVideoCallSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChannelVideoCallQuery,
    GetChannelVideoCallQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetChannelVideoCallQuery, GetChannelVideoCallQueryVariables>;
export function useGetChannelVideoCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelVideoCallQuery, GetChannelVideoCallQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetChannelVideoCallQuery | undefined,
  GetChannelVideoCallQueryVariables
>;
export function useGetChannelVideoCallSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChannelVideoCallQuery, GetChannelVideoCallQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetChannelVideoCallQuery, GetChannelVideoCallQueryVariables>(
    GetChannelVideoCallDocument,
    options,
  );
}
export type GetChannelVideoCallQueryHookResult = ReturnType<typeof useGetChannelVideoCallQuery>;
export type GetChannelVideoCallLazyQueryHookResult = ReturnType<
  typeof useGetChannelVideoCallLazyQuery
>;
export type GetChannelVideoCallSuspenseQueryHookResult = ReturnType<
  typeof useGetChannelVideoCallSuspenseQuery
>;
export type GetChannelVideoCallQueryResult = Apollo.QueryResult<
  GetChannelVideoCallQuery,
  GetChannelVideoCallQueryVariables
>;
export const GetVideosDocument = gql`
    query getVideos {
  getVideos {
    id
    title
    videoURL
    thumbnail
    isActive
    position
    completedByMe
    set {
      id
    }
  }
}
    `;

/**
 * __useGetVideosQuery__
 *
 * To run a query within a React component, call `useGetVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVideosQuery(
  baseOptions?: Apollo.QueryHookOptions<GetVideosQuery, GetVideosQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVideosQuery, GetVideosQueryVariables>(GetVideosDocument, options);
}
export function useGetVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVideosQuery, GetVideosQueryVariables>(GetVideosDocument, options);
}
// @ts-expect-error
export function useGetVideosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetVideosQuery, GetVideosQueryVariables>;
export function useGetVideosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetVideosQuery | undefined, GetVideosQueryVariables>;
export function useGetVideosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVideosQuery, GetVideosQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetVideosQuery, GetVideosQueryVariables>(
    GetVideosDocument,
    options,
  );
}
export type GetVideosQueryHookResult = ReturnType<typeof useGetVideosQuery>;
export type GetVideosLazyQueryHookResult = ReturnType<typeof useGetVideosLazyQuery>;
export type GetVideosSuspenseQueryHookResult = ReturnType<typeof useGetVideosSuspenseQuery>;
export type GetVideosQueryResult = Apollo.QueryResult<GetVideosQuery, GetVideosQueryVariables>;
export const AssessmentResultsAreSavedDocument = gql`
    subscription assessmentResultsAreSaved($assessmentId: String!) {
  assessmentResultsAreSaved(assessmentId: $assessmentId) {
    assessmentId
  }
}
    `;

/**
 * __useAssessmentResultsAreSavedSubscription__
 *
 * To run a query within a React component, call `useAssessmentResultsAreSavedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentResultsAreSavedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentResultsAreSavedSubscription({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentResultsAreSavedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AssessmentResultsAreSavedSubscription,
    AssessmentResultsAreSavedSubscriptionVariables
  > &
    (
      | { variables: AssessmentResultsAreSavedSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AssessmentResultsAreSavedSubscription,
    AssessmentResultsAreSavedSubscriptionVariables
  >(AssessmentResultsAreSavedDocument, options);
}
export type AssessmentResultsAreSavedSubscriptionHookResult = ReturnType<
  typeof useAssessmentResultsAreSavedSubscription
>;
export type AssessmentResultsAreSavedSubscriptionResult =
  Apollo.SubscriptionResult<AssessmentResultsAreSavedSubscription>;
export const AssessmentChargesAreSavedForUserDocument = gql`
    subscription assessmentChargesAreSavedForUser($userId: String!) {
  assessmentChargesAreSavedForUser(userId: $userId)
}
    `;

/**
 * __useAssessmentChargesAreSavedForUserSubscription__
 *
 * To run a query within a React component, call `useAssessmentChargesAreSavedForUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentChargesAreSavedForUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentChargesAreSavedForUserSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAssessmentChargesAreSavedForUserSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AssessmentChargesAreSavedForUserSubscription,
    AssessmentChargesAreSavedForUserSubscriptionVariables
  > &
    (
      | { variables: AssessmentChargesAreSavedForUserSubscriptionVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AssessmentChargesAreSavedForUserSubscription,
    AssessmentChargesAreSavedForUserSubscriptionVariables
  >(AssessmentChargesAreSavedForUserDocument, options);
}
export type AssessmentChargesAreSavedForUserSubscriptionHookResult = ReturnType<
  typeof useAssessmentChargesAreSavedForUserSubscription
>;
export type AssessmentChargesAreSavedForUserSubscriptionResult =
  Apollo.SubscriptionResult<AssessmentChargesAreSavedForUserSubscription>;
export const CommentCreatedDocument = gql`
    subscription commentCreated($targetId: String!) {
  commentCreated(targetId: $targetId) {
    id
    parentID
    message
    createdAt
    author {
      id
      name
      avatarUrl
    }
    reactions {
      id
      unifiedId
      user {
        id
        avatarUrl
        firstName
        lastName
      }
    }
    replies {
      id
      message
      createdAt
      author {
        id
        name
        avatarUrl
      }
      reactions {
        id
        unifiedId
        user {
          id
          avatarUrl
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useCommentCreatedSubscription__
 *
 * To run a query within a React component, call `useCommentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentCreatedSubscription({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useCommentCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    CommentCreatedSubscription,
    CommentCreatedSubscriptionVariables
  > &
    ({ variables: CommentCreatedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<CommentCreatedSubscription, CommentCreatedSubscriptionVariables>(
    CommentCreatedDocument,
    options,
  );
}
export type CommentCreatedSubscriptionHookResult = ReturnType<typeof useCommentCreatedSubscription>;
export type CommentCreatedSubscriptionResult =
  Apollo.SubscriptionResult<CommentCreatedSubscription>;
export const CommentDeletedDocument = gql`
    subscription commentDeleted($targetId: String!) {
  commentDeleted(targetId: $targetId) {
    id
    parentID
  }
}
    `;

/**
 * __useCommentDeletedSubscription__
 *
 * To run a query within a React component, call `useCommentDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentDeletedSubscription({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useCommentDeletedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    CommentDeletedSubscription,
    CommentDeletedSubscriptionVariables
  > &
    ({ variables: CommentDeletedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>(
    CommentDeletedDocument,
    options,
  );
}
export type CommentDeletedSubscriptionHookResult = ReturnType<typeof useCommentDeletedSubscription>;
export type CommentDeletedSubscriptionResult =
  Apollo.SubscriptionResult<CommentDeletedSubscription>;
export const ReactionCreatedDocument = gql`
    subscription reactionCreated($targetId: String!) {
  reactionCreated(targetId: $targetId) {
    id
    unifiedId
    user {
      id
      avatarUrl
      firstName
      lastName
    }
    comment {
      id
      parentID
    }
  }
}
    `;

/**
 * __useReactionCreatedSubscription__
 *
 * To run a query within a React component, call `useReactionCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReactionCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReactionCreatedSubscription({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useReactionCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ReactionCreatedSubscription,
    ReactionCreatedSubscriptionVariables
  > &
    ({ variables: ReactionCreatedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ReactionCreatedSubscription, ReactionCreatedSubscriptionVariables>(
    ReactionCreatedDocument,
    options,
  );
}
export type ReactionCreatedSubscriptionHookResult = ReturnType<
  typeof useReactionCreatedSubscription
>;
export type ReactionCreatedSubscriptionResult =
  Apollo.SubscriptionResult<ReactionCreatedSubscription>;
export const ReactionDeletedDocument = gql`
    subscription reactionDeleted($targetId: String!) {
  reactionDeleted(targetId: $targetId) {
    id
    unifiedId
    user {
      id
      avatarUrl
      firstName
      lastName
    }
    comment {
      id
      parentID
    }
  }
}
    `;

/**
 * __useReactionDeletedSubscription__
 *
 * To run a query within a React component, call `useReactionDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReactionDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReactionDeletedSubscription({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useReactionDeletedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ReactionDeletedSubscription,
    ReactionDeletedSubscriptionVariables
  > &
    ({ variables: ReactionDeletedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<ReactionDeletedSubscription, ReactionDeletedSubscriptionVariables>(
    ReactionDeletedDocument,
    options,
  );
}
export type ReactionDeletedSubscriptionHookResult = ReturnType<
  typeof useReactionDeletedSubscription
>;
export type ReactionDeletedSubscriptionResult =
  Apollo.SubscriptionResult<ReactionDeletedSubscription>;
export const EventUpdatedDocument = gql`
    subscription eventUpdated($eventId: String!) {
  eventUpdated(eventId: $eventId) {
    eventAndInvites {
      id
      closedDoorAt
      noParticipants
      participants {
        id
        avatarUrl
        createdAt
        firstName
        lastName
        isVerified
        kind
      }
      invites {
        id
        isHost
        status
        isConfirmed
        user {
          id
          name
          firstName
          lastName
          createdAt
          badge
          avatarUrl
          kind
        }
      }
    }
    eventDoorStatus {
      closedDoorAt
    }
  }
}
    `;

/**
 * __useEventUpdatedSubscription__
 *
 * To run a query within a React component, call `useEventUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEventUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventUpdatedSubscription({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    EventUpdatedSubscription,
    EventUpdatedSubscriptionVariables
  > &
    ({ variables: EventUpdatedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<EventUpdatedSubscription, EventUpdatedSubscriptionVariables>(
    EventUpdatedDocument,
    options,
  );
}
export type EventUpdatedSubscriptionHookResult = ReturnType<typeof useEventUpdatedSubscription>;
export type EventUpdatedSubscriptionResult = Apollo.SubscriptionResult<EventUpdatedSubscription>;
export const GuestPassUpdatedDocument = gql`
    subscription guestPassUpdated {
  guestPassUpdated {
    id
    userId
    startsAt
    endsAt
    daysRemaining
    tokenAllowance
    tokensUsed
    tokensRemaining
    isActive
    canActivateMembership
    shouldShowCompletionModal
  }
}
    `;

/**
 * __useGuestPassUpdatedSubscription__
 *
 * To run a query within a React component, call `useGuestPassUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGuestPassUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestPassUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGuestPassUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    GuestPassUpdatedSubscription,
    GuestPassUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    GuestPassUpdatedSubscription,
    GuestPassUpdatedSubscriptionVariables
  >(GuestPassUpdatedDocument, options);
}
export type GuestPassUpdatedSubscriptionHookResult = ReturnType<
  typeof useGuestPassUpdatedSubscription
>;
export type GuestPassUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<GuestPassUpdatedSubscription>;
export const LiveTableAboutToEndDocument = gql`
    subscription liveTableAboutToEnd($liveTableId: String!) {
  liveTableAboutToEnd(liveTableId: $liveTableId) {
    id
  }
}
    `;

/**
 * __useLiveTableAboutToEndSubscription__
 *
 * To run a query within a React component, call `useLiveTableAboutToEndSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTableAboutToEndSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTableAboutToEndSubscription({
 *   variables: {
 *      liveTableId: // value for 'liveTableId'
 *   },
 * });
 */
export function useLiveTableAboutToEndSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    LiveTableAboutToEndSubscription,
    LiveTableAboutToEndSubscriptionVariables
  > &
    ({ variables: LiveTableAboutToEndSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LiveTableAboutToEndSubscription,
    LiveTableAboutToEndSubscriptionVariables
  >(LiveTableAboutToEndDocument, options);
}
export type LiveTableAboutToEndSubscriptionHookResult = ReturnType<
  typeof useLiveTableAboutToEndSubscription
>;
export type LiveTableAboutToEndSubscriptionResult =
  Apollo.SubscriptionResult<LiveTableAboutToEndSubscription>;
export const LiveTableHasEndedDocument = gql`
    subscription liveTableHasEnded($liveTableId: String!) {
  liveTableHasEnded(liveTableId: $liveTableId) {
    id
    endedAt
  }
}
    `;

/**
 * __useLiveTableHasEndedSubscription__
 *
 * To run a query within a React component, call `useLiveTableHasEndedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTableHasEndedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTableHasEndedSubscription({
 *   variables: {
 *      liveTableId: // value for 'liveTableId'
 *   },
 * });
 */
export function useLiveTableHasEndedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    LiveTableHasEndedSubscription,
    LiveTableHasEndedSubscriptionVariables
  > &
    ({ variables: LiveTableHasEndedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LiveTableHasEndedSubscription,
    LiveTableHasEndedSubscriptionVariables
  >(LiveTableHasEndedDocument, options);
}
export type LiveTableHasEndedSubscriptionHookResult = ReturnType<
  typeof useLiveTableHasEndedSubscription
>;
export type LiveTableHasEndedSubscriptionResult =
  Apollo.SubscriptionResult<LiveTableHasEndedSubscription>;
export const LiveTableUpdatedDocument = gql`
    subscription liveTableUpdated($liveTableId: String!) {
  liveTableUpdated(liveTableId: $liveTableId) {
    id
    title
    englishLevel
    timeLimit
    endDate
    question {
      id
      question
      type
    }
    participants {
      id
      user {
        id
        firstName
        lastName
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useLiveTableUpdatedSubscription__
 *
 * To run a query within a React component, call `useLiveTableUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTableUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTableUpdatedSubscription({
 *   variables: {
 *      liveTableId: // value for 'liveTableId'
 *   },
 * });
 */
export function useLiveTableUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    LiveTableUpdatedSubscription,
    LiveTableUpdatedSubscriptionVariables
  > &
    ({ variables: LiveTableUpdatedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LiveTableUpdatedSubscription,
    LiveTableUpdatedSubscriptionVariables
  >(LiveTableUpdatedDocument, options);
}
export type LiveTableUpdatedSubscriptionHookResult = ReturnType<
  typeof useLiveTableUpdatedSubscription
>;
export type LiveTableUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<LiveTableUpdatedSubscription>;
export const LiveTableHasStartedDocument = gql`
    subscription liveTableHasStarted {
  liveTableHasStarted {
    name
    avatarUrl
    tableId
    tableTitle
    tableCreatorId
    tableEnglishLevel
  }
}
    `;

/**
 * __useLiveTableHasStartedSubscription__
 *
 * To run a query within a React component, call `useLiveTableHasStartedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTableHasStartedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTableHasStartedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useLiveTableHasStartedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    LiveTableHasStartedSubscription,
    LiveTableHasStartedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LiveTableHasStartedSubscription,
    LiveTableHasStartedSubscriptionVariables
  >(LiveTableHasStartedDocument, options);
}
export type LiveTableHasStartedSubscriptionHookResult = ReturnType<
  typeof useLiveTableHasStartedSubscription
>;
export type LiveTableHasStartedSubscriptionResult =
  Apollo.SubscriptionResult<LiveTableHasStartedSubscription>;
export const LiveTableChangedDocument = gql`
    subscription liveTableChanged {
  liveTableChanged {
    id
    title
    englishLevel
    timeLimit
    endDate
    endedAt
    maxParticipants
    createdAt
    dailyRoomId
    question {
      id
      question
      type
    }
    participants {
      id
      user {
        id
        firstName
        lastName
        avatarUrl
      }
    }
  }
}
    `;

/**
 * __useLiveTableChangedSubscription__
 *
 * To run a query within a React component, call `useLiveTableChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLiveTableChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTableChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useLiveTableChangedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    LiveTableChangedSubscription,
    LiveTableChangedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    LiveTableChangedSubscription,
    LiveTableChangedSubscriptionVariables
  >(LiveTableChangedDocument, options);
}
export type LiveTableChangedSubscriptionHookResult = ReturnType<
  typeof useLiveTableChangedSubscription
>;
export type LiveTableChangedSubscriptionResult =
  Apollo.SubscriptionResult<LiveTableChangedSubscription>;
export const NotificationsSubscriptionDocument = gql`
    subscription notificationsSubscription {
  notificationAdded {
    id
    type
    createdAt
    notificationSeen {
      id
      seenAt
    }
    chatNotification {
      ...ChatNotificationFields
    }
    commentNotification {
      ...CommentNotificationFields
    }
    eventNotification {
      ...EventNotificationFields
    }
    articleNotification {
      ...ArticleNotificationFields
    }
  }
}
    ${ChatNotificationFieldsFragmentDoc}
${CommentNotificationFieldsFragmentDoc}
${EventNotificationFieldsFragmentDoc}
${ArticleNotificationFieldsFragmentDoc}`;

/**
 * __useNotificationsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNotificationsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    NotificationsSubscriptionSubscription,
    NotificationsSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    NotificationsSubscriptionSubscription,
    NotificationsSubscriptionSubscriptionVariables
  >(NotificationsSubscriptionDocument, options);
}
export type NotificationsSubscriptionSubscriptionHookResult = ReturnType<
  typeof useNotificationsSubscriptionSubscription
>;
export type NotificationsSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<NotificationsSubscriptionSubscription>;
export const PopupNotificationsSubscriptionDocument = gql`
    subscription popupNotificationsSubscription {
  popupNotificationAdded {
    id
    type
    createdAt
    notificationSeen {
      id
      seenAt
    }
    badgeNotification {
      ...BadgeNotificationFields
    }
    eventNotification {
      ...EventNotificationFields
    }
    profileUpdateNotification {
      ...ProfileUpdateNotificationFields
    }
    monthlyReportNotification {
      ...MonthlyReportNotificationFields
    }
    friendJoinedNotification {
      ...FriendJoinedNotificationFields
    }
    customNotification {
      ...CustomNotificationFields
    }
  }
}
    ${BadgeNotificationFieldsFragmentDoc}
${EventNotificationFieldsFragmentDoc}
${ProfileUpdateNotificationFieldsFragmentDoc}
${MonthlyReportNotificationFieldsFragmentDoc}
${FriendJoinedNotificationFieldsFragmentDoc}
${CustomNotificationFieldsFragmentDoc}`;

/**
 * __usePopupNotificationsSubscriptionSubscription__
 *
 * To run a query within a React component, call `usePopupNotificationsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePopupNotificationsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopupNotificationsSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function usePopupNotificationsSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    PopupNotificationsSubscriptionSubscription,
    PopupNotificationsSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    PopupNotificationsSubscriptionSubscription,
    PopupNotificationsSubscriptionSubscriptionVariables
  >(PopupNotificationsSubscriptionDocument, options);
}
export type PopupNotificationsSubscriptionSubscriptionHookResult = ReturnType<
  typeof usePopupNotificationsSubscriptionSubscription
>;
export type PopupNotificationsSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<PopupNotificationsSubscriptionSubscription>;
export const DunningStatusUpdatedDocument = gql`
    subscription dunningStatusUpdated {
  dunningStatusUpdated {
    userId
    dunning
  }
}
    `;

/**
 * __useDunningStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useDunningStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDunningStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDunningStatusUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDunningStatusUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    DunningStatusUpdatedSubscription,
    DunningStatusUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DunningStatusUpdatedSubscription,
    DunningStatusUpdatedSubscriptionVariables
  >(DunningStatusUpdatedDocument, options);
}
export type DunningStatusUpdatedSubscriptionHookResult = ReturnType<
  typeof useDunningStatusUpdatedSubscription
>;
export type DunningStatusUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<DunningStatusUpdatedSubscription>;
export const SparkCreatedDocument = gql`
    subscription sparkCreated($eventId: String!) {
  sparkCreated(eventId: $eventId) {
    id
    event {
      id
    }
    user {
      id
    }
  }
}
    `;

/**
 * __useSparkCreatedSubscription__
 *
 * To run a query within a React component, call `useSparkCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSparkCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSparkCreatedSubscription({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSparkCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    SparkCreatedSubscription,
    SparkCreatedSubscriptionVariables
  > &
    ({ variables: SparkCreatedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<SparkCreatedSubscription, SparkCreatedSubscriptionVariables>(
    SparkCreatedDocument,
    options,
  );
}
export type SparkCreatedSubscriptionHookResult = ReturnType<typeof useSparkCreatedSubscription>;
export type SparkCreatedSubscriptionResult = Apollo.SubscriptionResult<SparkCreatedSubscription>;
export const CommunitySparkCreatedDocument = gql`
    subscription communitySparkCreated {
  communitySparkCreated {
    id
  }
}
    `;

/**
 * __useCommunitySparkCreatedSubscription__
 *
 * To run a query within a React component, call `useCommunitySparkCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySparkCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySparkCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useCommunitySparkCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    CommunitySparkCreatedSubscription,
    CommunitySparkCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    CommunitySparkCreatedSubscription,
    CommunitySparkCreatedSubscriptionVariables
  >(CommunitySparkCreatedDocument, options);
}
export type CommunitySparkCreatedSubscriptionHookResult = ReturnType<
  typeof useCommunitySparkCreatedSubscription
>;
export type CommunitySparkCreatedSubscriptionResult =
  Apollo.SubscriptionResult<CommunitySparkCreatedSubscription>;
export const StreakEventAttendedSubscriptionDocument = gql`
    subscription streakEventAttendedSubscription {
  streakEventAttended {
    weeklyGoal
    nextWeeklyGoal
    connectionStreak
    goalStreak
    eventsThisWeek
    connectionWeekCompletedThisWeek
    goalCompletedThisWeek
    connectionStreakBrokeLastWeek
    goalStreakBrokeLastWeek
    powerUpCount
    powerUpRevealed
    powerUpProgress
    connectionStreakIncrementedThisWeek
  }
}
    `;

/**
 * __useStreakEventAttendedSubscriptionSubscription__
 *
 * To run a query within a React component, call `useStreakEventAttendedSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useStreakEventAttendedSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStreakEventAttendedSubscriptionSubscription({
 *   variables: {
 *   },
 * });
 */
export function useStreakEventAttendedSubscriptionSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    StreakEventAttendedSubscriptionSubscription,
    StreakEventAttendedSubscriptionSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    StreakEventAttendedSubscriptionSubscription,
    StreakEventAttendedSubscriptionSubscriptionVariables
  >(StreakEventAttendedSubscriptionDocument, options);
}
export type StreakEventAttendedSubscriptionSubscriptionHookResult = ReturnType<
  typeof useStreakEventAttendedSubscriptionSubscription
>;
export type StreakEventAttendedSubscriptionSubscriptionResult =
  Apollo.SubscriptionResult<StreakEventAttendedSubscriptionSubscription>;
export const UserStatisticsUpdatedDocument = gql`
    subscription userStatisticsUpdated {
  userStatisticsUpdated {
    userId
    eventStatistics {
      id
      totalAttendedScheduledEvents
      updatedAt
      createdAt
    }
  }
}
    `;

/**
 * __useUserStatisticsUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserStatisticsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserStatisticsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserStatisticsUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserStatisticsUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    UserStatisticsUpdatedSubscription,
    UserStatisticsUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserStatisticsUpdatedSubscription,
    UserStatisticsUpdatedSubscriptionVariables
  >(UserStatisticsUpdatedDocument, options);
}
export type UserStatisticsUpdatedSubscriptionHookResult = ReturnType<
  typeof useUserStatisticsUpdatedSubscription
>;
export type UserStatisticsUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<UserStatisticsUpdatedSubscription>;
export const UserPermissionsUpdatedDocument = gql`
    subscription userPermissionsUpdated {
  userPermissionsUpdated {
    userId
    kind
    badge
  }
}
    `;

/**
 * __useUserPermissionsUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserPermissionsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionsUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserPermissionsUpdatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    UserPermissionsUpdatedSubscription,
    UserPermissionsUpdatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserPermissionsUpdatedSubscription,
    UserPermissionsUpdatedSubscriptionVariables
  >(UserPermissionsUpdatedDocument, options);
}
export type UserPermissionsUpdatedSubscriptionHookResult = ReturnType<
  typeof useUserPermissionsUpdatedSubscription
>;
export type UserPermissionsUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<UserPermissionsUpdatedSubscription>;
export const VideoAskFormCreatedDocument = gql`
    subscription videoAskFormCreated {
  videoAskFormCreated {
    id
  }
}
    `;

/**
 * __useVideoAskFormCreatedSubscription__
 *
 * To run a query within a React component, call `useVideoAskFormCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVideoAskFormCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoAskFormCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useVideoAskFormCreatedSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    VideoAskFormCreatedSubscription,
    VideoAskFormCreatedSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    VideoAskFormCreatedSubscription,
    VideoAskFormCreatedSubscriptionVariables
  >(VideoAskFormCreatedDocument, options);
}
export type VideoAskFormCreatedSubscriptionHookResult = ReturnType<
  typeof useVideoAskFormCreatedSubscription
>;
export type VideoAskFormCreatedSubscriptionResult =
  Apollo.SubscriptionResult<VideoAskFormCreatedSubscription>;
export const VideoCallUpdatedDocument = gql`
    subscription videoCallUpdated($id: String!) {
  videoCallUpdated(id: $id) {
    id
    title
    dailyRoomId
    closedDoorAt
    endedAt
  }
}
    `;

/**
 * __useVideoCallUpdatedSubscription__
 *
 * To run a query within a React component, call `useVideoCallUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useVideoCallUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoCallUpdatedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideoCallUpdatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    VideoCallUpdatedSubscription,
    VideoCallUpdatedSubscriptionVariables
  > &
    ({ variables: VideoCallUpdatedSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    VideoCallUpdatedSubscription,
    VideoCallUpdatedSubscriptionVariables
  >(VideoCallUpdatedDocument, options);
}
export type VideoCallUpdatedSubscriptionHookResult = ReturnType<
  typeof useVideoCallUpdatedSubscription
>;
export type VideoCallUpdatedSubscriptionResult =
  Apollo.SubscriptionResult<VideoCallUpdatedSubscription>;
export const ChannelVideoCallDocument = gql`
    subscription channelVideoCall($id: String!) {
  channelVideoCall(id: $id) {
    id
    title
    dailyRoomId
    closedDoorAt
    endedAt
  }
}
    `;

/**
 * __useChannelVideoCallSubscription__
 *
 * To run a query within a React component, call `useChannelVideoCallSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChannelVideoCallSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelVideoCallSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChannelVideoCallSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    ChannelVideoCallSubscription,
    ChannelVideoCallSubscriptionVariables
  > &
    ({ variables: ChannelVideoCallSubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    ChannelVideoCallSubscription,
    ChannelVideoCallSubscriptionVariables
  >(ChannelVideoCallDocument, options);
}
export type ChannelVideoCallSubscriptionHookResult = ReturnType<
  typeof useChannelVideoCallSubscription
>;
export type ChannelVideoCallSubscriptionResult =
  Apollo.SubscriptionResult<ChannelVideoCallSubscription>;
